import * as tslib_1 from "tslib";
import { OnInit, ElementRef } from "@angular/core";
import { ReleaseDetail } from "../models/release-detail.model";
import { Allocation } from "../models/allocation.model";
import { Building } from "../models/building.model";
import { LaborDetail } from "../models/labor-detail.model";
import { ContingencyDetail } from "../models/contingency-detail.model";
import { UploadFile } from "../models/upload-file.model";
import { ItProject } from "../models/it-project.model";
import { parseOperatingUnit } from "../shared/utils/operating-unit.util";
import { ErrorDialogComponent } from "../error-dialog/error-dialog.component";
import { AssignmentDialogComponent } from "../assignment-dialog/assignment-dialog.component";
import { ApproverDialogComponent } from "../approver-dialog/approver-dialog.component";
import { HttpClient } from "@angular/common/http";
import _ from "lodash";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { startWith, map } from "rxjs/operators";
import { CapabilityDescriptionComponent } from "../capability-description/capability-description.component";
import { CapabilityDetail } from "../models/capability-detail.model";
import { MaterialEstimate } from "../models/material-estimate.model";
import { FormApprovalDialogComponent } from "../form-approval-dialog/form-approval-dialog.component";
import { AddCharginDetailsDialogComponent } from "../add-charging-details-dialog/add-charging-details-dialog.component";
import { ItProjectEstimate } from "../models/it-project-estimate.model";
import { ItActivity } from "../models/it-activity.model";
import { ConfirmDeleteFormDialogComponent } from "../confirm-delete-form-dialog/confirm-delete-form-dialog.component";
import { printApprovalFormPDF } from "../shared/utils/pdfmake.utils";
export class ItProjectApprovalComponent {
    constructor(dataService, route, dialog, http, config, router, loaderService, currencyPipe, httpBackend) {
        this.dataService = dataService;
        this.route = route;
        this.dialog = dialog;
        this.http = http;
        this.config = config;
        this.router = router;
        this.loaderService = loaderService;
        this.currencyPipe = currencyPipe;
        this.webMethodUserName = this.config.getConfig("WebMethodUserName");
        this.webMethodPass = this.config.getConfig("WebMethodPassword");
        this.primaryContactControl = new FormControl();
        this.itSponsorControl = new FormControl();
        this.allocationDefaults = [];
        this.allocationDefaultsCopy = [];
        this.allocationDefaultList = [];
        // Tracks, per doaAmounts index, whether the last DOA lookup failed (so a stale/cached 0 isn't mistaken for a real amount).
        this.doaLookupFailed = [];
        // Tracks whether a lookup (including its automatic retries) is still in flight, so the UI doesn't
        // prematurely clear the failed state and flash a stale amount before the retries finish.
        this.doaLookupLoading = [];
        this.DOA_FAILURE_LOG_KEY = "doaFailureLog";
        this.userRoles = [];
        this.currentDate = new Date();
        this.buildingInfoControl = new FormControl();
        this.lastFilter = "";
        this.filteredStateOptions = [new Observable()];
        this.uopDescriptionOptions = [];
        this.commonUOPOptions = [];
        this.allocationTotalValue = 0;
        this.showErrorsDisclaimer = false;
        this.workOptions = {};
        this.allocationFunctions = [];
        this.derivationAndAllocations = {};
        //FLDT-1384 Adding variables to store LanIds
        this.projectManagerLanId = "";
        this.engineerLanId = "";
        this.contractAdminLanId = "";
        this.editSnapshot = '';
        this.approverListBackup = [];
        this.httpNoInterceptors = new HttpClient(httpBackend);
        this.sparDataLoaded = false;
        this.formActivityVisible = true;
        this.editFormMode = false;
        this.filteredFundingProjectOptions = [new Observable()];
        this.parser = new DOMParser();
    }
    ngOnInit() {
        let userData = JSON.parse(sessionStorage.getItem("userInfo"));
        if (userData) {
            let stringArray = userData.account.name.split(",");
            this.lastName = stringArray[0];
            this.firstName = stringArray[1].substring(1);
            this.userName = this.firstName + " " + this.lastName;
            this.userEmail = userData.account.username;
        }
        this.getAssetUsers();
        this.getAssetOrder();
        this.loadHardwareOrSoftwareOptionsFile();
        this.loadProjectConsistsOfOptionsFile();
        this.loadProjectClassificationOptionsFile();
        this.loadHowSoftwareReleasedOptionsFile();
        this.loadDefaultsByDepartmentFile();
        this.loadBUForStateFile();
        this.loadCommonUOPProjectsFile();
        this.loadChargeTypeOptionsFile();
        this.loadLeadPacReviewerFile();
        this.loadJointOwnerCoordinatorFile();
        this.loadAssetAccountingFile();
        this.loadCatawbaOperatingUnitFile();
        this.loadPACEmailFile();
        this.loadEmailRecipientsFile();
        this.loadStyleSheet();
        this.generateTodaysDate();
        this.loadBUTypeDerivation();
        this.loadUtilityRetirementDerivation();
        this.loadActivityDerivation();
        this.loadAccountingModelDerivation();
        this.loadProjectClassDerivations();
        this.loadProjectTypeDerivations();
        this.loadOUAssetLocMajorLoc();
        this.loadITPopAssetLocMajorLoc();
        this.loadOtherSpecialBuildings();
        this.loadBUDefaults();
        this.loadCompanyMajorLocation();
        this.loadNuclearAbbreviations();
        this.loadOperatingUnitFile();
        this.loadDistributionOptionsFile();
        this.loadAllocationDefaults();
        this.loadAllocationFunctions();
        this.loadDerivationAndAllocations();
        this.loadAccountingTreatment();
        this.loadSetIdToFunction();
        this.allocationTotalValue = 100;
        this.route.queryParams.subscribe((params) => {
            let userData = JSON.parse(sessionStorage.getItem("userInfo"));
            if (!userData) {
                // Guard should have ensured a valid session, but defend against any
                // edge case where sessionStorage was cleared after auth completed.
                console.warn('[AuthGuard] userInfo missing in queryParams handler, cannot load form.');
                return;
            }
            this.userRoles = (userData.idTokenClaims && userData.idTokenClaims.roles) || [];
            this.formCompletedSpecial = false;
            this.reviewComments = null;
            let requestedRevisionNumber;
            if (params.guid) {
                this.dataService.clearRequestCache(params.guid);
                this.itSparGuid = params.guid;
                if (params.revisionNum !== undefined && params.revisionNum !== null) {
                    this.displayRevisionNumber = Number(params.revisionNum);
                    requestedRevisionNumber = this.displayRevisionNumber;
                }
                else {
                    // If URL has guid but no revisionNum, explicitly load the base form.
                    this.displayRevisionNumber = 0;
                    requestedRevisionNumber = 0;
                }
                if (this.displayRevisionNumber > 0) {
                    this.getPreviousItSparData(this.itSparGuid, this.displayRevisionNumber);
                }
            }
            else {
                this.itSparGuid = JSON.parse(sessionStorage.getItem("itSparGuid"));
                const displayRevisionNumberFromSession = sessionStorage.getItem("displayRevisionNumber");
                this.displayRevisionNumber = displayRevisionNumberFromSession
                    ? Number(displayRevisionNumberFromSession)
                    : 0;
                requestedRevisionNumber = this.displayRevisionNumber;
            }
            if (requestedRevisionNumber !== undefined) {
                this.getItSparData(this.itSparGuid, requestedRevisionNumber);
            }
            else {
                this.getItSparData(this.itSparGuid);
            }
        });
        // for if we have a Lighthouse project with no Capital, we must use this default UOP and make a dummy row of 0.01.
        this.defaultCapitalUOP = "Miscellaneous Equipment";
    }
    toggleFormActivity() {
        this.formActivityVisible = !this.formActivityVisible;
    }
    toggleEditFormMode() {
        this.editFormMode = !this.editFormMode;
        if (this.editFormMode) {
            this.approverListBackup = JSON.parse(JSON.stringify(this.approverList || []));
            this.editSnapshot = this.getFormSnapshot();
        }
    }
    getFormSnapshot() {
        return JSON.stringify([
            this.projectNameCopy, this.omOnlyCopy, this.relatedWorkCopy,
            this.hardwareOrSoftwareCopy, this.itProjectClassificationCopy,
            this.estimatedStartDateCopy, this.estimatedInServiceDateCopy,
            this.projectScopeDescriptionCopy, this.primaryContactCopy,
            this.itSponsorCopy, this.purchasingWarrantiesCopy,
            this.projectConsistsOfCopy, this.projectConsistsOfCheckboxesCopy,
            this.distributeCostCopy, this.defaultOptionCopy, this.expectedLifeCopy,
            this.agileEffortCopy, this.softwareBeingUsedCopy, this.vendorNameCopy,
            this.softwareNameCopy, this.inServiceYearCopy, this.softwareProjectOverviewCopy,
            this.dataConversionActivitiesCopy, this.trainingCostsCopy,
            this.associatedRetirementCopy, this.softwareToBeRetiredCopy,
            this.retiredInServiceDateCopy, this.maintenanceContractsCopy,
            this.replacingInterfacesCopy, this.howSoftwareReleasedCopy,
            this.perpetualLicensesCopy, this.contractualRightCopy,
            this.significantPenaltyCopy, this.isFeasibleCopy, this.serviceFeesCopy,
            this.useWithoutPayingCopy, this.departmentCopy, this.buildingInfoCopy,
            this.releaseDetailsCopy, this.allocationsCopy, this.buildingsCopy,
            this.laborDetailsCopy, this.contingencyDetailsCopy,
            this.additionalCommentsCopy, this.doaAmountsCopy, this.approverList,
        ]);
    }
    isProjectConsistsOfCheckboxRequired() {
        if (this.hardwareOrSoftwareCopy === "O&M Only" ||
            this.hardwareOrSoftwareCopy === "Hardware Only")
            return false;
        if (this.projectConsistsOfCopy && this.projectConsistsOfCopy.length > 0)
            return false;
        return true;
    }
    validateGraphUser(control, selectedContact, displayFn) {
        try {
            const inputValue = control.value;
            let contact = "";
            if (inputValue.givenName && inputValue.surname && inputValue.jobTitle) {
                contact =
                    inputValue.givenName +
                        " " +
                        inputValue.surname +
                        " (" +
                        inputValue.mail +
                        "), " +
                        inputValue.jobTitle;
            }
            else if (inputValue.givenName &&
                inputValue.surname &&
                !inputValue.jobTitle) {
                contact =
                    inputValue.givenName +
                        " " +
                        inputValue.surname +
                        " (" +
                        inputValue.mail +
                        ")";
            }
            else if (inputValue.displayName && inputValue.jobTitle) {
                contact =
                    inputValue.displayName +
                        " (" +
                        inputValue.mail +
                        "), " +
                        inputValue.jobTitle;
            }
            else if (inputValue.displayName && !inputValue.jobTitle) {
                contact = inputValue.displayName + " (" + inputValue.mail + ")";
            }
            const isValid = contact === displayFn(selectedContact);
            return isValid;
        }
        catch (e) {
            return false;
        }
    }
    projectSetupFormCustomValidationCheck() {
        if (!(this.patiProject &&
            this.patiProject.Project_ID &&
            this.projectNameCopy &&
            this.itProjectClassificationCopy &&
            this.estimatedStartDateCopy &&
            this.estimatedInServiceDateCopy &&
            this.projectScopeDescriptionCopy &&
            this.primaryContactCopy &&
            this.primaryContactCopy.mail &&
            this.itSponsorCopy &&
            this.itSponsorCopy.mail &&
            this.hardwareOrSoftwareCopy)) {
            return true;
        }
        else if (this.patiProject &&
            this.patiProject.Project_ID &&
            this.projectNameCopy &&
            this.itProjectClassificationCopy &&
            this.estimatedStartDateCopy &&
            this.estimatedInServiceDateCopy &&
            this.projectScopeDescriptionCopy &&
            this.primaryContactCopy &&
            this.primaryContactCopy.mail &&
            this.itSponsorCopy &&
            this.itSponsorCopy.mail &&
            this.hardwareOrSoftwareCopy) {
            if (this.hardwareOrSoftwareCopy === "O&M Only") {
                return false;
            }
            else if (this.hardwareOrSoftwareCopy === "Hardware Only") {
                return !this.purchasingWarrantiesCopy;
            }
            else if (this.hardwareOrSoftwareCopy === "Software Only") {
                if (!(this.projectConsistsOfCopy &&
                    this.projectConsistsOfCopy.length > 0 &&
                    this.softwareBeingUsedCopy &&
                    this.softwareProjectOverviewCopy &&
                    this.dataConversionActivitiesCopy &&
                    this.trainingCostsCopy &&
                    this.associatedRetirementCopy &&
                    this.replacingInterfacesCopy &&
                    this.howSoftwareReleasedCopy)) {
                    return true;
                }
                else if (this.projectConsistsOfCopy &&
                    this.projectConsistsOfCopy.length > 0 &&
                    this.softwareBeingUsedCopy &&
                    this.softwareProjectOverviewCopy &&
                    this.dataConversionActivitiesCopy &&
                    this.trainingCostsCopy &&
                    this.associatedRetirementCopy &&
                    this.replacingInterfacesCopy &&
                    this.howSoftwareReleasedCopy) {
                    if (this.softwareBeingUsedCopy === "NO") {
                        if (this.associatedRetirementCopy === "YES") {
                            if (this.softwareToBeRetiredCopy) {
                                if (this.isVendorHosted()) {
                                    return !(this.perpetualLicensesCopy &&
                                        this.contractualRightCopy &&
                                        this.significantPenaltyCopy &&
                                        this.isFeasibleCopy &&
                                        this.serviceFeesCopy &&
                                        this.useWithoutPayingCopy);
                                }
                                else {
                                    return false;
                                }
                            }
                            else {
                                return true;
                            }
                        }
                        else if (this.associatedRetirementCopy === "NO") {
                            if (this.isVendorHosted()) {
                                return !(this.perpetualLicensesCopy &&
                                    this.contractualRightCopy &&
                                    this.significantPenaltyCopy &&
                                    this.isFeasibleCopy &&
                                    this.serviceFeesCopy &&
                                    this.useWithoutPayingCopy);
                            }
                            else {
                                return false;
                            }
                        }
                    }
                    if (this.softwareBeingUsedCopy === "YES") {
                        if (this.inServiceYearCopy) {
                            if (this.associatedRetirementCopy === "YES") {
                                if (this.softwareToBeRetiredCopy) {
                                    if (this.isVendorHosted()) {
                                        return !(this.perpetualLicensesCopy &&
                                            this.contractualRightCopy &&
                                            this.significantPenaltyCopy &&
                                            this.isFeasibleCopy &&
                                            this.serviceFeesCopy &&
                                            this.useWithoutPayingCopy);
                                    }
                                    else {
                                        return false;
                                    }
                                }
                                else {
                                    return true;
                                }
                            }
                            else if (this.associatedRetirementCopy === "NO") {
                                if (this.isVendorHosted()) {
                                    return !(this.perpetualLicensesCopy &&
                                        this.contractualRightCopy &&
                                        this.significantPenaltyCopy &&
                                        this.isFeasibleCopy &&
                                        this.serviceFeesCopy &&
                                        this.useWithoutPayingCopy);
                                }
                                else {
                                    return false;
                                }
                            }
                        }
                        else {
                            return true;
                        }
                    }
                }
            }
            else if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
                if (!(this.purchasingWarrantiesCopy &&
                    this.projectConsistsOfCopy &&
                    this.projectConsistsOfCopy.length > 0 &&
                    this.softwareBeingUsedCopy &&
                    this.softwareProjectOverviewCopy &&
                    this.dataConversionActivitiesCopy &&
                    this.trainingCostsCopy &&
                    this.associatedRetirementCopy &&
                    this.replacingInterfacesCopy &&
                    this.howSoftwareReleasedCopy)) {
                    return true;
                }
                else if (this.purchasingWarrantiesCopy &&
                    this.projectConsistsOfCopy &&
                    this.projectConsistsOfCopy.length > 0 &&
                    this.softwareBeingUsedCopy &&
                    this.softwareProjectOverviewCopy &&
                    this.dataConversionActivitiesCopy &&
                    this.trainingCostsCopy &&
                    this.associatedRetirementCopy &&
                    this.replacingInterfacesCopy &&
                    this.howSoftwareReleasedCopy) {
                    if (this.softwareBeingUsedCopy === "NO") {
                        if (this.associatedRetirementCopy === "YES") {
                            if (this.softwareToBeRetiredCopy) {
                                if (this.isVendorHosted()) {
                                    return !(this.perpetualLicensesCopy &&
                                        this.contractualRightCopy &&
                                        this.significantPenaltyCopy &&
                                        this.isFeasibleCopy &&
                                        this.serviceFeesCopy &&
                                        this.useWithoutPayingCopy);
                                }
                                else {
                                    return false;
                                }
                            }
                            else {
                                return true;
                            }
                        }
                        else if (this.associatedRetirementCopy === "NO") {
                            if (this.isVendorHosted()) {
                                return !(this.perpetualLicensesCopy &&
                                    this.contractualRightCopy &&
                                    this.significantPenaltyCopy &&
                                    this.isFeasibleCopy &&
                                    this.serviceFeesCopy &&
                                    this.useWithoutPayingCopy);
                            }
                            else {
                                return false;
                            }
                        }
                    }
                    if (this.softwareBeingUsedCopy === "YES") {
                        if (this.inServiceYearCopy) {
                            if (this.associatedRetirementCopy === "YES") {
                                if (this.softwareToBeRetiredCopy) {
                                    if (this.isVendorHosted()) {
                                        return !(this.perpetualLicensesCopy &&
                                            this.contractualRightCopy &&
                                            this.significantPenaltyCopy &&
                                            this.isFeasibleCopy &&
                                            this.serviceFeesCopy &&
                                            this.useWithoutPayingCopy);
                                    }
                                    else {
                                        return false;
                                    }
                                }
                                else {
                                    return true;
                                }
                            }
                            else if (this.associatedRetirementCopy === "NO") {
                                if (this.isVendorHosted()) {
                                    return !(this.perpetualLicensesCopy &&
                                        this.contractualRightCopy &&
                                        this.significantPenaltyCopy &&
                                        this.isFeasibleCopy &&
                                        this.serviceFeesCopy &&
                                        this.useWithoutPayingCopy);
                                }
                                else {
                                    return false;
                                }
                            }
                        }
                        else {
                            return true;
                        }
                    }
                }
            }
        }
    }
    scrollToErrorDisclaimer() {
        setTimeout(() => {
            const errorDisclaimerEl = document.getElementById("errorDisclaimerID");
            const materialHardwareErrorDisclaimerEl = document.getElementById("materialHardwareErrorDisclaimerID");
            const materialSoftwareErrorDisclaimerEl = document.getElementById("materialSoftwareErrorDisclaimerID");
            const materialOmOnlyErrorDisclaimerEl = document.getElementById("materialOmOnlyErrorDisclaimerID");
            if (errorDisclaimerEl) {
                errorDisclaimerEl.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
            else if (materialHardwareErrorDisclaimerEl) {
                materialHardwareErrorDisclaimerEl.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
            else if (materialSoftwareErrorDisclaimerEl) {
                materialSoftwareErrorDisclaimerEl.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
            else if (materialOmOnlyErrorDisclaimerEl) {
                materialOmOnlyErrorDisclaimerEl.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
        });
    }
    isProjectSetupFormValid(form) {
        const isProjectConsistsOfCheckboxRequired = this.isProjectConsistsOfCheckboxRequired();
        // Validate primaryContact
        const isPrimaryContactValid = this.validateGraphUser(this.primaryContactControl, this.primaryContactCopy, this.displayFnPrimaryContact);
        // Validate itSponsor
        const isItSponsorValid = this.validateGraphUser(this.itSponsorControl, this.itSponsorCopy, this.displayFnITSponsor);
        if (!isPrimaryContactValid) {
            this.primaryContactControl.setErrors({ invalidContact: true });
        }
        else {
            this.primaryContactControl.setErrors(null);
        }
        if (!isItSponsorValid) {
            this.itSponsorControl.setErrors({ invalidSponsor: true });
        }
        else {
            this.itSponsorControl.setErrors(null);
        }
        if (form.invalid ||
            isProjectConsistsOfCheckboxRequired ||
            !isPrimaryContactValid ||
            !isItSponsorValid) {
            this.showErrorsDisclaimer = true;
            this.scrollToErrorDisclaimer();
        }
        if (this.projectSetupFormCustomValidationCheck() ||
            form.invalid ||
            isProjectConsistsOfCheckboxRequired ||
            !isPrimaryContactValid ||
            !isItSponsorValid) {
            return false;
        }
        this.showErrorsDisclaimer = false;
        return true;
    }
    capabilityReleaseFilledOut() {
        for (let i = 0; i < this.releaseDetailsCopy.length; i++) {
            for (let j = 0; j < this.releaseDetailsCopy[i].capabilityDetails.length; j++) {
                if (i === 0) {
                    if (j === 0) {
                        if (!(!this.releaseDetailsCopy[i].capabilityDetails[j]
                            .releaseNumber &&
                            !this.releaseDetailsCopy[i].capabilityDetails[j].releaseDate &&
                            !this.releaseDetailsCopy[i].capabilityDetails[j].capabilities &&
                            !this.releaseDetailsCopy[i].capabilityDetails[j].description)) {
                            if (!this.releaseDetailsCopy[i].capabilityDetails[j]
                                .releaseNumber ||
                                !this.releaseDetailsCopy[i].capabilityDetails[j].releaseDate ||
                                !this.releaseDetailsCopy[i].capabilityDetails[j].capabilities ||
                                !this.releaseDetailsCopy[i].capabilityDetails[j].description) {
                                return false;
                            }
                        }
                    }
                    else if (!this.releaseDetailsCopy[i].capabilityDetails[j].capabilities ||
                        !this.releaseDetailsCopy[i].capabilityDetails[j].description) {
                        return false;
                    }
                }
                else {
                    if (j === 0) {
                        if (!this.releaseDetailsCopy[i].capabilityDetails[j].releaseNumber ||
                            !this.releaseDetailsCopy[i].capabilityDetails[j].releaseDate ||
                            !this.releaseDetailsCopy[i].capabilityDetails[j].capabilities ||
                            !this.releaseDetailsCopy[i].capabilityDetails[j].description) {
                            return false;
                        }
                    }
                    else if (!this.releaseDetailsCopy[i].capabilityDetails[j].capabilities ||
                        !this.releaseDetailsCopy[i].capabilityDetails[j].description) {
                        return false;
                    }
                }
            }
        }
        return true;
    }
    allocationsFilledOut() {
        for (let i = 0; i < this.allocationsCopy.length; i++) {
            if (!(this.allocationsCopy[i].operatingUnit &&
                this.allocationsCopy[i].operatingUnit.OPERATING_UNIT &&
                this.allocationsCopy[i].fundingProjectID &&
                this.allocationsCopy[i].fundingProjectID.work_order_number)) {
                return false;
            }
            else {
                if (!this.stateDisabled(this.allocationsCopy[i])) {
                    if (!this.allocationsCopy[i].state) {
                        return false;
                    }
                }
            }
        }
        return true;
    }
    materialsFilledOut() {
        for (let i = 0; i < this.buildingsCopy.length; i++) {
            if (i > 0) {
                if (!(this.buildingsCopy[i] &&
                    this.buildingsCopy[i].buildingName &&
                    this.buildingsCopy[i].buildingName.BuildingName)) {
                    return false;
                }
            }
            for (let j = 0; j < this.buildingsCopy[i].materialEstimates.length; j++) {
                if (i === 0 && j === 0) {
                    if (!(!this.buildingsCopy[i].materialEstimates[j].cost &&
                        !this.buildingsCopy[i].materialEstimates[j]
                            .unitOfPropertyDetails &&
                        this.buildingsCopy[i].materialEstimates[j].cost !== "O&M" &&
                        !this.buildingsCopy[i].materialEstimates[j]
                            .unitOfPropertyDescription &&
                        !this.buildingsCopy[i].materialEstimates[j].quantity &&
                        !this.buildingsCopy[i].materialEstimates[j].unitCosts)) {
                        if (!this.buildingsCopy[i].materialEstimates[j].cost ||
                            !this.buildingsCopy[i].materialEstimates[j]
                                .unitOfPropertyDetails ||
                            (this.buildingsCopy[i].materialEstimates[j].cost !== "O&M" &&
                                !this.buildingsCopy[i].materialEstimates[j]
                                    .unitOfPropertyDescription) ||
                            !this.buildingsCopy[i].materialEstimates[j].quantity ||
                            !this.buildingsCopy[i].materialEstimates[j].unitCosts ||
                            this.tangiblePropertyCheck(this.buildingsCopy[i].materialEstimates[j]) ||
                            this.tangibleTotalCostCheck(this.buildingsCopy[i].materialEstimates[j]) ||
                            this.tangibleDateCheck(this.buildingsCopy[i].materialEstimates[j])) {
                            return false;
                        }
                    }
                }
                else {
                    if (!this.buildingsCopy[i].materialEstimates[j].cost ||
                        !this.buildingsCopy[i].materialEstimates[j].unitOfPropertyDetails ||
                        (this.buildingsCopy[i].materialEstimates[j].cost !== "O&M" &&
                            !this.buildingsCopy[i].materialEstimates[j]
                                .unitOfPropertyDescription) ||
                        !this.buildingsCopy[i].materialEstimates[j].quantity ||
                        !this.buildingsCopy[i].materialEstimates[j].unitCosts ||
                        this.tangiblePropertyCheck(this.buildingsCopy[i].materialEstimates[j]) ||
                        this.tangibleTotalCostCheck(this.buildingsCopy[i].materialEstimates[j]) ||
                        this.tangibleDateCheck(this.buildingsCopy[i].materialEstimates[j])) {
                        return false;
                    }
                }
            }
        }
        return true;
    }
    employeeContractorFilledOut() {
        for (let i = 0; i < this.laborDetailsCopy.length; i++) {
            if (i === 0) {
                if (!(!(this.laborDetailsCopy[i].workTask &&
                    this.laborDetailsCopy[i].workTask.workTask) &&
                    !this.laborDetailsCopy[i].workDescription &&
                    !this.laborDetailsCopy[i].chargeType &&
                    !this.laborDetailsCopy[i].totalCosts)) {
                    if (!(this.laborDetailsCopy[i].workTask &&
                        this.laborDetailsCopy[i].workTask.workTask) ||
                        !this.laborDetailsCopy[i].workDescription ||
                        !this.laborDetailsCopy[i].chargeType ||
                        !this.laborDetailsCopy[i].totalCosts) {
                        return false;
                    }
                }
            }
            else {
                if (!(this.laborDetailsCopy[i].workTask &&
                    this.laborDetailsCopy[i].workTask.workTask) ||
                    !this.laborDetailsCopy[i].workDescription ||
                    !this.laborDetailsCopy[i].chargeType ||
                    !this.laborDetailsCopy[i].totalCosts) {
                    return false;
                }
            }
        }
        return true;
    }
    employeeContractorHasEntry() {
        for (let i = 0; i < this.laborDetailsCopy.length; i++) {
            if (this.laborDetailsCopy[i].workTask &&
                this.laborDetailsCopy[i].workTask.workTask &&
                this.laborDetailsCopy[i].workDescription &&
                this.laborDetailsCopy[i].chargeType &&
                this.laborDetailsCopy[i].totalCosts) {
                return true;
            }
        }
        return false;
    }
    contingencyFilledOut() {
        for (let i = 0; i < this.contingencyDetailsCopy.length; i++) {
            if (i === 0) {
                if (!(!this.contingencyDetailsCopy[i].cost &&
                    !this.contingencyDetailsCopy[i].description &&
                    !this.contingencyDetailsCopy[i].totalCosts)) {
                    if (!this.contingencyDetailsCopy[i].cost ||
                        !this.contingencyDetailsCopy[i].description ||
                        !this.contingencyDetailsCopy[i].totalCosts) {
                        return false;
                    }
                }
            }
            else {
                if (!this.contingencyDetailsCopy[i].cost ||
                    !this.contingencyDetailsCopy[i].description ||
                    !this.contingencyDetailsCopy[i].totalCosts) {
                    return false;
                }
            }
        }
        return true;
    }
    contingencyHasEntry() {
        for (let i = 0; i < this.contingencyDetailsCopy.length; i++) {
            if (this.contingencyDetailsCopy[i].cost &&
                this.contingencyDetailsCopy[i].description &&
                this.contingencyDetailsCopy[i].totalCosts) {
                return true;
            }
        }
        return false;
    }
    materialsHasEntry() {
        for (let i = 0; i < this.buildingsCopy.length; i++) {
            for (let j = 0; j < this.buildingsCopy[i].materialEstimates.length; j++) {
                const cost = this.buildingsCopy[i].materialEstimates[j].cost;
                if (cost &&
                    this.buildingsCopy[i].materialEstimates[j].unitOfPropertyDetails &&
                    this.buildingsCopy[i].materialEstimates[j].quantity &&
                    this.buildingsCopy[i].materialEstimates[j].unitCosts) {
                    if (cost === "O&M") {
                        return true;
                    }
                    if (cost !== "O&M" &&
                        this.buildingsCopy[i].materialEstimates[j].unitOfPropertyDescription) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    approversFilledOut() {
        for (let i = 0; i < this.approverList.length; i++) {
            if (!(this.approverList[i] && this.approverList[i].displayName)) {
                return false;
            }
        }
        return true;
    }
    reviewDisabled() {
        if (this.departmentCopy &&
            this.departmentCopy.department &&
            this.buildingInfoCopy &&
            this.buildingInfoCopy.BuildingName) {
            if ((!(this.hardwareOrSoftwareCopy === "Hardware Only" ||
                this.hardwareOrSoftwareCopy === "O&M Only") &&
                this.capabilityReleaseFilledOut()) ||
                this.hardwareOrSoftwareCopy === "Hardware Only" ||
                this.hardwareOrSoftwareCopy === "O&M Only") {
                if (this.distributeCostCopy === "Manually" ||
                    (this.distributeCostCopy === "Default" && this.defaultOptionCopy)) {
                    if (this.allocationsFilledOut() &&
                        this.allocationTotalValue == 100 &&
                        !this.multipleNuclearHardwareSoftware() &&
                        !this.emptyAllocationLine()) {
                        if (this.materialsFilledOut() &&
                            this.employeeContractorFilledOut() &&
                            this.contingencyFilledOut()) {
                            if (((this.hardwareOrSoftwareCopy === "Hardware Only" ||
                                this.hardwareOrSoftwareCopy === "Hardware and Software") &&
                                this.materialsHasEntry()) ||
                                ((this.hardwareOrSoftwareCopy === "Software Only" ||
                                    this.hardwareOrSoftwareCopy === "O&M Only") &&
                                    (this.materialsHasEntry() ||
                                        this.employeeContractorHasEntry() ||
                                        this.contingencyHasEntry()))) {
                                if (this.approversFilledOut()) {
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }
        return true;
    }
    materialHasCapital() {
        for (let i = 0; i < this.buildingsCopy.length; i++) {
            for (let j = 0; j < this.buildingsCopy[i].materialEstimates.length; j++) {
                if (this.buildingsCopy[i].materialEstimates[j].cost === "CAP") {
                    return true;
                }
            }
        }
        return false;
    }
    materialHasCapitalSoftware() {
        for (let i = 0; i < this.buildingsCopy.length; i++) {
            for (let j = 0; j < this.buildingsCopy[i].materialEstimates.length; j++) {
                const materialEstimate = this.buildingsCopy[i].materialEstimates[j];
                if (materialEstimate.cost === "CAP" &&
                    materialEstimate.unitOfPropertyDescription &&
                    materialEstimate.unitOfPropertyDescription.includes("Software")) {
                    return true;
                }
            }
        }
        return false;
    }
    materialHasCapitalHardware() {
        for (let i = 0; i < this.buildingsCopy.length; i++) {
            for (let j = 0; j < this.buildingsCopy[i].materialEstimates.length; j++) {
                const materialEstimate = this.buildingsCopy[i].materialEstimates[j];
                if (materialEstimate.cost === "CAP" &&
                    materialEstimate.unitOfPropertyDescription &&
                    !materialEstimate.unitOfPropertyDescription.includes("Software")) {
                    return true;
                }
            }
        }
        return false;
    }
    laborHasCapitalSoftware() {
        for (let i = 0; i < this.laborDetailsCopy.length; i++) {
            if (this.laborDetailsCopy[i].workTask &&
                this.laborDetailsCopy[i].workTask.workTask === "Software-CAP") {
                return true;
            }
        }
        return false;
    }
    isContingencyRowMissing(index, row) {
        if (this.showErrorsDisclaimer &&
            (this.contingencyDetailsCopy[index].cost ||
                this.contingencyDetailsCopy[index].description ||
                this.contingencyDetailsCopy[index].totalCosts)) {
            if (row === "cost") {
                if (!this.contingencyDetailsCopy[index].cost) {
                    return true;
                }
            }
            if (row === "description") {
                if (!this.contingencyDetailsCopy[index].description) {
                    return true;
                }
            }
            if (row === "totalCosts") {
                if (!this.contingencyDetailsCopy[index].totalCosts) {
                    return true;
                }
            }
        }
    }
    isMaterialRequired() {
        // If O&M, material row is required if neither materials or labor have an entry
        if (this.hardwareOrSoftwareCopy === "O&M Only") {
            return !this.materialsHasEntry() && !this.employeeContractorHasEntry();
        }
        // If Hardware, one CAP material is always required
        if (this.hardwareOrSoftwareCopy === "Hardware Only") {
            return !this.materialHasCapital();
        }
        // If Software, CAP material required if there is not a CAP labor entry
        if (this.hardwareOrSoftwareCopy === "Software Only") {
            return !this.materialHasCapital() && !this.laborHasCapitalSoftware();
        }
        // If Hardware & Software, one row in materials always required, plus a 2nd row required if no CAP software labor entry
        if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
            return !this.materialsHasEntry() && !this.laborHasCapitalSoftware();
        }
        return !this.materialsFilledOut();
    }
    isEmployeeContractorRequired() {
        // If O&M, labor row is required if neither materials or labor have an entry
        if (this.hardwareOrSoftwareCopy === "O&M Only") {
            return !this.materialsHasEntry() && !this.employeeContractorHasEntry();
        }
        // If Software, CAP labor required if there is no CAP material entry
        if (this.hardwareOrSoftwareCopy === "Software Only") {
            return !this.materialHasCapital() && !this.laborHasCapitalSoftware();
        }
        // If Hardware & Software, labor required if there is no CAP material or CAP labor software entry
        if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
            return !this.materialsHasEntry() && !this.laborHasCapitalSoftware();
        }
        // if Hardware only, labor is only required if the row is partially filled out (default)
        return !this.employeeContractorFilledOut();
    }
    isProjectEstimateFormValid(form) {
        // check Building Info for validity
        if (!(this.buildingInfoCopy && this.buildingInfoCopy.BuildingName)) {
            this.buildingInfoControl.setErrors({ invalidContact: true });
        }
        else {
            this.buildingInfoControl.setErrors(null);
        }
        // check Operating Units for validity
        for (let i = 0; i < this.operatingUnitControl.length; i++) {
            if (!this.allocationsCopy || i >= this.allocationsCopy.length)
                break;
            if (!this.operatingUnitControl[i])
                continue;
            if (!(this.allocationsCopy[i].operatingUnit &&
                this.allocationsCopy[i].operatingUnit.OPERATING_UNIT)) {
                this.operatingUnitControl[i].setErrors({ invalidContact: true });
            }
            else {
                this.operatingUnitControl[i].setErrors(null);
            }
        }
        // check Funding Project IDs for validity
        for (let i = 0; i < this.fundingProjectControl.length; i++) {
            if (!this.allocationsCopy || i >= this.allocationsCopy.length)
                break;
            if (!this.fundingProjectControl[i])
                continue;
            if (!(this.allocationsCopy[i].fundingProjectID &&
                this.allocationsCopy[i].fundingProjectID.work_order_number)) {
                this.fundingProjectControl[i].setErrors({ invalidContact: true });
            }
            else {
                this.fundingProjectControl[i].setErrors(null);
            }
        }
        // check Building for validity
        for (let i = 0; i < this.buildingControl.length; i++) {
            if (!this.buildingsCopy || i >= this.buildingsCopy.length)
                break;
            if (!this.buildingControl[i])
                continue;
            if (!this.isExtraBuilding(this.buildingsCopy[i].buildingName) && !(this.buildingsCopy[i] &&
                this.buildingsCopy[i].buildingName &&
                this.buildingsCopy[i].buildingName.BuildingName)) {
                this.buildingControl[i].setErrors({ invalidContact: true });
            }
            else {
                this.buildingControl[i].setErrors(null);
            }
        }
        this.showErrorsDisclaimer = form.invalid || this.allocationTotalValue !== 100;
        //A Hardware Only form must have at least one row in the materials section that is a CAP row.
        this.showMaterialHardwareOnlyErrorDisclaimer =
            (!this.materialsHasEntry() || !this.materialHasCapital()) &&
                this.hardwareOrSoftwareCopy === "Hardware Only";
        //A Hardware and Software form must have at least one row in the materials section that is a Hardware CAP row.
        //A Hardware and Software form must have at least one row in either the materials or labor section that is a Software CAP row.
        this.showMaterialHardwareSoftwareErrorDisclaimer =
            (!this.materialHasCapitalHardware() ||
                (!this.materialHasCapitalSoftware() &&
                    !this.laborHasCapitalSoftware())) &&
                this.hardwareOrSoftwareCopy === "Hardware and Software";
        //A Software Only form must have at least one row in the materials or labor section that is a CAP row.
        this.showMaterialSoftwareOnlyErrorDisclaimer =
            !this.materialHasCapital() &&
                !this.laborHasCapitalSoftware() &&
                this.hardwareOrSoftwareCopy === "Software Only";
        //An O&M form must have at least one row with all fields filled out in either the Materials or Labor section.
        this.showMaterialOmOnlyErrorDisclaimer =
            !this.employeeContractorHasEntry() &&
                !this.materialsHasEntry() &&
                this.hardwareOrSoftwareCopy === "O&M Only";
        if (this.showErrorsDisclaimer ||
            this.showMaterialHardwareOnlyErrorDisclaimer ||
            this.showMaterialHardwareSoftwareErrorDisclaimer ||
            this.showMaterialSoftwareOnlyErrorDisclaimer ||
            this.showMaterialOmOnlyErrorDisclaimer) {
            this.scrollToErrorDisclaimer();
            return false;
        }
        return true;
    }
    passDataFromCopyToOriginal() {
        this.projectName = this.projectNameCopy;
        this.omOnly = this.omOnlyCopy;
        this.relatedWork = this.relatedWorkCopy;
        this.hardwareOrSoftware = this.hardwareOrSoftwareCopy;
        this.itProjectClassification = JSON.parse(JSON.stringify(this.itProjectClassificationCopy));
        this.estimatedStartDate = this.estimatedStartDateCopy;
        this.estimatedInServiceDate = this.estimatedInServiceDateCopy;
        this.projectScopeDescription = this.projectScopeDescriptionCopy;
        this.primaryContact = JSON.parse(JSON.stringify(this.primaryContactCopy));
        this.itSponsor = JSON.parse(JSON.stringify(this.itSponsorCopy));
        this.purchasingWarranties = this.purchasingWarrantiesCopy;
        this.projectConsistsOf = JSON.parse(JSON.stringify(this.projectConsistsOfCopy));
        this.projectConsistsOfCheckboxes = JSON.parse(JSON.stringify(this.projectConsistsOfCheckboxesCopy));
        this.distributeCost = this.distributeCostCopy;
        this.allocationDefaults = this.allocationDefaultsCopy;
        this.defaultOption = this.defaultOptionCopy;
        this.expectedLife = this.expectedLifeCopy;
        this.agileEffort = this.agileEffortCopy;
        this.softwareBeingUsed = this.softwareBeingUsedCopy;
        this.vendorName = this.vendorNameCopy;
        this.softwareName = this.softwareNameCopy;
        this.inServiceYear = this.inServiceYearCopy;
        this.softwareProjectOverview = this.softwareProjectOverviewCopy;
        this.dataConversionActivities = this.dataConversionActivitiesCopy;
        this.trainingCosts = this.trainingCostsCopy;
        this.associatedRetirement = this.associatedRetirementCopy;
        this.softwareToBeRetired = this.softwareToBeRetiredCopy;
        this.retiredInServiceDate = this.retiredInServiceDateCopy;
        this.maintenanceContracts = this.maintenanceContractsCopy;
        this.replacingInterfaces = this.replacingInterfacesCopy;
        this.howSoftwareReleased = this.howSoftwareReleasedCopy;
        this.perpetualLicenses = this.perpetualLicensesCopy;
        this.contractualRight = this.contractualRightCopy;
        this.significantPenalty = this.significantPenaltyCopy;
        this.isFeasible = this.isFeasibleCopy;
        this.serviceFees = this.serviceFeesCopy;
        this.useWithoutPaying = this.useWithoutPayingCopy;
        this.department = JSON.parse(JSON.stringify(this.departmentCopy));
        this.buildingInfo = JSON.parse(JSON.stringify(this.buildingInfoCopy));
        this.releaseDetails = JSON.parse(JSON.stringify(this.releaseDetailsCopy));
        this.allocations = JSON.parse(JSON.stringify(this.allocationsCopy));
        this.buildings = JSON.parse(JSON.stringify(this.buildingsCopy));
        this.laborDetails = JSON.parse(JSON.stringify(this.laborDetailsCopy));
        this.contingencyDetails = JSON.parse(JSON.stringify(this.contingencyDetailsCopy));
        this.additionalComments = this.additionalCommentsCopy;
        this.files = this.filesCopy;
        this.doaAmounts = JSON.parse(JSON.stringify(this.doaAmountsCopy));
    }
    saveForm(projectSetupform, projectEstimateForm) {
        if (this.getFormSnapshot() === this.editSnapshot) {
            this.toggleEditFormMode();
            return;
        }
        this.showErrorsDisclaimer = false;
        projectSetupform.form.markAllAsTouched();
        projectEstimateForm.form.markAllAsTouched();
        if (!this.isProjectSetupFormValid(projectSetupform))
            return;
        if (!this.isProjectEstimateFormValid(projectEstimateForm))
            return;
        this.passDataFromCopyToOriginal();
        this.generateProjectIDs();
        this.toggleEditFormMode();
        this.allocationTotal();
        const saveInterval = setInterval(() => {
            if (this.itProjects && this.itProjects.length > 0 && this.assetAndMajorLocationFullyLoaded()) {
                clearInterval(saveInterval);
                this.saveItSparData(true);
            }
        }, 500);
    }
    cancelEdit() {
        this.toggleEditFormMode();
        this.projectNameCopy = this.projectName;
        this.omOnlyCopy = this.omOnly;
        this.relatedWorkCopy = this.relatedWork;
        this.hardwareOrSoftwareCopy = this.hardwareOrSoftware;
        this.itProjectClassificationCopy = JSON.parse(JSON.stringify(this.itProjectClassification));
        this.estimatedStartDateCopy = this.estimatedStartDate;
        this.estimatedInServiceDateCopy = this.estimatedInServiceDate;
        this.projectScopeDescriptionCopy = this.projectScopeDescription;
        this.primaryContactCopy = this.primaryContact;
        this.itSponsorCopy = this.itSponsor;
        this.purchasingWarrantiesCopy = this.purchasingWarranties;
        this.projectConsistsOfCopy = this.projectConsistsOf;
        this.projectConsistsOfCheckboxesCopy = this.projectConsistsOfCheckboxes;
        this.expectedLifeCopy = this.expectedLife;
        this.agileEffortCopy = this.agileEffort;
        this.softwareBeingUsedCopy = this.softwareBeingUsed;
        this.vendorNameCopy = this.vendorName;
        this.softwareNameCopy = this.softwareName;
        this.inServiceYearCopy = this.inServiceYear;
        this.softwareProjectOverviewCopy = this.softwareProjectOverview;
        this.dataConversionActivitiesCopy = this.dataConversionActivities;
        this.trainingCostsCopy = this.trainingCosts;
        this.associatedRetirementCopy = this.associatedRetirement;
        this.softwareToBeRetiredCopy = this.softwareToBeRetired;
        this.retiredInServiceDateCopy = this.retiredInServiceDate;
        this.maintenanceContractsCopy = this.maintenanceContracts;
        this.replacingInterfacesCopy = this.replacingInterfaces;
        this.howSoftwareReleasedCopy = this.howSoftwareReleased;
        this.perpetualLicensesCopy = this.perpetualLicenses;
        this.contractualRightCopy = this.contractualRight;
        this.significantPenaltyCopy = this.significantPenalty;
        this.isFeasibleCopy = this.isFeasible;
        this.serviceFeesCopy = this.serviceFees;
        this.useWithoutPayingCopy = this.useWithoutPaying;
        this.departmentCopy = JSON.parse(JSON.stringify(this.department));
        this.buildingInfoCopy = JSON.parse(JSON.stringify(this.buildingInfo));
        this.releaseDetailsCopy = JSON.parse(JSON.stringify(this.releaseDetails));
        this.allocationsCopy = JSON.parse(JSON.stringify(this.allocations));
        this.buildingsCopy = JSON.parse(JSON.stringify(this.buildings));
        this.laborDetailsCopy = JSON.parse(JSON.stringify(this.laborDetails));
        this.workDescriptions = [];
        for (let i = 0; i < this.laborDetails.length; i++) {
            this.workDescriptions.push(this.laborDetails[i].workTask.workDescriptions);
        }
        this.contingencyDetailsCopy = JSON.parse(JSON.stringify(this.contingencyDetails));
        this.additionalCommentsCopy = this.additionalComments;
        this.filesCopy = this.files;
        this.doaAmountsCopy = JSON.parse(JSON.stringify(this.doaAmounts));
        this.approverList = JSON.parse(JSON.stringify(this.approverListBackup || []));
    }
    base64ImageToBlob(str) {
        // extract content type and base64 payload from original string
        let pos = str.indexOf(";base64,");
        let type = str.substring(5, pos);
        let b64 = str.substr(pos + 8);
        // decode base64
        let imageContent = atob(b64);
        // create an ArrayBuffer and a view (as unsigned 8-bit)
        let buffer = new ArrayBuffer(imageContent.length);
        let view = new Uint8Array(buffer);
        // fill the view, using the decoded base64
        for (let n = 0; n < imageContent.length; n++) {
            view[n] = imageContent.charCodeAt(n);
        }
        // convert ArrayBuffer to Blob
        let blob = new Blob([buffer], { type: type });
        return blob;
    }
    downloadFile(index) {
        if (!this.editFormMode) {
            let data = {
                fileName: this.itSparGuid
                    .concat("/")
                    .concat(this.files[index].fileName),
                contentType: this.files[index].contentType,
                method: "get_object",
            };
            this.dataService.getPresignedURL(data).subscribe((result) => {
                let presignedUrl = JSON.parse(result).presigned_url;
                this.http
                    .get(presignedUrl, {
                    responseType: "blob",
                })
                    .subscribe((result) => {
                    let fileURL = URL.createObjectURL(result);
                    let downloadLink = document.createElement("a");
                    downloadLink.href = fileURL;
                    downloadLink.download = this.files[index].fileName;
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                });
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Get Presigned URL Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Get Presigned URL Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            });
        }
        else {
            let data = {
                fileName: this.itSparGuid
                    .concat("/")
                    .concat(this.filesCopy[index].fileName),
                contentType: this.filesCopy[index].contentType,
                method: "get_object",
            };
            this.dataService.getPresignedURL(data).subscribe((result) => {
                let presignedUrl = JSON.parse(result).presigned_url;
                this.http
                    .get(presignedUrl, {
                    responseType: "blob",
                })
                    .subscribe((result) => {
                    let fileURL = URL.createObjectURL(result);
                    let downloadLink = document.createElement("a");
                    downloadLink.href = fileURL;
                    downloadLink.download = this.filesCopy[index].fileName;
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                });
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Get Presigned URL Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Get Presigned URL Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            });
        }
    }
    contingencyTotal() {
        let contingencyTotal = 0;
        if (!this.editFormMode) {
            for (let i = 0; i < this.contingencyDetails.length; i++) {
                contingencyTotal += Number(this.contingencyDetails[i].totalCosts || 0);
            }
        }
        else {
            for (let i = 0; i < this.contingencyDetailsCopy.length; i++) {
                contingencyTotal += Number(this.contingencyDetailsCopy[i].totalCosts || 0);
            }
        }
        return Math.round(contingencyTotal);
    }
    laborTotal() {
        let laborTotal = 0;
        if (!this.editFormMode) {
            for (let i = 0; i < this.laborDetails.length; i++) {
                laborTotal += Number(this.laborDetails[i].totalCosts || 0);
            }
        }
        else {
            for (let i = 0; i < this.laborDetailsCopy.length; i++) {
                laborTotal += Number(this.laborDetailsCopy[i].totalCosts || 0);
            }
        }
        return Math.round(laborTotal);
    }
    buildingTotal() {
        let buildingTotal = 0;
        if (!this.editFormMode) {
            for (let i = 0; i < this.buildings.length; i++) {
                for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
                    buildingTotal += Number(this.buildings[i].materialEstimates[j].totalCosts);
                }
            }
        }
        else {
            for (let i = 0; i < this.buildingsCopy.length; i++) {
                for (let j = 0; j < this.buildingsCopy[i].materialEstimates.length; j++) {
                    buildingTotal += Number(this.buildingsCopy[i].materialEstimates[j].totalCosts);
                }
            }
        }
        return Math.round(buildingTotal);
    }
    isVendorHosted() {
        if (this.editFormMode) {
            return this.projectConsistsOfCopy.includes("Purchase - Vendor Hosted/Leased, Cloud Computing, or SaaS");
        }
        else {
            return this.projectConsistsOf.includes("Purchase - Vendor Hosted/Leased, Cloud Computing, or SaaS");
        }
    }
    stateDisabled(allocation) {
        if (!this.editFormMode) {
            if (!this.buildingInfo || this.buildingInfo.BuildingName !== "IT POP") {
                return true;
            }
            return !allocation.state;
        }
        else {
            if (!this.buildingInfoCopy ||
                this.buildingInfoCopy.BuildingName !== "IT POP")
                return true;
            return allocation.stateOptions.length === 0;
        }
    }
    isRepeatedOperatingUnit(index) {
        for (let i = 0; i < this.allocationsCopy.length; i++) {
            if (((this.allocationsCopy[index].businessUnitValue ===
                this.allocationsCopy[i].businessUnitValue &&
                this.allocationsCopy[index].businessUnitValue !== "20048" &&
                this.allocationsCopy[index].businessUnitValue !== "50125") ||
                (this.allocationsCopy[index].businessUnitValue ===
                    this.allocationsCopy[i].businessUnitValue &&
                    (this.allocationsCopy[index].businessUnitValue === "20048" ||
                        this.allocationsCopy[index].businessUnitValue === "50125") &&
                    this.allocationsCopy[index].operatingUnit.OPERATING_UNIT ===
                        this.allocationsCopy[i].operatingUnit.OPERATING_UNIT)) &&
                i < index) {
                return true;
            }
        }
        return false;
    }
    allocationTotal() {
        let total = 0;
        if (!this.editFormMode) {
            if (!this.allocations)
                return;
            for (let i = 0; i < this.allocations.length; i++) {
                total += this.allocations[i].percentage;
            }
        }
        else {
            if (!this.allocationsCopy)
                return;
            for (let i = 0; i < this.allocationsCopy.length; i++) {
                total += this.allocationsCopy[i].percentage;
            }
        }
        this.allocationTotalValue = Number(total.toPrecision(6));
    }
    internalOM() {
        let internalOM = 0;
        if (!this.editFormMode) {
            for (let i = 0; i < this.laborDetails.length; i++) {
                if (this.laborDetails[i].workTask &&
                    (this.laborDetails[i].workTask.workTask === "Labor-O&M" ||
                        this.laborDetails[i].workTask.workTask === "Hardware-O&M" ||
                        this.laborDetails[i].workTask.workTask === "Software-O&M")) {
                    if (this.laborDetails[i].chargeType === "Internal") {
                        internalOM += Number(this.laborDetails[i].totalCosts || 0);
                    }
                }
            }
        }
        else {
            for (let i = 0; i < this.laborDetailsCopy.length; i++) {
                if (this.laborDetailsCopy[i].workTask &&
                    (this.laborDetailsCopy[i].workTask.workTask === "Labor-O&M" ||
                        this.laborDetailsCopy[i].workTask.workTask === "Hardware-O&M" ||
                        this.laborDetailsCopy[i].workTask.workTask === "Software-O&M")) {
                    if (this.laborDetailsCopy[i].chargeType === "Internal") {
                        internalOM += Number(this.laborDetailsCopy[i].totalCosts || 0);
                    }
                }
            }
        }
        return Math.round(internalOM);
    }
    externalOM() {
        let externalOM = 0;
        if (!this.editFormMode) {
            for (let i = 0; i < this.laborDetails.length; i++) {
                if (this.laborDetails[i].workTask &&
                    (this.laborDetails[i].workTask.workTask === "Labor-O&M" ||
                        this.laborDetails[i].workTask.workTask === "Hardware-O&M" ||
                        this.laborDetails[i].workTask.workTask === "Software-O&M")) {
                    if (this.laborDetails[i].chargeType === "External") {
                        externalOM += Number(this.laborDetails[i].totalCosts || 0);
                    }
                }
            }
        }
        else {
            for (let i = 0; i < this.laborDetailsCopy.length; i++) {
                if (this.laborDetailsCopy[i].workTask &&
                    (this.laborDetailsCopy[i].workTask.workTask === "Labor-O&M" ||
                        this.laborDetailsCopy[i].workTask.workTask === "Hardware-O&M" ||
                        this.laborDetailsCopy[i].workTask.workTask === "Software-O&M")) {
                    if (this.laborDetailsCopy[i].chargeType === "External") {
                        externalOM += Number(this.laborDetailsCopy[i].totalCosts || 0);
                    }
                }
            }
        }
        return Math.round(externalOM);
    }
    materialOM() {
        let materialOM = 0;
        if (!this.editFormMode) {
            for (let i = 0; i < this.buildings.length; i++) {
                for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
                    if (this.buildings[i].materialEstimates[j].cost === "O&M") {
                        materialOM += this.buildings[i].materialEstimates[j].totalCosts;
                    }
                }
            }
        }
        else {
            for (let i = 0; i < this.buildingsCopy.length; i++) {
                for (let j = 0; j < this.buildingsCopy[i].materialEstimates.length; j++) {
                    if (this.buildingsCopy[i].materialEstimates[j].cost === "O&M") {
                        materialOM += this.buildingsCopy[i].materialEstimates[j].totalCosts;
                    }
                }
            }
        }
        return Math.round(materialOM);
    }
    contingencyOM() {
        let contingencyOM = 0;
        if (!this.editFormMode) {
            for (let i = 0; i < this.contingencyDetails.length; i++) {
                if (this.contingencyDetails[i].cost === "Contingency-O&M") {
                    contingencyOM += Number(this.contingencyDetails[i].totalCosts || 0);
                }
            }
        }
        else {
            for (let i = 0; i < this.contingencyDetailsCopy.length; i++) {
                if (this.contingencyDetailsCopy[i].cost === "Contingency-O&M") {
                    contingencyOM += Number(this.contingencyDetailsCopy[i].totalCosts || 0);
                }
            }
        }
        return Math.round(contingencyOM);
    }
    otherOM() {
        let otherOM = 0;
        if (!this.editFormMode) {
            for (let i = 0; i < this.contingencyDetails.length; i++) {
                if (this.contingencyDetails[i].cost === "Other-O&M") {
                    otherOM += Number(this.contingencyDetails[i].totalCosts || 0);
                }
            }
        }
        else {
            for (let i = 0; i < this.contingencyDetailsCopy.length; i++) {
                if (this.contingencyDetailsCopy[i].cost === "Other-O&M") {
                    otherOM += Number(this.contingencyDetailsCopy[i].totalCosts || 0);
                }
            }
        }
        return Math.round(otherOM);
    }
    subtotalOM() {
        return (this.internalOM() +
            this.externalOM() +
            this.materialOM() +
            this.contingencyOM() +
            this.otherOM());
    }
    subtotalOMThisRequest() {
        return this.subtotalOM() - this.previousOMSubtotal;
    }
    internalCapital(isAFUDC) {
        let internalCapital = 0;
        if (!this.editFormMode) {
            for (let i = 0; i < this.laborDetails.length; i++) {
                if ((this.laborDetails[i].workTask &&
                    this.laborDetails[i].workTask.workTask === "Hardware-CAP") ||
                    (this.laborDetails[i].workTask &&
                        this.laborDetails[i].workTask.workTask === "Hardware-Removal" &&
                        !isAFUDC) ||
                    (this.laborDetails[i].workTask &&
                        this.laborDetails[i].workTask.workTask === "Software-CAP")) {
                    if (this.laborDetails[i].chargeType === "Internal") {
                        internalCapital += Number(this.laborDetails[i].totalCosts || 0);
                    }
                }
            }
        }
        else {
            for (let i = 0; i < this.laborDetailsCopy.length; i++) {
                if ((this.laborDetailsCopy[i].workTask &&
                    this.laborDetailsCopy[i].workTask.workTask === "Hardware-CAP") ||
                    (this.laborDetailsCopy[i].workTask &&
                        this.laborDetailsCopy[i].workTask.workTask === "Hardware-Removal" &&
                        !isAFUDC) ||
                    (this.laborDetailsCopy[i].workTask &&
                        this.laborDetailsCopy[i].workTask.workTask === "Software-CAP")) {
                    if (this.laborDetailsCopy[i].chargeType === "Internal") {
                        internalCapital += Number(this.laborDetailsCopy[i].totalCosts || 0);
                    }
                }
            }
        }
        return Math.round(internalCapital);
    }
    externalCapital(isAFUDC) {
        let externalCapital = 0;
        if (!this.editFormMode) {
            for (let i = 0; i < this.laborDetails.length; i++) {
                if ((this.laborDetails[i].workTask &&
                    this.laborDetails[i].workTask.workTask === "Hardware-CAP") ||
                    (this.laborDetails[i].workTask &&
                        this.laborDetails[i].workTask.workTask === "Hardware-Removal" &&
                        !isAFUDC) ||
                    (this.laborDetails[i].workTask &&
                        this.laborDetails[i].workTask.workTask === "Software-CAP")) {
                    if (this.laborDetails[i].chargeType === "External") {
                        externalCapital += Number(this.laborDetails[i].totalCosts || 0);
                    }
                }
            }
        }
        else {
            for (let i = 0; i < this.laborDetailsCopy.length; i++) {
                if ((this.laborDetailsCopy[i].workTask &&
                    this.laborDetailsCopy[i].workTask.workTask === "Hardware-CAP") ||
                    (this.laborDetailsCopy[i].workTask &&
                        this.laborDetailsCopy[i].workTask.workTask === "Hardware-Removal" &&
                        !isAFUDC) ||
                    (this.laborDetailsCopy[i].workTask &&
                        this.laborDetailsCopy[i].workTask.workTask === "Software-CAP")) {
                    if (this.laborDetailsCopy[i].chargeType === "External") {
                        externalCapital += Number(this.laborDetailsCopy[i].totalCosts || 0);
                    }
                }
            }
        }
        return Math.round(externalCapital);
    }
    materialCapital() {
        let materialCapital = 0;
        if (!this.editFormMode) {
            for (let i = 0; i < this.buildings.length; i++) {
                for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
                    if (this.buildings[i].materialEstimates[j].cost === "CAP") {
                        materialCapital += Number(this.buildings[i].materialEstimates[j].totalCosts);
                    }
                }
            }
        }
        else {
            for (let i = 0; i < this.buildingsCopy.length; i++) {
                for (let j = 0; j < this.buildingsCopy[i].materialEstimates.length; j++) {
                    if (this.buildingsCopy[i].materialEstimates[j].cost === "CAP") {
                        materialCapital += Number(this.buildingsCopy[i].materialEstimates[j].totalCosts);
                    }
                }
            }
        }
        return Math.round(materialCapital);
    }
    contingencyCapital(isAFUDC) {
        let contingencyCapital = 0;
        if (!this.editFormMode) {
            for (let i = 0; i < this.contingencyDetails.length; i++) {
                if (this.contingencyDetails[i].cost === "Contingency-CAP" ||
                    (this.contingencyDetails[i].cost === "Contingency-Removal" &&
                        !isAFUDC)) {
                    contingencyCapital += Number(this.contingencyDetails[i].totalCosts || 0);
                }
            }
        }
        else {
            for (let i = 0; i < this.contingencyDetailsCopy.length; i++) {
                if (this.contingencyDetailsCopy[i].cost === "Contingency-CAP" ||
                    (this.contingencyDetailsCopy[i].cost === "Contingency-Removal" &&
                        !isAFUDC)) {
                    contingencyCapital += Number(this.contingencyDetailsCopy[i].totalCosts || 0);
                }
            }
        }
        return Math.round(contingencyCapital);
    }
    otherCapital(isAFUDC) {
        let otherCapital = 0;
        if (!this.editFormMode) {
            for (let i = 0; i < this.contingencyDetails.length; i++) {
                if (this.contingencyDetails[i].cost === "Other-CAP" ||
                    (this.contingencyDetails[i].cost === "Other-Removal" && !isAFUDC)) {
                    otherCapital += Number(this.contingencyDetails[i].totalCosts || 0);
                }
            }
        }
        else {
            for (let i = 0; i < this.contingencyDetailsCopy.length; i++) {
                if (this.contingencyDetailsCopy[i].cost === "Other-CAP" ||
                    (this.contingencyDetailsCopy[i].cost === "Other-Removal" && !isAFUDC)) {
                    otherCapital += Number(this.contingencyDetailsCopy[i].totalCosts || 0);
                }
            }
        }
        return Math.round(otherCapital);
    }
    subtotalCapital(isAFUDC) {
        return (this.internalCapital(isAFUDC) +
            this.externalCapital(isAFUDC) +
            this.materialCapital() +
            this.contingencyCapital(isAFUDC) +
            this.otherCapital(isAFUDC));
    }
    subtotalCapitalThisRequest() {
        return this.subtotalCapital() - this.previousCapitalSubtotal;
    }
    estimatedAFUDC() {
        let percentageTotal = 0;
        if (!this.editFormMode) {
            for (let i = 0; i < this.allocations.length; i++) {
                if (this.allocations[i].businessUnitValue &&
                    !this.allocations[i].businessUnitValue.startsWith("502")) {
                    percentageTotal += this.allocations[i].percentage;
                }
            }
            percentageTotal = percentageTotal / 100;
            let diffInDays = Math.floor((+this.estimatedInServiceDate - +this.estimatedStartDate) /
                (1000 * 60 * 60 * 24));
            return Math.round((diffInDays / 360) *
                0.065 *
                ((this.subtotalCapital(true) * percentageTotal) / 2));
        }
        else {
            for (let i = 0; i < this.allocationsCopy.length; i++) {
                if (this.allocationsCopy[i].businessUnitValue &&
                    !this.allocationsCopy[i].businessUnitValue.startsWith("502")) {
                    percentageTotal += this.allocationsCopy[i].percentage;
                }
            }
            percentageTotal = percentageTotal / 100;
            let diffInDays = Math.floor((+this.estimatedInServiceDateCopy - +this.estimatedStartDateCopy) /
                (1000 * 60 * 60 * 24));
            return Math.round((diffInDays / 360) *
                0.065 *
                ((this.subtotalCapital(true) * percentageTotal) / 2));
        }
    }
    calculateAFUDC(itProject) {
        if (itProject.businessUnit.startsWith("502")) {
            return 0;
        }
        let diffInDays = Math.floor((+this.estimatedInServiceDate - +this.estimatedStartDate) /
            (1000 * 60 * 60 * 24));
        let totalCapital = 0;
        for (let i = 0; i < itProject.itProjectEstimates.length; i++) {
            if (itProject.itProjectEstimates[i].estimateType.includes("CAP")) {
                totalCapital += itProject.itProjectEstimates[i].dollarAmount;
            }
        }
        return Math.round((diffInDays / 360) * 0.065 * (totalCapital / 2));
    }
    totalCapitalCost() {
        return this.subtotalCapital() + this.estimatedAFUDC();
    }
    totalProjectCost() {
        return this.totalCapitalCost() + this.subtotalOM();
    }
    isPACUser() {
        return (Array.isArray(this.userRoles) &&
            this.userRoles.includes("MMAPS_ETS_PAC_Users"));
    }
    isFormOwner() {
        return (this.userEmail &&
            this.formOwner.mail &&
            this.userEmail.toLowerCase() === this.formOwner.mail.toLowerCase());
    }
    loadHardOrSoftwareRelatedData() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield Promise.all([
                this.loadWorkTaskOptionsFile(),
                this.loadBuildingFile(),
                this.loadCostOptionsFile(),
                this.loadUOPOptionsFile(),
                this.loadContingencyCostOptionsFile(),
            ]);
        });
    }
    getItSparData(guid, revisionNumber) {
        let callBody;
        if (revisionNumber !== undefined) {
            callBody = {
                itSparGuid: guid,
                displayRevisionNumber: revisionNumber,
            };
        }
        else {
            callBody = {
                itSparGuid: guid,
            };
        }
        this.dataService.getItSparData(callBody, "ui").subscribe((result) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.currentRevisionData = result;
            this.revisionNumber = result.body.it_spar_revision_number;
            this.omOnly = result.body.omOnly;
            this.omOnlyCopy = result.body.omOnly;
            this.updateHardwareOrSoftwareOptions();
            this.relatedWork = result.body.relatedWork;
            this.relatedWorkCopy = result.body.relatedWork;
            this.hardwareOrSoftware = result.body.hardwareOrSoftware;
            this.hardwareOrSoftwareCopy = result.body.hardwareOrSoftware;
            this.hardwareOrSoftwarePrevious = result.body.hardwareOrSoftware;
            yield this.loadHardOrSoftwareRelatedData();
            this.patiProject = JSON.parse(result.body.patiId);
            if (this.patiProject) {
                this.displayPatiProject = this.patiProject.Project_ID.concat(" - ").concat(this.patiProject.Project_Name);
            }
            this.projectName = result.body.shortDescription;
            this.projectNameCopy = result.body.shortDescription;
            try {
                this.itProjectClassification = JSON.parse(result.body.etsProjectClassification);
                this.itProjectClassificationCopy = JSON.parse(result.body.etsProjectClassification);
            }
            catch (e) {
                this.itProjectClassification = {
                    it_proj_classification: result.body.etsProjectClassification,
                    ets_proj_classification: result.body.etsProjectClassification,
                };
            }
            let startDate = result.body.estimatedStartDate;
            if (startDate) {
                this.estimatedStartDate = new Date(startDate);
                this.estimatedStartDateCopy = new Date(startDate);
                this.estimatedStartDate.setDate(this.estimatedStartDate.getDate() + 1);
                this.estimatedStartDateCopy.setDate(this.estimatedStartDateCopy.getDate() + 1);
            }
            else {
                this.estimatedStartDate = null;
                this.estimatedStartDateCopy = null;
            }
            let inServiceDate = result.body.estimatedInServiceDate;
            if (inServiceDate) {
                this.estimatedInServiceDate = new Date(inServiceDate);
                this.estimatedInServiceDateCopy = new Date(inServiceDate);
                this.estimatedInServiceDate.setDate(this.estimatedInServiceDate.getDate() + 1);
                this.estimatedInServiceDateCopy.setDate(this.estimatedInServiceDateCopy.getDate() + 1);
            }
            else {
                this.estimatedInServiceDate = null;
                this.estimatedInServiceDateCopy = null;
            }
            this.projectScopeDescription = result.body.overviewAndScope;
            this.projectScopeDescriptionCopy = result.body.overviewAndScope;
            const primaryContactValue = result.body.primaryContact
                ? result.body.primaryContact
                : {
                    displayName: "",
                    givenName: "",
                    surname: "",
                    mail: "",
                    mailNickname: "",
                    jobTitle: "",
                };
            this.primaryContact = primaryContactValue;
            this.primaryContactCopy = primaryContactValue;
            this.primaryContactOptions = [primaryContactValue];
            if (this.primaryContact.givenName &&
                this.primaryContact.surname &&
                this.primaryContact.jobTitle) {
                this.displayPrimaryContact = this.primaryContact.givenName
                    .concat(" ")
                    .concat(this.primaryContact.surname)
                    .concat(" (")
                    .concat(this.primaryContact.mail)
                    .concat("), ")
                    .concat(this.primaryContact.jobTitle);
            }
            else if (this.primaryContact.givenName &&
                this.primaryContact.surname &&
                !this.primaryContact.jobTitle) {
                this.displayPrimaryContact = this.primaryContact.givenName
                    .concat(" ")
                    .concat(this.primaryContact.surname)
                    .concat(" (")
                    .concat(this.primaryContact.mail)
                    .concat(")");
            }
            else if (!(this.primaryContact.givenName && this.primaryContact.surname) &&
                this.primaryContact.jobTitle) {
                this.displayPrimaryContact = this.primaryContact.displayName
                    .concat(" (")
                    .concat(this.primaryContact.mail)
                    .concat("), ")
                    .concat(this.primaryContact.jobTitle);
            }
            else if ((!(this.primaryContact.givenName && this.primaryContact.surname) &&
                !this.primaryContact.jobTitle) && this.primaryContact.displayName) {
                this.displayPrimaryContact = this.primaryContact.displayName
                    .concat(" (")
                    .concat(this.primaryContact.mail)
                    .concat(")");
            }
            else {
                this.displayPrimaryContact = "";
            }
            const itSponsorValue = result.body.itSponsor
                ? result.body.itSponsor
                : {
                    displayName: "",
                    givenName: "",
                    surname: "",
                    mail: "",
                    mailNickname: "",
                    jobTitle: "",
                    doaAmount: "",
                };
            this.itSponsor = itSponsorValue;
            this.itSponsorCopy = itSponsorValue;
            this.itSponsorOptions = [itSponsorValue];
            this.doaAmounts = [Number(itSponsorValue.doaAmount)];
            this.doaAmountsCopy = [Number(itSponsorValue.doaAmount)];
            this.doaLookupFailed = [false];
            this.doaLookupLoading = [false];
            if (this.itSponsor.givenName &&
                this.itSponsor.surname &&
                this.itSponsor.jobTitle) {
                this.displayItSponsor = this.itSponsor.givenName
                    .concat(" ")
                    .concat(this.itSponsor.surname)
                    .concat(" (")
                    .concat(this.itSponsor.mail)
                    .concat("), ")
                    .concat(this.itSponsor.jobTitle);
            }
            else if (this.itSponsor.givenName &&
                this.itSponsor.surname &&
                !this.itSponsor.jobTitle) {
                this.displayItSponsor = this.itSponsor.givenName
                    .concat(" ")
                    .concat(this.itSponsor.surname)
                    .concat(" (")
                    .concat(this.itSponsor.mail)
                    .concat(")");
            }
            else if (!(this.itSponsor.givenName && this.itSponsor.surname) &&
                this.itSponsor.jobTitle) {
                this.displayItSponsor = this.itSponsor.displayName
                    .concat(" (")
                    .concat(this.itSponsor.mail)
                    .concat("), ")
                    .concat(this.itSponsor.jobTitle);
            }
            else if ((!(this.itSponsor.givenName && this.itSponsor.surname) &&
                !this.itSponsor.jobTitle) && this.itSponsor.displayName) {
                this.displayItSponsor = this.itSponsor.displayName
                    .concat(" (")
                    .concat(this.itSponsor.mail)
                    .concat(")");
            }
            else {
                this.displayItSponsor = "";
            }
            this.purchasingWarranties = result.body.purchasingWarranties;
            this.purchasingWarrantiesCopy = result.body.purchasingWarranties;
            this.projectConsistsOf = result.body.projectConsistsOf;
            this.projectConsistsOfCopy = result.body.projectConsistsOf;
            this.projectConsistsOfCheckboxes = [];
            this.projectConsistsOfCheckboxesCopy = [];
            for (let i = 0; i < this.projectConsistsOfOptions.length; i++) {
                if (this.projectConsistsOf.includes(this.projectConsistsOfOptions[i])) {
                    this.projectConsistsOfCheckboxes.push(true);
                    this.projectConsistsOfCheckboxesCopy.push(true);
                }
                else {
                    this.projectConsistsOfCheckboxes.push(false);
                    this.projectConsistsOfCheckboxesCopy.push(false);
                }
            }
            let expectedLifeCheck = result.body.expectedLife;
            if (expectedLifeCheck) {
                this.expectedLife = Number(expectedLifeCheck);
                this.expectedLifeCopy = Number(expectedLifeCheck);
            }
            else {
                this.expectedLife = null;
                this.expectedLifeCopy = null;
            }
            this.agileEffort = result.body.agileEffort;
            this.agileEffortCopy = result.body.agileEffort;
            this.softwareBeingUsed = result.body.softwareBeingUsed;
            this.softwareBeingUsedCopy = result.body.softwareBeingUsed;
            this.vendorName = result.body.vendorName;
            this.vendorNameCopy = result.body.vendorName;
            this.softwareName = result.body.softwareName;
            this.softwareNameCopy = result.body.softwareName;
            this.inServiceYear = result.body.inServiceYear;
            this.inServiceYearCopy = result.body.inServiceYear;
            this.softwareProjectOverview = result.body.softwareProjectOverview;
            this.softwareProjectOverviewCopy = result.body.softwareProjectOverview;
            this.dataConversionActivities = result.body.dataConversionActivities;
            this.dataConversionActivitiesCopy = result.body.dataConversionActivities;
            this.trainingCosts = result.body.trainingCosts;
            this.trainingCostsCopy = result.body.trainingCosts;
            this.associatedRetirement = result.body.associatedRetirement;
            this.associatedRetirementCopy = result.body.associatedRetirement;
            this.softwareToBeRetired = result.body.softwareToBeRetired;
            this.softwareToBeRetiredCopy = result.body.softwareToBeRetired;
            this.retiredInServiceDate = result.body.retiredInServiceDate;
            this.retiredInServiceDateCopy = result.body.retiredInServiceDate;
            this.maintenanceContracts = result.body.maintenanceContracts;
            this.maintenanceContractsCopy = result.body.maintenanceContracts;
            this.replacingInterfaces = result.body.replacingInterfaces;
            this.replacingInterfacesCopy = result.body.replacingInterfaces;
            this.howSoftwareReleased = result.body.howSoftwareReleased;
            this.howSoftwareReleasedCopy = result.body.howSoftwareReleased;
            this.perpetualLicenses = result.body.perpetualLicenses;
            this.perpetualLicensesCopy = result.body.perpetualLicenses;
            this.contractualRight = result.body.contractualRight;
            this.contractualRightCopy = result.body.contractualRight;
            this.significantPenalty = result.body.significantPenalty;
            this.significantPenaltyCopy = result.body.significantPenalty;
            this.isFeasible = result.body.isFeasible;
            this.isFeasibleCopy = result.body.isFeasible;
            this.serviceFees = result.body.serviceFees;
            this.serviceFeesCopy = result.body.serviceFees;
            this.useWithoutPaying = result.body.useWithoutPaying;
            this.useWithoutPayingCopy = result.body.useWithoutPaying;
            let buildingInfoCheck = result.body.buildingInfo;
            if (buildingInfoCheck) {
                this.buildingInfo = JSON.parse(buildingInfoCheck);
                this.buildingInfoCopy = JSON.parse(buildingInfoCheck);
            }
            else {
                this.buildingInfo = null;
                this.buildingInfoCopy = null;
            }
            let releaseDetailsCheck = result.body.releaseDetails;
            if (releaseDetailsCheck) {
                this.releaseDetails = result.body.releaseDetails;
                this.releaseDetailsCopy = JSON.parse(JSON.stringify(result.body.releaseDetails));
                for (let i = 0; i < this.releaseDetails.length; i++) {
                    for (let j = 0; j < this.releaseDetails[i].capabilityDetails.length; j++) {
                        this.releaseDetails[i].capabilityDetails[j].capabilities =
                            result.body.releaseDetails[i].capabilityDetails[j].capability;
                        this.releaseDetailsCopy[i].capabilityDetails[j].capabilities =
                            result.body.releaseDetails[i].capabilityDetails[j].capability;
                    }
                }
            }
            else {
                this.releaseDetails = [new ReleaseDetail()];
                this.releaseDetailsCopy = [new ReleaseDetail()];
            }
            let distributeCostCheck = result.body.distributeCost;
            if (distributeCostCheck) {
                this.distributeCost = JSON.parse(result.body.distributeCost);
                this.distributeCostCopy = JSON.parse(result.body.distributeCost);
            }
            else {
                this.distributeCost = "";
                this.distributeCostCopy = "";
            }
            let defaultOptionCheck = result.body.defaultOption;
            if (defaultOptionCheck) {
                this.defaultOption = JSON.parse(result.body.defaultOption);
                this.defaultOptionCopy = JSON.parse(result.body.defaultOption);
            }
            else {
                this.defaultOption = "";
                this.defaultOptionCopy = "";
            }
            let allocationsCheck = result.body.allocations;
            if (allocationsCheck) {
                this.allocations = allocationsCheck;
                this.allocationsCopy = JSON.parse(JSON.stringify(allocationsCheck));
                this.operatingUnitControl = [];
                this.stateControl = [];
                this.fundingProjectControl = [];
                this.filteredFundingProjectOptions = [];
                for (let i = 0; i < this.allocations.length; i++) {
                    this.operatingUnitControl.push(new FormControl());
                    this.stateControl.push(new FormControl());
                    this.fundingProjectControl.push(new FormControl());
                    this.allocations[i].fundingProjectID = JSON.parse(result.body.allocations[i].fundingProjectId);
                    this.allocationsCopy[i].fundingProjectID = JSON.parse(result.body.allocations[i].fundingProjectId);
                    this.allocations[i].operatingUnit = parseOperatingUnit(result.body.allocations[i].operatingUnit, result.body.allocations[i].businessUnit);
                    this.allocationsCopy[i].operatingUnit = parseOperatingUnit(result.body.allocations[i].operatingUnit, result.body.allocations[i].businessUnit);
                    if (this.allocations[i].operatingUnit) {
                        this.allocations[i].displayOperatingUnit = this.allocations[i].operatingUnit.OPERATING_UNIT.concat(" - ").concat(this.allocations[i].operatingUnit.DESCR);
                        this.allocationsCopy[i].displayOperatingUnit = this.allocationsCopy[i].operatingUnit.OPERATING_UNIT.concat(" - ").concat(this.allocationsCopy[i].operatingUnit.DESCR);
                        this.allocations[i].businessUnitValue =
                            this.allocations[i].operatingUnit.BUSINESS_UNIT;
                        this.allocationsCopy[i].businessUnitValue =
                            this.allocations[i].operatingUnit.BUSINESS_UNIT;
                        this.setAllocationSetId(this.allocations[i], this.allocations[i].operatingUnit.BUSINESS_UNIT);
                    }
                    this.allocations[i].percentage = Number(result.body.allocations[i].percentage);
                    this.allocationsCopy[i].percentage = Number(result.body.allocations[i].percentage);
                    this.filteredFundingProjectOptions.push(new Observable());
                    this.filteredFundingProjectOptions[i] = this.fundingProjectControl[i].valueChanges.pipe(startWith(""), map((value) => typeof value === "string" ? value : this.lastFilter), map((filter) => this.fundingProjectFilter(filter, this.allocations[i])));
                    let matchFound = false;
                    for (let j = 0; j < this.buForStateOptions.length && !matchFound; j++) {
                        if (this.allocations[i].operatingUnit.BUSINESS_UNIT ===
                            this.buForStateOptions[j]) {
                            matchFound = true;
                            this.allocations[i].stateOptions = ["NC", "SC", "NC & SC"];
                            this.allocationsCopy[i].stateOptions = ["NC", "SC", "NC & SC"];
                        }
                    }
                    if (!matchFound) {
                        this.allocations[i].stateOptions = [];
                        this.allocationsCopy[i].stateOptions = [];
                    }
                }
                this.allocationsCopy = JSON.parse(JSON.stringify(this.allocations));
                for (let i = 0; i < this.allocationsCopy.length; i++) {
                    if (this.allocationsCopy[i].operatingUnit) {
                        this.setAllocationSetId(this.allocationsCopy[i], this.allocationsCopy[i].operatingUnit.BUSINESS_UNIT);
                    }
                }
            }
            else {
                this.allocations = null;
                this.allocationsCopy = null;
                this.fundingProjectControl = [];
                this.operatingUnitControl = [];
                this.stateControl = [];
            }
            this.filteredOperatingUnitOptions = [];
            if (this.allocations) {
                for (let i = 0; i < this.allocations.length; i++) {
                    this.filteredOperatingUnitOptions.push(new Observable());
                    this.filteredOperatingUnitOptions[i] = this.operatingUnitControl[i].valueChanges.pipe(startWith(""), map((value) => (typeof value === "string" ? value : this.lastFilter)), map((filter) => this.operatingUnitFilter(filter)));
                }
            }
            this.allocationTotal();
            let departmentCheck = result.body.department;
            if (departmentCheck) {
                this.department = JSON.parse(departmentCheck);
                this.departmentCopy = JSON.parse(departmentCheck);
                this.allocationDefaults = this.department.defaults;
                this.allocationDefaultsCopy = this.department.defaults;
            }
            else {
                this.department = null;
                this.departmentCopy = null;
                this.allocationDefaults = [];
                this.allocationDefaultsCopy = [];
            }
            this.matchUpDepartment();
            let buildingsCheck = result.body.buildings;
            if (buildingsCheck) {
                this.buildings = buildingsCheck;
                this.buildingsCopy = JSON.parse(JSON.stringify(buildingsCheck));
                this.buildingControl = [];
                this.filteredBuildingOptions = [];
                for (let i = 0; i < this.buildings.length; i++) {
                    if (result.body.buildings[i].building) {
                        this.buildings[i].buildingName = JSON.parse(result.body.buildings[i].building);
                        this.buildingsCopy[i].buildingName = JSON.parse(result.body.buildings[i].building);
                    }
                    else {
                        this.buildings[i].buildingName = {
                            BuildingName: null,
                        };
                        this.buildingsCopy[i].buildingName = {
                            BuildingName: null,
                        };
                    }
                    this.buildingControl.push(new FormControl());
                    this.filteredBuildingOptions.push(this.buildingControl[i].valueChanges.pipe(startWith(""), map((value) => typeof value === "string" ? value : this.lastFilter), map((filter) => this.buildingInfoFilter(filter))));
                    for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
                        this.buildings[i].materialEstimates[j].unitOfPropertyDescription =
                            result.body.buildings[i].materialEstimates[j].uopDescription;
                        this.buildings[i].materialEstimates[j].unitOfPropertyDetails =
                            result.body.buildings[i].materialEstimates[j].details;
                        this.buildingsCopy[i].materialEstimates[j].unitOfPropertyDescription =
                            result.body.buildings[i].materialEstimates[j].uopDescription;
                        this.buildingsCopy[i].materialEstimates[j].unitOfPropertyDetails =
                            result.body.buildings[i].materialEstimates[j].details;
                        this.buildings[i].materialEstimates[j].totalCosts = Number(result.body.buildings[i].materialEstimates[j].totalCosts);
                        this.buildingsCopy[i].materialEstimates[j].totalCosts = Number(result.body.buildings[i].materialEstimates[j].totalCosts);
                    }
                }
            }
            else {
                this.buildings = null;
                this.buildingsCopy = null;
                this.buildingControl = [];
            }
            let laborDetailsCheck = result.body.laborDetails;
            this.workDescriptions = [];
            if (laborDetailsCheck) {
                this.laborDetails = laborDetailsCheck;
                this.laborDetailsCopy = JSON.parse(JSON.stringify(laborDetailsCheck));
                for (let i = 0; i < this.laborDetails.length; i++) {
                    const workTask = result.body.laborDetails[i].workTask;
                    let parsedWorkTask = workTask ? JSON.parse(workTask) : {};
                    if (parsedWorkTask &&
                        parsedWorkTask.workTask &&
                        typeof parsedWorkTask.workTask === "object" &&
                        typeof parsedWorkTask.workTask.workTask === "string") {
                        parsedWorkTask = parsedWorkTask.workTask;
                    }
                    this.laborDetails[i].workTask = parsedWorkTask;
                    this.laborDetailsCopy[i].workTask =
                        JSON.parse(JSON.stringify(parsedWorkTask));
                    if (workTask && result.body.laborDetails[i].workTask)
                        this.workDescriptions.push(result.body.laborDetails[i].workTask.workDescriptions);
                    this.laborDetails[i].totalCosts =
                        result.body.laborDetails[i].totalCosts;
                    this.laborDetailsCopy[i].totalCosts =
                        result.body.laborDetails[i].totalCosts;
                }
            }
            else {
                this.laborDetails = [];
                this.laborDetailsCopy = [];
            }
            let contingencyDetailsCheck = result.body.contingencyDetails;
            if (contingencyDetailsCheck) {
                this.contingencyDetails = contingencyDetailsCheck;
                this.contingencyDetailsCopy = contingencyDetailsCheck;
                for (let i = 0; i < this.contingencyDetails.length; i++) {
                    this.contingencyDetails[i].totalCosts =
                        result.body.contingencyDetails[i].totalCosts;
                }
            }
            else {
                this.contingencyDetails = [];
                this.contingencyDetailsCopy = [];
            }
            this.additionalComments = result.body.additionalComments;
            this.additionalCommentsCopy = result.body.additionalComments;
            let attachments = result.body.attachments;
            this.files = [];
            this.filesCopy = [];
            if (attachments) {
                for (let i = 0; i < attachments.length; i++) {
                    this.files.push(JSON.parse(attachments[i]));
                    this.filesCopy.push(JSON.parse(attachments[i]));
                }
            }
            let approversCheck = result.body.approvers;
            if (approversCheck) {
                this.approverList = approversCheck;
                for (let i = 0; i < this.approverList.length; i++) {
                    this.doaAmounts.push(Number(this.approverList[i].doaAmount));
                    this.doaAmountsCopy.push(Number(this.approverList[i].doaAmount));
                    this.doaLookupFailed.push(false);
                    this.doaLookupLoading.push(false);
                }
            }
            this.formStatus = result.body.formStatus;
            this.formActivity = result.body.formActivity;
            this.currentAssignment = result.body.currentAssignment;
            this.formOwner = result.body.formOwner;
            this.etsPacAssignment = result.body.etsPacAssignment;
            this.currentApprover = result.body.currentApprover;
            let tablesCheck = result.body.tables;
            if (tablesCheck) {
                this.tables = JSON.parse(result.body.tables);
            }
            else {
                this.tables = null;
            }
            let effectiveDate = result.body.effectiveDate;
            if (effectiveDate) {
                this.effectiveDate = new Date(effectiveDate);
                this.effectiveDate.setDate(this.effectiveDate.getDate() + 1);
            }
            else {
                this.effectiveDate = null;
            }
            this.formNumber = result.body.formNumber;
            this.displayRevisionNumber = Number(result.body.displayRevisionNumber);
            this.revisionExists = result.body.revisionExists;
            this.hasOpenRevisionDraft = !!result.body.hasOpenRevisionDraft;
            this.latestRevisionNumber = Number(result.body.latestRevisionNumber !== undefined &&
                result.body.latestRevisionNumber !== null
                ? result.body.latestRevisionNumber
                : this.displayRevisionNumber);
            // Canonicalize the URL: only add revisionNum when a revision exists (> 0).
            // guid-only URLs are the stable identity for the base/original form.
            const currentRevisionNumParam = this.route.snapshot.queryParamMap.get("revisionNum");
            if (this.displayRevisionNumber > 0 &&
                (currentRevisionNumParam === null || currentRevisionNumParam === "")) {
                this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: { revisionNum: this.displayRevisionNumber },
                    queryParamsHandling: "merge",
                    replaceUrl: true,
                });
            }
            if (result.body.previousCapitalSubtotal) {
                this.previousCapitalSubtotal = Number(result.body.previousCapitalSubtotal);
            }
            else {
                this.previousCapitalSubtotal = 0;
            }
            if (result.body.previousOMSubtotal) {
                this.previousOMSubtotal = Number(result.body.previousOMSubtotal);
            }
            else {
                this.previousOMSubtotal = 0;
            }
            if (!this.etsPacAssignment.mail &&
                this.formStatus === "ET&S PAC Review" &&
                this.isPACUser()) {
                this.saveItSparData(false, true);
            }
            if (!this.currentAssignment.mail &&
                this.formStatus === "Asset Accounting Review" &&
                this.isAssetUser()) {
                this.saveItSparData(false, false, false, true);
            }
            /*
          let extraBuildingsCheck = sessionStorage.getItem('extraBuildings');
          if (extraBuildingsCheck) {
            this.extraBuildings = JSON.parse(extraBuildingsCheck);
          }
          else {
            this.extraBuildings = [];
          }*/
            const storedItProjects = result.body.itProjects;
            if (storedItProjects) {
                this.itProjects = JSON.parse(storedItProjects);
                this.itProjects.forEach((project) => {
                    project.groupedEstimates = this.groupEstimatesByAssetLocation(project.itProjectEstimates);
                    project.totalProjectCost = this.calculateTotalProjectCost(project);
                });
            }
            else {
                this.generateProjectIDs();
            }
            // wait for asset and major location to fully loaded and then group estimates and calculate totals.
            const projectInterval = setInterval(() => {
                if (this.itProjects && this.itProjects.length > 0 && this.assetAndMajorLocationFullyLoaded()) {
                    clearInterval(projectInterval);
                    this.itProjects.forEach((project) => {
                        project.groupedEstimates = this.groupEstimatesByAssetLocation(project.itProjectEstimates);
                    });
                    // Calculate and assign total project cost for each project
                    this.itProjects.forEach((project) => {
                        project.totalProjectCost = this.calculateTotalProjectCost(project);
                    });
                }
            }, 500);
            if (this.etsPacAssignment.mail) {
                this.getUserLanIds();
            }
            this.getPACUsers();
            this.sparDataLoaded = true;
        }), (error) => {
            console.error("Error loading IT SPAR form data:", error);
            let errorType = "Unable to load form";
            let errorDescription = "Could not load the form data.";
            if (error && (error.status === 401 || error.status === 403)) {
                errorType = "Access denied";
                errorDescription = "You do not have access to view this form.";
            }
            else if (error && error.status === 404) {
                errorType = "Form not found";
                errorDescription = "The requested form could not be found.";
            }
            else if (error && error.error && error.error.message) {
                errorDescription = error.error.message;
            }
            this.dialog.open(ErrorDialogComponent, {
                data: {
                    errorType,
                    errorDescription,
                },
                disableClose: true,
            });
            this.sparDataLoaded = false;
            this.router.navigate(["/dashboard"]);
        });
    }
    setAllocationsAsTouched() {
        this.allocationsTouched = true;
    }
    isAssetUser() {
        for (let i = 0; i < this.assetAccounting.length; i++) {
            if (this.assetAccounting[i].mail &&
                this.userEmail &&
                this.assetAccounting[i].mail.toLowerCase() ===
                    this.userEmail.toLowerCase()) {
                return true;
            }
        }
        return false;
    }
    launchAssignmentDialog() {
        let dataStructure;
        if (!this.editFormMode) {
            dataStructure = {
                formOwner: this.formOwner,
                etsPacAssignment: this.etsPacAssignment,
                currentAssignment: this.currentAssignment,
                primaryContact: this.primaryContact,
                itSponsor: this.itSponsor,
            };
        }
        else {
            dataStructure = {
                formOwner: this.formOwner,
                etsPacAssignment: this.etsPacAssignment,
                currentAssignment: this.currentAssignment,
                primaryContact: this.primaryContactCopy,
                itSponsor: this.itSponsorCopy,
            };
        }
        let dialogRef = this.dialog.open(AssignmentDialogComponent, {
            data: dataStructure,
            disableClose: true,
        });
        dialogRef.componentInstance.onYes.subscribe((result) => {
            if (result &&
                result.currentAssignment &&
                (!result.currentAssignment.mail || !result.currentAssignment.mailNickname)) {
                this.dialog.open(ErrorDialogComponent, {
                    data: {
                        errorType: "Invalid assignment",
                        errorDescription: "Assigned To must be selected from search results before saving.",
                    },
                    disableClose: true,
                });
                return;
            }
            const primaryContactResult = result.primaryContact
                ? result.primaryContact
                : {
                    displayName: "",
                    givenName: "",
                    surname: "",
                    mail: "",
                    mailNickname: "",
                    jobTitle: "",
                };
            const itSponsorResult = result.itSponsor
                ? result.itSponsor
                : {
                    displayName: "",
                    givenName: "",
                    surname: "",
                    mail: "",
                    mailNickname: "",
                    jobTitle: "",
                    doaAmount: "",
                };
            this.primaryContact = primaryContactResult;
            this.primaryContactCopy = primaryContactResult;
            this.itSponsor = itSponsorResult;
            this.itSponsorCopy = itSponsorResult;
            this.etsPacAssignment = result.etsPacAssignment;
            this.currentAssignment = result.currentAssignment;
            this.formOwner = result.formOwner;
            this.getDOA(this.itSponsor.mailNickname, 0, false, true);
        });
    }
    launchApproverDialog(addNewRow = false) {
        let dataStructure;
        if (this.editFormMode) {
            dataStructure = {
                approverList: this.approverList,
                additionalApprovers: this.approverList,
                doaAmounts: this.doaAmountsCopy,
                addNewRow: addNewRow,
            };
        }
        else {
            dataStructure = {
                approverList: this.approverList,
                additionalApprovers: this.approverList,
                doaAmounts: this.doaAmounts,
                addNewRow: addNewRow,
            };
        }
        let dialogRef = this.dialog.open(ApproverDialogComponent, {
            data: dataStructure,
            disableClose: true,
            width: "71.875rem",
        });
        dialogRef.componentInstance.onYes.subscribe((result) => {
            // Drop any empty rows the user added but never filled in, keeping DOA amounts aligned
            const approverList = [];
            const doaAmounts = [result.doaAmounts[0]];
            for (let i = 0; i < result.approverList.length; i++) {
                const approver = result.approverList[i];
                if (approver && approver.mail) {
                    approverList.push(approver);
                    doaAmounts.push(result.doaAmounts[i + 1] || 0);
                }
            }
            this.approverList = approverList;
            this.doaLookupFailed = doaAmounts.map(() => false);
            this.doaLookupLoading = doaAmounts.map(() => false);
            if (this.editFormMode) {
                // While editing (e.g. a rejected form), keep changes local; they are persisted on SAVE FORM
                this.doaAmountsCopy = doaAmounts;
                return;
            }
            this.doaAmounts = doaAmounts;
            this.doaAmountsCopy = JSON.parse(JSON.stringify(doaAmounts));
            this.saveItSparData();
        });
    }
    // Removes an additional DOA approver while editing; persisted when the user clicks SAVE FORM
    removeApprover(index) {
        if (!this.editFormMode || index < 0 || index >= this.approverList.length) {
            return;
        }
        this.approverList = this.approverList.filter((_approver, i) => i !== index);
        this.doaAmountsCopy = this.doaAmountsCopy.filter((_amount, i) => i !== index + 1);
        this.doaLookupFailed = this.doaLookupFailed.filter((_flag, i) => i !== index + 1);
        this.doaLookupLoading = this.doaLookupLoading.filter((_flag, i) => i !== index + 1);
    }
    loadProjectConsistsOfOptionsFile() {
        this.http.get("assets/project-consists-of-options.json").subscribe((result) => {
            this.projectConsistsOfOptions = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Project Consists Of Options Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Project Consists Of Options Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadExtraBuildingOptions() {
        this.http.get("assets/extra-buildings.json").subscribe((result) => {
            this.extraBuildings = result;
            if (this.hardwareOrSoftwareCopy !== "O&M Only") {
                this.extraBuildings.splice(1, 1);
            }
            let buildingArray = [];
            for (let i = 0; i < this.extraBuildings.length; i++) {
                buildingArray.push({
                    BuildingName: this.extraBuildings[i],
                });
            }
            this.expandedBuildingInfoOptions = buildingArray.concat(this.buildingInfoOptions);
            this.expandedBuildingInfoOptions = _.sortBy(this.expandedBuildingInfoOptions, ["BuildingName"]);
            this.filteredBuildingInfoOptions =
                this.buildingInfoControl.valueChanges.pipe(startWith(""), map((value) => typeof value === "string" ? value : this.lastFilter), map((filter) => this.expandedBuildingInfoFilter(filter)));
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Extra Building Options Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Extra Building Options Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    displayFnOperatingUnit(value) {
        if (!value) {
            return "";
        }
        else {
            return value.OPERATING_UNIT + " - " + value.DESCR;
        }
    }
    setBusinessUnit(allocation, value, index) {
        allocation.businessUnitValue = value.BUSINESS_UNIT;
        allocation.businessUnit = value.BUSINESS_UNIT.concat(" - ").concat(value.BU_DESCR);
        this.setAllocationSetId(allocation, value.BUSINESS_UNIT);
        let matchFound = false;
        for (let i = 0; i < this.buForStateOptions.length && !matchFound; i++) {
            if (value.BUSINESS_UNIT === this.buForStateOptions[i]) {
                matchFound = true;
                allocation.stateOptions = ["NC", "SC", "NC & SC"];
            }
        }
        if (!matchFound) {
            allocation.stateOptions = [];
        }
        this.filteredStateOptions[index] = this.stateControl[index].valueChanges.pipe(startWith(""), map((value) => (typeof value === "string" ? value : this.lastFilter)), map((filter) => this.stateFilter(filter, allocation)));
    }
    sortUOPDescriptionOptions() {
        this.uopDescriptionOptions = _.sortBy(this.uopDescriptionOptions, [
            "uop_description",
        ]);
        let commonUOPOptions = [];
        for (let i = 0; i < this.uopDescriptionOptions.length; i++) {
            if (this.commonUOPOptions.includes(this.uopDescriptionOptions[i].uop_description.trim())) {
                commonUOPOptions.push(this.uopDescriptionOptions.splice(i, 1)[0]);
                i = i - 1;
            }
        }
        this.uopDescriptionOptions = commonUOPOptions.concat(this.uopDescriptionOptions);
    }
    getUOPDescriptionChoices() {
        this.uopDescriptionOptions = [];
        let businessUnits = [];
        for (let i = 0; i < this.allocationsCopy.length; i++) {
            if (!businessUnits.includes(this.allocationsCopy[i].businessUnitValue) &&
                this.allocationsCopy[i].businessUnitValue) {
                businessUnits.push(this.allocationsCopy[i].businessUnitValue);
            }
        }
        if (businessUnits.length > 0 && !businessUnits.includes(null)) {
            let callBody = {
                businessUnits: businessUnits,
            };
            this.dataService.getAthenaData("it_spar_uop_desc", callBody).subscribe((result) => {
                this.uopDescriptionOptions = JSON.parse(result);
                this.sortUOPDescriptionOptions();
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Get UOP Description Choices Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Get UOP Description Choices Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            });
        }
    }
    getDOA(lanID, index, editMode, adminEdit) {
        this.doaLookupLoading[index] = true;
        let doc = document.implementation.createDocument("", "", null);
        const pi = doc.createProcessingInstruction("xml", 'version="1.0" encoding="UTF-8"');
        doc.insertBefore(pi, doc.firstChild);
        let elem1 = doc.createElement("soapenv:Envelope");
        elem1.setAttribute("xmlns:soapenv", "http://schemas.xmlsoap.org/soap/envelope/");
        elem1.setAttribute("xmlns:web", "http://duke-energy.com/webservices/");
        let elem2 = doc.createElement("soapenv:Header");
        let elem3 = doc.createElement("soapenv:Body");
        let elem4 = doc.createElement("web:GetDoaInformationByLanid");
        let elem5 = doc.createElement("web:lanids");
        let elem6 = doc.createElement("web:string");
        elem6.innerHTML = this.encodeToXML(lanID);
        elem5.appendChild(elem6);
        elem4.appendChild(elem5);
        elem3.appendChild(elem4);
        elem1.appendChild(elem2);
        elem1.appendChild(elem3);
        doc.appendChild(elem1);
        let finalString = doc.documentElement.outerHTML;
        this.dataService.getDOA(finalString).subscribe((result) => {
            this.xmlDoc = this.parser.parseFromString(result, "text/xml");
            if (this.xmlDoc.getElementsByTagName("StatusCode")[0].innerHTML ===
                "ERROR") {
                /*let dataStructure;
              let error = this.xmlDoc.getElementsByTagName("StatusCodeMsg")[0].innerHTML;
              dataStructure = {
                error: true,
                data: error,
                isDOA: true
              }
              this.dialog.open(SuccessDialogComponent, {
                disableClose: true,
                data: dataStructure
              });*/
                if (editMode) {
                    this.doaAmountsCopy[index] = this.handleDoaFailure(lanID, index, "SOAP_ERROR", this.xmlDoc.getElementsByTagName("StatusCodeMsg")[0].innerHTML);
                }
                else {
                    const fallback = this.handleDoaFailure(lanID, index, "SOAP_ERROR", this.xmlDoc.getElementsByTagName("StatusCodeMsg")[0].innerHTML);
                    this.doaAmounts[index] = fallback;
                    this.doaAmountsCopy[index] = fallback;
                }
                if (adminEdit) {
                    this.saveItSparData();
                }
                let dataStructure = {
                    errorType: "Error Retrieving DOA Amount",
                    errorDescription: "An error occured when retrieving DOA information. Please click Retry to try again",
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            }
            else {
                if (editMode) {
                    this.doaAmountsCopy[index] = Number(this.xmlDoc.getElementsByTagName("Amount")[0].innerHTML);
                }
                else {
                    this.doaAmounts[index] = Number(this.xmlDoc.getElementsByTagName("Amount")[0].innerHTML);
                    this.doaAmountsCopy[index] = Number(this.xmlDoc.getElementsByTagName("Amount")[0].innerHTML);
                }
                this.doaLookupFailed[index] = false;
                this.doaLookupLoading[index] = false;
                if (adminEdit) {
                    this.saveItSparData();
                }
            }
        }, (error) => {
            if (editMode) {
                this.doaAmountsCopy[index] = this.handleDoaFailure(lanID, index, "HTTP_ERROR", error);
            }
            else {
                const fallback = this.handleDoaFailure(lanID, index, "HTTP_ERROR", error);
                this.doaAmounts[index] = fallback;
                this.doaAmountsCopy[index] = fallback;
            }
            if (adminEdit) {
                this.saveItSparData();
            }
            let dataStructure = {
                errorType: "Error Retrieving DOA Amount",
                errorDescription: "An error occured when retrieving DOA information. Please click Retry to try again",
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    retryDoaLookup(index) {
        if (index === 0) {
            this.getDOA((this.editFormMode ? this.itSponsorCopy : this.itSponsor).mailNickname, 0, this.editFormMode);
            return;
        }
        const approver = this.approverList[index - 1];
        if (!approver || !approver.mailNickname) {
            return;
        }
        this.getDOA(approver.mailNickname, index, this.editFormMode);
    }
    // Records failed DOA lookups (console + sessionStorage) so recurring failures can be diagnosed later.
    logDoaFailure(lanID, index, reason, detail) {
        const entry = {
            lanID,
            index,
            reason,
            detail: detail instanceof Error ? detail.message : detail,
            timestamp: new Date().toISOString(),
        };
        console.error("[DOA lookup failed]", entry);
        try {
            const log = JSON.parse(sessionStorage.getItem(this.DOA_FAILURE_LOG_KEY) || "[]");
            log.push(entry);
            // Keep the log bounded so sessionStorage doesn't grow unbounded during a long session.
            sessionStorage.setItem(this.DOA_FAILURE_LOG_KEY, JSON.stringify(log.slice(-25)));
        }
        catch (_a) {
            // best-effort logging only
        }
    }
    // Marks the lookup as failed and returns the amount to fall back to (always 0 - we don't reuse stale DOA data).
    handleDoaFailure(lanID, index, reason, detail) {
        this.doaLookupFailed[index] = true;
        this.doaLookupLoading[index] = false;
        this.logDoaFailure(lanID, index, reason, detail);
        return 0;
    }
    loadProjectClassificationOptionsFile() {
        this.http.get("assets/it-project-classification-options.json").subscribe((result) => {
            this.itProjectClassificationOptions = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Project Classification Options Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Project Classification Options Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    minimumInServiceDate() {
        if (this.estimatedStartDateCopy) {
            return this.estimatedStartDateCopy;
        }
        else {
            return this.todayDate;
        }
    }
    generateTodaysDate() {
        let today = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
        this.todayDate =
            today.getFullYear().toString() +
                "-" +
                (today.getMonth() + 1).toString().padStart(2, "0") +
                "-" +
                today.getDate().toString().padStart(2, "0");
    }
    onStartDateChange() {
        if (this.datepickerInput1.nativeElement.value.match(/^\s*\d{4}\s*$/)) {
            this.estimatedStartDateCopy = new Date(this.datepickerInput1.nativeElement.value, 0);
        }
    }
    onInServiceDateChange() {
        if (this.datepickerInput2.nativeElement.value.match(/^\s*\d{4}\s*$/)) {
            this.estimatedInServiceDateCopy = new Date(this.datepickerInput2.nativeElement.value, 0);
        }
    }
    searchUsersPrimaryContact(searchText) {
        this.dataService.searchUsers(searchText).subscribe((result) => {
            this.primaryContactOptions = _.orderBy(result["value"], [
                "surname",
                "givenName",
            ]);
            setTimeout(() => {
                document.getElementsByName("primaryContactField")[0].focus();
            });
        });
    }
    searchUsersItSponsor(searchText) {
        this.dataService
            .searchUsers(searchText, { excludeContractors: true })
            .subscribe((result) => {
            this.itSponsorOptions = _.orderBy(result["value"], [
                "surname",
                "givenName",
            ]);
            setTimeout(() => {
                document.getElementsByName("itSponsorField")[0].focus();
            });
        });
    }
    displayFnPrimaryContact(value) {
        if (!value) {
            return "";
        }
        else if (value.givenName && value.surname && value.jobTitle) {
            return (value.givenName +
                " " +
                value.surname +
                " (" +
                value.mail +
                "), " +
                value.jobTitle);
        }
        else if (value.givenName && value.surname && !value.jobTitle) {
            return value.givenName + " " + value.surname + " (" + value.mail + ")";
        }
        else if (value.displayName && value.jobTitle) {
            return value.displayName + " (" + value.mail + "), " + value.jobTitle;
        }
        else if (value.displayName && !value.jobTitle) {
            return value.displayName + " (" + value.mail + ")";
        }
        else {
            return value;
        }
    }
    displayFnITSponsor(value) {
        if (!value) {
            return "";
        }
        else if (value.givenName && value.surname && value.jobTitle) {
            return (value.givenName +
                " " +
                value.surname +
                " (" +
                value.mail +
                "), " +
                value.jobTitle);
        }
        else if (value.givenName && value.surname && !value.jobTitle) {
            return value.givenName + " " + value.surname + " (" + value.mail + ")";
        }
        else if (value.displayName && value.jobTitle) {
            return value.displayName + " (" + value.mail + "), " + value.jobTitle;
        }
        else if (value.displayName && !value.jobTitle) {
            return value.displayName + " (" + value.mail + ")";
        }
        else {
            return value;
        }
    }
    deletePrimaryContact() {
        this.primaryContactCopy = "";
        this.primaryContactOptions = [];
    }
    deleteITSponsor() {
        this.itSponsorCopy = "";
        this.itSponsorOptions = [];
    }
    deleteBuildingInfo() {
        this.buildingInfoCopy = "";
    }
    consistsOfChange(index, option) {
        this.projectConsistsOfCheckboxesCopy[index] =
            !this.projectConsistsOfCheckboxesCopy[index];
        if (this.projectConsistsOfCheckboxesCopy[index]) {
            this.projectConsistsOfCopy.push(option);
        }
        else {
            let matchFound = false;
            for (let i = 0; i < this.projectConsistsOfCopy.length && !matchFound; i++) {
                if (this.projectConsistsOfCopy[i] === option) {
                    this.projectConsistsOfCopy.splice(i, 1);
                    matchFound = true;
                }
            }
        }
    }
    getInServiceDate() {
        if (this.inServiceYearCopy) {
            return new Date(`${this.inServiceYearCopy}/01/01`);
        }
        return new Date();
    }
    onInServiceYearSelection(date, datePicker) {
        this.inServiceYearCopy = new Date(date).getFullYear().toString();
        datePicker.close();
    }
    softwareProjectLength() {
        if (this.softwareProjectOverviewCopy) {
            return this.softwareProjectOverviewCopy.length;
        }
        else {
            return 0;
        }
    }
    loadHowSoftwareReleasedOptionsFile() {
        this.http.get("assets/how-software-released-options.json").subscribe((result) => {
            this.howSoftwareReleasedOptions = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("How Software Released Options Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("How Software Released Options Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadDefaultsByDepartmentFile() {
        this.http.get("assets/defaults-by-department.json").subscribe((result) => {
            this.defaultsByDepartment = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Defaults By Department Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Defaults By Department Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    matchUpDepartment() {
        let matchFound = false;
        for (let i = 0; i < this.defaultsByDepartment.length && !matchFound; i++) {
            if (this.defaultsByDepartment[i].department === this.departmentCopy) {
                this.departmentCopy = this.defaultsByDepartment[i];
                matchFound = true;
            }
        }
    }
    compareDepartment(o1, o2) {
        if (!o1 || !o2) {
            return false;
        }
        return o1.department === o2.department;
    }
    compareWorkTask(o1, o2) {
        if (!o1 || !o2) {
            return false;
        }
        return o1.workTask === o2.workTask;
    }
    displayFnBuildingInfo(value) {
        if (!value) {
            return "";
        }
        else {
            return value.BuildingName;
        }
    }
    assignBuilding(value) {
        if (!this.editFormMode) {
            if (this.buildings.length > 0 ||
                this.isExtraBuilding(value) ||
                this.isExtraBuilding(this.buildings[0].buildingName)) {
                this.buildings[0].buildingName = value;
            }
            if (this.isExtraBuilding(value)) {
                this.buildings = [this.buildings[0]];
                if (this.buildingControl.length > 0)
                    this.buildingControl = [this.buildingControl[0]];
                if (this.filteredBuildingOptions.length > 0)
                    this.filteredBuildingOptions = [this.filteredBuildingOptions[0]];
            }
        }
        else {
            if (this.buildingsCopy.length > 0 ||
                this.isExtraBuilding(value) ||
                this.isExtraBuilding(this.buildingsCopy[0].buildingName)) {
                this.buildingsCopy[0].buildingName = value;
            }
            if (this.isExtraBuilding(value)) {
                this.buildingsCopy = [this.buildingsCopy[0]];
                if (this.buildingControl.length > 0)
                    this.buildingControl = [this.buildingControl[0]];
                if (this.filteredBuildingOptions.length > 0)
                    this.filteredBuildingOptions = [this.filteredBuildingOptions[0]];
            }
            if (!this.allocationsTouched) {
                let matchFound = false;
                for (let i = 0; i < this.operatingUnitOptions.length && !matchFound; i++) {
                    if (this.hardwareOrSoftwareCopy === "O&M Only") {
                        if (value.NewOMOUs ===
                            this.operatingUnitOptions[i].OPERATING_UNIT) {
                            this.allocationsCopy[0].operatingUnit =
                                this.operatingUnitOptions[i];
                            matchFound = true;
                        }
                    }
                    else {
                        if (value.NewCapOUs ===
                            this.operatingUnitOptions[i].OPERATING_UNIT) {
                            this.allocationsCopy[0].operatingUnit =
                                this.operatingUnitOptions[i];
                            matchFound = true;
                        }
                    }
                    if (matchFound) {
                        this.setBusinessUnit(this.allocationsCopy[0], this.allocationsCopy[0].operatingUnit, 0);
                        this.getFundingProjectIDChoices(this.allocationsCopy[0], this.allocationsCopy[0].operatingUnit, 0);
                        this.getUOPDescriptionChoices();
                    }
                }
            }
        }
    }
    isExtraBuilding(value) {
        if (!value || typeof value !== 'object')
            return false;
        for (let i = 0; i < this.extraBuildings.length; i++) {
            if (value.BuildingName === this.extraBuildings[i]) {
                return true;
            }
        }
        return false;
    }
    loadBuildingFile() {
        return new Promise((resolve, reject) => {
            this.http.get("assets/building-options.json").subscribe((result) => {
                this.buildingInfoOptions = result;
                this.loadExtraBuildingOptions();
                resolve(true);
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Load Building Options Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Load Building Options Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
                reject(false);
            });
        });
    }
    expandedBuildingInfoFilter(filter) {
        this.lastFilter = filter;
        if (filter) {
            return this.expandedBuildingInfoOptions.filter((option) => {
                if (option.BuildingName) {
                    return option.BuildingName.toLowerCase().includes(filter.toLowerCase());
                }
                else {
                    return this.expandedBuildingInfoOptions;
                }
            });
        }
        else {
            return this.expandedBuildingInfoOptions;
        }
    }
    isOdd(index) {
        return index % 2;
    }
    releaseNumberChange(index, jindex) {
        if (jindex === 0) {
            if (this.releaseDetailsCopy[index].capabilityDetails.length > 0) {
                for (let i = 1; i < this.releaseDetailsCopy[index].capabilityDetails.length; i++) {
                    this.releaseDetailsCopy[index].capabilityDetails[i].releaseNumber =
                        this.releaseDetailsCopy[index].capabilityDetails[0].releaseNumber;
                }
            }
        }
    }
    releaseDateChange(index, jindex) {
        if (jindex === 0) {
            if (this.releaseDetailsCopy[index].capabilityDetails.length > 0) {
                for (let i = 1; i < this.releaseDetailsCopy[index].capabilityDetails.length; i++) {
                    this.releaseDetailsCopy[index].capabilityDetails[i].releaseDate =
                        this.releaseDetailsCopy[index].capabilityDetails[0].releaseDate;
                }
            }
        }
    }
    openCapabilityDialog(i, j, readOnly) {
        if (readOnly) {
            this.dialog.open(CapabilityDescriptionComponent, {
                data: {
                    capabilityDetails: this.releaseDetails[i].capabilityDetails[j],
                    readOnly: true,
                },
                disableClose: true,
            });
        }
        else {
            this.dialog.open(CapabilityDescriptionComponent, {
                data: {
                    capabilityDetails: this.releaseDetailsCopy[i].capabilityDetails[j],
                    readOnly: false,
                },
                disableClose: true,
            });
        }
    }
    deleteRelease(i, j) {
        this.releaseDetailsCopy[i].capabilityDetails.splice(j, 1);
        if (this.releaseDetailsCopy[i].capabilityDetails.length === 0) {
            this.releaseDetailsCopy.splice(i, 1);
        }
    }
    addCapability(index) {
        this.releaseDetailsCopy[index].capabilityDetails.push(new CapabilityDetail());
        if (this.releaseDetailsCopy[index].capabilityDetails.length > 1) {
            this.releaseDetailsCopy[index].capabilityDetails[this.releaseDetailsCopy[index].capabilityDetails.length - 1].releaseNumber =
                this.releaseDetailsCopy[index].capabilityDetails[0].releaseNumber;
            this.releaseDetailsCopy[index].capabilityDetails[this.releaseDetailsCopy[index].capabilityDetails.length - 1].releaseDate =
                this.releaseDetailsCopy[index].capabilityDetails[0].releaseDate;
        }
    }
    addRelease() {
        this.releaseDetailsCopy.push(new ReleaseDetail());
    }
    fundingProjectIDDisabled(allocation, index) {
        return (!allocation.fundingProjectOptions ||
            allocation.fundingProjectOptions.length === 0 ||
            this.isRepeatedOperatingUnit(index));
    }
    displayFnFundingProject(value) {
        if (!value) {
            return "";
        }
        else {
            return value.work_order_number;
        }
    }
    fundingProjectFilter(filter, allocation) {
        this.lastFilter = filter;
        if (filter) {
            return allocation.fundingProjectOptions.filter((option) => {
                return option.work_order_number
                    .toLowerCase()
                    .includes(filter.toLowerCase());
            });
        }
        else {
            return allocation.fundingProjectOptions;
        }
    }
    deleteFundingProjectID(index) {
        this.allocationsCopy[index].fundingProjectID = "";
    }
    getFundingProjectIDChoices(allocation, value, index, isDefault, reload) {
        allocation.fundingProjectOptions = [];
        if (!reload) {
            allocation.fundingProjectID = "";
        }
        let callBody;
        if (isDefault) {
            callBody = {
                businessUnit: value,
            };
        }
        else {
            callBody = {
                businessUnit: value.BUSINESS_UNIT,
            };
        }
        this.dataService
            .getAthenaData("itspar_bu_funding_prjs", callBody)
            .subscribe((result) => {
            allocation.fundingProjectOptions = JSON.parse(result);
            if (allocation.fundingProjectOptions.length === 0) {
                allocation.hasFundingError = true;
            }
            else {
                allocation.hasFundingError = false;
            }
            this.sortFundingProjectOptions(allocation);
            this.filteredFundingProjectOptions[index] =
                this.fundingProjectControl[index].valueChanges.pipe(startWith(""), map((value) => typeof value === "string" ? value : this.lastFilter), map((filter) => this.fundingProjectFilter(filter, allocation)));
            if (reload) {
                let matchFound = false;
                for (let i = 0; i < allocation.fundingProjectOptions.length && !matchFound; i++) {
                    if (allocation.fundingProjectID.work_order_number ===
                        allocation.fundingProjectOptions[i].work_order_number) {
                        matchFound = true;
                        allocation.fundingProjectID =
                            allocation.fundingProjectOptions[i];
                    }
                }
            }
            if (!reload &&
                allocation.businessUnitValue !== "20048" &&
                allocation.businessUnitValue !== "50125") {
                let matchFound = false;
                for (let i = 0; i < allocation.fundingProjectOptions.length && !matchFound; i++) {
                    const defaultFPIT = allocation.fundingProjectOptions[i].work_order_number.startsWith("FPIT");
                    const defaultPIEDMONT = allocation.businessUnitValue === "47156" &&
                        allocation.fundingProjectOptions[i].work_order_number.startsWith("PIEDMONT");
                    if (defaultFPIT || defaultPIEDMONT) {
                        matchFound = true;
                        allocation.fundingProjectID =
                            allocation.fundingProjectOptions[i];
                    }
                }
            }
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Get Funding Project ID Choices Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Get Funding Project ID Choices Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    sortFundingProjectOptions(allocation) {
        allocation.fundingProjectOptions = _.sortBy(allocation.fundingProjectOptions, ["work_order_number"]);
        allocation.fundingProjectOptions = _.sortBy(allocation.fundingProjectOptions, ["preferred"], ["desc"]);
        let foundIndex = -1;
        for (let i = 0; i < allocation.fundingProjectOptions.length && foundIndex === -1; i++) {
            if (allocation.fundingProjectOptions[i].preferred === "Y") {
                foundIndex = i;
            }
        }
        if (foundIndex != -1) {
            let preferredProjects = allocation.fundingProjectOptions.splice(foundIndex, allocation.fundingProjectOptions.length - foundIndex);
            allocation.fundingProjectOptions = preferredProjects.concat(allocation.fundingProjectOptions);
        }
    }
    loadBUForStateFile() {
        this.http.get("assets/bu-for-state.json").subscribe((result) => {
            this.buForStateOptions = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load BU For State Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load BU For State Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    emptyAllocationLine() {
        for (let i = 0; i < this.allocationsCopy.length; i++) {
            if (this.allocationsCopy[i].percentage === 0) {
                return true;
            }
        }
        return false;
    }
    buildingInfoFilter(filter) {
        this.lastFilter = filter;
        if (filter) {
            return this.buildingInfoOptions.filter((option) => {
                return option.BuildingName.toLowerCase().includes(filter.toLowerCase());
            });
        }
        else {
            return this.buildingInfoOptions;
        }
    }
    deleteBuildingName(index) {
        this.buildingsCopy[index].buildingName = "";
    }
    deleteBuilding(i) {
        this.buildings.splice(i, 1);
        this.buildingControl.splice(i, 1);
        this.filteredBuildingOptions.splice(i, 1);
    }
    tangiblePropertyCheck(estimate) {
        if (estimate.cost === "CAP" &&
            (estimate.unitOfPropertyDescription === "Communication Equipment" ||
                estimate.unitOfPropertyDescription === "Electronic Data Processing" ||
                estimate.unitOfPropertyDescription === "Miscellaneous Equipment" ||
                estimate.unitOfPropertyDescription ===
                    "Office Furniture and Equipment" ||
                estimate.unitOfPropertyDescription === "Structures and Improvements" ||
                estimate.unitOfPropertyDescription ===
                    "Tools, Shop & Garage Equipment") &&
            Number(estimate.unitCosts) < 500 &&
            estimate.unitCosts !== null) {
            return true;
        }
        else {
            return false;
        }
    }
    costChanged(value, i, j) {
        if (value === "O&M") {
            this.buildingsCopy[i].materialEstimates[j].unitOfPropertyDescription =
                null;
        }
    }
    loadCostOptionsFile() {
        return new Promise((resolve, reject) => {
            this.http.get("assets/cost-options.json").subscribe((result) => {
                this.costOptions = result;
                if (this.hardwareOrSoftwareCopy === "O&M Only") {
                    this.costOptions = ["O&M"];
                }
                resolve(true);
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Distributing Options Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Distributing Options Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
                reject(false);
            });
        });
    }
    loadUOPOptionsFile() {
        return new Promise((resolve, reject) => {
            this.http.get("assets/uop-options.json").subscribe((result) => {
                let setOfUopOptions = result;
                if (this.hardwareOrSoftwareCopy === "Hardware Only") {
                    this.uopOptions = setOfUopOptions.slice(0, -2);
                }
                else if (this.hardwareOrSoftwareCopy === "Software Only") {
                    this.uopOptions = setOfUopOptions.slice(6);
                }
                else {
                    this.uopOptions = setOfUopOptions;
                }
                resolve(true);
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Load UOP Options Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Load UOP Options Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
                reject(false);
            });
        });
    }
    duplicateAllocation() {
        for (let i = 0; i < this.allocationsCopy.length; i++) {
            for (let j = i + 1; j < this.allocationsCopy.length; j++) {
                if (this.allocationsCopy[i].operatingUnit &&
                    this.allocationsCopy[j].operatingUnit &&
                    this.allocationsCopy[i].operatingUnit.OPERATING_UNIT ===
                        this.allocationsCopy[j].operatingUnit.OPERATING_UNIT) {
                    return true;
                }
            }
        }
        return false;
    }
    loadCommonUOPProjectsFile() {
        this.http.get("assets/common-uop-options.json").subscribe((result) => {
            this.commonUOPOptions = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Common UOP Options Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Common UOP Options Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    tangibleTotalCostCheck(estimate) {
        if (estimate.cost === "CAP" &&
            (estimate.unitOfPropertyDescription === "Communication Equipment" ||
                estimate.unitOfPropertyDescription === "Electronic Data Processing" ||
                estimate.unitOfPropertyDescription === "Miscellaneous Equipment" ||
                estimate.unitOfPropertyDescription ===
                    "Office Furniture and Equipment" ||
                estimate.unitOfPropertyDescription === "Structures and Improvements" ||
                estimate.unitOfPropertyDescription ===
                    "Tools, Shop & Garage Equipment") &&
            Number(estimate.unitCosts) >= 500 &&
            Number(estimate.unitCosts) <= 999 &&
            estimate.unitCosts !== null &&
            estimate.totalCosts < 50000) {
            return true;
        }
        else {
            return false;
        }
    }
    tangibleDateCheck(estimate) {
        if (estimate.cost === "CAP" &&
            (estimate.unitOfPropertyDescription === "Communication Equipment" ||
                estimate.unitOfPropertyDescription === "Electronic Data Processing" ||
                estimate.unitOfPropertyDescription === "Miscellaneous Equipment" ||
                estimate.unitOfPropertyDescription ===
                    "Office Furniture and Equipment" ||
                estimate.unitOfPropertyDescription === "Structures and Improvements" ||
                estimate.unitOfPropertyDescription ===
                    "Tools, Shop & Garage Equipment") &&
            Number(estimate.unitCosts) >= 500 &&
            Number(estimate.unitCosts) <= 999 &&
            estimate.unitCosts !== null &&
            !this.workLessThanYear()) {
            return true;
        }
        else {
            return false;
        }
    }
    workLessThanYear() {
        return (this.estimatedInServiceDateCopy.getTime() -
            this.estimatedStartDateCopy.getTime() <=
            31556952000);
    }
    recalculateTotalCost(i, j) {
        const unitCosts = Number(this.buildingsCopy[i].materialEstimates[j].unitCosts || 0);
        const quantity = this.buildingsCopy[i].materialEstimates[j].quantity || 0;
        this.buildingsCopy[i].materialEstimates[j].totalCosts =
            quantity * unitCosts;
    }
    deleteEstimate(i, j) {
        this.buildingsCopy[i].materialEstimates.splice(j, 1);
    }
    updateMatchingBusinessUnits(index) {
        let firstMatchIndex = -1;
        for (let i = 0; i < this.allocationsCopy.length; i++) {
            if ((this.allocationsCopy[index].businessUnitValue ===
                this.allocationsCopy[i].businessUnitValue &&
                this.allocationsCopy[index].businessUnitValue !== "20048" &&
                this.allocationsCopy[index].businessUnitValue !== "50125") ||
                (this.allocationsCopy[index].businessUnitValue ===
                    this.allocationsCopy[i].businessUnitValue &&
                    (this.allocationsCopy[index].businessUnitValue === "20048" ||
                        this.allocationsCopy[index].businessUnitValue === "50125") &&
                    this.allocationsCopy[index].operatingUnit.OPERATING_UNIT ===
                        this.allocationsCopy[i].operatingUnit.OPERATING_UNIT)) {
                if (firstMatchIndex !== -1) {
                    this.allocationsCopy[i].fundingProjectID =
                        this.allocationsCopy[firstMatchIndex].fundingProjectID;
                    this.allocationsCopy[i].state =
                        this.allocationsCopy[firstMatchIndex].state;
                }
                if (firstMatchIndex === -1) {
                    firstMatchIndex = i;
                }
            }
        }
    }
    deleteAllocation(i) {
        this.allocationsCopy.splice(i, 1);
        this.operatingUnitControl.splice(i, 1);
        this.filteredOperatingUnitOptions.splice(i, 1);
        this.filteredFundingProjectOptions.splice(i, 1);
        this.filteredStateOptions.splice(i, 1);
        this.fundingProjectControl.splice(i, 1);
        this.stateControl.splice(i, 1);
        this.getUOPDescriptionChoices();
    }
    deleteOperatingUnit(index) {
        this.allocationsCopy[index].operatingUnit = "";
    }
    addNewAllocation() {
        this.allocationsCopy.push(new Allocation());
        this.operatingUnitControl.push(new FormControl());
        this.fundingProjectControl.push(new FormControl());
        this.stateControl.push(new FormControl());
        this.filteredOperatingUnitOptions.push(new Observable());
        this.filteredOperatingUnitOptions[this.filteredOperatingUnitOptions.length - 1] = this.operatingUnitControl[this.operatingUnitControl.length - 1].valueChanges.pipe(startWith(""), map((value) => (typeof value === "string" ? value : this.lastFilter)), map((filter) => this.operatingUnitFilter(filter)));
        this.filteredFundingProjectOptions.push(new Observable());
        this.filteredFundingProjectOptions[this.filteredFundingProjectOptions.length - 1] = this.fundingProjectControl[this.fundingProjectControl.length - 1].valueChanges.pipe(startWith(""), map((value) => (typeof value === "string" ? value : this.lastFilter)), map((filter) => this.fundingProjectFilter(filter, this.allocationsCopy[this.allocationsCopy.length - 1])));
        this.filteredStateOptions.push(new Observable());
        this.filteredStateOptions[this.filteredStateOptions.length - 1] =
            this.stateControl[this.stateControl.length - 1].valueChanges.pipe(startWith(""), map((value) => (typeof value === "string" ? value : this.lastFilter)), map((filter) => this.stateFilter(filter, this.allocationsCopy[this.allocationsCopy.length - 1])));
    }
    stateFilter(filter, allocation) {
        this.lastFilter = filter;
        if (filter) {
            return allocation.stateOptions.filter((option) => {
                return option.toLowerCase().includes(filter.toLowerCase());
            });
        }
        else {
            return allocation.stateOptions;
        }
    }
    multipleNuclearHardwareSoftware() {
        if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
            return this.containsMultipleNuclear();
        }
        return false;
    }
    addMaterial(index) {
        this.buildingsCopy[index].materialEstimates.push(new MaterialEstimate());
        if (this.hardwareOrSoftwareCopy === "O&M Only") {
            this.buildingsCopy[index].materialEstimates[this.buildingsCopy[index].materialEstimates.length - 1].cost = "O&M";
        }
    }
    addBuilding() {
        this.buildings.push(new Building());
        if (this.editFormMode)
            this.buildingsCopy.push(new Building());
        this.buildingControl.push(new FormControl());
        this.filteredBuildingOptions.push(new Observable());
        this.filteredBuildingOptions[this.buildings.length - 1] =
            this.buildingControl[this.buildings.length - 1].valueChanges.pipe(startWith(""), map((value) => (typeof value === "string" ? value : this.lastFilter)), map((filter) => this.buildingInfoFilter(filter)));
    }
    workTaskChanged(workTask, index) {
        this.workDescriptions[index] = workTask.workDescriptions;
        this.laborDetailsCopy[index].workDescription = "";
    }
    operatingUnitFilter(filter) {
        this.lastFilter = filter;
        if (filter) {
            return this.operatingUnitOptions.filter((option) => {
                if (this.hardwareOrSoftwareCopy === "O&M Only") {
                    return option.OPERATING_UNIT.concat(" - ")
                        .concat(option.DESCR)
                        .toLowerCase()
                        .includes(filter.toLowerCase());
                }
                else {
                    return (option.OPERATING_UNIT.concat(" - ")
                        .concat(option.DESCR)
                        .toLowerCase()
                        .includes(filter.toLowerCase()) &&
                        option.BUSINESS_UNIT !== "50124" &&
                        option.BUSINESS_UNIT !== "50224" &&
                        option.BUSINESS_UNIT !== "75083");
                }
            });
        }
        else {
            return this.operatingUnitOptions;
        }
    }
    loadHardwareOrSoftwareOptionsFile() {
        this.http.get("assets/hardware-or-software-options.json").subscribe((result) => {
            this.workOptions = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Hardware or Software Options Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Hardware or Software Options Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadAllocationDefaults() {
        this.http.get("assets/allocation-defaults.json").subscribe((result) => {
            this.allocationDefaultList = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Allocation Defaults Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Allocation Defaults Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadDerivationAndAllocations() {
        this.http.get("assets/derivations-and-allocations.json").subscribe((result) => {
            this.derivationAndAllocations = result;
            // FLDT-1384 Declaring variables for values in JSON file
            const projectManagerName = this.derivationAndAllocations.projectManager;
            const engineerName = this.derivationAndAllocations.engineer;
            const contractAdminName = this.derivationAndAllocations.contractAdmin;
            // Get LanIDs of each name only once and cache them
            this.getLanIdFromName(projectManagerName, (lanId) => {
                this.projectManagerLanId = lanId || "";
            });
            this.getLanIdFromName(engineerName, (lanId) => {
                this.engineerLanId = lanId || "";
            });
            this.getLanIdFromName(contractAdminName, (lanId) => {
                this.contractAdminLanId = lanId || "";
            });
            // End FLDT-1384 Changes
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Derivations And Allocations Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Derivations And Allocations Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadAllocationFunctions() {
        this.http.get("assets/allocation-functions.json").subscribe((result) => {
            let options = result;
            options.sort();
            this.allocationFunctions = options;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Allocation Funtions Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Allocation Funtions  Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadDistributionOptionsFile() {
        this.http.get("assets/distributing-options.json").subscribe((result) => {
            this.distributeOptions = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Distributing Options Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Distributing Options Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadOperatingUnitFile() {
        this.http.get("assets/operating-units.json").subscribe((result) => {
            this.operatingUnitOptions = result;
            if (this.operatingUnitControl && this.operatingUnitControl.length > 0) {
                this.filteredOperatingUnitOptions[0] =
                    this.operatingUnitControl[0].valueChanges.pipe(startWith(""), map((value) => typeof value === "string" ? value : this.lastFilter), map((filter) => this.operatingUnitFilter(filter)));
            }
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load OU File Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load OU File Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadWorkTaskOptionsFile() {
        return new Promise((resolve, reject) => {
            this.http.get("assets/work-task-options.json").subscribe((result) => {
                this.workTaskOptions = result;
                if (this.hardwareOrSoftwareCopy === "Hardware Only") {
                    this.workTaskOptions.splice(2, 2);
                }
                if (this.hardwareOrSoftwareCopy === "Software Only") {
                    this.workTaskOptions.splice(4, 1);
                    this.workTaskOptions.splice(0, 2);
                }
                if (this.hardwareOrSoftwareCopy === "O&M Only") {
                    this.workTaskOptions = [
                        {
                            workTask: "Labor-O&M",
                            workDescriptions: ["Labor-O&M"],
                        },
                    ];
                }
                resolve(true);
            }, (error) => {
                console.log("error", error);
                reject(false);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Load Work Task Options Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Load Work Task Options Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            });
        });
    }
    loadChargeTypeOptionsFile() {
        this.http.get("assets/charge-type-options.json").subscribe((result) => {
            this.chargeTypeOptions = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Charge Type Options Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Charge Type Options Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    deleteLaborDetail(i) {
        this.laborDetailsCopy.splice(i, 1);
        this.workDescriptions.splice(i, 1);
    }
    addLaborDetail() {
        this.laborDetailsCopy.push(new LaborDetail());
        this.workDescriptions.push([]);
        if (this.hardwareOrSoftwareCopy === "O&M Only") {
            this.laborDetailsCopy[this.laborDetailsCopy.length - 1].workTask = {
                workTask: "Labor-O&M",
                workDescriptions: ["Labor-O&M"],
            };
            this.workTaskChanged({
                workTask: "Labor-O&M",
                workDescriptions: ["Labor-O&M"],
            }, this.laborDetailsCopy.length - 1);
        }
    }
    loadContingencyCostOptionsFile() {
        return new Promise((resolve, reject) => {
            this.http.get("assets/contingency-cost-options.json").subscribe((result) => {
                this.contingencyCostOptions = result;
                if (this.hardwareOrSoftwareCopy === "O&M Only") {
                    this.contingencyCostOptions = ["Contingency-O&M", "Other-O&M"];
                }
                else if (this.hardwareOrSoftwareCopy === "Software Only") {
                    this.contingencyCostOptions = [
                        "Contingency-CAP",
                        "Contingency-O&M",
                        "Other-CAP",
                        "Other-O&M",
                    ];
                }
                resolve(true);
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Load Work Task Options Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Load Work Task Options Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
                reject(false);
            });
        });
    }
    loadEmailRecipientsFile() {
        this.http.get("assets/email_recipients.json").subscribe((result) => {
            this.emailRecipients = result;
            // Map to existing properties for backward compatibility
            this.pacEmail = { mail: this.emailRecipients.groups.itPacGroup[0].email };
            this.leadPacReviewer = {
                displayName: this.emailRecipients.reviewers.leadPacReviewer.displayName,
                givenName: this.emailRecipients.reviewers.leadPacReviewer.givenName,
                surname: this.emailRecipients.reviewers.leadPacReviewer.surname,
                mail: this.emailRecipients.reviewers.leadPacReviewer.email,
                mailNickname: "",
                jobTitle: "",
                doaAmount: ""
            };
            this.assetAccounting = [
                {
                    displayName: this.emailRecipients.assetAccounting.primary.displayName,
                    givenName: this.emailRecipients.assetAccounting.primary.givenName,
                    surname: this.emailRecipients.assetAccounting.primary.surname,
                    mail: this.emailRecipients.assetAccounting.primary.email,
                    mailNickname: "",
                    jobTitle: "",
                    doaAmount: ""
                },
                {
                    displayName: this.emailRecipients.assetAccounting.secondary.displayName,
                    givenName: this.emailRecipients.assetAccounting.secondary.givenName,
                    surname: this.emailRecipients.assetAccounting.secondary.surname,
                    mail: this.emailRecipients.assetAccounting.secondary.email,
                    mailNickname: "",
                    jobTitle: "",
                    doaAmount: ""
                }
            ];
            this.jointOwnerCoordinator = {
                displayName: this.emailRecipients.reviewers.jointOwnerCoordinator.displayName,
                givenName: this.emailRecipients.reviewers.jointOwnerCoordinator.givenName,
                surname: this.emailRecipients.reviewers.jointOwnerCoordinator.surname,
                mail: this.emailRecipients.reviewers.jointOwnerCoordinator.email,
                mailNickname: "",
                jobTitle: "",
                doaAmount: ""
            };
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Email Recipients Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Email Recipients Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadLeadPacReviewerFile() {
        this.http.get("assets/lead-pac-reviewer.json").subscribe((result) => {
            this.leadPacReviewer = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Lead PAC Reviewer Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Lead PAC Reviewer Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadAssetAccountingFile() {
        this.http.get("assets/asset-accounting.json").subscribe((result) => {
            this.assetAccounting = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Lead PAC Reviewer Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Lead PAC Reviewer Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadJointOwnerCoordinatorFile() {
        this.http.get("assets/joint-owner-coordinator.json").subscribe((result) => {
            this.jointOwnerCoordinator = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Joint Owner Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Joint Owner Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadCatawbaOperatingUnitFile() {
        this.http.get("assets/catawba-operating-units.json").subscribe((result) => {
            this.catawbaOperatingUnits = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Catawba Operating Units Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Catawba Operating Units Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadPACEmailFile() {
        this.http.get("assets/pac-email.json").subscribe((result) => {
            this.pacEmail = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Catawba Operating Units Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Catawba Operating Units Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadStyleSheet() {
        this.http
            .get("assets/it-project-approval.component.scss", {
            responseType: "text",
        })
            .subscribe((result) => {
            this.styleSheet = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Style Sheet Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Style Sheet Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadAccountingTreatment() {
        this.http.get("assets/accounting-treatment.json").subscribe((result) => {
            this.accountingTreatment = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Accounting Treatment Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Accounting Treatment Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadSetIdToFunction() {
        this.http.get("assets/setid-to-function.json").subscribe((result) => {
            this.setIdToFunction = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Set Id To Function Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Set Id To Function Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    deleteContingencyDetail(i) {
        this.contingencyDetails.splice(i, 1);
    }
    addContingencyDetail() {
        this.contingencyDetails.push(new ContingencyDetail());
    }
    additionalCommentLength() {
        if (this.additionalCommentsCopy) {
            return this.additionalCommentsCopy.length;
        }
        else {
            return 0;
        }
    }
    onFileSelected(event) {
        for (let i = 0; i < event.target.files.length; i++) {
            this.uploadFile(event.target.files[i]);
        }
    }
    uploadFile(file) {
        let userData = JSON.parse(sessionStorage.getItem("userInfo"));
        let stringArray = userData.account.name.split(",");
        let lastName = stringArray[0];
        let firstName = stringArray[1].substring(1);
        let today = new Date();
        let yyyy = today.getFullYear();
        let mm = today.getMonth() + 1;
        let dd = today.getDate();
        let ddstring = "";
        let mmstring = "";
        if (dd < 10) {
            ddstring = "0" + dd;
        }
        else {
            ddstring = dd.toString();
        }
        if (mm < 10) {
            mmstring = "0" + mm;
        }
        else {
            mmstring = mm.toString();
        }
        let formattedToday = mmstring + "/" + ddstring + "/" + yyyy;
        let data = {
            fileName: this.itSparGuid.concat("/").concat(file.name),
            contentType: file.type,
            method: "put_object",
        };
        this.dataService.getPresignedURL(data).subscribe((result) => {
            let presignedURL = JSON.parse(result).presigned_url;
            this.httpNoInterceptors.put(presignedURL, file, { headers: { 'Content-Type': file.type } }).subscribe((result) => {
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    this.filesCopy.push(new UploadFile(firstName + " " + lastName, formattedToday));
                    this.filesCopy[this.filesCopy.length - 1].fileName = file.name;
                    this.filesCopy[this.filesCopy.length - 1].contentType = file.type;
                    this.files = this.filesCopy;
                    this.saveItSparData(false, false, false, false, false, false, false, false, false, false, true);
                };
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.status === 0) {
                    errorType = "Upload Blocked";
                    errorDescription = "File upload was blocked. Your network security policy may not allow this file type to be uploaded. Please try uploading a PDF instead.";
                }
                else {
                    if (error.error.message) {
                        errorDescription = errorDescription.concat("Upload File to Presigned URL Error - ", error.error.message);
                    }
                    else {
                        errorDescription = errorDescription.concat("Upload File to Presigned URL Error");
                    }
                    errorType = errorType.concat(error.status, " ", error.statusText);
                }
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            });
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Get Presigned URL Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Get Presigned URL Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    onDrop(event) {
        event.preventDefault();
        for (let i = 0; i < event.dataTransfer.files.length; i++) {
            this.uploadFile(event.dataTransfer.files[i]);
        }
    }
    onDragOver(event) {
        event.preventDefault();
    }
    deleteFile(index) {
        this.filesCopy.splice(index, 1);
        this.files = this.filesCopy;
        this.saveItSparData(false, false, false, false, false, false, false, false, false, false, true);
    }
    saveItSparData(isFormEdit, isFirstPACUser, isApproval, isFirstAssetUser, isRejection, isResubmission, isCompletion, isChargingDetails, isRevisionStart, isFormDeletion, isAttachmentOnly) {
        // for sending emails
        let sendingReviewEmail = false;
        let sendingReviewReceiver = [];
        let sendingReviewFirstName = [];
        let sendingModifiedEmail = false;
        let sendingModifiedReceiver = [];
        let sendingModifiedFirstName = [];
        let sendingModifiedName = "";
        let sendingChargingEmail = false;
        let sendingChargingReceiver = [];
        let sendingChargingFirstName = [];
        let sendingCompletionEmail = false;
        let sendingCompletionReceiver = [];
        let sendingCompletionFirstName = [];
        let sendingReadyChargingEmail = false;
        let sendingReadyChargingReceiver = [];
        let sendingReadyChargingFirstName = [];
        let sendingJointOwnerRejectCompleteEmail = false;
        let sendingJointOwnerRejectCompleteReceiver = [];
        let sendingJointOwnerRejectCompleteFirstName = [];
        let sendingJointOwnerRejectCompleteName = "";
        let sendingJointOwnerRejectCompleteComments = "";
        let sendingRejectedEmail = false;
        let sendingRejectedReceiver = [];
        let sendingRejectedFirstName = [];
        let sendingRejectedName = "";
        let sendingRejectedComments = "";
        let sendingRejectedReadyEmail = false;
        let sendingRejectedReadyReceiver = [];
        let sendingRejectedReadyFirstName = [];
        let sendingRejectedReadyName = "";
        let sendingRejectedReadyComments = "";
        let sendingFormCompletedEmail = false;
        let sendingFormCompletedReceiver = [];
        let sendingFormCompletedFirstName = [];
        let sendingFormCompletedName = "";
        let sendingFormCompletedComments = "";
        let releaseDetailsObject = [];
        for (let i = 0; i < this.releaseDetails.length; i++) {
            releaseDetailsObject.push({
                capabilityDetails: [],
            });
            for (let j = 0; j < this.releaseDetails[i].capabilityDetails.length; j++) {
                releaseDetailsObject[i].capabilityDetails.push({
                    releaseNumber: this.releaseDetails[i].capabilityDetails[j].releaseNumber,
                    releaseDate: this.releaseDetails[i].capabilityDetails[j].releaseDate,
                    capability: this.releaseDetails[i].capabilityDetails[j].capabilities,
                    description: this.releaseDetails[i].capabilityDetails[j].description,
                    capitalCost: this.releaseDetails[i].capabilityDetails[j].capitalCost,
                    omCost: this.releaseDetails[i].capabilityDetails[j].omCost,
                });
            }
        }
        let allocationsObject = [];
        for (let i = 0; i < this.allocations.length; i++) {
            allocationsObject.push({
                operatingUnit: JSON.stringify(this.allocations[i].operatingUnit),
                businessUnit: this.allocations[i].businessUnit,
                fundingProjectId: JSON.stringify(this.allocations[i].fundingProjectID),
                state: this.allocations[i].state,
                function: this.allocations[i].function,
                percentage: `${this.allocations[i].percentage}`,
            });
        }
        let buildingsObject = [];
        for (let i = 0; i < this.buildings.length; i++) {
            buildingsObject.push({
                building: JSON.stringify(this.buildings[i].buildingName),
                materialEstimates: [],
            });
            for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
                buildingsObject[i].materialEstimates.push({
                    cost: this.buildings[i].materialEstimates[j].cost,
                    details: this.buildings[i].materialEstimates[j].unitOfPropertyDetails,
                    uopDescription: this.buildings[i].materialEstimates[j].unitOfPropertyDescription,
                    quantity: this.buildings[i].materialEstimates[j].quantity,
                    unitCosts: this.buildings[i].materialEstimates[j].unitCosts,
                    totalCosts: this.buildings[i].materialEstimates[j].totalCosts,
                });
            }
        }
        let laborDetailsObject = [];
        for (let i = 0; i < this.laborDetails.length; i++) {
            laborDetailsObject.push({
                workTask: JSON.stringify(this.laborDetails[i].workTask),
                workDescription: this.laborDetails[i].workDescription,
                chargeType: this.laborDetails[i].chargeType,
                totalCosts: this.laborDetails[i].totalCosts,
            });
        }
        let contingencyDetailsObject = [];
        for (let i = 0; i < this.contingencyDetails.length; i++) {
            contingencyDetailsObject.push({
                cost: this.contingencyDetails[i].cost,
                description: this.contingencyDetails[i].description,
                totalCosts: this.contingencyDetails[i].totalCosts,
            });
        }
        let filesObject = [];
        for (let i = 0; i < this.files.length; i++) {
            filesObject.push(JSON.stringify(this.files[i]));
        }
        let additionalApproverObject = [];
        for (let i = 0; i < this.approverList.length; i++) {
            additionalApproverObject.push({
                displayName: this.approverList[i].displayName,
                givenName: this.approverList[i].givenName,
                surname: this.approverList[i].surname,
                mail: this.approverList[i].mail,
                mailNickname: this.approverList[i].mailNickname,
                jobTitle: this.approverList[i].jobTitle,
                doaAmount: this.doaAmounts[i + 1],
            });
        }
        additionalApproverObject = _.orderBy(additionalApproverObject, [
            "doaAmount",
            "surname",
            "givenName",
            "displayName",
        ]);
        if (isFormDeletion) {
            let savedDate = new Date();
            let options = { month: "long", day: "numeric", year: "numeric" };
            let formattedDate = savedDate.toLocaleDateString("en-US", options);
            let savedTime = this.formatAMPM(savedDate);
            this.formActivity.unshift({
                name: this.userName,
                email: this.userEmail,
                comment: this.comments,
                action: "Deleted/Canceled",
                day: formattedDate,
                time: savedTime,
                status: this.formStatus,
            });
        }
        if (isFormEdit) {
            let savedDate = new Date();
            let options = { month: "long", day: "numeric", year: "numeric" };
            let formattedDate = savedDate.toLocaleDateString("en-US", options);
            let savedTime = this.formatAMPM(savedDate);
            this.formActivity.unshift({
                name: this.userName,
                email: this.userEmail,
                comment: "",
                action: "Made a Change",
                day: formattedDate,
                time: savedTime,
                status: this.formStatus,
            });
        }
        if (isApproval) {
            let savedDate = new Date();
            let options = { month: "long", day: "numeric", year: "numeric" };
            let formattedDate = savedDate.toLocaleDateString("en-US", options);
            let savedTime = this.formatAMPM(savedDate);
            this.formActivity.unshift({
                name: this.userName,
                email: this.userEmail,
                comment: this.reviewComments,
                action: "Approved",
                day: formattedDate,
                time: savedTime,
                status: this.formStatus,
            });
        }
        if (isRejection) {
            let savedDate = new Date();
            let options = { month: "long", day: "numeric", year: "numeric" };
            let formattedDate = savedDate.toLocaleDateString("en-US", options);
            let savedTime = this.formatAMPM(savedDate);
            this.formActivity.unshift({
                name: this.userName,
                email: this.userEmail,
                comment: this.reviewComments,
                action: "Rejected",
                day: formattedDate,
                time: savedTime,
                status: this.formStatus,
            });
        }
        if (isCompletion) {
            let savedDate = new Date();
            let options = { month: "long", day: "numeric", year: "numeric" };
            let formattedDate = savedDate.toLocaleDateString("en-US", options);
            let savedTime = this.formatAMPM(savedDate);
            this.formActivity.unshift({
                name: this.userName,
                email: this.userEmail,
                comment: this.comments,
                action: "Completed",
                day: formattedDate,
                time: savedTime,
                status: this.formStatus,
            });
        }
        if (isChargingDetails) {
            let savedDate = new Date();
            let options = { month: "long", day: "numeric", year: "numeric" };
            let formattedDate = savedDate.toLocaleDateString("en-US", options);
            let savedTime = this.formatAMPM(savedDate);
            this.formActivity.unshift({
                name: this.userName,
                email: this.userEmail,
                comment: this.comments,
                action: "Added Charging Details",
                day: formattedDate,
                time: savedTime,
                status: this.formStatus,
            });
            sendingChargingEmail = true;
            sendingChargingReceiver = [
                this.formOwner.mail,
                this.primaryContact.mail,
            ];
            sendingChargingFirstName = [
                this.formOwner.givenName,
                this.primaryContact.givenName,
            ];
        }
        if (isResubmission) {
            let savedDate = new Date();
            let options = { month: "long", day: "numeric", year: "numeric" };
            let formattedDate = savedDate.toLocaleDateString("en-US", options);
            let savedTime = this.formatAMPM(savedDate);
            this.formActivity.unshift({
                name: this.userName,
                email: this.userEmail,
                comment: this.reviewComments,
                action: "Resubmitted",
                day: formattedDate,
                time: savedTime,
                status: this.formStatus,
            });
        }
        if (isFormEdit) {
            sendingModifiedEmail = false;
            sendingModifiedReceiver = [];
            sendingModifiedFirstName = [];
            sendingModifiedName = "";
        }
        let etsPacAssignmentValue = {};
        let currentAssignmentValue = {};
        if (isFirstPACUser) {
            etsPacAssignmentValue = {
                displayName: "",
                givenName: this.firstName,
                surname: this.lastName,
                mail: this.userEmail,
                mailNickname: "",
                jobTitle: "",
                doaAmount: "",
            };
            currentAssignmentValue = {
                displayName: "",
                givenName: this.firstName,
                surname: this.lastName,
                mail: this.userEmail,
                mailNickname: "",
                jobTitle: "",
                doaAmount: "",
            };
        }
        else {
            etsPacAssignmentValue = this.etsPacAssignment;
            currentAssignmentValue = this.currentAssignment;
        }
        if (isFirstAssetUser) {
            currentAssignmentValue = {
                displayName: "",
                givenName: this.firstName,
                surname: this.lastName,
                mail: this.userEmail,
                mailNickname: "",
                jobTitle: "",
                doaAmount: "",
            };
        }
        let formStatusValue = "";
        if (isFormDeletion) {
            formStatusValue = this.formStatus;
        }
        if (isApproval) {
            if (this.formStatus === "ET&S PAC Review" &&
                (this.hardwareOrSoftware === "Hardware Only" ||
                    this.hardwareOrSoftware === "O&M Only")) {
                formStatusValue = "IT Sponsor Review";
                currentAssignmentValue = this.itSponsor;
                sendingReviewEmail = true;
                sendingReviewReceiver = [this.itSponsor.mail];
                sendingReviewFirstName = [this.itSponsor.givenName];
                sendingModifiedEmail = true;
                sendingModifiedReceiver = [
                    this.formOwner.mail,
                    this.etsPacAssignment.mail,
                ];
                sendingModifiedFirstName = [
                    this.formOwner.givenName,
                    this.etsPacAssignment.givenName,
                ];
                sendingModifiedName = this.currentAssignment.givenName
                    .concat(" ")
                    .concat(this.currentAssignment.surname);
            }
            else if (this.formStatus === "ET&S PAC Review" &&
                (this.hardwareOrSoftware === "Hardware and Software" ||
                    this.hardwareOrSoftware === "Software Only")) {
                formStatusValue = "Lead ET&S PAC Review";
                currentAssignmentValue = this.leadPacReviewer;
                sendingReviewEmail = true;
                sendingReviewReceiver = [this.leadPacReviewer.mail];
                sendingReviewFirstName = [this.leadPacReviewer.givenName];
                sendingModifiedEmail = true;
                sendingModifiedReceiver = [
                    this.formOwner.mail,
                    this.etsPacAssignment.mail,
                ];
                sendingModifiedFirstName = [
                    this.formOwner.givenName,
                    this.etsPacAssignment.givenName,
                ];
                sendingModifiedName = this.currentAssignment.givenName
                    .concat(" ")
                    .concat(this.currentAssignment.surname);
            }
            else if (this.formStatus === "Lead ET&S PAC Review") {
                this.selectAssetReviewer();
                currentAssignmentValue = this.assetReviewer;
                formStatusValue = "Asset Accounting Review";
                sendingReviewEmail = true;
                sendingReviewReceiver = [];
                sendingReviewFirstName = [];
                sendingReviewReceiver.push(this.assetReviewer.mail);
                sendingReviewFirstName.push(this.assetReviewer.givenName);
                sendingModifiedEmail = true;
                sendingModifiedReceiver = [
                    this.formOwner.mail,
                    this.etsPacAssignment.mail,
                ];
                sendingModifiedFirstName = [
                    this.formOwner.givenName,
                    this.etsPacAssignment.givenName,
                ];
                sendingModifiedName = this.currentAssignment.givenName
                    .concat(" ")
                    .concat(this.currentAssignment.surname);
            }
            else if (this.formStatus === "Asset Accounting Review") {
                formStatusValue = "IT Sponsor Review";
                currentAssignmentValue = this.itSponsor;
                sendingReviewEmail = true;
                sendingReviewReceiver = [this.itSponsor.mail];
                sendingReviewFirstName = [this.itSponsor.givenName];
                sendingModifiedEmail = true;
                sendingModifiedReceiver = [
                    this.formOwner.mail,
                    this.etsPacAssignment.mail,
                ];
                sendingModifiedFirstName = [
                    this.formOwner.givenName,
                    this.etsPacAssignment.givenName,
                ];
                sendingModifiedName = this.currentAssignment.givenName
                    .concat(" ")
                    .concat(this.currentAssignment.surname);
            }
            else if (this.formStatus === "IT Sponsor Review" &&
                this.approverList &&
                this.approverList.length > 0) {
                formStatusValue = "DOA Review 0";
                currentAssignmentValue = this.approverList[0];
                sendingReviewEmail = true;
                sendingReviewReceiver = [this.approverList[0].mail];
                sendingReviewFirstName = [this.approverList[0].givenName];
                sendingModifiedEmail = true;
                sendingModifiedReceiver = [
                    this.formOwner.mail,
                    this.etsPacAssignment.mail,
                ];
                sendingModifiedFirstName = [
                    this.formOwner.givenName,
                    this.etsPacAssignment.givenName,
                ];
                sendingModifiedName = this.currentAssignment.givenName
                    .concat(" ")
                    .concat(this.currentAssignment.surname);
            }
            else if (this.formStatus === "IT Sponsor Review" &&
                (!this.approverList || this.approverList.length === 0)) {
                if ((!this.isAllFlagged() && !this.isMixed()) || !this.isJointOwnerEligible()) {
                    formStatusValue = "Approved";
                    currentAssignmentValue = this.etsPacAssignment;
                    sendingCompletionEmail = true;
                    sendingCompletionReceiver = [this.etsPacAssignment.mail];
                    sendingCompletionFirstName = [this.etsPacAssignment.givenName];
                    sendingModifiedEmail = true;
                    sendingModifiedReceiver = [this.formOwner.mail];
                    sendingModifiedFirstName = [this.formOwner.givenName];
                    sendingModifiedName = this.currentAssignment.givenName
                        .concat(" ")
                        .concat(this.currentAssignment.surname);
                }
                else {
                    formStatusValue = "Joint Owner Review";
                    currentAssignmentValue = this.jointOwnerCoordinator;
                    sendingReviewEmail = true;
                    sendingReviewReceiver = [this.jointOwnerCoordinator.mail];
                    sendingReviewFirstName = [this.jointOwnerCoordinator.givenName];
                    if (this.isAllFlagged()) {
                        sendingModifiedEmail = true;
                        sendingModifiedReceiver = [
                            this.formOwner.mail,
                            this.etsPacAssignment.mail,
                        ];
                        sendingModifiedFirstName = [
                            this.formOwner.givenName,
                            this.etsPacAssignment.givenName,
                        ];
                        sendingModifiedName = this.currentAssignment.givenName
                            .concat(" ")
                            .concat(this.currentAssignment.surname);
                    }
                    else if (this.isMixed()) {
                        sendingModifiedEmail = true;
                        sendingModifiedReceiver = [this.formOwner.mail];
                        sendingModifiedFirstName = [this.formOwner.givenName];
                        sendingModifiedName = this.currentAssignment.givenName
                            .concat(" ")
                            .concat(this.currentAssignment.surname);
                        sendingReadyChargingEmail = true;
                        sendingReadyChargingReceiver = [this.etsPacAssignment.mail];
                        sendingReadyChargingFirstName = [this.etsPacAssignment.givenName];
                    }
                }
            }
            else if (this.formStatus.startsWith("DOA Review")) {
                let matchIndex = Number(this.formStatus.substring(11));
                if (matchIndex === this.approverList.length - 1) {
                    if ((!this.isAllFlagged() && !this.isMixed()) || !this.isJointOwnerEligible()) {
                        formStatusValue = "Approved";
                        currentAssignmentValue = this.etsPacAssignment;
                        sendingCompletionEmail = true;
                        sendingCompletionReceiver = [this.etsPacAssignment.mail];
                        sendingCompletionFirstName = [this.etsPacAssignment.givenName];
                        sendingModifiedEmail = true;
                        sendingModifiedReceiver = [this.formOwner.mail];
                        sendingModifiedFirstName = [this.formOwner.givenName];
                        sendingModifiedName = this.currentAssignment.givenName
                            .concat(" ")
                            .concat(this.currentAssignment.surname);
                    }
                    else {
                        formStatusValue = "Joint Owner Review";
                        currentAssignmentValue = this.jointOwnerCoordinator;
                        sendingReviewEmail = true;
                        sendingReviewReceiver = [this.jointOwnerCoordinator.mail];
                        sendingReviewFirstName = [this.jointOwnerCoordinator.givenName];
                        if (this.isAllFlagged()) {
                            sendingModifiedEmail = true;
                            sendingModifiedReceiver = [
                                this.formOwner.mail,
                                this.etsPacAssignment.mail,
                            ];
                            sendingModifiedFirstName = [
                                this.formOwner.givenName,
                                this.etsPacAssignment.givenName,
                            ];
                            sendingModifiedName = this.currentAssignment.givenName
                                .concat(" ")
                                .concat(this.currentAssignment.surname);
                        }
                        else if (this.isMixed()) {
                            sendingModifiedEmail = true;
                            sendingModifiedReceiver = [this.formOwner.mail];
                            sendingModifiedFirstName = [this.formOwner.givenName];
                            sendingModifiedName = this.currentAssignment.givenName
                                .concat(" ")
                                .concat(this.currentAssignment.surname);
                            sendingReadyChargingEmail = true;
                            sendingReadyChargingReceiver = [this.etsPacAssignment.mail];
                            sendingReadyChargingFirstName = [this.etsPacAssignment.givenName];
                        }
                    }
                }
                else {
                    currentAssignmentValue = this.approverList[matchIndex + 1];
                    formStatusValue = "DOA Review ".concat((matchIndex + 1).toString());
                    sendingReviewEmail = true;
                    sendingReviewReceiver = [this.approverList[matchIndex + 1].mail];
                    sendingReviewFirstName = [
                        this.approverList[matchIndex + 1].givenName,
                    ];
                    sendingModifiedEmail = true;
                    sendingModifiedReceiver = [
                        this.formOwner.mail,
                        this.etsPacAssignment.mail,
                    ];
                    sendingModifiedFirstName = [
                        this.formOwner.givenName,
                        this.etsPacAssignment.givenName,
                    ];
                    sendingModifiedName = this.currentAssignment.givenName
                        .concat(" ")
                        .concat(this.currentAssignment.surname);
                }
            }
            else if (this.formStatus === "Joint Owner Review") {
                formStatusValue = "Approved";
                currentAssignmentValue = this.etsPacAssignment;
                sendingCompletionEmail = true;
                sendingCompletionReceiver = [this.etsPacAssignment.mail];
                sendingCompletionFirstName = [this.etsPacAssignment.givenName];
                sendingModifiedEmail = true;
                sendingModifiedReceiver = [this.formOwner.mail];
                sendingModifiedFirstName = [this.formOwner.givenName];
                sendingModifiedName = this.currentAssignment.givenName
                    .concat(" ")
                    .concat(this.currentAssignment.surname);
            }
        }
        else {
            formStatusValue = this.formStatus;
        }
        if (isRejection) {
            if (this.formStatus === "Joint Owner Review" &&
                this.isMixed() &&
                !this.tables) {
                formStatusValue = "Approved, Rejected by Joint Owners";
                currentAssignmentValue = this.etsPacAssignment;
                sendingJointOwnerRejectCompleteEmail = true;
                sendingJointOwnerRejectCompleteReceiver = [
                    this.etsPacAssignment.mail,
                ];
                sendingJointOwnerRejectCompleteFirstName = [
                    this.etsPacAssignment.givenName,
                ];
                sendingJointOwnerRejectCompleteName = this.currentAssignment.givenName
                    .concat(" ")
                    .concat(this.currentAssignment.surname);
                sendingJointOwnerRejectCompleteComments = this.reviewComments;
                sendingModifiedEmail = true;
                sendingModifiedReceiver = [this.formOwner.mail];
                sendingModifiedFirstName = [this.formOwner.givenName];
                sendingModifiedName = this.currentAssignment.givenName
                    .concat(" ")
                    .concat(this.currentAssignment.surname);
            }
            else if (this.formStatus === "Joint Owner Review") {
                formStatusValue = "Completed, Rejected by Joint Owners";
                sendingRejectedEmail = true;
                sendingRejectedReceiver = [this.etsPacAssignment.mail];
                sendingRejectedFirstName = [this.etsPacAssignment.givenName];
                sendingRejectedName = this.currentAssignment.givenName
                    .concat(" ")
                    .concat(this.currentAssignment.surname);
                sendingRejectedComments = this.reviewComments;
            }
            else {
                let rejectedCurrentAssignment = this.currentAssignment;
                formStatusValue = "Rejected";
                currentAssignmentValue = this.formOwner;
                sendingRejectedEmail = true;
                sendingRejectedReceiver = [this.etsPacAssignment.mail];
                sendingRejectedFirstName = [this.etsPacAssignment.givenName];
                sendingRejectedName = rejectedCurrentAssignment.givenName
                    .concat(" ")
                    .concat(rejectedCurrentAssignment.surname);
                sendingRejectedComments = this.reviewComments;
                sendingRejectedReadyEmail = true;
                sendingRejectedReadyReceiver = [this.formOwner.mail];
                sendingRejectedReadyFirstName = [this.formOwner.givenName];
                sendingRejectedReadyName = rejectedCurrentAssignment.givenName
                    .concat(" ")
                    .concat(rejectedCurrentAssignment.surname);
                sendingRejectedReadyComments = this.reviewComments;
            }
        }
        if (isResubmission) {
            formStatusValue = "ET&S PAC Review";
            if (this.etsPacAssignment.mail) {
                currentAssignmentValue = this.etsPacAssignment;
                sendingReviewEmail = true;
                sendingReviewReceiver = [this.etsPacAssignment.mail];
                sendingReviewFirstName = [this.etsPacAssignment.givenName];
            }
            else {
                currentAssignmentValue = {
                    displayName: "",
                    givenName: "",
                    surname: "",
                    mail: "",
                    mailNickname: "",
                    jobTitle: "",
                    doaAmount: "",
                };
                sendingReviewEmail = true;
                // send to PAC's group email
                sendingReviewReceiver = [this.pacEmail.mail];
                sendingReviewFirstName = ["ITPAC"];
            }
        }
        if (isCompletion) {
            if (this.formStatus === "Approved, Rejected by Joint Owners") {
                formStatusValue = "Completed, Rejected by Joint Owners";
                sendingFormCompletedEmail = false;
                sendingChargingEmail = true;
                sendingChargingReceiver = [this.etsPacAssignment.mail];
                sendingChargingFirstName = [this.etsPacAssignment.givenName];
            }
            else {
                formStatusValue = "Completed";
                sendingFormCompletedEmail = true;
                sendingFormCompletedReceiver = [
                    this.formOwner.mail,
                    this.primaryContact.mail,
                ];
                sendingFormCompletedFirstName = [
                    this.formOwner.givenName,
                    this.primaryContact.givenName,
                ];
                sendingFormCompletedName = this.currentAssignment.givenName
                    .concat(" ")
                    .concat(this.currentAssignment.surname);
                sendingFormCompletedComments = this.comments;
            }
            currentAssignmentValue = {
                displayName: "",
                givenName: "",
                surname: "",
                mail: "",
                mailNickname: "",
                jobTitle: "",
                doaAmount: "",
            };
        }
        let callBody = {
            itSparGuid: this.itSparGuid,
            patiId: JSON.stringify(this.patiProject),
            shortDescription: this.projectName,
            etsProjectClassification: JSON.stringify(this.itProjectClassification),
            estimatedStartDate: this.convertToDateStringFormat(this.estimatedStartDate),
            estimatedInServiceDate: this.convertToDateStringFormat(this.estimatedInServiceDate),
            overviewAndScope: this.projectScopeDescription,
            primaryContact: {
                displayName: this.primaryContact
                    ? this.primaryContact.displayName
                    : null,
                givenName: this.primaryContact ? this.primaryContact.givenName : null,
                surname: this.primaryContact ? this.primaryContact.surname : null,
                mail: this.primaryContact ? this.primaryContact.mail : null,
                mailNickname: this.primaryContact
                    ? this.primaryContact.mailNickname
                    : null,
                jobTitle: this.primaryContact ? this.primaryContact.jobTitle : null,
            },
            itSponsor: {
                displayName: this.itSponsor ? this.itSponsor.displayName : null,
                givenName: this.itSponsor ? this.itSponsor.givenName : null,
                surname: this.itSponsor ? this.itSponsor.surname : null,
                mail: this.itSponsor ? this.itSponsor.mail : null,
                mailNickname: this.itSponsor ? this.itSponsor.mailNickname : null,
                jobTitle: this.itSponsor ? this.itSponsor.jobTitle : null,
                doaAmount: this.doaAmounts && this.doaAmounts.length > 0
                    ? this.doaAmounts[0]
                    : null,
            },
            omOnly: this.omOnly,
            relatedWork: this.relatedWork,
            hardwareOrSoftware: this.hardwareOrSoftware,
            purchasingWarranties: this.purchasingWarranties,
            projectConsistsOf: this.projectConsistsOf,
            expectedLife: this.expectedLife,
            agileEffort: this.agileEffort,
            softwareBeingUsed: this.softwareBeingUsed,
            vendorName: this.vendorName,
            softwareName: this.softwareName,
            inServiceYear: this.inServiceYear,
            softwareProjectOverview: this.softwareProjectOverview,
            dataConversionActivities: this.dataConversionActivities,
            trainingCosts: this.trainingCosts,
            associatedRetirement: this.associatedRetirement,
            softwareToBeRetired: this.softwareToBeRetired,
            retiredInServiceDate: this.retiredInServiceDate,
            maintenanceContracts: this.maintenanceContracts,
            replacingInterfaces: this.replacingInterfaces,
            howSoftwareReleased: this.howSoftwareReleased,
            perpetualLicenses: this.perpetualLicenses,
            contractualRight: this.contractualRight,
            significantPenalty: this.significantPenalty,
            isFeasible: this.isFeasible,
            serviceFees: this.serviceFees,
            useWithoutPaying: this.useWithoutPaying,
            department: JSON.stringify(this.department),
            buildingInfo: JSON.stringify(this.buildingInfo),
            releaseDetails: releaseDetailsObject,
            distributeCost: JSON.stringify(this.distributeCost),
            defaultOption: JSON.stringify(this.defaultOption),
            allocations: allocationsObject,
            buildings: buildingsObject,
            laborDetails: laborDetailsObject,
            contingencyDetails: contingencyDetailsObject,
            additionalComments: this.additionalComments,
            attachments: filesObject,
            approvers: additionalApproverObject,
            formStatus: formStatusValue,
            formActivity: this.formActivity,
            currentApprover: this.currentApprover,
            formOwner: this.formOwner,
            etsPacAssignment: etsPacAssignmentValue,
            currentAssignment: currentAssignmentValue,
            tables: JSON.stringify(this.tables),
            effectiveDate: this.effectiveDate
                ? this.convertToDateStringFormat(new Date(this.effectiveDate))
                : "",
            formNumber: this.formNumber,
            displayRevisionNumber: this.displayRevisionNumber,
            previousCapitalSubtotal: this.previousCapitalSubtotal.toString(),
            previousOMSubtotal: this.previousOMSubtotal.toString(),
            itProjects: this.itProjects ? JSON.stringify(this.itProjects) : "",
        };
        if (isApproval && formStatusValue === "Approved") {
            let dataStructure = {
                sendingReviewEmail: sendingReviewEmail,
                sendingReviewReceiver: sendingReviewReceiver,
                sendingReviewFirstName: sendingReviewFirstName,
                sendingModifiedEmail: sendingModifiedEmail,
                sendingModifiedReceiver: sendingModifiedReceiver,
                sendingModifiedFirstName: sendingModifiedFirstName,
                sendingModifiedName: sendingModifiedName,
                sendingChargingEmail: sendingChargingEmail,
                sendingChargingReceiver: sendingChargingReceiver,
                sendingChargingFirstName: sendingChargingFirstName,
                sendingCompletionEmail: sendingCompletionEmail,
                sendingCompletionReceiver: sendingCompletionReceiver,
                sendingCompletionFirstName: sendingCompletionFirstName,
                sendingReadyChargingEmail: sendingReadyChargingEmail,
                sendingReadyChargingReceiver: sendingReadyChargingReceiver,
                sendingReadyChargingFirstName: sendingReadyChargingFirstName,
                sendingJointOwnerRejectCompleteEmail: sendingJointOwnerRejectCompleteEmail,
                sendingJointOwnerRejectCompleteReceiver: sendingJointOwnerRejectCompleteReceiver,
                sendingJointOwnerRejectCompleteFirstName: sendingJointOwnerRejectCompleteFirstName,
                sendingJointOwnerRejectCompleteName: sendingJointOwnerRejectCompleteName,
                sendingJointOwnerRejectCompleteComments: sendingJointOwnerRejectCompleteComments,
                sendingRejectedEmail: sendingRejectedEmail,
                sendingRejectedReceiver: sendingRejectedReceiver,
                sendingRejectedFirstName: sendingRejectedFirstName,
                sendingRejectedName: sendingRejectedName,
                sendingRejectedComments: sendingRejectedComments,
                sendingRejectedReadyEmail: sendingRejectedReadyEmail,
                sendingRejectedReadyReceiver: sendingRejectedReadyReceiver,
                sendingRejectedReadyFirstName: sendingRejectedReadyFirstName,
                sendingRejectedReadyName: sendingRejectedReadyName,
                sendingRejectedReadyComments: sendingRejectedReadyComments,
                sendingFormCompletedEmail: sendingFormCompletedEmail,
                sendingFormCompletedReceiver: sendingFormCompletedReceiver,
                sendingFormCompletedFirstName: sendingFormCompletedFirstName,
                sendingFormCompletedName: sendingFormCompletedName,
                sendingFormCompletedComments: sendingFormCompletedComments,
                callBody: callBody,
            };
            // Prevent Action Taken emails when this is a plain form edit/save
            if (isFormEdit) {
                dataStructure.sendingModifiedEmail = false;
                dataStructure.sendingModifiedReceiver = [];
                dataStructure.sendingModifiedFirstName = [];
                dataStructure.sendingModifiedName = "";
            }
            if (this.config.getConfig("powerplan_enabled")) {
                let projectSubmissions = [];
                let projectNumbers = [];
                let businessUnits = [];
                for (let i = 0; i < this.itProjects.length; i++) {
                    projectSubmissions.push(this.createProjectSubmissionBody(this.itProjects[i], i));
                    projectNumbers.push(this.itProjects[i].projectID);
                    businessUnits.push(this.itProjects[i].businessUnit);
                }
                this.submitProjects(projectSubmissions, dataStructure, null, projectNumbers, businessUnits, []);
            }
            else {
                const notificationType = this.formStatus === "Joint Owner Review" ? "catawba" : "standard";
                this.dataService.saveItSparData(callBody).subscribe((result) => {
                    if (result.statusCode !== 200) {
                        console.log("error", result);
                        let errorType = "";
                        let errorDescription = result;
                        let errorDataStructure = {
                            errorType: errorType,
                            errorDescription: errorDescription,
                        };
                        this.dialog.open(ErrorDialogComponent, {
                            data: errorDataStructure,
                            disableClose: true,
                        });
                    }
                    this.sendEmailNotifications(dataStructure);
                    this.getItSparData(this.itSparGuid, this.displayRevisionNumber);
                    this.sendItpacNotificationEmail(notificationType);
                }, (error) => {
                    console.log("error", error);
                    let errorType = "";
                    let errorDescription = "";
                    if (error.error.message) {
                        errorDescription = errorDescription.concat("Save IT SPAR Data Error - ", error.error.message);
                    }
                    else {
                        errorDescription = errorDescription.concat("Save IT SPAR Data Error");
                    }
                    errorType = errorType.concat(error.status, " ", error.statusText);
                    let errorDataStructure = {
                        errorType: errorType,
                        errorDescription: errorDescription,
                    };
                    this.dialog.open(ErrorDialogComponent, {
                        data: errorDataStructure,
                        disableClose: true,
                    });
                });
            }
        }
        else if ((isRejection &&
            formStatusValue === "Approved, Rejected by Joint Owners") ||
            formStatusValue === "Completed, Rejected by Joint Owners") {
            let dataStructure = {
                sendingReviewEmail: sendingReviewEmail,
                sendingReviewReceiver: sendingReviewReceiver,
                sendingReviewFirstName: sendingReviewFirstName,
                sendingModifiedEmail: sendingModifiedEmail,
                sendingModifiedReceiver: sendingModifiedReceiver,
                sendingModifiedFirstName: sendingModifiedFirstName,
                sendingModifiedName: sendingModifiedName,
                sendingChargingEmail: sendingChargingEmail,
                sendingChargingReceiver: sendingChargingReceiver,
                sendingChargingFirstName: sendingChargingFirstName,
                sendingCompletionEmail: sendingCompletionEmail,
                sendingCompletionReceiver: sendingCompletionReceiver,
                sendingCompletionFirstName: sendingCompletionFirstName,
                sendingReadyChargingEmail: sendingReadyChargingEmail,
                sendingReadyChargingReceiver: sendingReadyChargingReceiver,
                sendingReadyChargingFirstName: sendingReadyChargingFirstName,
                sendingJointOwnerRejectCompleteEmail: sendingJointOwnerRejectCompleteEmail,
                sendingJointOwnerRejectCompleteReceiver: sendingJointOwnerRejectCompleteReceiver,
                sendingJointOwnerRejectCompleteFirstName: sendingJointOwnerRejectCompleteFirstName,
                sendingJointOwnerRejectCompleteName: sendingJointOwnerRejectCompleteName,
                sendingJointOwnerRejectCompleteComments: sendingJointOwnerRejectCompleteComments,
                sendingRejectedEmail: sendingRejectedEmail,
                sendingRejectedReceiver: sendingRejectedReceiver,
                sendingRejectedFirstName: sendingRejectedFirstName,
                sendingRejectedName: sendingRejectedName,
                sendingRejectedComments: sendingRejectedComments,
                sendingRejectedReadyEmail: sendingRejectedReadyEmail,
                sendingRejectedReadyReceiver: sendingRejectedReadyReceiver,
                sendingRejectedReadyFirstName: sendingRejectedReadyFirstName,
                sendingRejectedReadyName: sendingRejectedReadyName,
                sendingRejectedReadyComments: sendingRejectedReadyComments,
                sendingFormCompletedEmail: sendingFormCompletedEmail,
                sendingFormCompletedReceiver: sendingFormCompletedReceiver,
                sendingFormCompletedFirstName: sendingFormCompletedFirstName,
                sendingFormCompletedName: sendingFormCompletedName,
                sendingFormCompletedComments: sendingFormCompletedComments,
                callBody: callBody,
            };
            if (this.config.getConfig("powerplan_enabled")) {
                let projectSubmissions = [];
                let projectNumbers = [];
                let businessUnits = [];
                for (let i = 0; i < this.itProjects.length; i++) {
                    if (!this.catawbaOperatingUnits.includes(this.itProjects[i].operatingUnit)) {
                        projectSubmissions.push(this.createProjectSubmissionBody(this.itProjects[i], i));
                        projectNumbers.push(this.itProjects[i].projectID);
                        businessUnits.push(this.itProjects[i].businessUnit);
                    }
                }
                this.submitProjects(projectSubmissions, dataStructure, true, projectNumbers, businessUnits, []);
            }
            else {
                this.dataService.saveItSparData(callBody).subscribe((result) => {
                    if (result.statusCode !== 200) {
                        console.log("error", result);
                        let errorType = "";
                        let errorDescription = result;
                        let errorDataStructure = {
                            errorType: errorType,
                            errorDescription: errorDescription,
                        };
                        this.dialog.open(ErrorDialogComponent, {
                            data: errorDataStructure,
                            disableClose: true,
                        });
                    }
                    this.sendEmailNotifications(dataStructure);
                    this.getItSparData(this.itSparGuid, this.displayRevisionNumber);
                    this.sendItpacNotificationEmail("non-catawba");
                }, (error) => {
                    console.log("error", error);
                    let errorType = "";
                    let errorDescription = "";
                    if (error.error.message) {
                        errorDescription = errorDescription.concat("Save IT SPAR Data Error - ", error.error.message);
                    }
                    else {
                        errorDescription = errorDescription.concat("Save IT SPAR Data Error");
                    }
                    errorType = errorType.concat(error.status, " ", error.statusText);
                    let errorDataStructure = {
                        errorType: errorType,
                        errorDescription: errorDescription,
                    };
                    this.dialog.open(ErrorDialogComponent, {
                        data: errorDataStructure,
                        disableClose: true,
                    });
                });
            }
        }
        else {
            this.dataService.saveItSparData(callBody).subscribe((result) => {
                if (result.statusCode !== 200) {
                    console.log("error", result);
                    let errorType = "";
                    let errorDescription = result;
                    let dataStructure = {
                        errorType: errorType,
                        errorDescription: errorDescription,
                    };
                    this.dialog.open(ErrorDialogComponent, {
                        data: dataStructure,
                        disableClose: true,
                    });
                }
                let dataStructure = {
                    sendingReviewEmail: sendingReviewEmail,
                    sendingReviewReceiver: sendingReviewReceiver,
                    sendingReviewFirstName: sendingReviewFirstName,
                    sendingModifiedEmail: sendingModifiedEmail,
                    sendingModifiedReceiver: sendingModifiedReceiver,
                    sendingModifiedFirstName: sendingModifiedFirstName,
                    sendingModifiedName: sendingModifiedName,
                    sendingChargingEmail: sendingChargingEmail,
                    sendingChargingReceiver: sendingChargingReceiver,
                    sendingChargingFirstName: sendingChargingFirstName,
                    sendingCompletionEmail: sendingCompletionEmail,
                    sendingCompletionReceiver: sendingCompletionReceiver,
                    sendingCompletionFirstName: sendingCompletionFirstName,
                    sendingReadyChargingEmail: sendingReadyChargingEmail,
                    sendingReadyChargingReceiver: sendingReadyChargingReceiver,
                    sendingReadyChargingFirstName: sendingReadyChargingFirstName,
                    sendingJointOwnerRejectCompleteEmail: sendingJointOwnerRejectCompleteEmail,
                    sendingJointOwnerRejectCompleteReceiver: sendingJointOwnerRejectCompleteReceiver,
                    sendingJointOwnerRejectCompleteFirstName: sendingJointOwnerRejectCompleteFirstName,
                    sendingJointOwnerRejectCompleteName: sendingJointOwnerRejectCompleteName,
                    sendingJointOwnerRejectCompleteComments: sendingJointOwnerRejectCompleteComments,
                    sendingRejectedEmail: sendingRejectedEmail,
                    sendingRejectedReceiver: sendingRejectedReceiver,
                    sendingRejectedFirstName: sendingRejectedFirstName,
                    sendingRejectedName: sendingRejectedName,
                    sendingRejectedComments: sendingRejectedComments,
                    sendingRejectedReadyEmail: sendingRejectedReadyEmail,
                    sendingRejectedReadyReceiver: sendingRejectedReadyReceiver,
                    sendingRejectedReadyFirstName: sendingRejectedReadyFirstName,
                    sendingRejectedReadyName: sendingRejectedReadyName,
                    sendingRejectedReadyComments: sendingRejectedReadyComments,
                    sendingFormCompletedEmail: sendingFormCompletedEmail,
                    sendingFormCompletedReceiver: sendingFormCompletedReceiver,
                    sendingFormCompletedFirstName: sendingFormCompletedFirstName,
                    sendingFormCompletedName: sendingFormCompletedName,
                    sendingFormCompletedComments: sendingFormCompletedComments,
                };
                if (!isFormEdit && !isAttachmentOnly) {
                    this.sendEmailNotifications(dataStructure);
                }
                if (!isAttachmentOnly) {
                    if (!isRevisionStart) {
                        this.getItSparData(this.itSparGuid, this.displayRevisionNumber);
                    }
                    else {
                        sessionStorage.setItem("itSparGuid", JSON.stringify(this.itSparGuid));
                        sessionStorage.setItem("isRevision", "yes");
                        sessionStorage.setItem("previousCapitalSubtotal", this.subtotalCapital().toString());
                        sessionStorage.setItem("previousOMSubtotal", this.subtotalOM().toString());
                        sessionStorage.setItem("displayRevisionNumber", this.displayRevisionNumber.toString());
                        this.router.navigate(["/it-project-setup"]);
                    }
                }
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Save IT SPAR Data Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Save IT SPAR Data Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            });
        }
    }
    formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? "0" + minutes : minutes;
        var strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
    }
    convertToDateStringFormat(date) {
        return (date.getFullYear().toString() +
            "-" +
            (date.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            date.getDate().toString().padStart(2, "0"));
    }
    isCurrentApprover() {
        return (this.userEmail &&
            this.currentAssignment.mail &&
            this.userEmail.toLowerCase() === this.currentAssignment.mail.toLowerCase());
    }
    readyForReview() {
        return ((this.formStatus === "ET&S PAC Review" ||
            this.formStatus === "Lead ET&S PAC Review" ||
            this.formStatus === "Asset Accounting Review" ||
            this.formStatus === "IT Sponsor Review" ||
            this.formStatus.startsWith("DOA Review") ||
            this.formStatus === "Joint Owner Review") &&
            this.isCurrentApprover() &&
            !this.formResubmitted());
    }
    beingReviewed() {
        return ((this.formStatus === "ET&S PAC Review" ||
            this.formStatus === "Lead ET&S PAC Review" ||
            this.formStatus === "Asset Accounting Review" ||
            this.formStatus === "IT Sponsor Review" ||
            this.formStatus.startsWith("DOA Review") ||
            this.formStatus === "Joint Owner Review") &&
            !this.isCurrentApprover() &&
            !this.youApprovedForm() &&
            !this.youRejectedForm() &&
            !this.awaitingJointOwner());
    }
    youRejectedForm() {
        if (!this.formActivity || this.formActivity.length === 0) {
            return false;
        }
        return (this.formActivity[0].name === this.userName &&
            this.formActivity[0].action === "Rejected" &&
            !this.readyForReview() &&
            !this.rejectedNeedingEdits() &&
            !this.readyForCompletion());
    }
    formRejected() {
        return (this.formStatus === "Rejected" &&
            !this.youRejectedForm() &&
            !this.rejectedNeedingEdits());
    }
    youApprovedForm() {
        if (!this.formActivity || this.formActivity.length === 0) {
            return false;
        }
        return (this.formActivity[0].name === this.userName &&
            this.formActivity[0].action === "Approved" &&
            !this.readyForReview() &&
            !this.readyForCompletion() &&
            !this.awaitingJointOwner());
    }
    awaitingJointOwner() {
        return (this.formStatus === "Joint Owner Review" &&
            this.isMixed() &&
            this.isPACUser() &&
            !this.readyForReview());
    }
    readyForCompletion() {
        return (this.formStatus === "Approved" ||
            this.formStatus === "Approved, Rejected by Joint Owners");
    }
    youCompleted() {
        if (!this.formActivity || this.formActivity.length === 0) {
            return false;
        }
        return (this.formActivity[0].name === this.userName &&
            this.formActivity[0].action === "Completed");
    }
    formCompleted() {
        return ((this.formStatus === "Completed" ||
            this.formStatus === "Completed, Rejected by Joint Owners") &&
            !this.youCompleted());
    }
    rejectedNeedingEdits() {
        return this.formStatus === "Rejected" && this.isCurrentApprover();
    }
    canEditForm() {
        if (this.isPACUser()) {
            return true;
        }
        return this.isFormOwner() && this.rejectedNeedingEdits();
    }
    formResubmitted() {
        if (!this.formActivity || this.formActivity.length < 2) {
            return false;
        }
        return (this.formStatus === "ET&S PAC Review" &&
            this.formActivity[0].action === "Submitted" &&
            this.formActivity[0].name === this.userName &&
            this.formActivity[1].action === "Rejected");
    }
    isAllFlagged() {
        let nonCatawbaFound = false;
        let catawbaFound = false;
        for (let i = 0; i < this.allocationsCopy.length; i++) {
            if (this.catawbaOperatingUnits.includes(this.allocationsCopy[i].operatingUnit.OPERATING_UNIT)) {
                catawbaFound = true;
            }
            else {
                nonCatawbaFound = true;
            }
        }
        return catawbaFound && !nonCatawbaFound;
    }
    isMixed() {
        let nonCatawbaFound = false;
        let catawbaFound = false;
        for (let i = 0; i < this.allocationsCopy.length; i++) {
            if (this.catawbaOperatingUnits.includes(this.allocationsCopy[i].operatingUnit.OPERATING_UNIT)) {
                catawbaFound = true;
            }
            else {
                nonCatawbaFound = true;
            }
        }
        return catawbaFound && nonCatawbaFound;
    }
    isJointOwnerEligible() {
        let catawbaTotal = 0;
        for (let i = 0; i < this.itProjects.length; i++) {
            if (this.catawbaOperatingUnits.includes(this.itProjects[i].operatingUnit) && this.estimateWithCapital(this.itProjects[i])) {
                for (let j = 0; j < this.itProjects[i].itProjectEstimates.length; j++) {
                    if (this.itProjects[i].itProjectEstimates[j].estimateType.includes("CAP")) {
                        catawbaTotal += this.itProjects[i].itProjectEstimates[j].dollarAmount;
                    }
                }
            }
        }
        return catawbaTotal >= 100000;
    }
    approveForm(isReject, isResubmit, validateForm, projectSetupform, projectEstimateForm) {
        if (validateForm) {
            this.showErrorsDisclaimer = false;
            // When resubmitting without being in edit mode, the form fields are
            // read-only and FormControls (primaryContact, itSponsor, etc.) have
            // never been bound to the DOM, so validateGraphUser() always returns
            // false — causing a "there are errors" banner with nothing highlighted.
            // The form was already validated at original submission. If the user
            // makes edits they must click SAVE FORM first, which validates then.
            if (!isResubmit || this.editFormMode) {
                projectSetupform.form.markAllAsTouched();
                projectEstimateForm.form.markAllAsTouched();
                if (!this.isProjectSetupFormValid(projectSetupform))
                    return;
                if (!this.isProjectEstimateFormValid(projectEstimateForm))
                    return;
            }
        }
        let dataStructure = {
            reviewComments: this.reviewComments,
            isReject: isReject,
            isResubmit: isResubmit,
        };
        let height;
        if (!this.reviewComments) {
            height = "14.5rem";
        }
        let dialogRef = this.dialog.open(FormApprovalDialogComponent, {
            data: dataStructure,
            disableClose: true,
            width: "50.375rem",
            height: height,
        });
        dialogRef.componentInstance.onYes.subscribe(() => {
            if (isReject) {
                this.saveItSparData(false, false, false, false, true);
            }
            else if (isResubmit) {
                this.passDataFromCopyToOriginal();
                if (this.editFormMode)
                    this.toggleEditFormMode();
                this.saveItSparData(false, false, false, false, false, true);
            }
            else {
                this.saveItSparData(false, false, true);
            }
        });
    }
    openChargingDetailsDialog(isCompletion) {
        let dataStructure = {
            formNumber: this.formNumber,
            revisionNumber: this.displayRevisionNumber,
            isCompletion: isCompletion,
            tables: this.tables,
            effectiveDate: this.effectiveDate,
            itProjectClassification: this.itProjectClassification,
            itProjects: this.itProjects,
            catawbaOperatingUnits: this.catawbaOperatingUnits,
            approvedAfterJointOwner: this.approvedAfterJointOwner(),
            rejectedByJointOwner: this.formStatus === 'Approved, Rejected by Joint Owners'
        };
        let dialogRef = this.dialog.open(AddCharginDetailsDialogComponent, {
            data: dataStructure,
            disableClose: true,
            width: "97vw",
            maxWidth: "1400px",
            height: "80vh",
        });
        dialogRef.componentInstance.onYes.subscribe((result) => {
            this.tables = result.tables;
            this.comments = result.comments;
            this.effectiveDate = result.effectiveDate;
            if (isCompletion) {
                this.saveItSparData(false, false, false, false, false, false, true);
            }
            else {
                this.saveItSparData(false, false, false, false, false, false, false, true);
            }
        });
    }
    getRowValue(tableIndex, rowIndex, columnIndex) {
        if (this.tables[tableIndex].tableData[rowIndex][columnIndex])
            return this.tables[tableIndex].tableData[rowIndex][columnIndex];
        return "";
    }
    getColumnDefs(tableIndex) {
        return [...this.tables[tableIndex].columns.map((c) => c.colNo)];
    }
    getFormStatus() {
        if (this.formStatus.startsWith("DOA Review"))
            return "DOA Review";
        switch (this.formStatus) {
            case "ET&S PAC Review":
                return "ITPAC Review";
            case "Lead ET&S PAC Review":
                return "Lead ITPAC Review";
            case "Asset Accounting Review":
                return "Asset Accounting Review";
            case "IT Sponsor Review":
                return "Sponsor Review";
            case "Joint Owner Review":
                return "Joint Owner Review";
            case "Approved":
                return "Approved";
            case "Approved, Rejected by Joint Owners":
                return "Approved, Rejected by Joint Owners";
            case "Completed":
                return "Completed";
            case "Completed, Rejected by Joint Owners":
                return "Completed, Rejected by Joint Owners";
            case "Rejected":
                return "Rejected";
        }
    }
    generatePDF() {
        printApprovalFormPDF(this);
    }
    openDeleteConfirmationDialog() {
        const dialogRef = this.dialog.open(ConfirmDeleteFormDialogComponent, {
            width: "400px",
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result === "delete") {
                this.deleteForm();
            }
        });
    }
    deleteForm() {
        console.log("Delete Form clicked");
        this.formStatus = "Canceled";
        this.saveItSparData(false, false, false, false, false, false, false, false, false, true);
        this.router.navigate(["/dashboard"]);
    }
    sendFailureEmail(dataStructure, isGenericError) {
        let emailBody = "";
        let emailSubject = "";
        /*
        dataStructure = {
                error: true,
                data: errorTexts,
                isEstimate: true,
              };*/
        /*
        let dataStructure = {
              errorType: errorType,
              errorDescription: errorDescription,
              isEstimate: true,
            };
        */
        if (!isGenericError) {
            emailBody = '<div style="width: 37.5rem;"><div style="text-align: center"><span style="color: rgb(158, 27, 50); font-size: 1.688rem;">PowerPlan Submission Failed</span></div>';
            emailBody = emailBody.concat('<div style="text-align: center; padding-top: 1.563rem; width: 31.25rem; margin: auto;"><div><div style="padding-bottom: 0.313rem;"><span style="color: #676767; font-size: 0.875rem;">Save failed with the following errors:</span></div>');
            for (let i = 0; i < dataStructure.data.length; i++) {
                emailBody = emailBody.concat('<div style="padding-bottom: 0.313rem;"><span style="color: #676767; font-size: 0.875rem;">');
                emailBody = emailBody.concat(dataStructure.data[i]);
                emailBody = emailBody.concat('</span></div>');
            }
            emailBody = emailBody.concat('</div></div>');
        }
        else {
            emailBody = '<div style="background: rgb(255, 255, 255); border-radius: 0; width: 44.25rem;"><div style="text-align: center"><span style="color: rgb(158, 27, 50)">Something went wrong on our end. </span>';
            emailBody = emailBody.concat('</div><div style="text-align: center"><span style="color: rgb(158, 27, 50); font-size: 0.75rem;">Error info: ');
            emailBody = emailBody.concat(dataStructure.errorDescription);
            emailBody = emailBody.concat('</span></div></div>');
        }
        let environment = this.config.getConfig("EnvName");
        if (environment !== "prod") {
            emailSubject = "TEST (".concat(environment).concat(") - ");
        }
        else {
            emailSubject = "";
        }
        if (dataStructure.projectSubmissionError) {
            emailSubject = emailSubject.concat('Error sending Project ');
            emailSubject = emailSubject.concat(dataStructure.projectNumber);
            emailSubject = emailSubject.concat(' (BU ');
            emailSubject = emailSubject.concat(dataStructure.businessUnit);
            emailSubject = emailSubject.concat(') to PowerPlan for form #');
            emailSubject = emailSubject.concat(this.formNumber);
        }
        else {
            emailSubject = emailSubject.concat('Error sending class codes to PowerPlan for form #');
            emailSubject = emailSubject.concat(this.formNumber);
        }
        let callBody = this.emailRecipients.groups.itPacGroup.map((pacRecipient) => ({
            email: pacRecipient.email,
            sub: emailSubject,
            body: emailBody,
        }));
        callBody.push({
            email: this.emailRecipients.assetAccounting.secondary.email,
            sub: emailSubject,
            body: emailBody,
        });
        // Add all approval notification recipients
        for (let contact of this.emailRecipients.itProjectContacts.approvalNotifications) {
            callBody.push({
                email: contact.email,
                sub: emailSubject,
                body: emailBody,
            });
        }
        for (let i = 0; i < callBody.length; i++) {
            this.dataService.sendEmail(callBody[i]).subscribe((result) => {
                if (result.statusCode !== 200) {
                    console.log("error", result);
                    let errorType = "";
                    let errorDescription = JSON.parse(result.body).message;
                    let dataStructure = {
                        errorType: errorType,
                        errorDescription: errorDescription,
                    };
                    this.dialog.open(ErrorDialogComponent, {
                        data: dataStructure,
                        disableClose: true,
                    });
                }
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Send Email Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Send Email Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            });
        }
    }
    sendItpacNotificationEmail(notificationType) {
        // Prefer the actual approver from formActivity when the latest action
        // is an approval from the Joint Owner Review. Fall back to the ETS PAC
        // assignment name otherwise.
        let reviewerName = ((this.etsPacAssignment && this.etsPacAssignment.givenName) || "").concat(" ").concat((this.etsPacAssignment && this.etsPacAssignment.surname) || "");
        // If the most recent activity is an approval, prefer that approver's
        // display name so emails show the user who actually clicked Approve.
        if (this.formActivity &&
            this.formActivity.length > 0 &&
            this.formActivity[0].action === "Approved") {
            reviewerName = this.formActivity[0].name || reviewerName;
        }
        const formUrl = this.config.getConfig("RedirectUri")
            .concat("/it-project-approval?guid=")
            .concat(this.itSparGuid)
            .concat("&revisionNum=")
            .concat(this.displayRevisionNumber.toString());
        let actionText = "";
        let instructionText = "";
        if (notificationType === "catawba") {
            actionText = "</a> has received Joint Owner approval by "
                .concat(reviewerName)
                .concat(" and is ready for Catawba PowerPlan setup.");
            instructionText = "Please click below to complete the Catawba setup in PowerPlan.";
        }
        else if (notificationType === "non-catawba") {
            actionText = "</a> has been approved by "
                .concat(reviewerName)
                .concat(" and is ready for PowerPlan setup, excluding Catawba projects.");
            instructionText = "Please click below to set up the non-Catawba projects in PowerPlan.";
        }
        else {
            actionText = "</a> has been approved by "
                .concat(reviewerName)
                .concat(" and is ready for PowerPlan setup.");
            instructionText = "Please click below to set up the form in PowerPlan.";
        }
        let emailSubject = "";
        const environment = this.config.getConfig("EnvName");
        if (environment !== "prod") {
            emailSubject = "TEST (".concat(environment).concat(") - ");
        }
        if (notificationType === "catawba") {
            if (this.displayRevisionNumber > 0) {
                emailSubject = emailSubject.concat("MMARF Form ").concat(this.formNumber).concat(", Rev ").concat(this.displayRevisionNumber.toString()).concat(" \u2013 Ready for Catawba Setup (MMAPS)");
            }
            else {
                emailSubject = emailSubject.concat("MMARF Form ").concat(this.formNumber).concat(" \u2013 Ready for Catawba Setup (MMAPS)");
            }
        }
        else {
            if (this.displayRevisionNumber > 0) {
                emailSubject = emailSubject.concat("MMARF Form ").concat(this.formNumber).concat(", Rev ").concat(this.displayRevisionNumber.toString()).concat(" \u2013 Ready for Setup (MMAPS)");
            }
            else {
                emailSubject = emailSubject.concat("MMARF Form ").concat(this.formNumber).concat(" \u2013 Ready for Setup (MMAPS)");
            }
        }
        let emailBody = "";
        emailBody = emailBody.concat('<div style="margin: auto; text-align: center; width: 42.75rem"><div style="text-align: left"><span style="font-size: 0.875rem">');
        emailBody = emailBody.concat("ITPAC,");
        emailBody = emailBody.concat('</span></div><div><span style="font-size: 0.875rem">The <a href="');
        emailBody = emailBody.concat(formUrl);
        emailBody = emailBody.concat('" style="font-size: 0.875rem">ET&S Accounting Request Form #');
        emailBody = emailBody.concat(this.formNumber);
        if (this.displayRevisionNumber > 0) {
            emailBody = emailBody.concat(", Rev ");
            emailBody = emailBody.concat(this.displayRevisionNumber.toString());
        }
        emailBody = emailBody.concat(" ");
        emailBody = emailBody.concat(this.projectName);
        emailBody = emailBody.concat(actionText);
        emailBody = emailBody.concat('</span></div></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><span style="font-size: 0.875rem">');
        emailBody = emailBody.concat(instructionText);
        emailBody = emailBody.concat('</span></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><a href="');
        emailBody = emailBody.concat(formUrl);
        emailBody = emailBody.concat('"><div style="width: 14.25rem; background: rgb(0, 120, 158); border-radius: 0.125rem; height: 2.75rem; display: inline-block; cursor: pointer; border-width: 0;"><span style="color: rgb(255, 255, 255); font-size: 0.875rem; font-weight: normal; letter-spacing: 0.01rem; line-height: 1.063rem;">VIEW THE FORM</span></div></a></div>');
        const pacEmails = (this.emailRecipients && this.emailRecipients.groups && this.emailRecipients.groups.itPacGroup) || [{ email: "ITPAC@duke-energy.com" }];
        for (let pacRecipient of pacEmails) {
            const itpacCallBody = {
                email: pacRecipient.email,
                sub: emailSubject,
                body: emailBody,
            };
            this.dataService.sendEmail(itpacCallBody).subscribe((result) => {
                if (result.statusCode !== 200) {
                    console.log("error", result);
                    let errorType = "";
                    let errorDescription = JSON.parse(result.body).message;
                    let dataStructure = {
                        errorType: errorType,
                        errorDescription: errorDescription,
                    };
                    this.dialog.open(ErrorDialogComponent, {
                        data: dataStructure,
                        disableClose: true,
                    });
                }
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Send Email Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Send Email Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            });
        }
        // Also send directly to the assigned IT-PAC person so they do not need to check the shared mailbox
        if (this.etsPacAssignment && this.etsPacAssignment.mail) {
            const assignedFirstName = this.etsPacAssignment.givenName || "ITPAC";
            const personalizedEmailBody = emailBody.replace("ITPAC,", assignedFirstName.concat(","));
            const assignedPacCallBody = {
                email: this.etsPacAssignment.mail,
                sub: emailSubject,
                body: personalizedEmailBody,
            };
            this.dataService.sendEmail(assignedPacCallBody).subscribe((result) => {
                if (result.statusCode !== 200) {
                    console.log("error", result);
                    let errorType = "";
                    let errorDescription = JSON.parse(result.body).message;
                    let dataStructure = {
                        errorType: errorType,
                        errorDescription: errorDescription,
                    };
                    this.dialog.open(ErrorDialogComponent, {
                        data: dataStructure,
                        disableClose: true,
                    });
                }
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Send Email Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Send Email Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            });
        }
    }
    getRecipientRole(email) {
        if (!email)
            return undefined;
        if (this.formOwner && this.formOwner.mail === email)
            return 'Form Owner';
        if (this.primaryContact && this.primaryContact.mail === email)
            return 'Primary Contact';
        if (this.etsPacAssignment && this.etsPacAssignment.mail === email)
            return 'IT PAC Assignment';
        if (this.itSponsor && this.itSponsor.mail === email)
            return 'IT Sponsor';
        if (this.leadPacReviewer && this.leadPacReviewer.mail === email)
            return 'Lead ET&S PAC Reviewer';
        if (this.assetReviewer && this.assetReviewer.mail === email)
            return 'Asset Accounting Reviewer';
        if (this.jointOwnerCoordinator && this.jointOwnerCoordinator.mail === email)
            return 'Joint Owner Coordinator';
        if (this.approverList && this.approverList.some((a) => a.mail === email))
            return 'DOA Approver';
        return undefined;
    }
    sendEmailNotifications(dataStructure) {
        /*setTimeout(() => {
          console.log(document.getElementById('tableSection'));
        }, 2000);*/
        const actualActorName = this.formActivity && this.formActivity.length > 0 ? this.formActivity[0].name : null;
        const actualActorAction = this.formActivity && this.formActivity.length > 0 ? this.formActivity[0].action : null;
        if (dataStructure.sendingReviewEmail) {
            let emailBody = "";
            let emailSubject = "";
            for (let i = 0; i < dataStructure.sendingReviewReceiver.length; i++) {
                emailBody =
                    '<div style="margin: auto; text-align: center; width: 42.75rem"><div style="text-align: left"><span style="font-size: 0.875rem">';
                emailBody = emailBody.concat(dataStructure.sendingReviewFirstName[i]);
                emailBody = emailBody.concat(',</span></div><div><span style="font-size: 0.875rem">The <a href="');
                emailBody = emailBody.concat(this.config.getConfig("RedirectUri"));
                emailBody = emailBody.concat("/it-project-approval?guid=");
                emailBody = emailBody.concat(this.itSparGuid);
                emailBody = emailBody.concat("&revisionNum=");
                emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                emailBody = emailBody.concat('" style="font-size: 0.875rem">ET&S Accounting Request Form #');
                emailBody = emailBody.concat(this.formNumber);
                if (this.displayRevisionNumber > 0) {
                    emailBody = emailBody.concat(", Rev ");
                    emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                }
                emailBody = emailBody.concat(" ");
                emailBody = emailBody.concat(this.projectName);
                emailBody = emailBody.concat('</a> is available for your review.</span></div></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><span style="font-size: 0.875rem">Please click below to review and approve or reject the form.</span></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><a href="');
                emailBody = emailBody.concat(this.config.getConfig("RedirectUri"));
                emailBody = emailBody.concat("/it-project-approval?guid=");
                emailBody = emailBody.concat(this.itSparGuid);
                emailBody = emailBody.concat("&revisionNum=");
                emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                emailBody = emailBody.concat('"><div style="width: 14.25rem; background: rgb(0, 120, 158); border-radius: 0.125rem; height: 2.75rem; display: inline-block; cursor: pointer; border-width: 0;"><span style="color: rgb(255, 255, 255); font-size: 0.875rem; font-weight: normal; letter-spacing: 0.01rem; line-height: 1.063rem;">REVIEW THE FORM</span></div></a></div>');
                let environment = this.config.getConfig("EnvName");
                if (environment !== "prod") {
                    emailSubject = "TEST (".concat(environment).concat(") - ");
                }
                else {
                    emailSubject = "";
                }
                if (this.displayRevisionNumber > 0) {
                    emailSubject = emailSubject.concat("Ready for Review - ET&S ARF Form #"
                        .concat(this.formNumber)
                        .concat(", Rev ")
                        .concat(this.displayRevisionNumber.toString())
                        .concat(" (MMAPS)"));
                }
                else if (this.displayRevisionNumber === 0) {
                    emailSubject = emailSubject.concat("Ready for Review - ET&S ARF Form #"
                        .concat(this.formNumber)
                        .concat(" (MMAPS)"));
                }
                if (dataStructure.sendingReviewReceiver[i]) {
                    let callBody = {
                        email: dataStructure.sendingReviewReceiver[i],
                        sub: emailSubject,
                        body: emailBody,
                        role: this.getRecipientRole(dataStructure.sendingReviewReceiver[i]),
                    };
                    this.dataService.sendEmail(callBody).subscribe((result) => {
                        if (result.statusCode !== 200) {
                            console.log("error", result);
                            let errorType = "";
                            let errorDescription = JSON.parse(result.body).message;
                            let dataStructure = {
                                errorType: errorType,
                                errorDescription: errorDescription,
                            };
                            this.dialog.open(ErrorDialogComponent, {
                                data: dataStructure,
                                disableClose: true,
                            });
                        }
                    }, (error) => {
                        console.log("error", error);
                        let errorType = "";
                        let errorDescription = "";
                        if (error.error.message) {
                            errorDescription = errorDescription.concat("Send Email Error - ", error.error.message);
                        }
                        else {
                            errorDescription = errorDescription.concat("Send Email Error");
                        }
                        errorType = errorType.concat(error.status, " ", error.statusText);
                        let dataStructure = {
                            errorType: errorType,
                            errorDescription: errorDescription,
                        };
                        this.dialog.open(ErrorDialogComponent, {
                            data: dataStructure,
                            disableClose: true,
                        });
                    });
                }
            }
        }
        if (dataStructure.sendingModifiedEmail) {
            let emailBody = "";
            let emailSubject = "";
            for (let i = 0; i < dataStructure.sendingModifiedReceiver.length; i++) {
                emailBody =
                    '<div style="margin: auto; text-align: center; width: 42.75rem"><div style="text-align: left"><span style="font-size: 0.875rem">';
                emailBody = emailBody.concat(dataStructure.sendingModifiedFirstName[i]);
                emailBody = emailBody.concat(',</span></div><div><span style="font-size: 0.875rem">Action has been taken on your <a href="');
                emailBody = emailBody.concat(this.config.getConfig("RedirectUri"));
                emailBody = emailBody.concat("/it-project-approval?guid=");
                emailBody = emailBody.concat(this.itSparGuid);
                emailBody = emailBody.concat("&revisionNum=");
                emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                emailBody = emailBody.concat('" style="font-size: 0.875rem">ET&S Accounting Request Form #');
                emailBody = emailBody.concat(this.formNumber);
                if (this.displayRevisionNumber > 0) {
                    emailBody = emailBody.concat(", Rev ");
                    emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                }
                emailBody = emailBody.concat(" ");
                emailBody = emailBody.concat(this.projectName);
                emailBody = emailBody.concat("</a> by ");
                const actorForModified = actualActorName && (actualActorAction === "Approved" || actualActorAction === "Rejected" || actualActorAction === "Completed") ? actualActorName : (dataStructure.sendingModifiedName ? "Approval not recorded (assigned: ".concat(dataStructure.sendingModifiedName).concat(")") : "Approval not recorded");
                emailBody = emailBody.concat(actorForModified);
                emailBody = emailBody.concat('.</span></div></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><span style="font-size: 0.875rem">Please click below to view the updated form.</span></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><a href="');
                emailBody = emailBody.concat(this.config.getConfig("RedirectUri"));
                emailBody = emailBody.concat("/it-project-approval?guid=");
                emailBody = emailBody.concat(this.itSparGuid);
                emailBody = emailBody.concat("&revisionNum=");
                emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                emailBody = emailBody.concat('"><div style="width: 14.25rem; background: rgb(0, 120, 158); border-radius: 0.125rem; height: 2.75rem; display: inline-block; cursor: pointer; border-width: 0;"><span style="color: rgb(255, 255, 255); font-size: 0.875rem; font-weight: normal; letter-spacing: 0.01rem; line-height: 1.063rem;">VIEW THE FORM</span></div></a></div>');
                let environment = this.config.getConfig("EnvName");
                if (environment !== "prod") {
                    emailSubject = "TEST (".concat(environment).concat(") - ");
                }
                else {
                    emailSubject = "";
                }
                if (this.displayRevisionNumber > 0) {
                    emailSubject = emailSubject.concat("Action Taken - ET&S ARF Form #"
                        .concat(this.formNumber)
                        .concat(", Rev ")
                        .concat(this.displayRevisionNumber.toString())
                        .concat(" (MMAPS)"));
                }
                else if (this.displayRevisionNumber === 0) {
                    emailSubject = emailSubject.concat("Action Taken - ET&S ARF Form #"
                        .concat(this.formNumber)
                        .concat(" (MMAPS)"));
                }
                if (dataStructure.sendingModifiedReceiver[i]) {
                    let callBody = {
                        email: dataStructure.sendingModifiedReceiver[i],
                        sub: emailSubject,
                        body: emailBody,
                        role: this.getRecipientRole(dataStructure.sendingModifiedReceiver[i]),
                    };
                    this.dataService.sendEmail(callBody).subscribe((result) => {
                        if (result.statusCode !== 200) {
                            console.log("error", result);
                            let errorType = "";
                            let errorDescription = JSON.parse(result.body).message;
                            let dataStructure = {
                                errorType: errorType,
                                errorDescription: errorDescription,
                            };
                            this.dialog.open(ErrorDialogComponent, {
                                data: dataStructure,
                                disableClose: true,
                            });
                        }
                    }, (error) => {
                        console.log("error", error);
                        let errorType = "";
                        let errorDescription = "";
                        if (error.error.message) {
                            errorDescription = errorDescription.concat("Send Email Error - ", error.error.message);
                        }
                        else {
                            errorDescription = errorDescription.concat("Send Email Error");
                        }
                        errorType = errorType.concat(error.status, " ", error.statusText);
                        let dataStructure = {
                            errorType: errorType,
                            errorDescription: errorDescription,
                        };
                        this.dialog.open(ErrorDialogComponent, {
                            data: dataStructure,
                            disableClose: true,
                        });
                    });
                }
            }
        }
        if (dataStructure.sendingChargingEmail) {
            let emailBody = "";
            let emailSubject = "";
            for (let i = 0; i < dataStructure.sendingChargingReceiver.length; i++) {
                const redirectUrl = `${this.config.getConfig("RedirectUri")}/it-project-approval?guid=${this.itSparGuid}&revisionNum=${this.displayRevisionNumber}`;
                emailBody = document.getElementById("email_template_charging_email").innerHTML;
                emailBody = emailBody.replace("$firstName", dataStructure.sendingChargingFirstName[i]);
                emailBody = emailBody.replace(/\$redirectUrl/g, redirectUrl);
                emailBody = emailBody.replace("$formInfo", `ET&S Accounting Request Form #${this.formNumber} ${this.displayRevisionNumber
                    ? ", Rev " + this.displayRevisionNumber
                    : ""} ${this.projectName}`);
                emailBody = emailBody.replace("$effectiveDate", this.effectiveDate.toLocaleDateString());
                let environment = this.config.getConfig("EnvName");
                if (environment !== "prod") {
                    emailSubject = `TEST (${environment}) - `;
                }
                else {
                    emailSubject = "";
                }
                emailSubject = `${emailSubject}Charging Details Added - ET&S ARF Form #${this.formNumber} ${this.displayRevisionNumber
                    ? ", Rev " + this.displayRevisionNumber
                    : ""} (MMAPS)`;
                //console.log(dataStructure.sendingChargingReceiver[i]);
                //console.log(emailSubject);
                //console.log(emailBody);
                if (dataStructure.sendingChargingReceiver[i]) {
                    let callBody = {
                        email: dataStructure.sendingChargingReceiver[i],
                        sub: emailSubject,
                        body: emailBody,
                        role: this.getRecipientRole(dataStructure.sendingChargingReceiver[i]),
                    };
                    this.dataService.sendEmail(callBody).subscribe((result) => {
                        if (result.statusCode !== 200) {
                            console.log("error", result);
                            let errorType = "";
                            let errorDescription = JSON.parse(result.body).message;
                            let dataStructure = {
                                errorType: errorType,
                                errorDescription: errorDescription,
                            };
                            this.dialog.open(ErrorDialogComponent, {
                                data: dataStructure,
                                disableClose: true,
                            });
                        }
                    }, (error) => {
                        console.log("error", error);
                        let errorType = "";
                        let errorDescription = "";
                        if (error.error.message) {
                            errorDescription = errorDescription.concat("Send Email Error - ", error.error.message);
                        }
                        else {
                            errorDescription = errorDescription.concat("Send Email Error");
                        }
                        errorType = errorType.concat(error.status, " ", error.statusText);
                        let dataStructure = {
                            errorType: errorType,
                            errorDescription: errorDescription,
                        };
                        this.dialog.open(ErrorDialogComponent, {
                            data: dataStructure,
                            disableClose: true,
                        });
                    });
                }
            }
        }
        if (dataStructure.sendingCompletionEmail) {
            let emailBody = "";
            let emailSubject = "";
            for (let i = 0; i < dataStructure.sendingCompletionReceiver.length; i++) {
                emailBody = emailBody.concat('<div style="margin: auto; text-align: center; width: 42.75rem"><div style="text-align: left"><span style="font-size: 0.875rem">');
                emailBody = emailBody.concat(dataStructure.sendingCompletionFirstName[i]);
                emailBody = emailBody.concat(',</span></div><div><span style="font-size: 0.875rem">The <a href="');
                emailBody = emailBody.concat(this.config.getConfig("RedirectUri"));
                emailBody = emailBody.concat("/it-project-approval?guid=");
                emailBody = emailBody.concat(this.itSparGuid);
                emailBody = emailBody.concat("&revisionNum=");
                emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                emailBody = emailBody.concat('" style="font-size: 0.875rem">ET&S Accounting Request Form #');
                emailBody = emailBody.concat(this.formNumber);
                if (this.displayRevisionNumber > 0) {
                    emailBody = emailBody.concat(", Rev ");
                    emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                }
                emailBody = emailBody.concat(" ");
                emailBody = emailBody.concat(this.projectName);
                emailBody = emailBody.concat('</a> is ready to be completed.</span></div></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><span style="font-size: 0.875rem">Please click below to review and complete the form.</span></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><a href="');
                emailBody = emailBody.concat(this.config.getConfig("RedirectUri"));
                emailBody = emailBody.concat("/it-project-approval?guid=");
                emailBody = emailBody.concat(this.itSparGuid);
                emailBody = emailBody.concat("&revisionNum=");
                emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                emailBody = emailBody.concat('"><div style="width: 14.25rem; background: rgb(0, 120, 158); border-radius: 0.125rem; height: 2.75rem; display: inline-block; cursor: pointer; border-width: 0;"><span style="color: rgb(255, 255, 255); font-size: 0.875rem; font-weight: normal; letter-spacing: 0.01rem; line-height: 1.063rem;">COMPLETE THE FORM</span></div></a></div>');
                let environment = this.config.getConfig("EnvName");
                if (environment !== "prod") {
                    emailSubject = "TEST (".concat(environment).concat(") - ");
                }
                else {
                    emailSubject = "";
                }
                if (this.displayRevisionNumber > 0) {
                    emailSubject = emailSubject.concat("Ready for Completion - ET&S ARF Form #"
                        .concat(this.formNumber)
                        .concat(", Rev ")
                        .concat(this.displayRevisionNumber.toString())
                        .concat(" (MMAPS)"));
                }
                else if (this.displayRevisionNumber === 0) {
                    emailSubject = emailSubject.concat("Ready for Completion - ET&S ARF Form #"
                        .concat(this.formNumber)
                        .concat(" (MMAPS)"));
                }
                if (dataStructure.sendingCompletionReceiver[i]) {
                    let callBody = {
                        email: dataStructure.sendingCompletionReceiver[i],
                        sub: emailSubject,
                        body: emailBody,
                        role: this.getRecipientRole(dataStructure.sendingCompletionReceiver[i]),
                    };
                    this.dataService.sendEmail(callBody).subscribe((result) => {
                        if (result.statusCode !== 200) {
                            console.log("error", result);
                            let errorType = "";
                            let errorDescription = JSON.parse(result.body).message;
                            let dataStructure = {
                                errorType: errorType,
                                errorDescription: errorDescription,
                            };
                            this.dialog.open(ErrorDialogComponent, {
                                data: dataStructure,
                                disableClose: true,
                            });
                        }
                    }, (error) => {
                        console.log("error", error);
                        let errorType = "";
                        let errorDescription = "";
                        if (error.error.message) {
                            errorDescription = errorDescription.concat("Send Email Error - ", error.error.message);
                        }
                        else {
                            errorDescription = errorDescription.concat("Send Email Error");
                        }
                        errorType = errorType.concat(error.status, " ", error.statusText);
                        let dataStructure = {
                            errorType: errorType,
                            errorDescription: errorDescription,
                        };
                        this.dialog.open(ErrorDialogComponent, {
                            data: dataStructure,
                            disableClose: true,
                        });
                    });
                }
            }
        }
        if (dataStructure.sendingReadyChargingEmail) {
            let emailBody = "";
            let emailSubject = "";
            for (let i = 0; i < dataStructure.sendingReadyChargingReceiver.length; i++) {
                emailBody =
                    '<div style="margin: auto; text-align: center; width: 42.75rem"><div style="text-align: left"><span style="font-size: 0.875rem">';
                emailBody = emailBody.concat(dataStructure.sendingReadyChargingFirstName[i]);
                emailBody = emailBody.concat(',</span></div><div><span style="font-size: 0.875rem">The <a href="');
                emailBody = emailBody.concat(this.config.getConfig("RedirectUri"));
                emailBody = emailBody.concat("/it-project-approval?guid=");
                emailBody = emailBody.concat(this.itSparGuid);
                emailBody = emailBody.concat("&revisionNum=");
                emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                emailBody = emailBody.concat('" style="font-size: 0.875rem">ET&S Accounting Request Form #');
                emailBody = emailBody.concat(this.formNumber);
                if (this.displayRevisionNumber > 0) {
                    emailBody = emailBody.concat(", Rev ");
                    emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                }
                emailBody = emailBody.concat(" ");
                emailBody = emailBody.concat(this.projectName);
                emailBody = emailBody.concat('</a> is ready for approval by the Joint Owners. Charging details may be added.</span></div></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><span style="font-size: 0.875rem">Please click below to view the form and add charging details.</span></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><a href="');
                emailBody = emailBody.concat(this.config.getConfig("RedirectUri"));
                emailBody = emailBody.concat("/it-project-approval?guid=");
                emailBody = emailBody.concat(this.itSparGuid);
                emailBody = emailBody.concat("&revisionNum=");
                emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                emailBody = emailBody.concat('"><div style="width: 14.25rem; background: rgb(0, 120, 158); border-radius: 0.125rem; height: 2.75rem; display: inline-block; cursor: pointer; border-width: 0;"><span style="color: rgb(255, 255, 255); font-size: 0.875rem; font-weight: normal; letter-spacing: 0.01rem; line-height: 1.063rem;">VIEW THE FORM</span></div></a></div>');
                let environment = this.config.getConfig("EnvName");
                if (environment !== "prod") {
                    emailSubject = "TEST (".concat(environment).concat(") - ");
                }
                else {
                    emailSubject = "";
                }
                if (this.displayRevisionNumber > 0) {
                    emailSubject = emailSubject.concat("Ready for Charging Details - ET&S ARF Form #"
                        .concat(this.formNumber)
                        .concat(", Rev ")
                        .concat(this.displayRevisionNumber.toString())
                        .concat(" (MMAPS)"));
                }
                else if (this.displayRevisionNumber === 0) {
                    emailSubject = emailSubject.concat("Ready for Charging Details - ET&S ARF Form #"
                        .concat(this.formNumber)
                        .concat(" (MMAPS)"));
                }
                if (dataStructure.sendingReadyChargingReceiver[i]) {
                    let callBody = {
                        email: dataStructure.sendingReadyChargingReceiver[i],
                        sub: emailSubject,
                        body: emailBody,
                        role: this.getRecipientRole(dataStructure.sendingReadyChargingReceiver[i]),
                    };
                    this.dataService.sendEmail(callBody).subscribe((result) => {
                        if (result.statusCode !== 200) {
                            console.log("error", result);
                            let errorType = "";
                            let errorDescription = JSON.parse(result.body).message;
                            let dataStructure = {
                                errorType: errorType,
                                errorDescription: errorDescription,
                            };
                            this.dialog.open(ErrorDialogComponent, {
                                data: dataStructure,
                                disableClose: true,
                            });
                        }
                    }, (error) => {
                        console.log("error", error);
                        let errorType = "";
                        let errorDescription = "";
                        if (error.error.message) {
                            errorDescription = errorDescription.concat("Send Email Error - ", error.error.message);
                        }
                        else {
                            errorDescription = errorDescription.concat("Send Email Error");
                        }
                        errorType = errorType.concat(error.status, " ", error.statusText);
                        let dataStructure = {
                            errorType: errorType,
                            errorDescription: errorDescription,
                        };
                        this.dialog.open(ErrorDialogComponent, {
                            data: dataStructure,
                            disableClose: true,
                        });
                    });
                }
            }
        }
        if (dataStructure.sendingJointOwnerRejectCompleteEmail) {
            let emailBody = "";
            let emailSubject = "";
            for (let i = 0; i < dataStructure.sendingJointOwnerRejectCompleteReceiver.length; i++) {
                emailBody =
                    '<div style="margin: auto; text-align: center; width: 42.75rem"><div style="text-align: left"><span style="font-size: 0.875rem">';
                emailBody = emailBody.concat(dataStructure.sendingJointOwnerRejectCompleteFirstName[i]);
                emailBody = emailBody.concat(',</span></div><div><span style="font-size: 0.875rem">Projects have been rejected by the Joint Owners for <a href="');
                emailBody = emailBody.concat(this.config.getConfig("RedirectUri"));
                emailBody = emailBody.concat("/it-project-approval?guid=");
                emailBody = emailBody.concat(this.itSparGuid);
                emailBody = emailBody.concat("&revisionNum=");
                emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                emailBody = emailBody.concat('" style="font-size: 0.875rem">ET&S Accounting Request Form #');
                emailBody = emailBody.concat(this.formNumber);
                if (this.displayRevisionNumber > 0) {
                    emailBody = emailBody.concat(", Rev ");
                    emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                }
                emailBody = emailBody.concat(" ");
                emailBody = emailBody.concat(this.projectName);
                emailBody = emailBody.concat("</a>. The form is ready to be completed.</span></div></div>");
                // added in comment section
                emailBody = emailBody.concat('<div style="margin: auto; text-align: center; width: 42.75rem; margin-top: 1.5rem"><div style="text-align: left"><span style="font-size: 0.875rem">Comments from the Joint Owner Coordinator, ');
                const actorForJointOwnerReject = actualActorName && actualActorAction === "Rejected" ? actualActorName : (dataStructure.sendingJointOwnerRejectCompleteName ? "Approval not recorded (assigned: ".concat(dataStructure.sendingJointOwnerRejectCompleteName).concat(")") : "Approval not recorded");
                emailBody = emailBody.concat(actorForJointOwnerReject);
                emailBody = emailBody.concat(':</span></div><div><span style="font-size: 0.875rem">');
                emailBody = emailBody.concat(dataStructure.sendingJointOwnerRejectCompleteComments);
                emailBody = emailBody.concat("</span></div></div>");
                //
                emailBody = emailBody.concat('<div style="margin: auto; text-align: center; margin-top: 1.5rem;"><span style="font-size: 0.875rem">Please click below to view and complete the form.</span></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><a href="');
                emailBody = emailBody.concat(this.config.getConfig("RedirectUri"));
                emailBody = emailBody.concat("/it-project-approval?guid=");
                emailBody = emailBody.concat(this.itSparGuid);
                emailBody = emailBody.concat("&revisionNum=");
                emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                emailBody = emailBody.concat('"><div style="width: 14.25rem; background: rgb(0, 120, 158); border-radius: 0.125rem; height: 2.75rem; display: inline-block; cursor: pointer; border-width: 0;"><span style="color: rgb(255, 255, 255); font-size: 0.875rem; font-weight: normal; letter-spacing: 0.01rem; line-height: 1.063rem;">COMPLETE THE FORM</span></div></a></div>');
                let environment = this.config.getConfig("EnvName");
                if (environment !== "prod") {
                    emailSubject = "TEST (".concat(environment).concat(") - ");
                }
                else {
                    emailSubject = "";
                }
                if (this.displayRevisionNumber > 0) {
                    emailSubject = emailSubject.concat("Rejected by Joint Owners, Ready to Complete - ET&S ARF Form #"
                        .concat(this.formNumber)
                        .concat(", Rev ")
                        .concat(this.displayRevisionNumber.toString())
                        .concat(" (MMAPS)"));
                }
                else if (this.displayRevisionNumber === 0) {
                    emailSubject = emailSubject.concat("Rejected by Joint Owners, Ready to Complete - ET&S ARF Form #"
                        .concat(this.formNumber)
                        .concat(" (MMAPS)"));
                }
                if (dataStructure.sendingJointOwnerRejectCompleteReceiver[i]) {
                    let callBody = {
                        email: dataStructure.sendingJointOwnerRejectCompleteReceiver[i],
                        sub: emailSubject,
                        body: emailBody,
                        role: this.getRecipientRole(dataStructure.sendingJointOwnerRejectCompleteReceiver[i]),
                    };
                    this.dataService.sendEmail(callBody).subscribe((result) => {
                        if (result.statusCode !== 200) {
                            console.log("error", result);
                            let errorType = "";
                            let errorDescription = JSON.parse(result.body).message;
                            let dataStructure = {
                                errorType: errorType,
                                errorDescription: errorDescription,
                            };
                            this.dialog.open(ErrorDialogComponent, {
                                data: dataStructure,
                                disableClose: true,
                            });
                        }
                    }, (error) => {
                        console.log("error", error);
                        let errorType = "";
                        let errorDescription = "";
                        if (error.error.message) {
                            errorDescription = errorDescription.concat("Send Email Error - ", error.error.message);
                        }
                        else {
                            errorDescription = errorDescription.concat("Send Email Error");
                        }
                        errorType = errorType.concat(error.status, " ", error.statusText);
                        let dataStructure = {
                            errorType: errorType,
                            errorDescription: errorDescription,
                        };
                        this.dialog.open(ErrorDialogComponent, {
                            data: dataStructure,
                            disableClose: true,
                        });
                    });
                }
            }
        }
        if (dataStructure.sendingRejectedEmail) {
            let emailBody = "";
            let emailSubject = "";
            for (let i = 0; i < dataStructure.sendingRejectedReceiver.length; i++) {
                emailBody =
                    '<div style="margin: auto; text-align: center; width: 42.75rem"><div style="text-align: left"><span style="font-size: 0.875rem">';
                emailBody = emailBody.concat(dataStructure.sendingRejectedFirstName[i]);
                emailBody = emailBody.concat(',</span></div><div><span style="font-size: 0.875rem">The <a href="');
                emailBody = emailBody.concat(this.config.getConfig("RedirectUri"));
                emailBody = emailBody.concat("/it-project-approval?guid=");
                emailBody = emailBody.concat(this.itSparGuid);
                emailBody = emailBody.concat("&revisionNum=");
                emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                emailBody = emailBody.concat('" style="font-size: 0.875rem">ET&S Accounting Request Form #');
                emailBody = emailBody.concat(this.formNumber);
                if (this.displayRevisionNumber > 0) {
                    emailBody = emailBody.concat(", Rev ");
                    emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                }
                emailBody = emailBody.concat(" ");
                emailBody = emailBody.concat(this.projectName);
                emailBody = emailBody.concat("</a> has been rejected.</span></div></div>");
                // added in comment section
                emailBody = emailBody.concat('<div style="margin: auto; text-align: center; width: 42.75rem; margin-top: 1.5rem"><div style="text-align: left"><span style="font-size: 0.875rem">Comments from the reviewer, ');
                const actorForRejected = actualActorName && actualActorAction === "Rejected" ? actualActorName : (dataStructure.sendingRejectedName ? "Approval not recorded (assigned: ".concat(dataStructure.sendingRejectedName).concat(")") : "Approval not recorded");
                emailBody = emailBody.concat(actorForRejected);
                emailBody = emailBody.concat(':</span></div><div style="text-align: left"><span style="font-size: 0.875rem">');
                emailBody = emailBody.concat(dataStructure.sendingRejectedComments || "N/A");
                emailBody = emailBody.concat("</span></div></div>");
                //
                emailBody = emailBody.concat('<div style="margin: auto; text-align: center; margin-top: 1.5rem"><span style"font-size: 0.875rem">Please click below to view the rejected form.</span></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><a href="');
                emailBody = emailBody.concat(this.config.getConfig("RedirectUri"));
                emailBody = emailBody.concat("/it-project-approval?guid=");
                emailBody = emailBody.concat(this.itSparGuid);
                emailBody = emailBody.concat("&revisionNum=");
                emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                emailBody = emailBody.concat('"><div style="width: 14.25rem; background: rgb(0, 120, 158); border-radius: 0.125rem; height: 2.75rem; display: inline-block; cursor: pointer; border-width: 0;"><span style="color: rgb(255, 255, 255); font-size: 0.875rem; font-weight: normal; letter-spacing: 0.01rem; line-height: 1.063rem;">VIEW THE FORM</span></div></a></div>');
                let environment = this.config.getConfig("EnvName");
                if (environment !== "prod") {
                    emailSubject = "TEST (".concat(environment).concat(") - ");
                }
                else {
                    emailSubject = "";
                }
                if (this.displayRevisionNumber > 0) {
                    emailSubject = emailSubject.concat("Rejected - ET&S ARF Form #"
                        .concat(this.formNumber)
                        .concat(", Rev ")
                        .concat(this.displayRevisionNumber.toString())
                        .concat(" (MMAPS)"));
                }
                else if (this.displayRevisionNumber === 0) {
                    emailSubject = emailSubject.concat("Rejected - ET&S ARF Form #"
                        .concat(this.formNumber)
                        .concat(" (MMAPS)"));
                }
                if (dataStructure.sendingRejectedReceiver[i]) {
                    let callBody = {
                        email: dataStructure.sendingRejectedReceiver[i],
                        sub: emailSubject,
                        body: emailBody,
                        role: this.getRecipientRole(dataStructure.sendingRejectedReceiver[i]),
                    };
                    this.dataService.sendEmail(callBody).subscribe((result) => {
                        if (result.statusCode !== 200) {
                            console.log("error", result);
                            let errorType = "";
                            let errorDescription = JSON.parse(result.body).message;
                            let dataStructure = {
                                errorType: errorType,
                                errorDescription: errorDescription,
                            };
                            this.dialog.open(ErrorDialogComponent, {
                                data: dataStructure,
                                disableClose: true,
                            });
                        }
                    }, (error) => {
                        console.log("error", error);
                        let errorType = "";
                        let errorDescription = "";
                        if (error.error.message) {
                            errorDescription = errorDescription.concat("Send Email Error - ", error.error.message);
                        }
                        else {
                            errorDescription = errorDescription.concat("Send Email Error");
                        }
                        errorType = errorType.concat(error.status, " ", error.statusText);
                        let dataStructure = {
                            errorType: errorType,
                            errorDescription: errorDescription,
                        };
                        this.dialog.open(ErrorDialogComponent, {
                            data: dataStructure,
                            disableClose: true,
                        });
                    });
                }
            }
        }
        if (dataStructure.sendingRejectedReadyEmail) {
            let emailBody = "";
            let emailSubject = "";
            for (let i = 0; i < dataStructure.sendingRejectedReadyReceiver.length; i++) {
                emailBody =
                    '<div style="margin: auto; text-align: center; width: 42.75rem"><div style="text-align: left"><span style="font-size: 0.875rem">';
                emailBody = emailBody.concat(dataStructure.sendingRejectedReadyFirstName[i]);
                emailBody = emailBody.concat(',</span></div><div><span style="font-size: 0.875rem">The <a href="');
                emailBody = emailBody.concat(this.config.getConfig("RedirectUri"));
                emailBody = emailBody.concat("/it-project-approval?guid=");
                emailBody = emailBody.concat(this.itSparGuid);
                emailBody = emailBody.concat("&revisionNum=");
                emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                emailBody = emailBody.concat('" style="font-size: 0.875rem">ET&S Accounting Request Form #');
                emailBody = emailBody.concat(this.formNumber);
                if (this.displayRevisionNumber > 0) {
                    emailBody = emailBody.concat(", Rev ");
                    emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                }
                emailBody = emailBody.concat(" ");
                emailBody = emailBody.concat(this.projectName);
                emailBody = emailBody.concat("</a> has been rejected and is ready to be resubmitted.</span></div></div>");
                // added in comment section
                emailBody = emailBody.concat('<div style="margin: auto; text-align: center; width: 42.75rem; margin-top: 1.5rem"><div style="text-align: left"><span style="font-size: 0.875rem">Comments from the reviewer, ');
                const actorForRejectedReady = actualActorName && actualActorAction === "Rejected" ? actualActorName : (dataStructure.sendingRejectedReadyName ? "Approval not recorded (assigned: ".concat(dataStructure.sendingRejectedReadyName).concat(")") : "Approval not recorded");
                emailBody = emailBody.concat(actorForRejectedReady);
                emailBody = emailBody.concat(':</span></div><div style="text-align: left"><span style="font-size: 0.875rem">');
                emailBody = emailBody.concat(dataStructure.sendingRejectedReadyComments || "N/A");
                emailBody = emailBody.concat("</span></div></div>");
                //
                emailBody = emailBody.concat('<div style="margin: auto; text-align: center; margin-top: 1.5rem;"><span style="font-size: 0.875rem">Please click below to view and resubmit the rejected form.</span></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><a href="');
                emailBody = emailBody.concat(this.config.getConfig("RedirectUri"));
                emailBody = emailBody.concat("/it-project-approval?guid=");
                emailBody = emailBody.concat(this.itSparGuid);
                emailBody = emailBody.concat("&revisionNum=");
                emailBody = emailBody.concat(this.displayRevisionNumber.toString());
                emailBody = emailBody.concat('"><div style="width: 14.25rem; background: rgb(0, 120, 158); border-radius: 0.125rem; height: 2.75rem; display: inline-block; cursor: pointer; border-width: 0;"><span style="color: rgb(255, 255, 255); font-size: 0.875rem; font-weight: normal; letter-spacing: 0.01rem; line-height: 1.063rem;">VIEW THE FORM</span></div></a></div>');
                let environment = this.config.getConfig("EnvName");
                if (environment !== "prod") {
                    emailSubject = "TEST (".concat(environment).concat(") - ");
                }
                else {
                    emailSubject = "";
                }
                if (this.displayRevisionNumber > 0) {
                    emailSubject = emailSubject.concat("Rejected and Ready for Resubmission - ET&S ARF Form #"
                        .concat(this.formNumber)
                        .concat(", Rev ")
                        .concat(this.displayRevisionNumber.toString())
                        .concat(" (MMAPS)"));
                }
                else if (this.displayRevisionNumber === 0) {
                    emailSubject = emailSubject.concat("Rejected and Ready for Resubmission - ET&S ARF Form #"
                        .concat(this.formNumber)
                        .concat(" (MMAPS)"));
                }
                if (dataStructure.sendingRejectedReadyReceiver[i]) {
                    let callBody = {
                        email: dataStructure.sendingRejectedReadyReceiver[i],
                        sub: emailSubject,
                        body: emailBody,
                        role: this.getRecipientRole(dataStructure.sendingRejectedReadyReceiver[i]),
                    };
                    this.dataService.sendEmail(callBody).subscribe((result) => {
                        if (result.statusCode !== 200) {
                            console.log("error", result);
                            let errorType = "";
                            let errorDescription = JSON.parse(result.body).message;
                            let dataStructure = {
                                errorType: errorType,
                                errorDescription: errorDescription,
                            };
                            this.dialog.open(ErrorDialogComponent, {
                                data: dataStructure,
                                disableClose: true,
                            });
                        }
                    }, (error) => {
                        console.log("error", error);
                        let errorType = "";
                        let errorDescription = "";
                        if (error.error.message) {
                            errorDescription = errorDescription.concat("Send Email Error - ", error.error.message);
                        }
                        else {
                            errorDescription = errorDescription.concat("Send Email Error");
                        }
                        errorType = errorType.concat(error.status, " ", error.statusText);
                        let dataStructure = {
                            errorType: errorType,
                            errorDescription: errorDescription,
                        };
                        this.dialog.open(ErrorDialogComponent, {
                            data: dataStructure,
                            disableClose: true,
                        });
                    });
                }
            }
        }
        if (dataStructure.sendingFormCompletedEmail) {
            let emailBody = "";
            let emailSubject = "";
            for (let i = 0; i < dataStructure.sendingFormCompletedReceiver.length; i++) {
                const redirectUrl = `${this.config.getConfig("RedirectUri")}/it-project-approval?guid=${this.itSparGuid}&revisionNum=${this.displayRevisionNumber}`;
                emailBody = document.getElementById("email_template_form_completed").innerHTML;
                emailBody = emailBody.replace("$firstName", dataStructure.sendingFormCompletedFirstName[i]);
                emailBody = emailBody.replace(/\$redirectUrl/g, redirectUrl);
                emailBody = emailBody.replace("$formInfo", `ET&S Accounting Request Form #${this.formNumber} ${this.displayRevisionNumber
                    ? ", Rev " + this.displayRevisionNumber
                    : ""}, ${this.projectName}`);
                if (this.effectiveDate) {
                    emailBody = emailBody.replace("$effectiveDate", this.effectiveDate.toLocaleDateString());
                }
                else {
                    emailBody = emailBody.replace("$effectiveDate", "");
                }
                emailBody = emailBody.replace("$comments", dataStructure.sendingFormCompletedComments || "N/A");
                let environment = this.config.getConfig("EnvName");
                if (environment !== "prod") {
                    emailSubject = `TEST (${environment}) - `;
                }
                else {
                    emailSubject = "";
                }
                emailSubject = `${emailSubject}Completed - ET&S ARF Form #${this.formNumber} ${this.displayRevisionNumber
                    ? ", Rev " + this.displayRevisionNumber
                    : ""} (MMAPS)`;
                //console.log(dataStructure.sendingFormCompletedReceiver[i]);
                //console.log(emailSubject);
                //console.log(emailBody);
                if (dataStructure.sendingFormCompletedReceiver[i]) {
                    let callBody = {
                        email: dataStructure.sendingFormCompletedReceiver[i],
                        sub: emailSubject,
                        body: emailBody,
                        role: this.getRecipientRole(dataStructure.sendingFormCompletedReceiver[i]),
                    };
                    this.dataService.sendEmail(callBody).subscribe((result) => {
                        if (result.statusCode !== 200) {
                            console.log("error", result);
                            let errorType = "";
                            let errorDescription = JSON.parse(result.body).message;
                            let dataStructure = {
                                errorType: errorType,
                                errorDescription: errorDescription,
                            };
                            this.dialog.open(ErrorDialogComponent, {
                                data: dataStructure,
                                disableClose: true,
                            });
                        }
                    }, (error) => {
                        console.log("error", error);
                        let errorType = "";
                        let errorDescription = "";
                        if (error.error.message) {
                            errorDescription = errorDescription.concat("Send Email Error - ", error.error.message);
                        }
                        else {
                            errorDescription = errorDescription.concat("Send Email Error");
                        }
                        errorType = errorType.concat(error.status, " ", error.statusText);
                        let dataStructure = {
                            errorType: errorType,
                            errorDescription: errorDescription,
                        };
                        this.dialog.open(ErrorDialogComponent, {
                            data: dataStructure,
                            disableClose: true,
                        });
                    });
                }
            }
        }
    }
    sameNuclearSite() {
        if (!this.nuclearAbbreviations) {
            return false;
        }
        for (let i = 0; i < this.allocationsCopy.length; i++) {
            for (let j = i + 1; j < this.allocationsCopy.length; j++) {
                if ((this.allocationsCopy[i].businessUnitValue === "20048" ||
                    this.allocationsCopy[i].businessUnitValue === "50125") &&
                    (this.allocationsCopy[j].businessUnitValue === "20048" ||
                        this.allocationsCopy[j].businessUnitValue === "50125")) {
                    let firstElementMatchFound = false;
                    let secondElementMatchFound = false;
                    let firstElementAbbreviation = "";
                    let secondElementAbbreviation = "";
                    for (let k = 0; k < this.nuclearAbbreviations.length &&
                        (!firstElementMatchFound || !secondElementMatchFound); k++) {
                        if (this.allocationsCopy[i].operatingUnit.OPERATING_UNIT ===
                            this.nuclearAbbreviations[k].operatingUnit) {
                            firstElementAbbreviation =
                                this.nuclearAbbreviations[k].stationCode;
                            firstElementMatchFound = true;
                        }
                        if (this.allocationsCopy[j].operatingUnit.OPERATING_UNIT ===
                            this.nuclearAbbreviations[k].operatingUnit) {
                            secondElementAbbreviation =
                                this.nuclearAbbreviations[k].stationCode;
                            secondElementMatchFound = true;
                        }
                    }
                    if (firstElementMatchFound && secondElementMatchFound) {
                        if (firstElementAbbreviation === secondElementAbbreviation &&
                            this.allocationsCopy[i].operatingUnit.OPERATING_UNIT !==
                                this.allocationsCopy[j].operatingUnit.OPERATING_UNIT) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }
    containsMultipleNuclear() {
        if (!this.processedAllocations)
            return false;
        let nuclearFound = 0;
        for (let i = 0; i < this.processedAllocations.length && nuclearFound < 2; i++) {
            if (this.processedAllocations[i].businessUnitValue === "20048" ||
                this.processedAllocations[i].businessUnitValue === "50125") {
                let matchFound = false;
                for (let j = 0; j < this.nuclearAbbreviations.length && !matchFound; j++) {
                    if (this.processedAllocations[i].operatingUnit.OPERATING_UNIT ===
                        this.nuclearAbbreviations[j].operatingUnit) {
                        matchFound = true;
                        nuclearFound++;
                    }
                }
            }
        }
        return nuclearFound === 2;
    }
    formNumbersRunningOut() {
        if (!this.formNumber || !this.processedAllocations)
            return false;
        let formEntry;
        if (this.hardwareOrSoftwareCopy === "Hardware and Software" ||
            this.containsMultipleNuclear()) {
            formEntry = this.formNumber.slice(-2);
            return Number(formEntry) >= 90;
        }
        else {
            formEntry = this.formNumber.slice(-3);
            return Number(formEntry) >= 990;
        }
    }
    createRevision() {
        // Do NOT persist to DynamoDB here. The draft revision row is only created
        // when the user explicitly saves from the it-project-setup form.
        sessionStorage.setItem('itSparGuid', JSON.stringify(this.itSparGuid));
        sessionStorage.setItem('isRevision', 'yes');
        sessionStorage.setItem('previousCapitalSubtotal', this.subtotalCapital().toString());
        sessionStorage.setItem('previousOMSubtotal', this.subtotalOM().toString());
        sessionStorage.setItem('displayRevisionNumber', this.displayRevisionNumber.toString());
        this.router.navigate(['/it-project-setup']);
    }
    canCreateRevisionFromCurrentView() {
        if (this.hasOpenRevisionDraft) {
            return false;
        }
        if (this.revisionExists !== 'true') {
            return true;
        }
        const currentRevisionNumber = Number(this.displayRevisionNumber);
        const latestRevisionNumber = Number(this.latestRevisionNumber);
        if (Number.isNaN(currentRevisionNumber) || Number.isNaN(latestRevisionNumber)) {
            return false;
        }
        return currentRevisionNumber === latestRevisionNumber;
    }
    goToLatestRevisionInProgress() {
        if (!this.itSparGuid) {
            return;
        }
        this.dataService
            .getItSparData({
            itSparGuid: this.itSparGuid,
        }, "ui")
            .subscribe((result) => {
            const latestRevisionNumber = Number(result.body.displayRevisionNumber);
            const latestFormStatus = result && result.body && result.body.formStatus
                ? result.body.formStatus
                : "";
            const latestIsDraft = latestFormStatus.includes("Draft");
            this.router.navigate([latestIsDraft ? "/it-project-setup" : "/it-project-approval"], {
                queryParams: {
                    guid: this.itSparGuid,
                    revisionNum: Number.isNaN(latestRevisionNumber)
                        ? 0
                        : latestRevisionNumber,
                },
            });
        });
    }
    generateProjectIDs() {
        setTimeout(() => {
            console.log(this.itProjects);
        }, 20000);
        this.processedAllocations = JSON.parse(JSON.stringify(this.allocationsCopy));
        for (let i = 0; i < this.processedAllocations.length; i++) {
            for (let j = i + 1; j < this.processedAllocations.length; j++) {
                if ((this.processedAllocations[i].businessUnitValue ===
                    this.processedAllocations[j].businessUnitValue &&
                    this.processedAllocations[i].businessUnitValue !== "20048" &&
                    this.processedAllocations[i].businessUnitValue !== "50125") ||
                    (this.processedAllocations[i].businessUnitValue ===
                        this.processedAllocations[j].businessUnitValue &&
                        (this.processedAllocations[i].businessUnitValue === "20048" ||
                            this.processedAllocations[i].businessUnitValue === "50125") &&
                        this.isSameNuclearAbbreviation(this.processedAllocations[i], this.processedAllocations[j]))) {
                    this.processedAllocations[i].percentage =
                        this.processedAllocations[i].percentage +
                            this.processedAllocations[j].percentage;
                    this.processedAllocations.splice(j, 1);
                    j--;
                }
            }
        }
        this.itProjects = [];
        if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
            for (let i = 0; i < this.processedAllocations.length; i++) {
                this.itProjects.push(new ItProject(this.formNumber.concat("H"), this.processedAllocations[i].businessUnitValue, "Hardware", this.processedAllocations[i].operatingUnit.OPERATING_UNIT, this.processedAllocations[i].fundingProjectID.work_order_number, this.processedAllocations[i].percentage));
                this.itProjects.push(new ItProject(this.formNumber.concat("S"), this.processedAllocations[i].businessUnitValue, "Software", this.processedAllocations[i].operatingUnit.OPERATING_UNIT, this.processedAllocations[i].fundingProjectID.work_order_number, this.processedAllocations[i].percentage));
            }
            //this.generateProjectClassValues();
            this.generateProjectTypeValues();
        }
        else {
            if (this.containsMultipleNuclear()) {
                for (let i = 0; i < this.processedAllocations.length; i++) {
                    if (this.processedAllocations[i].businessUnitValue === "20048" ||
                        this.processedAllocations[i].businessUnitValue === "50125") {
                        let matchFound = false;
                        for (let j = 0; j < this.nuclearAbbreviations.length && !matchFound; j++) {
                            if (this.processedAllocations[i].operatingUnit.OPERATING_UNIT ===
                                this.nuclearAbbreviations[j].operatingUnit) {
                                this.itProjects.push(new ItProject(this.formNumber.concat(this.nuclearAbbreviations[j].stationCode), this.processedAllocations[i].businessUnitValue, null, this.processedAllocations[i].operatingUnit.OPERATING_UNIT, this.processedAllocations[i].fundingProjectID.work_order_number, this.processedAllocations[i].percentage));
                                if (this.hardwareOrSoftwareCopy === "Hardware Only") {
                                    this.itProjects[this.itProjects.length - 1].hardwareOrSoftware = "Hardware";
                                }
                                if (this.hardwareOrSoftwareCopy === "Software Only") {
                                    this.itProjects[this.itProjects.length - 1].hardwareOrSoftware = "Software";
                                }
                                matchFound = true;
                            }
                        }
                        if (!matchFound) {
                            this.itProjects.push(new ItProject(this.formNumber, this.processedAllocations[i].businessUnitValue, null, this.processedAllocations[i].operatingUnit.OPERATING_UNIT, this.processedAllocations[i].fundingProjectID.work_order_number, this.processedAllocations[i].percentage));
                            if (this.hardwareOrSoftwareCopy === "Hardware Only") {
                                this.itProjects[this.itProjects.length - 1].hardwareOrSoftware =
                                    "Hardware";
                            }
                            if (this.hardwareOrSoftwareCopy === "Software Only") {
                                this.itProjects[this.itProjects.length - 1].hardwareOrSoftware =
                                    "Software";
                            }
                        }
                    }
                    else {
                        this.itProjects.push(new ItProject(this.formNumber, this.processedAllocations[i].businessUnitValue, null, this.processedAllocations[i].operatingUnit.OPERATING_UNIT, this.processedAllocations[i].fundingProjectID.work_order_number, this.processedAllocations[i].percentage));
                        if (this.hardwareOrSoftwareCopy === "Hardware Only") {
                            this.itProjects[this.itProjects.length - 1].hardwareOrSoftware =
                                "Hardware";
                        }
                        if (this.hardwareOrSoftwareCopy === "Software Only") {
                            this.itProjects[this.itProjects.length - 1].hardwareOrSoftware =
                                "Software";
                        }
                    }
                }
                this.generateProjectClassValues();
                this.generateProjectTypeValues();
            }
            else {
                for (let i = 0; i < this.processedAllocations.length; i++) {
                    this.itProjects.push(new ItProject(this.formNumber, this.processedAllocations[i].businessUnitValue, null, this.processedAllocations[i].operatingUnit.OPERATING_UNIT, this.processedAllocations[i].fundingProjectID.work_order_number, this.processedAllocations[i].percentage));
                }
                this.generateProjectClassValues();
                this.generateProjectTypeValues();
            }
        }
        if (this.displayRevisionNumber > 0 &&
            !this.formStatus.includes("Completed") &&
            !this.formStatus.includes("Approved")) {
            this.currentActivityData = [];
            this.currentProjectData = [];
            this.currentWorkOrderData = [];
            for (let i = 0; i < this.itProjects.length; i++) {
                this.currentActivityData.push(null);
                this.currentProjectData.push(null);
                this.currentWorkOrderData.push(null);
                this.getRevisionActivityData(i);
                this.getRevisionProjectData(i);
                this.getRevisionWorkOrderData(i);
            }
        }
    }
    generateProjectClassValues() {
        if (this.hardwareOrSoftwareCopy === "O&M Only") {
            let matchFound = false;
            for (let i = 0; i < this.projectClassDerivations.length && !matchFound; i++) {
                if (this.projectClassDerivations[i].derivationType &&
                    this.projectClassDerivations[i].derivationType === "O&M Only") {
                    for (let j = 0; j < this.itProjects.length; j++) {
                        this.itProjects[j].projectClass =
                            this.projectClassDerivations[i].projectClass;
                    }
                }
                matchFound = true;
            }
        }
        if (this.hardwareOrSoftwareCopy === "Hardware Only") {
            for (let i = 0; i < this.processedAllocations.length; i++) {
                let matchFound = false;
                for (let j = 0; j < this.projectClassDerivations.length && !matchFound; j++) {
                    if (this.projectClassDerivations[j].derivationType &&
                        (this.projectClassDerivations[j].derivationType ===
                            "Hardware and Software" ||
                            this.projectClassDerivations[j].derivationType ===
                                "Hardware Only")) {
                        if (this.projectClassDerivations[j].businessUnit &&
                            this.projectClassDerivations[j].businessUnit.includes(this.processedAllocations[i].businessUnitValue)) {
                            this.itProjects[i].projectClass =
                                this.projectClassDerivations[j].projectClass;
                            matchFound = true;
                        }
                    }
                    if (this.projectClassDerivations[j].derivationType &&
                        this.projectClassDerivations[j].derivationType === "Largest UOP") {
                        if ((this.projectClassDerivations[j].businessUnit &&
                            this.projectClassDerivations[j].businessUnit.includes(this.processedAllocations[i].businessUnitValue)) ||
                            !this.projectClassDerivations[j].businessUnit) {
                            if (this.projectClassDerivations[j].uopDescriptionToProjectType) {
                                let maxValue = 0;
                                let maxUopDescription = "";
                                for (let k = 0; k < this.buildings.length; k++) {
                                    for (let l = 0; l < this.buildings[k].materialEstimates.length; l++) {
                                        if (this.buildings[k].materialEstimates[l].cost === "CAP" &&
                                            this.buildings[k].materialEstimates[l].totalCosts >
                                                maxValue) {
                                            maxValue =
                                                this.buildings[k].materialEstimates[l].totalCosts;
                                            maxUopDescription =
                                                this.buildings[k].materialEstimates[l]
                                                    .unitOfPropertyDescription;
                                        }
                                    }
                                }
                                for (let k = 0; k <
                                    this.projectClassDerivations[j].uopDescriptionToProjectType
                                        .length && !matchFound; k++) {
                                    if (this.projectClassDerivations[j].uopDescriptionToProjectType[k].uopDescription.includes(maxUopDescription)) {
                                        if (this.projectClassDerivations[j]
                                            .uopDescriptionToProjectType[k].isAgile) {
                                            if (this.projectClassDerivations[j]
                                                .uopDescriptionToProjectType[k].isAgile ===
                                                this.agileEffort) {
                                                this.itProjects[i].projectClass =
                                                    this.projectClassDerivations[j].uopDescriptionToProjectType[k].projectClass;
                                                matchFound = true;
                                            }
                                        }
                                        else {
                                            this.itProjects[i].projectClass =
                                                this.projectClassDerivations[j].uopDescriptionToProjectType[k].projectClass;
                                            matchFound = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        if (this.hardwareOrSoftwareCopy === "Software Only") {
            for (let i = 0; i < this.processedAllocations.length; i++) {
                let matchFound = false;
                for (let j = 0; j < this.projectClassDerivations.length && !matchFound; j++) {
                    if (this.projectClassDerivations[j].derivationType &&
                        this.projectClassDerivations[j].derivationType ===
                            "Hardware and Software") {
                        if (this.projectClassDerivations[j].businessUnit &&
                            this.projectClassDerivations[j].businessUnit.includes(this.processedAllocations[i].businessUnitValue)) {
                            this.itProjects[i].projectClass =
                                this.projectClassDerivations[j].projectClass;
                            matchFound = true;
                        }
                    }
                    if (this.projectClassDerivations[j].derivationType &&
                        this.projectClassDerivations[j].derivationType === "Largest UOP") {
                        if ((this.projectClassDerivations[j].businessUnit &&
                            this.projectClassDerivations[j].businessUnit.includes(this.processedAllocations[i].businessUnitValue)) ||
                            !this.projectClassDerivations[j].businessUnit) {
                            if (this.projectClassDerivations[j].uopDescriptionToProjectType) {
                                let maxValue = 0;
                                let maxUopDescription = "";
                                for (let k = 0; k < this.buildings.length; k++) {
                                    for (let l = 0; l < this.buildings[k].materialEstimates.length; l++) {
                                        if (this.buildings[k].materialEstimates[l].cost === "CAP" &&
                                            this.buildings[k].materialEstimates[l].totalCosts >
                                                maxValue) {
                                            maxValue =
                                                this.buildings[k].materialEstimates[l].totalCosts;
                                            maxUopDescription =
                                                this.buildings[k].materialEstimates[l]
                                                    .unitOfPropertyDescription;
                                        }
                                    }
                                }
                                if (maxUopDescription === "") {
                                    maxUopDescription = "Software - Non-License Fees";
                                }
                                for (let k = 0; k <
                                    this.projectClassDerivations[j].uopDescriptionToProjectType
                                        .length && !matchFound; k++) {
                                    if (this.projectClassDerivations[j].uopDescriptionToProjectType[k].uopDescription.includes(maxUopDescription)) {
                                        if (this.projectClassDerivations[j]
                                            .uopDescriptionToProjectType[k].isAgile) {
                                            if (this.projectClassDerivations[j]
                                                .uopDescriptionToProjectType[k].isAgile ===
                                                this.agileEffort) {
                                                this.itProjects[i].projectClass =
                                                    this.projectClassDerivations[j].uopDescriptionToProjectType[k].projectClass;
                                                matchFound = true;
                                            }
                                        }
                                        else {
                                            this.itProjects[i].projectClass =
                                                this.projectClassDerivations[j].uopDescriptionToProjectType[k].projectClass;
                                            matchFound = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
            for (let i = 0; i < this.itProjects.length; i++) {
                let matchFound = false;
                // Hardware Project
                if (!(i % 2)) {
                    for (let j = 0; j < this.projectClassDerivations.length && !matchFound; j++) {
                        if (this.projectClassDerivations[j].derivationType &&
                            (this.projectClassDerivations[j].derivationType ===
                                "Hardware and Software" ||
                                this.projectClassDerivations[j].derivationType ===
                                    "Hardware Only")) {
                            if (this.projectClassDerivations[j].businessUnit &&
                                this.projectClassDerivations[j].businessUnit.includes(this.processedAllocations[Math.floor(i / 2)].businessUnitValue)) {
                                this.itProjects[i].projectClass =
                                    this.projectClassDerivations[j].projectClass;
                                matchFound = true;
                            }
                        }
                        if (this.projectClassDerivations[j].derivationType &&
                            this.projectClassDerivations[j].derivationType === "Largest UOP") {
                            if ((this.projectClassDerivations[j].businessUnit &&
                                this.projectClassDerivations[j].businessUnit.includes(this.processedAllocations[i].businessUnitValue)) ||
                                !this.projectClassDerivations[j].businessUnit) {
                                if (this.projectClassDerivations[j].uopDescriptionToProjectType) {
                                    let maxValue = 0;
                                    let maxUopDescription = "";
                                    for (let k = 0; k < this.buildings.length; k++) {
                                        for (let l = 0; l < this.buildings[k].materialEstimates.length; l++) {
                                            if (this.buildings[k].materialEstimates[l].cost === "CAP" &&
                                                this.uopOptions
                                                    .slice(0, -2)
                                                    .includes(this.buildings[k].materialEstimates[l]
                                                    .unitOfPropertyDescription) &&
                                                this.buildings[k].materialEstimates[l].totalCosts >
                                                    maxValue) {
                                                maxValue =
                                                    this.buildings[k].materialEstimates[l].totalCosts;
                                                maxUopDescription =
                                                    this.buildings[k].materialEstimates[l]
                                                        .unitOfPropertyDescription;
                                            }
                                        }
                                    }
                                    for (let k = 0; k <
                                        this.projectClassDerivations[j]
                                            .uopDescriptionToProjectType.length && !matchFound; k++) {
                                        if (this.projectClassDerivations[j].uopDescriptionToProjectType[k].uopDescription.includes(maxUopDescription)) {
                                            if (this.projectClassDerivations[j]
                                                .uopDescriptionToProjectType[k].isAgile) {
                                                if (this.projectClassDerivations[j]
                                                    .uopDescriptionToProjectType[k].isAgile ===
                                                    this.agileEffort) {
                                                    this.itProjects[i].projectClass =
                                                        this.projectClassDerivations[j].uopDescriptionToProjectType[k].projectClass;
                                                    matchFound = true;
                                                }
                                            }
                                            else {
                                                this.itProjects[i].projectClass =
                                                    this.projectClassDerivations[j].uopDescriptionToProjectType[k].projectClass;
                                                matchFound = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                // Software Project
                else {
                    for (let j = 0; j < this.projectClassDerivations.length && !matchFound; j++) {
                        if (this.projectClassDerivations[j].derivationType &&
                            this.projectClassDerivations[j].derivationType ===
                                "Hardware and Software") {
                            if (this.projectClassDerivations[j].businessUnit &&
                                this.projectClassDerivations[j].businessUnit.includes(this.processedAllocations[Math.floor(i / 2)].businessUnitValue)) {
                                this.itProjects[i].projectClass =
                                    this.projectClassDerivations[j].projectClass;
                                matchFound = true;
                            }
                        }
                        if (this.projectClassDerivations[j].derivationType &&
                            this.projectClassDerivations[j].derivationType === "Largest UOP") {
                            if ((this.projectClassDerivations[j].businessUnit &&
                                this.projectClassDerivations[j].businessUnit.includes(this.processedAllocations[i].businessUnitValue)) ||
                                !this.projectClassDerivations[j].businessUnit) {
                                if (this.projectClassDerivations[j].uopDescriptionToProjectType) {
                                    let maxValue = 0;
                                    let maxUopDescription = "";
                                    for (let k = 0; k < this.buildings.length; k++) {
                                        for (let l = 0; l < this.buildings[k].materialEstimates.length; l++) {
                                            if (this.buildings[k].materialEstimates[l].cost === "CAP" &&
                                                this.uopOptions
                                                    .slice(6)
                                                    .includes(this.buildings[k].materialEstimates[l]
                                                    .unitOfPropertyDescription) &&
                                                this.buildings[k].materialEstimates[l].totalCosts >
                                                    maxValue) {
                                                maxValue =
                                                    this.buildings[k].materialEstimates[l].totalCosts;
                                                maxUopDescription =
                                                    this.buildings[k].materialEstimates[l]
                                                        .unitOfPropertyDescription;
                                            }
                                        }
                                    }
                                    if (maxUopDescription === "") {
                                        maxUopDescription = "Software - Non-License Fees";
                                    }
                                    for (let k = 0; k <
                                        this.projectClassDerivations[j]
                                            .uopDescriptionToProjectType.length && !matchFound; k++) {
                                        if (this.projectClassDerivations[j].uopDescriptionToProjectType[k].uopDescription.includes(maxUopDescription)) {
                                            if (this.projectClassDerivations[j]
                                                .uopDescriptionToProjectType[k].isAgile) {
                                                if (this.projectClassDerivations[j]
                                                    .uopDescriptionToProjectType[k].isAgile ===
                                                    this.agileEffort) {
                                                    this.itProjects[i].projectClass =
                                                        this.projectClassDerivations[j].uopDescriptionToProjectType[k].projectClass;
                                                    matchFound = true;
                                                }
                                            }
                                            else {
                                                this.itProjects[i].projectClass =
                                                    this.projectClassDerivations[j].uopDescriptionToProjectType[k].projectClass;
                                                matchFound = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    generateProjectTypeValues() {
        if (this.hardwareOrSoftwareCopy === "O&M Only") {
            for (let i = 0; i < this.processedAllocations.length; i++) {
                let matchFound = false;
                for (let j = 0; j < this.projectTypeDerivations.length && !matchFound; j++) {
                    if (this.projectTypeDerivations[j].derivationType &&
                        this.projectTypeDerivations[j].derivationType === "O&M Only") {
                        if (this.projectTypeDerivations[j].businessUnit) {
                            if (this.projectTypeDerivations[j].businessUnit.includes(this.processedAllocations[i].businessUnitValue)) {
                                this.itProjects[i].projectType = this.projectTypeDerivations[j].projectType.replaceAll("[BU]", this.processedAllocations[i].businessUnitValue);
                                matchFound = true;
                            }
                        }
                        else {
                            this.itProjects[i].projectType = this.projectTypeDerivations[j].projectType.replaceAll("[BU]", this.processedAllocations[i].businessUnitValue);
                            matchFound = true;
                        }
                    }
                }
            }
        }
        if (this.hardwareOrSoftwareCopy === "Hardware Only") {
            for (let i = 0; i < this.processedAllocations.length; i++) {
                let matchFound = false;
                for (let j = 0; j < this.projectTypeDerivations.length && !matchFound; j++) {
                    if (this.projectTypeDerivations[j].derivationType &&
                        (this.projectTypeDerivations[j].derivationType ===
                            "Hardware and Software" ||
                            this.projectTypeDerivations[j].derivationType === "Hardware Only")) {
                        if (this.projectTypeDerivations[j].businessUnit &&
                            this.projectTypeDerivations[j].businessUnit.includes(this.processedAllocations[i].businessUnitValue) &&
                            (!this.projectTypeDerivations[j].stationCode ||
                                ((this.processedAllocations[i].businessUnitValue === "20048" ||
                                    this.processedAllocations[i].businessUnitValue === "50125") &&
                                    this.projectTypeDerivations[j].stationCode ===
                                        this.getNuclearCode(this.processedAllocations[i])))) {
                            this.itProjects[i].projectType = this.projectTypeDerivations[j].projectType.replaceAll("[BU]", this.processedAllocations[i].businessUnitValue);
                            matchFound = true;
                        }
                    }
                    if (this.projectTypeDerivations[j].derivationType &&
                        this.projectTypeDerivations[j].derivationType === "Largest UOP") {
                        if ((this.projectTypeDerivations[j].businessUnit &&
                            this.projectTypeDerivations[j].businessUnit.includes(this.processedAllocations[i].businessUnitValue)) ||
                            !this.projectTypeDerivations[j].businessUnit) {
                            if (this.projectTypeDerivations[j].uopDescriptionToProjectType) {
                                let maxValue = 0;
                                let maxUopDescription = "";
                                for (let k = 0; k < this.buildings.length; k++) {
                                    for (let l = 0; l < this.buildings[k].materialEstimates.length; l++) {
                                        if (this.buildings[k].materialEstimates[l].cost === "CAP" &&
                                            this.buildings[k].materialEstimates[l].totalCosts >
                                                maxValue) {
                                            maxValue =
                                                this.buildings[k].materialEstimates[l].totalCosts;
                                            maxUopDescription =
                                                this.buildings[k].materialEstimates[l]
                                                    .unitOfPropertyDescription;
                                        }
                                    }
                                }
                                for (let k = 0; k <
                                    this.projectTypeDerivations[j].uopDescriptionToProjectType
                                        .length && !matchFound; k++) {
                                    if (this.projectTypeDerivations[j].uopDescriptionToProjectType[k].uopDescription.includes(maxUopDescription)) {
                                        if (this.projectTypeDerivations[j]
                                            .uopDescriptionToProjectType[k].isAgile) {
                                            if (this.projectTypeDerivations[j]
                                                .uopDescriptionToProjectType[k].isAgile ===
                                                this.agileEffort) {
                                                this.itProjects[i].projectType =
                                                    this.projectTypeDerivations[j].uopDescriptionToProjectType[k].projectType.replaceAll("[BU]", this.processedAllocations[i].businessUnitValue);
                                                matchFound = true;
                                            }
                                        }
                                        else {
                                            this.itProjects[i].projectType =
                                                this.projectTypeDerivations[j].uopDescriptionToProjectType[k].projectType.replaceAll("[BU]", this.processedAllocations[i].businessUnitValue);
                                            matchFound = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        if (this.hardwareOrSoftwareCopy === "Software Only") {
            for (let i = 0; i < this.processedAllocations.length; i++) {
                let matchFound = false;
                for (let j = 0; j < this.projectTypeDerivations.length && !matchFound; j++) {
                    if (this.projectTypeDerivations[j].derivationType &&
                        (this.projectTypeDerivations[j].derivationType ===
                            "Hardware and Software" ||
                            this.projectTypeDerivations[j].derivationType === "Software Only")) {
                        if (this.projectTypeDerivations[j].businessUnit &&
                            this.projectTypeDerivations[j].businessUnit.includes(this.processedAllocations[i].businessUnitValue) &&
                            (!this.projectTypeDerivations[j].stationCode ||
                                ((this.processedAllocations[i].businessUnitValue === "20048" ||
                                    this.processedAllocations[i].businessUnitValue === "50125") &&
                                    this.projectTypeDerivations[j].stationCode ===
                                        this.getNuclearCode(this.processedAllocations[i])))) {
                            this.itProjects[i].projectType = this.projectTypeDerivations[j].projectType.replaceAll("[BU]", this.processedAllocations[i].businessUnitValue);
                            matchFound = true;
                        }
                    }
                    if (this.projectTypeDerivations[j].derivationType &&
                        this.projectTypeDerivations[j].derivationType === "Largest UOP") {
                        if ((this.projectTypeDerivations[j].businessUnit &&
                            this.projectTypeDerivations[j].businessUnit.includes(this.processedAllocations[i].businessUnitValue)) ||
                            !this.projectTypeDerivations[j].businessUnit) {
                            if (this.projectTypeDerivations[j].uopDescriptionToProjectType) {
                                let maxValue = 0;
                                let maxUopDescription = "";
                                for (let k = 0; k < this.buildings.length; k++) {
                                    for (let l = 0; l < this.buildings[k].materialEstimates.length; l++) {
                                        if (this.buildings[k].materialEstimates[l].cost === "CAP" &&
                                            this.buildings[k].materialEstimates[l].totalCosts >
                                                maxValue) {
                                            maxValue =
                                                this.buildings[k].materialEstimates[l].totalCosts;
                                            maxUopDescription =
                                                this.buildings[k].materialEstimates[l]
                                                    .unitOfPropertyDescription;
                                        }
                                    }
                                }
                                if (maxUopDescription === "") {
                                    maxUopDescription = "Software - Non-License Fees";
                                }
                                for (let k = 0; k <
                                    this.projectTypeDerivations[j].uopDescriptionToProjectType
                                        .length && !matchFound; k++) {
                                    if (this.projectTypeDerivations[j].uopDescriptionToProjectType[k].uopDescription.includes(maxUopDescription)) {
                                        if (this.projectTypeDerivations[j]
                                            .uopDescriptionToProjectType[k].isAgile) {
                                            if (this.projectTypeDerivations[j]
                                                .uopDescriptionToProjectType[k].isAgile ===
                                                this.agileEffort) {
                                                this.itProjects[i].projectType =
                                                    this.projectTypeDerivations[j].uopDescriptionToProjectType[k].projectType.replaceAll("[BU]", this.processedAllocations[i].businessUnitValue);
                                                matchFound = true;
                                            }
                                        }
                                        else {
                                            this.itProjects[i].projectType =
                                                this.projectTypeDerivations[j].uopDescriptionToProjectType[k].projectType.replaceAll("[BU]", this.processedAllocations[i].businessUnitValue);
                                            matchFound = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
            for (let i = 0; i < this.itProjects.length; i++) {
                let matchFound = false;
                // Hardware Project
                if (!(i % 2)) {
                    for (let j = 0; j < this.projectTypeDerivations.length && !matchFound; j++) {
                        if (this.projectTypeDerivations[j].derivationType &&
                            (this.projectTypeDerivations[j].derivationType ===
                                "Hardware and Software" ||
                                this.projectTypeDerivations[j].derivationType ===
                                    "Hardware Only")) {
                            if (this.projectTypeDerivations[j].businessUnit &&
                                this.projectTypeDerivations[j].businessUnit.includes(this.processedAllocations[Math.floor(i / 2)].businessUnitValue) &&
                                (!this.projectTypeDerivations[j].stationCode ||
                                    ((this.processedAllocations[Math.floor(i / 2)]
                                        .businessUnitValue === "20048" ||
                                        this.processedAllocations[Math.floor(i / 2)]
                                            .businessUnitValue === "50125") &&
                                        this.projectTypeDerivations[j].stationCode ===
                                            this.getNuclearCode(this.processedAllocations[Math.floor(i / 2)])))) {
                                this.itProjects[i].projectType = this.projectTypeDerivations[j].projectType.replaceAll("[BU]", this.processedAllocations[Math.floor(i / 2)].businessUnitValue);
                                matchFound = true;
                            }
                        }
                        if (this.projectTypeDerivations[j].derivationType &&
                            this.projectTypeDerivations[j].derivationType === "Largest UOP") {
                            if ((this.projectTypeDerivations[j].businessUnit &&
                                this.projectTypeDerivations[j].businessUnit.includes(this.processedAllocations[Math.floor(i / 2)]
                                    .businessUnitValue)) ||
                                !this.projectTypeDerivations[j].businessUnit) {
                                if (this.projectTypeDerivations[j].uopDescriptionToProjectType) {
                                    let maxValue = 0;
                                    let maxUopDescription = "";
                                    for (let k = 0; k < this.buildings.length; k++) {
                                        for (let l = 0; l < this.buildings[k].materialEstimates.length; l++) {
                                            if (this.buildings[k].materialEstimates[l].cost === "CAP" &&
                                                this.uopOptions
                                                    .slice(0, -2)
                                                    .includes(this.buildings[k].materialEstimates[l]
                                                    .unitOfPropertyDescription) &&
                                                this.buildings[k].materialEstimates[l].totalCosts >
                                                    maxValue) {
                                                maxValue =
                                                    this.buildings[k].materialEstimates[l].totalCosts;
                                                maxUopDescription =
                                                    this.buildings[k].materialEstimates[l]
                                                        .unitOfPropertyDescription;
                                            }
                                        }
                                    }
                                    for (let k = 0; k <
                                        this.projectTypeDerivations[j].uopDescriptionToProjectType
                                            .length && !matchFound; k++) {
                                        if (this.projectTypeDerivations[j].uopDescriptionToProjectType[k].uopDescription.includes(maxUopDescription)) {
                                            if (this.projectTypeDerivations[j]
                                                .uopDescriptionToProjectType[k].isAgile) {
                                                if (this.projectTypeDerivations[j]
                                                    .uopDescriptionToProjectType[k].isAgile ===
                                                    this.agileEffort) {
                                                    this.itProjects[i].projectType =
                                                        this.projectTypeDerivations[j].uopDescriptionToProjectType[k].projectType.replaceAll("[BU]", this.processedAllocations[Math.floor(i / 2)]
                                                            .businessUnitValue);
                                                    matchFound = true;
                                                }
                                            }
                                            else {
                                                this.itProjects[i].projectType =
                                                    this.projectTypeDerivations[j].uopDescriptionToProjectType[k].projectType.replaceAll("[BU]", this.processedAllocations[Math.floor(i / 2)]
                                                        .businessUnitValue);
                                                matchFound = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                // Software Project
                else {
                    for (let j = 0; j < this.projectTypeDerivations.length && !matchFound; j++) {
                        if (this.projectTypeDerivations[j].derivationType &&
                            this.projectTypeDerivations[j].derivationType ===
                                "Hardware and Software") {
                            if (this.projectTypeDerivations[j].businessUnit &&
                                this.projectTypeDerivations[j].businessUnit.includes(this.processedAllocations[Math.floor(i / 2)].businessUnitValue) &&
                                (!this.projectTypeDerivations[j].stationCode ||
                                    ((this.processedAllocations[Math.floor(i / 2)]
                                        .businessUnitValue === "20048" ||
                                        this.processedAllocations[Math.floor(i / 2)]
                                            .businessUnitValue === "50125") &&
                                        this.projectTypeDerivations[j].stationCode ===
                                            this.getNuclearCode(this.processedAllocations[Math.floor(i / 2)])))) {
                                this.itProjects[i].projectType = this.projectTypeDerivations[j].projectType.replaceAll("[BU]", this.processedAllocations[Math.floor(i / 2)].businessUnitValue);
                                matchFound = true;
                            }
                        }
                        if (this.projectTypeDerivations[j].derivationType &&
                            this.projectTypeDerivations[j].derivationType === "Largest UOP") {
                            if ((this.projectTypeDerivations[j].businessUnit &&
                                this.projectTypeDerivations[j].businessUnit.includes(this.processedAllocations[Math.floor(i / 2)]
                                    .businessUnitValue)) ||
                                !this.projectTypeDerivations[j].businessUnit) {
                                if (this.projectTypeDerivations[j].uopDescriptionToProjectType) {
                                    let maxValue = 0;
                                    let maxUopDescription = "";
                                    for (let k = 0; k < this.buildings.length; k++) {
                                        for (let l = 0; l < this.buildings[k].materialEstimates.length; l++) {
                                            if (this.buildings[k].materialEstimates[l].cost === "CAP" &&
                                                this.uopOptions
                                                    .slice(6)
                                                    .includes(this.buildings[k].materialEstimates[l]
                                                    .unitOfPropertyDescription) &&
                                                this.buildings[k].materialEstimates[l].totalCosts >
                                                    maxValue) {
                                                maxValue =
                                                    this.buildings[k].materialEstimates[l].totalCosts;
                                                maxUopDescription =
                                                    this.buildings[k].materialEstimates[l]
                                                        .unitOfPropertyDescription;
                                            }
                                        }
                                    }
                                    if (maxUopDescription === "") {
                                        maxUopDescription = "Software - Non-License Fees";
                                    }
                                    for (let k = 0; k <
                                        this.projectTypeDerivations[j].uopDescriptionToProjectType
                                            .length && !matchFound; k++) {
                                        if (this.projectTypeDerivations[j].uopDescriptionToProjectType[k].uopDescription.includes(maxUopDescription)) {
                                            if (this.projectTypeDerivations[j]
                                                .uopDescriptionToProjectType[k].isAgile) {
                                                if (this.projectTypeDerivations[j]
                                                    .uopDescriptionToProjectType[k].isAgile ===
                                                    this.agileEffort) {
                                                    this.itProjects[i].projectType =
                                                        this.projectTypeDerivations[j].uopDescriptionToProjectType[k].projectType.replaceAll("[BU]", this.processedAllocations[Math.floor(i / 2)]
                                                            .businessUnitValue);
                                                    matchFound = true;
                                                }
                                            }
                                            else {
                                                this.itProjects[i].projectType =
                                                    this.projectTypeDerivations[j].uopDescriptionToProjectType[k].projectType.replaceAll("[BU]", this.processedAllocations[Math.floor(i / 2)]
                                                        .businessUnitValue);
                                                matchFound = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        this.allocateEstimates();
    }
    allocateEstimates() {
        if (this.hardwareOrSoftwareCopy !== "Hardware and Software") {
            let estimatesForAllProjects = [];
            let materialTotal = 0;
            let materialCapitalTotal = 0;
            for (let i = 0; i < this.buildings.length; i++) {
                for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
                    if (this.buildings[i].materialEstimates[j].cost) {
                        let assetLocation = "";
                        let majorLocation = "";
                        let assetLocationID = "";
                        if (this.buildings[i].buildingName &&
                            this.buildings[i].buildingName.NewAssetLocationAssignment) {
                            assetLocation =
                                this.buildings[i].buildingName.NewAssetLocationAssignment;
                            majorLocation = this.buildings[i].buildingName.NewMajorLocationAssignment;
                            assetLocationID = this.buildings[i].buildingName.AssetLocationID;
                        }
                        materialTotal += this.buildings[i].materialEstimates[j].totalCosts;
                        if (this.buildings[i].materialEstimates[j].cost === "CAP") {
                            materialCapitalTotal +=
                                this.buildings[i].materialEstimates[j].totalCosts;
                        }
                        estimatesForAllProjects.push(new ItProjectEstimate("Materials-".concat(this.buildings[i].materialEstimates[j].cost), Number(this.buildings[i].materialEstimates[j].totalCosts), null, null, assetLocation, majorLocation, this.buildings[i].materialEstimates[j].unitOfPropertyDescription, Number(this.buildings[i].materialEstimates[j].quantity), "", assetLocationID));
                    }
                }
            }
            let materialRatiosAndUopDescriptions = [];
            for (let i = 0; i < this.buildings.length; i++) {
                for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
                    if (this.buildings[i].materialEstimates[j].cost &&
                        this.buildings[i].materialEstimates[j].cost === "CAP") {
                        materialRatiosAndUopDescriptions.push({
                            materialRatio: this.buildings[i].materialEstimates[j].totalCosts /
                                materialCapitalTotal,
                            uopDescription: this.buildings[i].materialEstimates[j]
                                .unitOfPropertyDescription,
                            assetLocation: this.buildings[i].buildingName
                                .NewAssetLocationAssignment
                                ? this.buildings[i].buildingName.NewAssetLocationAssignment
                                : null,
                            majorLocation: this.buildings[i].buildingName
                                .NewAssetLocationAssignment
                                ? this.buildings[i].buildingName.NewMajorLocationAssignment
                                : null,
                            assetLocationID: this.buildings[i].buildingName
                                .NewAssetLocationAssignment
                                ? this.buildings[i].buildingName.AssetLocationID
                                : null
                        });
                    }
                }
            }
            for (let i = 0; i < this.laborDetails.length; i++) {
                if (this.laborDetails[i].workTask &&
                    this.laborDetails[i].workTask.workTask) {
                    if (this.laborDetails[i].workTask.workTask.includes("O&M")) {
                        estimatesForAllProjects.push(new ItProjectEstimate(this.laborDetails[i].workTask.workTask, Number(this.laborDetails[i].totalCosts), null, null, null, null, null, null, this.laborDetails[i].chargeType));
                    }
                    else {
                        for (let j = 0; j < materialRatiosAndUopDescriptions.length; j++) {
                            estimatesForAllProjects.push(new ItProjectEstimate(this.laborDetails[i].workTask.workTask, Math.round(Number(this.laborDetails[i].totalCosts) *
                                materialRatiosAndUopDescriptions[j].materialRatio), null, null, materialRatiosAndUopDescriptions[j].assetLocation, materialRatiosAndUopDescriptions[j].majorLocation, materialRatiosAndUopDescriptions[j].uopDescription, null, this.laborDetails[i].chargeType, materialRatiosAndUopDescriptions[j].assetLocationID));
                        }
                        if (materialRatiosAndUopDescriptions.length === 0 &&
                            this.hardwareOrSoftwareCopy === "Software Only") {
                            estimatesForAllProjects.push(new ItProjectEstimate(this.laborDetails[i].workTask.workTask, Number(this.laborDetails[i].totalCosts), null, null, null, null, "Software - Non-License Fees", null, this.laborDetails[i].chargeType));
                        }
                        else if (materialRatiosAndUopDescriptions.length === 0) {
                            estimatesForAllProjects.push(new ItProjectEstimate(this.laborDetails[i].workTask.workTask, Number(this.laborDetails[i].totalCosts), null, null, null, null, null, null, this.laborDetails[i].chargeType));
                        }
                    }
                }
            }
            for (let i = 0; i < this.contingencyDetails.length; i++) {
                if (this.contingencyDetails[i].cost) {
                    if (this.contingencyDetails[i].cost.includes("O&M")) {
                        estimatesForAllProjects.push(new ItProjectEstimate(this.contingencyDetails[i].cost, Number(this.contingencyDetails[i].totalCosts)));
                    }
                    else {
                        for (let j = 0; j < materialRatiosAndUopDescriptions.length; j++) {
                            estimatesForAllProjects.push(new ItProjectEstimate(this.contingencyDetails[i].cost, Math.round(Number(this.contingencyDetails[i].totalCosts) *
                                materialRatiosAndUopDescriptions[j].materialRatio), null, null, materialRatiosAndUopDescriptions[j].assetLocation, materialRatiosAndUopDescriptions[j].majorLocation, materialRatiosAndUopDescriptions[j].uopDescription, null, "", materialRatiosAndUopDescriptions[j].assetLocationID));
                        }
                        if (materialRatiosAndUopDescriptions.length === 0 &&
                            this.hardwareOrSoftwareCopy === "Software Only") {
                            estimatesForAllProjects.push(new ItProjectEstimate(this.contingencyDetails[i].cost, Number(this.contingencyDetails[i].totalCosts), null, null, null, null, "Software - Non-License Fees"));
                        }
                        else if (materialRatiosAndUopDescriptions.length === 0) {
                            estimatesForAllProjects.push(new ItProjectEstimate(this.contingencyDetails[i].cost, Number(this.contingencyDetails[i].totalCosts)));
                        }
                    }
                }
            }
            let topPercentageIndex = 0;
            let topPercentage = 0;
            for (let i = 0; i < this.processedAllocations.length; i++) {
                if (this.processedAllocations[i].percentage > topPercentage) {
                    topPercentageIndex = i;
                    topPercentage = this.processedAllocations[i].percentage;
                }
                this.itProjects[i].itProjectEstimates = [];
                for (let j = 0; j < estimatesForAllProjects.length; j++) {
                    this.itProjects[i].itProjectEstimates.push(new ItProjectEstimate(estimatesForAllProjects[j].estimateType, Math.round(estimatesForAllProjects[j].dollarAmount *
                        (this.processedAllocations[i].percentage / 100)), null, null, estimatesForAllProjects[j].assetLocation, estimatesForAllProjects[j].majorLocation, estimatesForAllProjects[j].uopDescription, Math.round(estimatesForAllProjects[j].quantity *
                        (this.processedAllocations[i].percentage / 100)), estimatesForAllProjects[j].chargeType, estimatesForAllProjects[j].assetLocationId));
                }
            }
            for (let i = 0; i < estimatesForAllProjects.length; i++) {
                let originalTotal = estimatesForAllProjects[i].dollarAmount;
                let originalQuantityTotal = estimatesForAllProjects[i].quantity;
                let newTotal = 0;
                let newQuantityTotal = 0;
                for (let j = 0; j < this.itProjects.length; j++) {
                    newTotal = Math.round(newTotal + this.itProjects[j].itProjectEstimates[i].dollarAmount);
                    newQuantityTotal =
                        newQuantityTotal +
                            this.itProjects[j].itProjectEstimates[i].quantity;
                }
                let difference = Math.round(originalTotal - newTotal);
                let quantityDifference = originalQuantityTotal - newQuantityTotal;
                this.itProjects[topPercentageIndex].itProjectEstimates[i].dollarAmount =
                    Math.round(this.itProjects[topPercentageIndex].itProjectEstimates[i]
                        .dollarAmount + difference);
                this.itProjects[topPercentageIndex].itProjectEstimates[i].quantity =
                    this.itProjects[topPercentageIndex].itProjectEstimates[i].quantity +
                        quantityDifference;
            }
            for (let i = 0; i < this.itProjects.length; i++) {
                let afudcTotal = this.calculateAFUDC(this.itProjects[i]);
                if (afudcTotal > 0) {
                    if (materialRatiosAndUopDescriptions.length > 0) {
                        for (let j = 0; j < materialRatiosAndUopDescriptions.length; j++) {
                            this.itProjects[i].itProjectEstimates.push(new ItProjectEstimate("AFUDC", Math.round(afudcTotal * materialRatiosAndUopDescriptions[j].materialRatio), null, null, materialRatiosAndUopDescriptions[j].assetLocation, materialRatiosAndUopDescriptions[j].majorLocation, materialRatiosAndUopDescriptions[j].uopDescription, null, null, materialRatiosAndUopDescriptions[j].assetLocationID));
                        }
                    }
                    else {
                        this.itProjects[i].itProjectEstimates.push(new ItProjectEstimate("AFUDC", Math.round(afudcTotal), null, null, null, null, "Software - Non-License Fees", null, null));
                    }
                }
            }
        }
        else {
            let hardwareTotal = 0;
            let softwareTotal = 0;
            let hardwareMaterialTotal = 0;
            let hardwareMaterialCapitalTotal = 0;
            let softwareMaterialTotal = 0;
            let softwareMaterialCapitalTotal = 0;
            let estimatesForHardwareProjects = [];
            let estimatesForSoftwareProjects = [];
            let estimatesToBeSplit = [];
            let estimatesForAllProjects = [];
            for (let i = 0; i < this.buildings.length; i++) {
                let assetLocation = "";
                let majorLocation = "";
                let assetLocationID = "";
                if (this.buildings[i].buildingName.NewAssetLocationAssignment) {
                    assetLocation =
                        this.buildings[i].buildingName.NewAssetLocationAssignment;
                    majorLocation = this.buildings[i].buildingName.NewMajorLocationAssignment;
                    assetLocationID = this.buildings[i].buildingName.AssetLocationID;
                }
                for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
                    if (this.buildings[i].materialEstimates[j].cost &&
                        this.buildings[i].materialEstimates[j].cost === "CAP") {
                        if (this.uopOptions
                            .slice(0, -2)
                            .includes(this.buildings[i].materialEstimates[j]
                            .unitOfPropertyDescription)) {
                            hardwareMaterialTotal +=
                                this.buildings[i].materialEstimates[j].totalCosts;
                            if (this.buildings[i].materialEstimates[j].cost === "CAP") {
                                hardwareMaterialCapitalTotal +=
                                    this.buildings[i].materialEstimates[j].totalCosts;
                            }
                            estimatesForHardwareProjects.push(new ItProjectEstimate("Materials-".concat(this.buildings[i].materialEstimates[j].cost), Number(this.buildings[i].materialEstimates[j].totalCosts), "M ".concat(i.toString()).concat(" ").concat(j.toString()), "Hardware", assetLocation, majorLocation, this.buildings[i].materialEstimates[j].unitOfPropertyDescription, Number(this.buildings[i].materialEstimates[j].quantity), "", assetLocationID));
                            estimatesForAllProjects.push(new ItProjectEstimate("Materials-".concat(this.buildings[i].materialEstimates[j].cost), Number(this.buildings[i].materialEstimates[j].totalCosts), "M ".concat(i.toString()).concat(" ").concat(j.toString()), "Hardware", assetLocation, majorLocation, this.buildings[i].materialEstimates[j].unitOfPropertyDescription, Number(this.buildings[i].materialEstimates[j].quantity), "", assetLocationID));
                            hardwareTotal = Math.round(hardwareTotal +
                                this.buildings[i].materialEstimates[j].totalCosts);
                        }
                        else {
                            softwareMaterialTotal +=
                                this.buildings[i].materialEstimates[j].totalCosts;
                            if (this.buildings[i].materialEstimates[j].cost === "CAP") {
                                softwareMaterialCapitalTotal +=
                                    this.buildings[i].materialEstimates[j].totalCosts;
                            }
                            estimatesForSoftwareProjects.push(new ItProjectEstimate("Materials-".concat(this.buildings[i].materialEstimates[j].cost), Number(this.buildings[i].materialEstimates[j].totalCosts), "M ".concat(i.toString()).concat(" ").concat(j.toString()), "Software", assetLocation, majorLocation, this.buildings[i].materialEstimates[j].unitOfPropertyDescription, Number(this.buildings[i].materialEstimates[j].quantity), "", assetLocationID));
                            estimatesForAllProjects.push(new ItProjectEstimate("Materials-".concat(this.buildings[i].materialEstimates[j].cost), Number(this.buildings[i].materialEstimates[j].totalCosts), "M ".concat(i.toString()).concat(" ").concat(j.toString()), "Software", assetLocation, majorLocation, this.buildings[i].materialEstimates[j].unitOfPropertyDescription, Number(this.buildings[i].materialEstimates[j].quantity), "", assetLocationID));
                            softwareTotal = Math.round(softwareTotal +
                                this.buildings[i].materialEstimates[j].totalCosts);
                        }
                    }
                    else {
                        estimatesToBeSplit.push(new ItProjectEstimate("Materials-".concat(this.buildings[i].materialEstimates[j].cost), Number(this.buildings[i].materialEstimates[j].totalCosts), "M ".concat(i.toString()).concat(" ").concat(j.toString()), "Both", assetLocation, majorLocation, null, Number(this.buildings[i].materialEstimates[j].quantity), "", assetLocationID));
                        estimatesForAllProjects.push(new ItProjectEstimate("Materials-".concat(this.buildings[i].materialEstimates[j].cost), Number(this.buildings[i].materialEstimates[j].totalCosts), "M ".concat(i.toString()).concat(" ").concat(j.toString()), "Both", assetLocation, majorLocation, null, Number(this.buildings[i].materialEstimates[j].quantity), "", assetLocationID));
                    }
                }
            }
            let hardwareMaterialRatiosAndUopDescriptions = [];
            let softwareMaterialRatiosAndUopDescriptions = [];
            for (let i = 0; i < this.buildings.length; i++) {
                for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
                    if (this.buildings[i].materialEstimates[j].cost &&
                        this.buildings[i].materialEstimates[j].cost === "CAP") {
                        if (this.uopOptions
                            .slice(0, -2)
                            .includes(this.buildings[i].materialEstimates[j]
                            .unitOfPropertyDescription)) {
                            hardwareMaterialRatiosAndUopDescriptions.push({
                                materialRatio: this.buildings[i].materialEstimates[j].totalCosts /
                                    hardwareMaterialCapitalTotal,
                                uopDescription: this.buildings[i].materialEstimates[j]
                                    .unitOfPropertyDescription,
                                assetLocation: this.buildings[i].buildingName
                                    .NewAssetLocationAssignment
                                    ? this.buildings[i].buildingName.NewAssetLocationAssignment
                                    : null,
                                majorLocation: this.buildings[i].buildingName
                                    .NewAssetLocationAssignment
                                    ? this.buildings[i].buildingName.NewMajorLocationAssignment
                                    : null,
                                assetLocationID: this.buildings[i].buildingName
                                    .NewAssetLocationAssignment
                                    ? this.buildings[i].buildingName.AssetLocationID
                                    : null
                            });
                        }
                        else {
                            softwareMaterialRatiosAndUopDescriptions.push({
                                materialRatio: this.buildings[i].materialEstimates[j].totalCosts /
                                    softwareMaterialCapitalTotal,
                                uopDescription: this.buildings[i].materialEstimates[j]
                                    .unitOfPropertyDescription,
                                assetLocation: this.buildings[i].buildingName
                                    .NewAssetLocationAssignment
                                    ? this.buildings[i].buildingName.NewAssetLocationAssignment
                                    : null,
                                majorLocation: this.buildings[i].buildingName
                                    .NewAssetLocationAssignment
                                    ? this.buildings[i].buildingName.NewMajorLocationAssignment
                                    : null,
                                assetLocationID: this.buildings[i].buildingName
                                    .NewAssetLocationAssignment
                                    ? this.buildings[i].buildingName.AssetLocationID
                                    : null,
                            });
                        }
                    }
                }
            }
            for (let i = 0; i < this.laborDetails.length; i++) {
                if (this.laborDetails[i].workTask &&
                    this.laborDetails[i].workTask.workTask &&
                    this.laborDetails[i].workTask.workTask.includes("Hardware")) {
                    hardwareTotal = Math.round(hardwareTotal + Number(this.laborDetails[i].totalCosts || 0));
                    estimatesForAllProjects.push(new ItProjectEstimate(this.laborDetails[i].workTask.workTask, Number(this.laborDetails[i].totalCosts), "L ".concat(i.toString()), "Hardware", null, null, null, null, this.laborDetails[i].chargeType));
                    if (this.laborDetails[i].workTask.workTask.includes("O&M")) {
                        estimatesForHardwareProjects.push(new ItProjectEstimate(this.laborDetails[i].workTask.workTask, Number(this.laborDetails[i].totalCosts), "L ".concat(i.toString()), "Hardware", null, null, null, null, this.laborDetails[i].chargeType));
                    }
                    else {
                        for (let j = 0; j < hardwareMaterialRatiosAndUopDescriptions.length; j++) {
                            estimatesForHardwareProjects.push(new ItProjectEstimate(this.laborDetails[i].workTask.workTask, Math.round(Number(this.laborDetails[i].totalCosts) *
                                hardwareMaterialRatiosAndUopDescriptions[j].materialRatio), "L ".concat(i.toString()), "Hardware", hardwareMaterialRatiosAndUopDescriptions[j].assetLocation, hardwareMaterialRatiosAndUopDescriptions[j].majorLocation, hardwareMaterialRatiosAndUopDescriptions[j].uopDescription, null, this.laborDetails[i].chargeType, hardwareMaterialRatiosAndUopDescriptions[j].assetLocationID));
                        }
                        if (hardwareMaterialRatiosAndUopDescriptions.length === 0) {
                            estimatesForHardwareProjects.push(new ItProjectEstimate(this.laborDetails[i].workTask.workTask, Number(this.laborDetails[i].totalCosts), "L ".concat(i.toString()), "Hardware", null, null, null, null, this.laborDetails[i].chargeType));
                        }
                    }
                }
                else if (this.laborDetails[i].workTask &&
                    this.laborDetails[i].workTask.workTask) {
                    softwareTotal = Math.round(softwareTotal + Number(this.laborDetails[i].totalCosts || 0));
                    estimatesForAllProjects.push(new ItProjectEstimate(this.laborDetails[i].workTask.workTask, Number(this.laborDetails[i].totalCosts), "L ".concat(i.toString()), "Software", null, null, null, null, this.laborDetails[i].chargeType));
                    if (this.laborDetails[i].workTask.workTask.includes("O&M")) {
                        estimatesForSoftwareProjects.push(new ItProjectEstimate(this.laborDetails[i].workTask.workTask, Number(this.laborDetails[i].totalCosts), "L ".concat(i.toString()), "Software", null, null, null, null, this.laborDetails[i].chargeType));
                    }
                    else {
                        for (let j = 0; j < softwareMaterialRatiosAndUopDescriptions.length; j++) {
                            estimatesForSoftwareProjects.push(new ItProjectEstimate(this.laborDetails[i].workTask.workTask, Math.round(Number(this.laborDetails[i].totalCosts) *
                                softwareMaterialRatiosAndUopDescriptions[j].materialRatio), "L ".concat(i.toString()), "Software", softwareMaterialRatiosAndUopDescriptions[j].assetLocation, softwareMaterialRatiosAndUopDescriptions[j].majorLocation, softwareMaterialRatiosAndUopDescriptions[j].uopDescription, null, this.laborDetails[i].chargeType, softwareMaterialRatiosAndUopDescriptions[j].assetLocationID));
                        }
                        if (softwareMaterialRatiosAndUopDescriptions.length === 0) {
                            estimatesForSoftwareProjects.push(new ItProjectEstimate(this.laborDetails[i].workTask.workTask, Number(this.laborDetails[i].totalCosts), "L ".concat(i.toString()), "Software", null, null, "Software - Non-License Fees", null, this.laborDetails[i].chargeType));
                        }
                    }
                }
            }
            for (let i = 0; i < this.contingencyDetails.length; i++) {
                if (this.contingencyDetails[i].cost &&
                    this.contingencyDetails[i].cost.includes("Removal")) {
                    hardwareTotal = Math.round(hardwareTotal + Number(this.contingencyDetails[i].totalCosts || 0));
                    estimatesForAllProjects.push(new ItProjectEstimate(this.contingencyDetails[i].cost, Number(this.contingencyDetails[i].totalCosts), "C ".concat(i.toString()), "Hardware"));
                    for (let j = 0; j < hardwareMaterialRatiosAndUopDescriptions.length; j++) {
                        estimatesForHardwareProjects.push(new ItProjectEstimate(this.contingencyDetails[i].cost, Math.round(Number(this.contingencyDetails[i].totalCosts) *
                            hardwareMaterialRatiosAndUopDescriptions[j].materialRatio), "C ".concat(i.toString()), "Hardware", hardwareMaterialRatiosAndUopDescriptions[j].assetLocation, hardwareMaterialRatiosAndUopDescriptions[j].majorLocation, hardwareMaterialRatiosAndUopDescriptions[j].uopDescription, null, "", hardwareMaterialRatiosAndUopDescriptions[j].assetLocationID));
                    }
                    if (hardwareMaterialRatiosAndUopDescriptions.length === 0) {
                        estimatesForHardwareProjects.push(new ItProjectEstimate(this.contingencyDetails[i].cost, Number(this.contingencyDetails[i].totalCosts), "C ".concat(i.toString()), "Hardware"));
                    }
                }
                else if (this.contingencyDetails[i].cost) {
                    estimatesToBeSplit.push(new ItProjectEstimate(this.contingencyDetails[i].cost, Number(this.contingencyDetails[i].totalCosts), "C ".concat(i.toString()), "Both"));
                    estimatesForAllProjects.push(new ItProjectEstimate(this.contingencyDetails[i].cost, Number(this.contingencyDetails[i].totalCosts), "C ".concat(i.toString()), "Both"));
                }
            }
            let hardwareSoftwareSum = Math.round(hardwareTotal + softwareTotal);
            let hardwarePercentage = hardwareTotal / hardwareSoftwareSum;
            let softwarePercentage = softwareTotal / hardwareSoftwareSum;
            for (let i = 0; i < estimatesToBeSplit.length; i++) {
                if (estimatesToBeSplit[i].estimateType.includes("O&M")) {
                    estimatesForHardwareProjects.push(new ItProjectEstimate(estimatesToBeSplit[i].estimateType, Math.round(estimatesToBeSplit[i].dollarAmount * hardwarePercentage), estimatesToBeSplit[i].estimateIdentifier, estimatesToBeSplit[i].hardwareSoftware, estimatesToBeSplit[i].assetLocation, estimatesToBeSplit[i].majorLocation, estimatesToBeSplit[i].uopDescription, Math.round(estimatesToBeSplit[i].quantity * hardwarePercentage), estimatesToBeSplit[i].chargeType, estimatesToBeSplit[i].assetLocationId));
                    estimatesForSoftwareProjects.push(new ItProjectEstimate(estimatesToBeSplit[i].estimateType, Math.round(estimatesToBeSplit[i].dollarAmount * softwarePercentage), estimatesToBeSplit[i].estimateIdentifier, estimatesToBeSplit[i].hardwareSoftware, estimatesToBeSplit[i].assetLocation, estimatesToBeSplit[i].majorLocation, estimatesToBeSplit[i].uopDescription, Math.round(estimatesToBeSplit[i].quantity * softwarePercentage), estimatesToBeSplit[i].chargeType, estimatesToBeSplit[i].assetLocationId));
                }
                else {
                    for (let j = 0; j < hardwareMaterialRatiosAndUopDescriptions.length; j++) {
                        estimatesForHardwareProjects.push(new ItProjectEstimate(estimatesToBeSplit[i].estimateType, Math.round(Math.round(estimatesToBeSplit[i].dollarAmount * hardwarePercentage) * hardwareMaterialRatiosAndUopDescriptions[j].materialRatio), estimatesToBeSplit[i].estimateIdentifier, estimatesToBeSplit[i].hardwareSoftware, hardwareMaterialRatiosAndUopDescriptions[j].assetLocation, hardwareMaterialRatiosAndUopDescriptions[j].majorLocation, hardwareMaterialRatiosAndUopDescriptions[j].uopDescription, Math.round(Math.round(estimatesToBeSplit[i].quantity * hardwarePercentage) * hardwareMaterialRatiosAndUopDescriptions[j].materialRatio), estimatesToBeSplit[i].chargeType, hardwareMaterialRatiosAndUopDescriptions[j].assetLocationID));
                    }
                    for (let j = 0; j < softwareMaterialRatiosAndUopDescriptions.length; j++) {
                        estimatesForSoftwareProjects.push(new ItProjectEstimate(estimatesToBeSplit[i].estimateType, Math.round(Math.round(estimatesToBeSplit[i].dollarAmount * softwarePercentage) * softwareMaterialRatiosAndUopDescriptions[j].materialRatio), estimatesToBeSplit[i].estimateIdentifier, estimatesToBeSplit[i].hardwareSoftware, softwareMaterialRatiosAndUopDescriptions[j].assetLocation, softwareMaterialRatiosAndUopDescriptions[j].majorLocation, softwareMaterialRatiosAndUopDescriptions[j].uopDescription, Math.round(Math.round(estimatesToBeSplit[i].quantity * softwarePercentage) * softwareMaterialRatiosAndUopDescriptions[j].materialRatio), estimatesToBeSplit[i].chargeType, softwareMaterialRatiosAndUopDescriptions[j].assetLocationID));
                    }
                    if (softwareMaterialRatiosAndUopDescriptions.length === 0) {
                        estimatesForSoftwareProjects.push(new ItProjectEstimate(estimatesToBeSplit[i].estimateType, Math.round(Math.round(estimatesToBeSplit[i].dollarAmount * softwarePercentage)), estimatesToBeSplit[i].estimateIdentifier, estimatesToBeSplit[i].hardwareSoftware, estimatesToBeSplit[i].assetLocation, estimatesToBeSplit[i].majorLocation, "Software - Non-License Fees", Math.round(Math.round(estimatesToBeSplit[i].quantity * softwarePercentage)), estimatesToBeSplit[i].chargeType, estimatesToBeSplit[i].assetLocationId));
                    }
                    if (hardwareMaterialRatiosAndUopDescriptions.length === 0) {
                        estimatesForHardwareProjects.push(new ItProjectEstimate(estimatesToBeSplit[i].estimateType, Math.round(Math.round(estimatesToBeSplit[i].dollarAmount * hardwarePercentage)), estimatesToBeSplit[i].estimateIdentifier, estimatesToBeSplit[i].hardwareSoftware, estimatesToBeSplit[i].assetLocation, estimatesToBeSplit[i].majorLocation, estimatesToBeSplit[i].uopDescription, Math.round(Math.round(estimatesToBeSplit[i].quantity * hardwarePercentage)), estimatesToBeSplit[i].chargeType, estimatesToBeSplit[i].assetLocationId));
                    }
                }
            }
            for (let i = 0; i < this.itProjects.length; i++) {
                this.itProjects[i].itProjectEstimates = [];
                // Hardware Project
                if (!(i % 2)) {
                    for (let j = 0; j < estimatesForHardwareProjects.length; j++) {
                        this.itProjects[i].itProjectEstimates.push(new ItProjectEstimate(estimatesForHardwareProjects[j].estimateType, Math.round(estimatesForHardwareProjects[j].dollarAmount *
                            (this.processedAllocations[Math.floor(i / 2)].percentage /
                                100)), estimatesForHardwareProjects[j].estimateIdentifier, estimatesForHardwareProjects[j].hardwareSoftware, estimatesForHardwareProjects[j].assetLocation, estimatesForHardwareProjects[j].majorLocation, estimatesForHardwareProjects[j].uopDescription, Math.round(estimatesForHardwareProjects[j].quantity *
                            (this.processedAllocations[Math.floor(i / 2)].percentage /
                                100)), estimatesForHardwareProjects[j].chargeType, estimatesForHardwareProjects[j].assetLocationId));
                    }
                }
                // Software Project
                else {
                    for (let j = 0; j < estimatesForSoftwareProjects.length; j++) {
                        this.itProjects[i].itProjectEstimates.push(new ItProjectEstimate(estimatesForSoftwareProjects[j].estimateType, Math.round(estimatesForSoftwareProjects[j].dollarAmount *
                            (this.processedAllocations[Math.floor(i / 2)].percentage /
                                100)), estimatesForSoftwareProjects[j].estimateIdentifier, estimatesForSoftwareProjects[j].hardwareSoftware, estimatesForSoftwareProjects[j].assetLocation, estimatesForSoftwareProjects[j].majorLocation, estimatesForSoftwareProjects[j].uopDescription, Math.round(estimatesForSoftwareProjects[j].quantity *
                            (this.processedAllocations[Math.floor(i / 2)].percentage /
                                100)), estimatesForSoftwareProjects[j].chargeType, estimatesForSoftwareProjects[j].assetLocationId));
                    }
                }
            }
            let topPercentageIndex = 0;
            let topPercentage = 0;
            for (let i = 0; i < this.processedAllocations.length; i++) {
                if (this.processedAllocations[i].percentage > topPercentage) {
                    topPercentageIndex = i;
                    topPercentage = this.processedAllocations[i].percentage;
                }
            }
            for (let i = 0; i < estimatesForAllProjects.length; i++) {
                let originalTotal = estimatesForAllProjects[i].dollarAmount;
                let originalQuantityTotal = estimatesForAllProjects[i].quantity;
                let newTotal = 0;
                let newQuantityTotal = 0;
                if (estimatesForAllProjects[i].hardwareSoftware === "Hardware") {
                    for (let j = 0; j < this.processedAllocations.length; j++) {
                        for (let k = 0; k < this.itProjects[j * 2].itProjectEstimates.length; k++) {
                            if (this.itProjects[j * 2].itProjectEstimates[k]
                                .estimateIdentifier ===
                                estimatesForAllProjects[i].estimateIdentifier) {
                                newTotal = Math.round(newTotal +
                                    this.itProjects[j * 2].itProjectEstimates[k].dollarAmount);
                                newQuantityTotal =
                                    newQuantityTotal +
                                        this.itProjects[j * 2].itProjectEstimates[k].quantity;
                            }
                        }
                    }
                }
                else if (estimatesForAllProjects[i].hardwareSoftware === "Software") {
                    for (let j = 0; j < this.processedAllocations.length; j++) {
                        for (let k = 0; k < this.itProjects[j * 2 + 1].itProjectEstimates.length; k++) {
                            if (this.itProjects[j * 2 + 1].itProjectEstimates[k]
                                .estimateIdentifier ===
                                estimatesForAllProjects[i].estimateIdentifier) {
                                newTotal = Math.round(newTotal +
                                    this.itProjects[j * 2 + 1].itProjectEstimates[k]
                                        .dollarAmount);
                                newQuantityTotal =
                                    newQuantityTotal +
                                        this.itProjects[j * 2 + 1].itProjectEstimates[k].quantity;
                            }
                        }
                    }
                }
                else {
                    for (let j = 0; j < this.processedAllocations.length; j++) {
                        for (let k = 0; k < this.itProjects[j * 2].itProjectEstimates.length; k++) {
                            if (this.itProjects[j * 2].itProjectEstimates[k]
                                .estimateIdentifier ===
                                estimatesForAllProjects[i].estimateIdentifier) {
                                newTotal = Math.round(newTotal +
                                    this.itProjects[j * 2].itProjectEstimates[k].dollarAmount);
                                newQuantityTotal =
                                    newQuantityTotal +
                                        this.itProjects[j * 2].itProjectEstimates[k].quantity;
                            }
                        }
                        for (let k = 0; k < this.itProjects[j * 2 + 1].itProjectEstimates.length; k++) {
                            if (this.itProjects[j * 2 + 1].itProjectEstimates[k]
                                .estimateIdentifier ===
                                estimatesForAllProjects[i].estimateIdentifier) {
                                newTotal = Math.round(newTotal +
                                    this.itProjects[j * 2 + 1].itProjectEstimates[k]
                                        .dollarAmount);
                                newQuantityTotal =
                                    newQuantityTotal +
                                        this.itProjects[j * 2 + 1].itProjectEstimates[k].quantity;
                            }
                        }
                    }
                }
                let difference = Math.round(originalTotal - newTotal);
                let quantityDifference = originalQuantityTotal - newQuantityTotal;
                if (estimatesForAllProjects[i].hardwareSoftware === "Hardware") {
                    for (let j = 0; j <
                        this.itProjects[topPercentageIndex * 2].itProjectEstimates.length; j++) {
                        if (this.itProjects[topPercentageIndex * 2].itProjectEstimates[j]
                            .estimateIdentifier ===
                            estimatesForAllProjects[i].estimateIdentifier) {
                            this.itProjects[topPercentageIndex * 2].itProjectEstimates[j].dollarAmount = Math.round(this.itProjects[topPercentageIndex * 2].itProjectEstimates[j]
                                .dollarAmount + difference);
                            this.itProjects[topPercentageIndex * 2].itProjectEstimates[j].quantity =
                                this.itProjects[topPercentageIndex * 2].itProjectEstimates[j]
                                    .quantity + quantityDifference;
                        }
                    }
                }
                else if (estimatesForAllProjects[i].hardwareSoftware === "Software") {
                    for (let j = 0; j <
                        this.itProjects[topPercentageIndex * 2 + 1].itProjectEstimates
                            .length; j++) {
                        if (this.itProjects[topPercentageIndex * 2 + 1].itProjectEstimates[j]
                            .estimateIdentifier ===
                            estimatesForAllProjects[i].estimateIdentifier) {
                            this.itProjects[topPercentageIndex * 2 + 1].itProjectEstimates[j].dollarAmount = Math.round(this.itProjects[topPercentageIndex * 2 + 1].itProjectEstimates[j].dollarAmount + difference);
                            this.itProjects[topPercentageIndex * 2 + 1].itProjectEstimates[j].quantity =
                                this.itProjects[topPercentageIndex * 2 + 1].itProjectEstimates[j].quantity + quantityDifference;
                        }
                    }
                }
                else {
                    for (let j = 0; j <
                        this.itProjects[topPercentageIndex * 2].itProjectEstimates.length; j++) {
                        if (this.itProjects[topPercentageIndex * 2].itProjectEstimates[j]
                            .estimateIdentifier ===
                            estimatesForAllProjects[i].estimateIdentifier) {
                            this.itProjects[topPercentageIndex * 2].itProjectEstimates[j].dollarAmount = Math.round(this.itProjects[topPercentageIndex * 2].itProjectEstimates[j]
                                .dollarAmount +
                                difference * hardwarePercentage);
                            this.itProjects[topPercentageIndex * 2].itProjectEstimates[j].quantity = Math.round(this.itProjects[topPercentageIndex * 2].itProjectEstimates[j]
                                .quantity +
                                quantityDifference * hardwarePercentage);
                        }
                    }
                    for (let j = 0; j <
                        this.itProjects[topPercentageIndex * 2 + 1].itProjectEstimates
                            .length; j++) {
                        if (this.itProjects[topPercentageIndex * 2 + 1].itProjectEstimates[j]
                            .estimateIdentifier ===
                            estimatesForAllProjects[i].estimateIdentifier) {
                            this.itProjects[topPercentageIndex * 2 + 1].itProjectEstimates[j].dollarAmount = Math.round(this.itProjects[topPercentageIndex * 2 + 1].itProjectEstimates[j].dollarAmount +
                                difference * softwarePercentage);
                            this.itProjects[topPercentageIndex * 2 + 1].itProjectEstimates[j].quantity = Math.round(this.itProjects[topPercentageIndex * 2 + 1].itProjectEstimates[j].quantity +
                                quantityDifference * softwarePercentage);
                        }
                    }
                }
            }
            for (let i = 0; i < this.itProjects.length; i++) {
                let afudcTotal = this.calculateAFUDC(this.itProjects[i]);
                if (afudcTotal > 0) {
                    if (!(i % 2)) {
                        for (let j = 0; j < hardwareMaterialRatiosAndUopDescriptions.length; j++) {
                            this.itProjects[i].itProjectEstimates.push(new ItProjectEstimate("AFUDC", Math.round(afudcTotal *
                                hardwareMaterialRatiosAndUopDescriptions[j].materialRatio), null, null, hardwareMaterialRatiosAndUopDescriptions[j].assetLocation, hardwareMaterialRatiosAndUopDescriptions[j].majorLocation, hardwareMaterialRatiosAndUopDescriptions[j].uopDescription, null, null, hardwareMaterialRatiosAndUopDescriptions[j].assetLocationID));
                        }
                    }
                    else {
                        if (softwareMaterialRatiosAndUopDescriptions.length > 0) {
                            for (let j = 0; j < softwareMaterialRatiosAndUopDescriptions.length; j++) {
                                this.itProjects[i].itProjectEstimates.push(new ItProjectEstimate("AFUDC", Math.round(afudcTotal *
                                    softwareMaterialRatiosAndUopDescriptions[j]
                                        .materialRatio), null, null, softwareMaterialRatiosAndUopDescriptions[j].assetLocation, softwareMaterialRatiosAndUopDescriptions[j].majorLocation, softwareMaterialRatiosAndUopDescriptions[j].uopDescription, null, null, softwareMaterialRatiosAndUopDescriptions[j].assetLocationID));
                            }
                        }
                        else {
                            this.itProjects[i].itProjectEstimates.push(new ItProjectEstimate("AFUDC", Math.round(afudcTotal), null, null, null, null, "Software - Non-License Fees", null, null));
                        }
                    }
                }
            }
        }
        for (let i = 0; i < this.itProjects.length; i++) {
            if (this.itProjectClassification.ets_proj_classification === "Lighthouse" &&
                !this.estimateWithCapital(this.itProjects[i])) {
                this.itProjects[i].itProjectEstimates.push(new ItProjectEstimate("Other-CAP", 0.01, null, null, this.itProjects[i].assetLocation, this.itProjects[i].majorLocation, this.defaultCapitalUOP, null, null, this.itProjects[i].assetLocationId));
            }
            if (this.itProjectClassification.ets_proj_classification === "Lighthouse" &&
                !this.estimateWithOM(this.itProjects[i])) {
                this.itProjects[i].itProjectEstimates.push(new ItProjectEstimate("Other-O&M", 0.01, null, null, this.itProjects[i].assetLocation, this.itProjects[i].majorLocation, null, null, null, this.itProjects[i].assetLocationId));
            }
        }
        for (let i = 0; i < this.itProjects.length; i++) {
            this.getActivities(i);
        }
        this.makeAFUDCRoundingAdjustment();
        this.generateProjectChargeIndicator();
        this.generateAssetLocations();
    }
    makeAFUDCRoundingAdjustment() {
        let afudcInitialTotal = 0;
        for (let i = 0; i < this.itProjects.length; i++) {
            for (let j = 0; j < this.itProjects[i].itProjectEstimates.length; j++) {
                if (this.itProjects[i].itProjectEstimates[j].estimateType === "AFUDC") {
                    afudcInitialTotal +=
                        this.itProjects[i].itProjectEstimates[j].dollarAmount;
                }
            }
        }
        let difference = afudcInitialTotal - this.estimatedAFUDC();
        if (difference > 0) {
            for (let i = 0; i < this.itProjects.length && difference > 0; i++) {
                for (let j = 0; j < this.itProjects[i].itProjectEstimates.length && difference > 0; j++) {
                    if (this.itProjects[i].itProjectEstimates[j].estimateType === "AFUDC") {
                        this.itProjects[i].itProjectEstimates[j].dollarAmount =
                            this.itProjects[i].itProjectEstimates[j].dollarAmount - 1;
                        difference = difference - 1;
                    }
                }
            }
        }
        if (difference < 0) {
            for (let i = 0; i < this.itProjects.length && difference < 0; i++) {
                for (let j = 0; j < this.itProjects[i].itProjectEstimates.length && difference < 0; j++) {
                    if (this.itProjects[i].itProjectEstimates[j].estimateType === "AFUDC") {
                        this.itProjects[i].itProjectEstimates[j].dollarAmount =
                            this.itProjects[i].itProjectEstimates[j].dollarAmount + 1;
                        difference = difference + 1;
                    }
                }
            }
        }
    }
    getActivities(i) {
        let callBody = {
            woDescription: this.itProjects[i].projectType,
            businessUnit: this.itProjects[i].businessUnit,
        };
        if (callBody.woDescription) {
            this.dataService
                .getAthenaData("it_spar_wo_desc_to_id", callBody)
                .subscribe((result) => {
                let results = JSON.parse(result);
                let workOrderId;
                this.itProjects[i].activities = [];
                let matchFound = false;
                for (let j = 0; j < this.activityDerivation.length && !matchFound; j++) {
                    if ((this.itProjectClassification.ets_proj_classification ===
                        "Lighthouse" &&
                        this.activityDerivation[j].isLighthouse === "YES") ||
                        (this.itProjectClassification.ets_proj_classification !==
                            "Lighthouse" &&
                            this.activityDerivation[j].isLighthouse === "NO")) {
                        if ((this.activityDerivation[j].hardwareOrSoftware &&
                            this.activityDerivation[j].hardwareOrSoftware.includes(this.hardwareOrSoftware)) ||
                            !this.activityDerivation[j].hardwareOrSoftware) {
                            if (!this.activityDerivation[j].hasRemoval ||
                                (((this.activityDerivation[j].hasRemoval === "YES" &&
                                    this.estimateWithRemoval(this.itProjects[i])) ||
                                    (this.activityDerivation[j].hasRemoval === "NO" &&
                                        !this.estimateWithRemoval(this.itProjects[i]))) &&
                                    ((this.activityDerivation[j].hasCapital === "YES" &&
                                        this.estimateWithCapital(this.itProjects[i])) ||
                                        (this.activityDerivation[j].hasCapital === "NO" &&
                                            !this.estimateWithCapital(this.itProjects[i]))) &&
                                    ((this.activityDerivation[j].hasOM === "YES" &&
                                        this.estimateWithOM(this.itProjects[i])) ||
                                        (this.activityDerivation[j].hasOM === "NO" &&
                                            !this.estimateWithOM(this.itProjects[i]))))) {
                                matchFound = true;
                                for (let k = 0; k <
                                    this.activityDerivation[j].additionalActivities.length; k++) {
                                    this.itProjects[i].activities.push(new ItActivity(this.activityDerivation[j].additionalActivities[k].activity, this.activityDerivation[j].additionalActivities[k].description));
                                }
                            }
                        }
                    }
                }
                if (results.length === 0) {
                    workOrderId = "";
                }
                else {
                    workOrderId = results[0].work_order_type_id;
                }
                let callBody2 = {
                    businessUnit: [this.itProjects[i].businessUnit],
                };
                this.dataService
                    .getFireHubData("fihub_get_acct_model", callBody2)
                    .subscribe((result) => {
                    let callBody3 = {
                        workOrderTypeId: workOrderId,
                    };
                    if (result.length > 0) {
                        this.itProjects[i].setId = result[0].ACCT_MODEL_SETID;
                        this.generateAccountingTreatments(i);
                        this.setProjectFunction(i);
                    }
                    else {
                        this.itProjects[i].setId = "";
                    }
                }, (error) => {
                    console.log("error", error);
                    let errorType = "";
                    let errorDescription = "";
                    if (error.error.message) {
                        errorDescription = errorDescription.concat("Get FiHub SetID Error - ", error.error.message);
                    }
                    else {
                        errorDescription = errorDescription.concat("Get FiHub SetID Error");
                    }
                    errorType = errorType.concat(error.status, " ", error.statusText);
                    let dataStructure = {
                        errorType: errorType,
                        errorDescription: errorDescription,
                    };
                    this.dialog.open(ErrorDialogComponent, {
                        data: dataStructure,
                        disableClose: true,
                    });
                });
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Get WO Desc Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Get WO Desc Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            });
        }
    }
    setProjectFunction(i) {
        let matchFound = false;
        for (let j = 0; j < this.setIdToFunction.length && !matchFound; j++) {
            if (this.itProjects[i].setId === this.setIdToFunction[j].setId) {
                if (this.setIdToFunction[j].function === "User Input") {
                    if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
                        this.itProjects[i].function = this.processedAllocations[Math.floor(i / 2)].function;
                    }
                    else {
                        this.itProjects[i].function = this.processedAllocations[i].function;
                    }
                }
                else {
                    this.itProjects[i].function = this.setIdToFunction[j].function;
                }
                matchFound = true;
            }
        }
        this.generateUtilityAccountRetirementUnit(i);
    }
    generateAccountingTreatments(i) {
        for (let j = 0; j < this.itProjects[i].activities.length; j++) {
            // find accounting treatment
            let matchFound = false;
            for (let k = 0; k < this.accountingTreatment.length && !matchFound; k++) {
                if (this.itProjects[i].activities[j].activity === this.accountingTreatment[k].activity) {
                    if (this.accountingTreatment[k].accountingTreatment) {
                        this.itProjects[i].activities[j].accountingTreatment = this.accountingTreatment[k].accountingTreatment;
                        matchFound = true;
                    }
                    else {
                        // get the Pertains To value
                        let pertainsToValue = '';
                        if (this.hardwareOrSoftwareCopy === 'O&M Only') {
                            pertainsToValue = this.relatedWork;
                        }
                        else if (this.hardwareOrSoftwareCopy === 'Hardware and Software') {
                            pertainsToValue = this.itProjects[i].hardwareOrSoftware;
                        }
                        else if (this.hardwareOrSoftwareCopy === 'Hardware Only') {
                            pertainsToValue = 'Hardware';
                        }
                        else if (this.hardwareOrSoftwareCopy === 'Software Only') {
                            pertainsToValue = 'Software';
                        }
                        if (this.accountingTreatment[k].isOMOnly) {
                            if ((this.hardwareOrSoftwareCopy === 'O&M Only' && this.accountingTreatment[k].isOMOnly === "YES")
                                || (this.hardwareOrSoftwareCopy !== 'O&M Only' && this.accountingTreatment[k].isOMOnly === "NO")) {
                                let matchFound2 = false;
                                for (let l = 0; l < this.accountingTreatment[k].workPertainsTo.length && !matchFound2; l++) {
                                    if (pertainsToValue === this.accountingTreatment[k].workPertainsTo[l].pertainsTo) {
                                        if (this.accountingTreatment[k].workPertainsTo[l].uopMostDollars) {
                                            let maxUOP = this.highestDollarUOP(i);
                                            if (this.accountingTreatment[k].workPertainsTo[l].uopMostDollars === maxUOP) {
                                                this.itProjects[i].activities[j].accountingTreatment = this.accountingTreatment[k].workPertainsTo[l].accountingTreatment;
                                                matchFound = true;
                                                matchFound2 = true;
                                            }
                                        }
                                        else {
                                            this.itProjects[i].activities[j].accountingTreatment = this.accountingTreatment[k].workPertainsTo[l].accountingTreatment;
                                            matchFound = true;
                                            matchFound2 = true;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            let matchFound2 = false;
                            for (let l = 0; l < this.accountingTreatment[k].workPertainsTo.length && !matchFound2; l++) {
                                if (pertainsToValue === this.accountingTreatment[k].workPertainsTo[l].pertainsTo) {
                                    if (this.accountingTreatment[k].workPertainsTo[l].uopMostDollars) {
                                        let maxUOP = this.highestDollarUOP(i);
                                        if (this.accountingTreatment[k].workPertainsTo[l].uopMostDollars === maxUOP) {
                                            this.itProjects[i].activities[j].accountingTreatment = this.accountingTreatment[k].workPertainsTo[l].accountingTreatment;
                                            matchFound = true;
                                            matchFound2 = true;
                                        }
                                    }
                                    else {
                                        this.itProjects[i].activities[j].accountingTreatment = this.accountingTreatment[k].workPertainsTo[l].accountingTreatment;
                                        matchFound = true;
                                        matchFound2 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (!matchFound) {
                console.log('no match found');
            }
        }
        this.generateAccountingModels(i);
    }
    generateAccountingModels(i) {
        let matchFound = false;
        let derivationEntry = null;
        for (let k = 0; k < this.accountingModelDerivation.length && !matchFound; k++) {
            if (this.itProjects[i].setId === this.accountingModelDerivation[k].setId) {
                derivationEntry = this.accountingModelDerivation[k];
                matchFound = true;
            }
        }
        for (let j = 0; j < this.itProjects[i].activities.length; j++) {
            let matchFound = false;
            for (let k = 0; k < derivationEntry.activityToAccountingModel.length && !matchFound; k++) {
                if (derivationEntry.activityToAccountingModel[k].accountingTreatment === this.itProjects[i].activities[j].accountingTreatment) {
                    if (derivationEntry.businessUnit) {
                        if (derivationEntry.activityToAccountingModel[k].businessUnit) {
                            if (derivationEntry.activityToAccountingModel[k].businessUnit === "like 47%") {
                                this.itProjects[i].activities[j].accountingModel = derivationEntry.activityToAccountingModel[k].accountingModel;
                                matchFound = true;
                            }
                        }
                        else if (derivationEntry.activityToAccountingModel[k].businessUnit === "not like 47%") {
                            if (!this.itProjects[i].businessUnit.startsWith("47")) {
                                this.itProjects[i].activities[j].accountingModel = derivationEntry.activityToAccountingModel[k].accountingModel;
                                matchFound = true;
                            }
                        }
                    }
                    else if (derivationEntry.activityToAccountingModel[k].function) {
                        if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
                            if (this.processedAllocations[Math.floor(i / 2)].function === derivationEntry.activityToAccountingModel[k].function) {
                                this.itProjects[i].activities[j].accountingModel = derivationEntry.activityToAccountingModel[k].accountingModel;
                                matchFound = true;
                            }
                        }
                        else {
                            if (this.processedAllocations[i].function === derivationEntry.activityToAccountingModel[k].function) {
                                this.itProjects[i].activities[j].accountingModel = derivationEntry.activityToAccountingModel[k].accountingModel;
                                matchFound = true;
                            }
                        }
                    }
                    else {
                        this.itProjects[i].activities[j].accountingModel = derivationEntry.activityToAccountingModel[k].accountingModel;
                        matchFound = true;
                    }
                }
            }
        }
    }
    highestDollarUOP(i) {
        let uopDescriptions = [];
        let uopValues = [];
        for (let j = 0; j < this.itProjects[i].itProjectEstimates.length; j++) {
            if (this.itProjects[i].itProjectEstimates[j].utilityAccountDescription) {
                let uopMatchFound = false;
                for (let k = 0; k < uopDescriptions.length && !uopMatchFound; k++) {
                    if (this.itProjects[i].itProjectEstimates[j].utilityAccountDescription === uopDescriptions[k]) {
                        uopValues[k] = uopValues[k] += this.itProjects[i].itProjectEstimates[j].dollarAmount;
                        uopMatchFound = true;
                    }
                }
                if (!uopMatchFound) {
                    uopDescriptions.push(this.itProjects[i].itProjectEstimates[j].utilityAccountDescription);
                    uopValues.push(this.itProjects[i].itProjectEstimates[j].dollarAmount);
                }
            }
        }
        let maxUopDescription = '';
        let maxUopValue = -1;
        for (let i = 0; i < uopDescriptions.length; i++) {
            if (uopValues[i] > maxUopValue) {
                maxUopValue = uopValues[i];
                maxUopDescription = uopDescriptions[i];
            }
        }
        return maxUopDescription;
    }
    generateProjectChargeIndicator() {
        for (let i = 0; i < this.itProjects.length; i++) {
            let isCWIP = false;
            let isRWIP = false;
            let isOM = true;
            for (let j = 0; j < this.itProjects[i].itProjectEstimates.length; j++) {
                if (this.itProjects[i].itProjectEstimates[j].estimateType.includes("CAP")) {
                    isCWIP = true;
                }
                if (this.itProjects[i].itProjectEstimates[j].estimateType.includes("Removal")) {
                    isRWIP = true;
                }
                if (this.itProjects[i].itProjectEstimates[j].estimateType.includes("O&M") ||
                    this.itProjectClassification.ets_proj_classification === "Lighthouse") {
                    isOM = true;
                }
            }
            if (isCWIP) {
                if (isRWIP) {
                    if (isOM) {
                        this.itProjects[i].projectChargeIndicator = "CWIP, RWIP and O&M";
                    }
                    else {
                        this.itProjects[i].projectChargeIndicator = "CWIP and RWIP";
                    }
                }
                else if (isOM) {
                    this.itProjects[i].projectChargeIndicator = "CWIP and O&M";
                }
                else {
                    this.itProjects[i].projectChargeIndicator = "CWIP Only";
                }
            }
            else if (isRWIP) {
                if (isOM) {
                    this.itProjects[i].projectChargeIndicator = "RWIP and O&M";
                }
                else {
                    this.itProjects[i].projectChargeIndicator = "RWIP Only";
                }
            }
            else if (isOM) {
                this.itProjects[i].projectChargeIndicator = "O&M";
            }
            else {
                this.itProjects[i].projectChargeIndicator = "";
            }
        }
    }
    generateAssetLocations() {
        let assetLocationID = "";
        // a real building
        if (this.buildingInfo && this.buildingInfo.AssetLocationID) {
            assetLocationID = this.buildingInfo.AssetLocationID;
            for (let i = 0; i < this.itProjects.length; i++) {
                this.itProjects[i].assetLocationId = assetLocationID;
                for (let j = 0; j < this.itProjects[i].itProjectEstimates.length; j++) {
                    if (!this.itProjects[i].itProjectEstimates[j].assetLocationId) {
                        this.itProjects[i].itProjectEstimates[j].assetLocationId = assetLocationID;
                    }
                }
            }
            this.getDescriptionAndMajorLocation(assetLocationID);
        }
        // a special building that is Costs will be spread across Nuclear Sites or one of the particular nuclear sites
        else if (this.buildingInfo && (this.buildingInfo.BuildingName === "Costs Will Be Spread Across Nuclear Sites" ||
            this.buildingInfo.BuildingName === "Brunswick Nuclear Plant" ||
            this.buildingInfo.BuildingName === "Catawba Nuclear Station" ||
            this.buildingInfo.BuildingName === "Harris Nuclear Plant" ||
            this.buildingInfo.BuildingName === "McGuire Nuclear Station" ||
            this.buildingInfo.BuildingName === "Oconee Nuclear Station" ||
            this.buildingInfo.BuildingName === "Robinson Nuclear Plant")) {
            for (let i = 0; i < this.itProjects.length; i++) {
                let matchFound = false;
                for (let j = 0; j < this.ouAssetLocMajorLoc.length && !matchFound; j++) {
                    if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
                        if (this.processedAllocations[Math.floor(i / 2)].operatingUnit.OPERATING_UNIT ===
                            this.ouAssetLocMajorLoc[j].operatingUnit) {
                            this.itProjects[i].assetLocationId =
                                this.ouAssetLocMajorLoc[j].assetLocationID;
                            for (let k = 0; k < this.itProjects[i].itProjectEstimates.length; k++) {
                                this.itProjects[i].itProjectEstimates[k].assetLocationId =
                                    this.ouAssetLocMajorLoc[j].assetLocationID;
                            }
                            matchFound = true;
                            this.getDescriptionAndMajorLocation(this.ouAssetLocMajorLoc[j].assetLocationID, false, true, i);
                        }
                    }
                    else {
                        if (this.processedAllocations[i].operatingUnit.OPERATING_UNIT ===
                            this.ouAssetLocMajorLoc[j].operatingUnit) {
                            this.itProjects[i].assetLocationId =
                                this.ouAssetLocMajorLoc[j].assetLocationID;
                            for (let k = 0; k < this.itProjects[i].itProjectEstimates.length; k++) {
                                this.itProjects[i].itProjectEstimates[k].assetLocationId =
                                    this.ouAssetLocMajorLoc[j].assetLocationID;
                            }
                            matchFound = true;
                            this.getDescriptionAndMajorLocation(this.ouAssetLocMajorLoc[j].assetLocationID, false, true, i);
                        }
                    }
                }
                if (!matchFound) {
                    let matchFound2 = false;
                    for (let j = 0; j < this.buDefaults.length && !matchFound2; j++) {
                        if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
                            if (!this.buDefaults[j].BusinessUnit ||
                                this.processedAllocations[Math.floor(i / 2)].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                this.itProjects[i].assetLocationId = this.buDefaults[j].AssetLocationID;
                                for (let k = 0; k < this.itProjects[i].itProjectEstimates.length; k++) {
                                    this.itProjects[i].itProjectEstimates[k].assetLocationId =
                                        this.buDefaults[j].AssetLocationID;
                                }
                                matchFound2 = true;
                                this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, true, i, true);
                            }
                        }
                        else {
                            if (!this.buDefaults[j].BusinessUnit ||
                                this.processedAllocations[i].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                this.itProjects[i].assetLocationId = this.buDefaults[j].AssetLocationID;
                                for (let k = 0; k < this.itProjects[i].itProjectEstimates.length; k++) {
                                    this.itProjects[i].itProjectEstimates[k].assetLocationId =
                                        this.buDefaults[j].AssetLocationID;
                                }
                                matchFound2 = true;
                                this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, true, i, true);
                            }
                        }
                    }
                }
            }
        }
        // a special building (IT POP)
        else if (this.buildingInfo && this.buildingInfo.BuildingName === "IT POP") {
            for (let i = 0; i < this.itProjects.length; i++) {
                let matchFound = false;
                for (let j = 0; j < this.itPopAssetLocMajorLoc.length && !matchFound; j++) {
                    if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
                        if (this.processedAllocations[Math.floor(i / 2)].businessUnitValue ===
                            this.itPopAssetLocMajorLoc[j].businessUnit) {
                            if (this.itPopAssetLocMajorLoc[j].assetLocationSC &&
                                this.processedAllocations[Math.floor(i / 2)].state === "SC") {
                                this.itProjects[i].assetLocationId =
                                    this.itPopAssetLocMajorLoc[j].assetLocationIDSC;
                                for (let k = 0; k < this.itProjects[i].itProjectEstimates.length; k++) {
                                    this.itProjects[i].itProjectEstimates[k].assetLocationId =
                                        this.itPopAssetLocMajorLoc[j].assetLocationIDSC;
                                }
                                matchFound = true;
                                this.getDescriptionAndMajorLocation(this.itPopAssetLocMajorLoc[j].assetLocationIDSC, false, true, i);
                            }
                            else {
                                this.itProjects[i].assetLocationId =
                                    this.itPopAssetLocMajorLoc[j].assetLocationID;
                                for (let k = 0; k < this.itProjects[i].itProjectEstimates.length; k++) {
                                    this.itProjects[i].itProjectEstimates[k].assetLocationId =
                                        this.itPopAssetLocMajorLoc[j].assetLocationID;
                                }
                                matchFound = true;
                                this.getDescriptionAndMajorLocation(this.itPopAssetLocMajorLoc[j].assetLocationID, false, true, i);
                            }
                        }
                    }
                    else {
                        if (this.processedAllocations[i].businessUnitValue ===
                            this.itPopAssetLocMajorLoc[j].businessUnit) {
                            if (this.itPopAssetLocMajorLoc[j].assetLocationSC &&
                                this.processedAllocations[i].state === "SC") {
                                this.itProjects[i].assetLocationId =
                                    this.itPopAssetLocMajorLoc[j].assetLocationIDSC;
                                for (let k = 0; k < this.itProjects[i].itProjectEstimates.length; k++) {
                                    this.itProjects[i].itProjectEstimates[k].assetLocationId =
                                        this.itPopAssetLocMajorLoc[j].assetLocationIDSC;
                                }
                                matchFound = true;
                                this.getDescriptionAndMajorLocation(this.itPopAssetLocMajorLoc[j].assetLocationIDSC, false, true, i);
                            }
                            else {
                                this.itProjects[i].assetLocationId =
                                    this.itPopAssetLocMajorLoc[j].assetLocationID;
                                for (let k = 0; k < this.itProjects[i].itProjectEstimates.length; k++) {
                                    this.itProjects[i].itProjectEstimates[k].assetLocationId =
                                        this.itPopAssetLocMajorLoc[j].assetLocationID;
                                }
                                matchFound = true;
                                this.getDescriptionAndMajorLocation(this.itPopAssetLocMajorLoc[j].assetLocationID, false, true, i);
                            }
                        }
                    }
                }
                if (!matchFound) {
                    let matchFound2 = false;
                    for (let j = 0; j < this.buDefaults.length && !matchFound2; j++) {
                        if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
                            if (!this.buDefaults[j].BusinessUnit ||
                                this.processedAllocations[Math.floor(i / 2)].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                this.itProjects[i].assetLocationId = this.buDefaults[j].AssetLocationID;
                                for (let k = 0; k < this.itProjects[i].itProjectEstimates.length; k++) {
                                    this.itProjects[i].itProjectEstimates[k].assetLocationId =
                                        this.buDefaults[j].AssetLocationID;
                                }
                                matchFound2 = true;
                                this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, true, i, true);
                            }
                        }
                        else {
                            if (!this.buDefaults[j].BusinessUnit ||
                                this.processedAllocations[i].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                this.itProjects[i].assetLocationId = this.buDefaults[j].AssetLocationID;
                                for (let k = 0; k < this.itProjects[i].itProjectEstimates.length; k++) {
                                    this.itProjects[i].itProjectEstimates[k].assetLocationId =
                                        this.buDefaults[j].AssetLocationID;
                                }
                                matchFound2 = true;
                                this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, true, i, true);
                            }
                        }
                    }
                }
            }
        }
        // any other special building
        else if (this.buildingInfo && this.buildingInfo.BuildingName) {
            let matchFound = false;
            let assetLocationID = "";
            for (let i = 0; i < this.otherSpecialBuildings.length && !matchFound; i++) {
                if (this.buildingInfo.BuildingName === this.otherSpecialBuildings[i].SpecialBuilding) {
                    assetLocationID = this.otherSpecialBuildings[i].AssetLocationID;
                    matchFound = true;
                }
            }
            for (let i = 0; i < this.itProjects.length; i++) {
                this.itProjects[i].assetLocationId = assetLocationID;
                for (let j = 0; j < this.itProjects[i].itProjectEstimates.length; j++) {
                    this.itProjects[i].itProjectEstimates[j].assetLocationId = assetLocationID;
                }
            }
            if (assetLocationID) {
                this.getDescriptionAndMajorLocation(assetLocationID, true);
            }
        }
    }
    getDescriptionAndMajorLocation(assetLocationID, isAll, isProjLevel, projIndex, isDefault, isEstLevel, estIndex, projLevelSkipping) {
        let assetLocation = "";
        let majorLocation = "";
        let majorLocationId = "";
        let callBody = {
            assetLocId: assetLocationID,
        };
        this.dataService
            .getAthenaData("get_asset_and_major_location_info", callBody)
            .subscribe((result) => {
            if (result[0] && result[0].asset_location) {
                assetLocation = result[0].asset_location;
                majorLocation = result[0].major_location;
                majorLocationId = result[0].major_location_id;
                if (isAll) {
                    for (let i = 0; i < this.itProjects.length; i++) {
                        this.itProjects[i].assetLocation = assetLocation;
                        this.itProjects[i].majorLocation = majorLocation;
                        this.itProjects[i].majorLocationId = majorLocationId;
                        for (let j = 0; j < this.itProjects[i].itProjectEstimates.length; j++) {
                            this.itProjects[i].itProjectEstimates[j].assetLocation = assetLocation;
                            this.itProjects[i].itProjectEstimates[j].majorLocation = majorLocation;
                            this.itProjects[i].itProjectEstimates[j].majorLocationId = majorLocationId;
                        }
                        this.validateMajorLocation(i, isDefault);
                    }
                }
                else if (isProjLevel) {
                    this.itProjects[projIndex].assetLocation = assetLocation;
                    this.itProjects[projIndex].majorLocation = majorLocation;
                    this.itProjects[projIndex].majorLocationId = majorLocationId;
                    for (let j = 0; j < this.itProjects[projIndex].itProjectEstimates.length; j++) {
                        if (!projLevelSkipping ||
                            (projLevelSkipping && assetLocationID === this.itProjects[projIndex].itProjectEstimates[j].assetLocationId)) {
                            this.itProjects[projIndex].itProjectEstimates[j].assetLocation = assetLocation;
                            this.itProjects[projIndex].itProjectEstimates[j].majorLocation = majorLocation;
                            this.itProjects[projIndex].itProjectEstimates[j].majorLocationId = majorLocationId;
                        }
                    }
                    this.validateMajorLocation(projIndex, isDefault, projLevelSkipping);
                }
                else if (isEstLevel) {
                    this.itProjects[projIndex].itProjectEstimates[estIndex].assetLocation = assetLocation;
                    this.itProjects[projIndex].itProjectEstimates[estIndex].majorLocation = majorLocation;
                    this.itProjects[projIndex].itProjectEstimates[estIndex].majorLocationId = majorLocationId;
                    this.validateMajorLocation(projIndex, isDefault, false, true, estIndex);
                }
                else {
                    for (let i = 0; i < this.itProjects.length; i++) {
                        this.itProjects[i].assetLocation = assetLocation;
                        this.itProjects[i].majorLocation = majorLocation;
                        this.itProjects[i].majorLocationId = majorLocationId;
                        for (let j = 0; j < this.itProjects[i].itProjectEstimates.length; j++) {
                            if (this.itProjects[i].itProjectEstimates[j].assetLocationId === assetLocationID) {
                                this.itProjects[i].itProjectEstimates[j].assetLocation = assetLocation;
                                this.itProjects[i].itProjectEstimates[j].majorLocation = majorLocation;
                                this.itProjects[i].itProjectEstimates[j].majorLocationId = majorLocationId;
                            }
                            else {
                                // recursive call to handle the estimate row that differs from parent Building
                                this.getDescriptionAndMajorLocation(this.itProjects[i].itProjectEstimates[j].assetLocationId, false, false, i, false, true, j);
                            }
                        }
                        this.validateMajorLocation(i, isDefault, true);
                    }
                }
            }
            else {
                if (isDefault) {
                    // if we are using a BU default
                    if (isAll) {
                        for (let i = 0; i < this.itProjects.length; i++) {
                            this.itProjects[i].assetLocation = "";
                            this.itProjects[i].assetLocationId = "";
                            this.itProjects[i].majorLocation = "";
                            this.itProjects[i].majorLocationId = "";
                            for (let j = 0; j < this.itProjects[i].itProjectEstimates.length; j++) {
                                this.itProjects[i].itProjectEstimates[j].assetLocation = "";
                                this.itProjects[i].itProjectEstimates[j].assetLocationId = "";
                                this.itProjects[i].itProjectEstimates[j].majorLocation = "";
                                this.itProjects[i].itProjectEstimates[j].majorLocationId = "";
                                this.itProjects[i].itProjectEstimates[j].assetAndMajorLoaded = true;
                                this.showDerivationError = true;
                            }
                        }
                    }
                    else if (isProjLevel) {
                        this.itProjects[projIndex].assetLocation = "";
                        this.itProjects[projIndex].assetLocationId = "";
                        this.itProjects[projIndex].majorLocation = "";
                        this.itProjects[projIndex].majorLocationId = "";
                        for (let j = 0; j < this.itProjects[projIndex].itProjectEstimates.length; j++) {
                            if (!projLevelSkipping ||
                                (projLevelSkipping && assetLocationID === this.itProjects[projIndex].itProjectEstimates[j].assetLocationId)) {
                                this.itProjects[projIndex].itProjectEstimates[j].assetLocation = "";
                                this.itProjects[projIndex].itProjectEstimates[j].assetLocationId = "";
                                this.itProjects[projIndex].itProjectEstimates[j].majorLocation = "";
                                this.itProjects[projIndex].itProjectEstimates[j].majorLocationId = "";
                                this.itProjects[projIndex].itProjectEstimates[j].assetAndMajorLoaded = true;
                                this.showDerivationError = true;
                            }
                        }
                    }
                    else if (isEstLevel) {
                        this.itProjects[projIndex].itProjectEstimates[estIndex].assetLocation = "";
                        this.itProjects[projIndex].itProjectEstimates[estIndex].assetLocationId = "";
                        this.itProjects[projIndex].itProjectEstimates[estIndex].majorLocation = "";
                        this.itProjects[projIndex].itProjectEstimates[estIndex].majorLocationId = "";
                        this.itProjects[projIndex].itProjectEstimates[estIndex].assetAndMajorLoaded = true;
                        this.showDerivationError = true;
                    }
                    else {
                        for (let i = 0; i < this.itProjects.length; i++) {
                            this.itProjects[i].assetLocation = "";
                            this.itProjects[i].assetLocationId = "";
                            this.itProjects[i].majorLocation = "";
                            this.itProjects[i].majorLocationId = "";
                            for (let j = 0; j < this.itProjects[i].itProjectEstimates.length; j++) {
                                if (this.itProjects[i].itProjectEstimates[j].assetLocationId === assetLocationID) {
                                    this.itProjects[i].itProjectEstimates[j].assetLocation = "";
                                    this.itProjects[i].itProjectEstimates[j].assetLocationId = "";
                                    this.itProjects[i].itProjectEstimates[j].majorLocation = "";
                                    this.itProjects[i].itProjectEstimates[j].majorLocationId = "";
                                    this.itProjects[i].itProjectEstimates[j].assetAndMajorLoaded = true;
                                    this.showDerivationError = true;
                                }
                                else {
                                    // recursive call to handle the estimate row that differs from parent Building
                                    this.getDescriptionAndMajorLocation(this.itProjects[i].itProjectEstimates[j].assetLocationId, false, false, i, false, true, j);
                                }
                            }
                        }
                    }
                }
                else {
                    // if we have not tried using a BU default yet
                    if (isAll) {
                        for (let i = 0; i < this.itProjects.length; i++) {
                            let matchFound = false;
                            for (let j = 0; j < this.buDefaults.length && !matchFound; j++) {
                                if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
                                    if (!this.buDefaults[j].BusinessUnit ||
                                        this.processedAllocations[Math.floor(i / 2)].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                        this.itProjects[i].assetLocationId = this.buDefaults[j].AssetLocationID;
                                        for (let k = 0; k < this.itProjects[i].itProjectEstimates.length; k++) {
                                            this.itProjects[i].itProjectEstimates[k].assetLocationId =
                                                this.buDefaults[j].AssetLocationID;
                                        }
                                        matchFound = true;
                                        this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, true, i, true);
                                    }
                                }
                                else {
                                    if (!this.buDefaults[j].BusinessUnit ||
                                        this.processedAllocations[i].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                        this.itProjects[i].assetLocationId = this.buDefaults[j].AssetLocationID;
                                        for (let k = 0; k < this.itProjects[i].itProjectEstimates.length; k++) {
                                            this.itProjects[i].itProjectEstimates[k].assetLocationId =
                                                this.buDefaults[j].AssetLocationID;
                                        }
                                        matchFound = true;
                                        this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, true, i, true);
                                    }
                                }
                            }
                        }
                    }
                    else if (isProjLevel) {
                        let matchFound = false;
                        for (let j = 0; j < this.buDefaults.length && !matchFound; j++) {
                            if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
                                if (!this.buDefaults[j].BusinessUnit ||
                                    this.processedAllocations[Math.floor(projIndex / 2)].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                    this.itProjects[projIndex].assetLocationId = this.buDefaults[j].AssetLocationID;
                                    for (let k = 0; k < this.itProjects[projIndex].itProjectEstimates.length; k++) {
                                        if (!projLevelSkipping ||
                                            (projLevelSkipping && assetLocationID === this.itProjects[projIndex].itProjectEstimates[k].assetLocationId)) {
                                            this.itProjects[projIndex].itProjectEstimates[k].assetLocationId =
                                                this.buDefaults[j].AssetLocationID;
                                        }
                                    }
                                    matchFound = true;
                                    this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, true, projIndex, true, false, -1, projLevelSkipping);
                                }
                            }
                            else {
                                if (!this.buDefaults[j].BusinessUnit ||
                                    this.processedAllocations[projIndex].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                    this.itProjects[projIndex].assetLocationId = this.buDefaults[j].AssetLocationID;
                                    for (let k = 0; k < this.itProjects[projIndex].itProjectEstimates.length; k++) {
                                        if (!projLevelSkipping ||
                                            (projLevelSkipping && assetLocationID === this.itProjects[projIndex].itProjectEstimates[k].assetLocationId)) {
                                            this.itProjects[projIndex].itProjectEstimates[k].assetLocationId =
                                                this.buDefaults[j].AssetLocationID;
                                        }
                                    }
                                    matchFound = true;
                                    this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, true, projIndex, true, false, -1, projLevelSkipping);
                                }
                            }
                        }
                    }
                    else if (isEstLevel) {
                        let matchFound = false;
                        for (let j = 0; j < this.buDefaults.length && !matchFound; j++) {
                            if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
                                if (!this.buDefaults[j].BusinessUnit ||
                                    this.processedAllocations[Math.floor(projIndex / 2)].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                    this.itProjects[projIndex].itProjectEstimates[estIndex].assetLocationId =
                                        this.buDefaults[j].AssetLocationID;
                                }
                                matchFound = true;
                                this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, false, projIndex, true, true, estIndex);
                            }
                            else {
                                if (!this.buDefaults[j].BusinessUnit ||
                                    this.processedAllocations[projIndex].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                    this.itProjects[projIndex].itProjectEstimates[estIndex].assetLocationId =
                                        this.buDefaults[j].AssetLocationID;
                                    matchFound = true;
                                    this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, false, projIndex, true, true, estIndex);
                                }
                            }
                        }
                    }
                    else {
                        for (let i = 0; i < this.itProjects.length; i++) {
                            let matchFound = false;
                            for (let j = 0; j < this.buDefaults.length && !matchFound; j++) {
                                if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
                                    if (!this.buDefaults[j].BusinessUnit ||
                                        this.processedAllocations[Math.floor(i / 2)].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                        this.itProjects[i].assetLocationId = this.buDefaults[j].AssetLocationID;
                                        for (let k = 0; k < this.itProjects[i].itProjectEstimates.length; k++) {
                                            if (this.itProjects[i].itProjectEstimates[k].assetLocationId === assetLocationID) {
                                                this.itProjects[i].itProjectEstimates[k].assetLocationId =
                                                    this.buDefaults[j].AssetLocationID;
                                            }
                                        }
                                        matchFound = true;
                                        this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, true, i, true);
                                    }
                                }
                                else {
                                    if (!this.buDefaults[j].BusinessUnit ||
                                        this.processedAllocations[i].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                        this.itProjects[i].assetLocationId = this.buDefaults[j].AssetLocationID;
                                        for (let k = 0; k < this.itProjects[i].itProjectEstimates.length; k++) {
                                            this.itProjects[i].itProjectEstimates[k].assetLocationId =
                                                this.buDefaults[j].AssetLocationID;
                                        }
                                        matchFound = true;
                                        this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, true, i, true);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Get Asset and Major Location Info Description Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Get Asset and Major Location Info Description Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    validateMajorLocation(projIndex, isDefault, differingEstimates, isEstLevel, estIndex) {
        let businessUnit = "";
        if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
            businessUnit = this.processedAllocations[Math.floor(projIndex / 2)].businessUnitValue;
        }
        else {
            businessUnit = this.processedAllocations[projIndex].businessUnitValue;
        }
        // call commented out for now while waiting on Redshift tables to be added.
        /*
        let callBody = {
          majLocId: this.itProjects[projIndex].majorLocationId,
          businessUnit: businessUnit
        };
        this.dataService
          .getAthenaData("check_major_location_valid", callBody)
          .subscribe(
            (result: any) => {
          },
          (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
              errorDescription = errorDescription.concat(
                "Check Major Location Valid Error - ",
                error.error.message
              );
            } else {
              errorDescription = errorDescription.concat(
                "Check Major Location Valid Error"
              );
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
              errorType: errorType,
              errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
              data: dataStructure,
              disableClose: true,
            });
        });*/
        if (isEstLevel) {
            // estimate level check
            let matchFound = false;
            for (let j = 0; j < this.companyMajorLocation.length && !matchFound; j++) {
                if (businessUnit.toString() === this.companyMajorLocation[j].COMPANY_ID.toString() &&
                    this.itProjects[projIndex].itProjectEstimates[estIndex].majorLocationId.toString() === this.companyMajorLocation[j].MAJOR_LOCATION_ID.toString()) {
                    matchFound = true;
                }
            }
            if (matchFound) {
                this.itProjects[projIndex].itProjectEstimates[estIndex].assetAndMajorLoaded = true;
            }
            else {
                if (isDefault) {
                    this.itProjects[projIndex].itProjectEstimates[estIndex].assetLocation = "";
                    this.itProjects[projIndex].itProjectEstimates[estIndex].assetLocationId = "";
                    this.itProjects[projIndex].itProjectEstimates[estIndex].majorLocation = "";
                    this.itProjects[projIndex].itProjectEstimates[estIndex].majorLocationId = "";
                    this.itProjects[projIndex].itProjectEstimates[estIndex].assetAndMajorLoaded = true;
                    this.showDerivationError = true;
                }
                else {
                    let matchFound = false;
                    for (let j = 0; j < this.buDefaults.length && !matchFound; j++) {
                        if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
                            if (!this.buDefaults[j].BusinessUnit ||
                                this.processedAllocations[Math.floor(projIndex / 2)].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                this.itProjects[projIndex].itProjectEstimates[estIndex].assetLocationId =
                                    this.buDefaults[j].AssetLocationID;
                                matchFound = true;
                                this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, false, projIndex, true, true, estIndex);
                            }
                        }
                        else {
                            if (!this.buDefaults[j].BusinessUnit ||
                                this.processedAllocations[projIndex].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                this.itProjects[projIndex].itProjectEstimates[estIndex].assetLocationId =
                                    this.buDefaults[j].AssetLocationID;
                                matchFound = true;
                                this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, false, projIndex, true, true, estIndex);
                            }
                        }
                    }
                }
            }
        }
        else {
            let matchFound = false;
            for (let j = 0; j < this.companyMajorLocation.length && !matchFound; j++) {
                if (businessUnit.toString() === this.companyMajorLocation[j].COMPANY_ID.toString() &&
                    this.itProjects[projIndex].majorLocationId.toString() === this.companyMajorLocation[j].MAJOR_LOCATION_ID.toString()) {
                    matchFound = true;
                }
            }
            if (matchFound) {
                for (let j = 0; j < this.itProjects[projIndex].itProjectEstimates.length; j++) {
                    if (!differingEstimates ||
                        (differingEstimates && this.itProjects[projIndex].assetLocationId === this.itProjects[projIndex].itProjectEstimates[j].assetLocationId)) {
                        this.itProjects[projIndex].itProjectEstimates[j].assetAndMajorLoaded = true;
                    }
                }
            }
            else {
                let previousAssetLocationID = this.itProjects[projIndex].assetLocationId;
                if (isDefault) {
                    this.itProjects[projIndex].assetLocation = "";
                    this.itProjects[projIndex].assetLocationId = "";
                    this.itProjects[projIndex].majorLocation = "";
                    this.itProjects[projIndex].majorLocationId = "";
                    for (let j = 0; j < this.itProjects[projIndex].itProjectEstimates.length; j++) {
                        if (!differingEstimates ||
                            (differingEstimates && previousAssetLocationID === this.itProjects[projIndex].itProjectEstimates[j].assetLocationId)) {
                            this.itProjects[projIndex].itProjectEstimates[j].assetLocation = "";
                            this.itProjects[projIndex].itProjectEstimates[j].assetLocationId = "";
                            this.itProjects[projIndex].itProjectEstimates[j].majorLocation = "";
                            this.itProjects[projIndex].itProjectEstimates[j].majorLocationId = "";
                            this.itProjects[projIndex].itProjectEstimates[j].assetAndMajorLoaded = true;
                            this.showDerivationError = true;
                        }
                    }
                }
                else {
                    let matchFound = false;
                    for (let j = 0; j < this.buDefaults.length && !matchFound; j++) {
                        if (this.hardwareOrSoftwareCopy === "Hardware and Software") {
                            if (!this.buDefaults[j].BusinessUnit ||
                                this.processedAllocations[Math.floor(projIndex / 2)].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                this.itProjects[projIndex].assetLocationId = this.buDefaults[j].AssetLocationID;
                                for (let k = 0; k < this.itProjects[projIndex].itProjectEstimates.length; k++) {
                                    if (!differingEstimates ||
                                        (differingEstimates && previousAssetLocationID === this.itProjects[projIndex].itProjectEstimates[k].assetLocationId)) {
                                        this.itProjects[projIndex].itProjectEstimates[k].assetLocationId =
                                            this.buDefaults[j].AssetLocationID;
                                    }
                                }
                                matchFound = true;
                                this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, true, projIndex, true, false, -1, differingEstimates);
                            }
                        }
                        else {
                            if (!this.buDefaults[j].BusinessUnit ||
                                this.processedAllocations[projIndex].businessUnitValue === this.buDefaults[j].BusinessUnit) {
                                this.itProjects[projIndex].assetLocationId = this.buDefaults[j].AssetLocationID;
                                for (let k = 0; k < this.itProjects[projIndex].itProjectEstimates.length; k++) {
                                    if (!differingEstimates ||
                                        (differingEstimates && previousAssetLocationID === this.itProjects[projIndex].itProjectEstimates[k].assetLocationId)) {
                                        this.itProjects[projIndex].itProjectEstimates[k].assetLocationId =
                                            this.buDefaults[j].AssetLocationID;
                                    }
                                }
                                matchFound = true;
                                this.getDescriptionAndMajorLocation(this.buDefaults[j].AssetLocationID, false, true, projIndex, true, false, -1, differingEstimates);
                            }
                        }
                    }
                }
            }
        }
    }
    generateUtilityAccountRetirementUnit(i) {
        for (let j = 0; j < this.itProjects[i].itProjectEstimates.length; j++) {
            let matchFound = false;
            for (let k = 0; k < this.utilityRetirementDerivation.length && !matchFound; k++) {
                if (this.itProjects[i].function === this.utilityRetirementDerivation[k].function) {
                    for (let l = 0; l < this.utilityRetirementDerivation[k].uopDerivations.length &&
                        !matchFound; l++) {
                        if (this.itProjects[i].itProjectEstimates[j].uopDescription ===
                            this.utilityRetirementDerivation[k].uopDerivations[l]
                                .uopDescription) {
                            if (this.utilityRetirementDerivation[k].uopDerivations[l]
                                .lifeOfSoftware) {
                                if ((this.utilityRetirementDerivation[k].uopDerivations[l]
                                    .lifeOfSoftware === "<= 3" &&
                                    this.expectedLife <= 3) ||
                                    (this.utilityRetirementDerivation[k].uopDerivations[l]
                                        .lifeOfSoftware === "> 3" &&
                                        this.expectedLife > 3)) {
                                    this.itProjects[i].itProjectEstimates[j].retirementUnitId =
                                        this.utilityRetirementDerivation[k].uopDerivations[l].retirementUnitId;
                                    this.itProjects[i].itProjectEstimates[j].utilityAccountId =
                                        this.utilityRetirementDerivation[k].uopDerivations[l].utilityAccountId;
                                    this.getUtilityAccountDescription(i, j);
                                    this.getRetirementAccountDescription(i, j);
                                    matchFound = true;
                                }
                            }
                            else {
                                this.itProjects[i].itProjectEstimates[j].retirementUnitId =
                                    this.utilityRetirementDerivation[k].uopDerivations[l].retirementUnitId;
                                this.itProjects[i].itProjectEstimates[j].utilityAccountId =
                                    this.utilityRetirementDerivation[k].uopDerivations[l].utilityAccountId;
                                this.getUtilityAccountDescription(i, j);
                                this.getRetirementAccountDescription(i, j);
                                matchFound = true;
                            }
                        }
                    }
                }
            }
        }
    }
    estimateWithOM(itProject) {
        for (let i = 0; i < itProject.itProjectEstimates.length; i++) {
            if (itProject.itProjectEstimates[i].estimateType.includes("O&M")) {
                return true;
            }
        }
        return false;
    }
    estimateWithCapital(itProject) {
        for (let i = 0; i < itProject.itProjectEstimates.length; i++) {
            if (itProject.itProjectEstimates[i].estimateType.includes("CAP")) {
                return true;
            }
        }
        return false;
    }
    estimateWithRemoval(itProject) {
        for (let i = 0; i < itProject.itProjectEstimates.length; i++) {
            if (itProject.itProjectEstimates[i].estimateType.includes("Removal")) {
                return true;
            }
        }
        return false;
    }
    getBUType(businessUnit) {
        for (let i = 0; i < this.buTypeDerivation.length; i++) {
            for (let j = 0; j < this.buTypeDerivation[i].businessUnit.length; j++) {
                if (this.buTypeDerivation[i].businessUnit[j] === businessUnit ||
                    businessUnit.startsWith(this.buTypeDerivation[i].businessUnit[j].split("*")[0])) {
                    return this.buTypeDerivation[i].buType;
                }
            }
        }
        return "";
    }
    getUtilityAccountDescription(i, j) {
        let callBody = {
            utilAcctId: this.itProjects[i].itProjectEstimates[j].utilityAccountId,
        };
        this.dataService
            .getAthenaData("it_spar_utilacctid_to_desc", callBody)
            .subscribe((result) => {
            let descriptions = JSON.parse(result);
            if (descriptions.length > 0) {
                this.itProjects[i].itProjectEstimates[j].utilityAccountDescription =
                    descriptions[0].description;
            }
            else {
                this.itProjects[i].itProjectEstimates[j].utilityAccountDescription =
                    "";
            }
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Get Utility Account Description Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Get Utility Account Description Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    getRetirementAccountDescription(i, j) {
        let callBody = {
            retUnitId: this.itProjects[i].itProjectEstimates[j].retirementUnitId,
        };
        this.dataService
            .getAthenaData("it_spar_retunitid_to_desc", callBody)
            .subscribe((result) => {
            let descriptions = JSON.parse(result);
            if (descriptions.length > 0) {
                this.itProjects[i].itProjectEstimates[j].retirementUnitDescription =
                    descriptions[0].description;
            }
            else {
                this.itProjects[i].itProjectEstimates[j].retirementUnitDescription =
                    "";
            }
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Get Retirement Unit Description Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Get Retirement Unit Description Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadBUTypeDerivation() {
        this.http.get("assets/bu-type-derivation.json").subscribe((result) => {
            this.buTypeDerivation = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load BU Type Derivation Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load BU Type Derivation Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadOtherSpecialBuildings() {
        this.http.get("assets/other-special-buildings.json").subscribe((result) => {
            this.otherSpecialBuildings = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Other Special Buildings Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Other Special Buildings Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadBUDefaults() {
        this.http.get("assets/bu-defaults.json").subscribe((result) => {
            this.buDefaults = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load BU Defaults Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load BU Defaults Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadCompanyMajorLocation() {
        this.http.get("assets/company-major-location.json").subscribe((result) => {
            this.companyMajorLocation = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load BU Defaults Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load BU Defaults Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadUtilityRetirementDerivation() {
        this.http.get("assets/utility-retirement-derivation.json").subscribe((result) => {
            this.utilityRetirementDerivation = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Utility Retirement Derivation Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Utility Retirement Derivation Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadActivityDerivation() {
        this.http.get("assets/activity-derivation.json").subscribe((result) => {
            this.activityDerivation = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Activity Derivation Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Activity Derivation Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadAccountingModelDerivation() {
        this.http.get("assets/accounting-model-derivation.json").subscribe((result) => {
            this.accountingModelDerivation = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Accounting Model Derivation Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Accounting Model Derivation Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadProjectClassDerivations() {
        this.http.get("assets/business-unit-project-class.json").subscribe((result) => {
            this.projectClassDerivations = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Project Class Derivations Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Project Class Derivations Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadProjectTypeDerivations() {
        this.http.get("assets/business-unit-project-type.json").subscribe((result) => {
            this.projectTypeDerivations = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Project Type Derivations Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Project Type Derivations Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadOUAssetLocMajorLoc() {
        this.http.get("assets/ou-asset-loc-major-loc.json").subscribe((result) => {
            this.ouAssetLocMajorLoc = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load OU Asset Loc Major Loc Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load OU Asset Loc Major Loc Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadITPopAssetLocMajorLoc() {
        this.http.get("assets/it-pop-asset-loc-major-loc.json").subscribe((result) => {
            this.itPopAssetLocMajorLoc = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load IT POP Asset Loc Major Loc Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load IT POP Asset Loc Major Loc Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    loadNuclearAbbreviations() {
        this.http.get("assets/nuclear-abbreviations.json").subscribe((result) => {
            this.nuclearAbbreviations = result;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Load Nuclear Abbreviations Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Load Nuclear Abbreviations Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    getProjectNotes() {
        if (this.primaryContact &&
            this.primaryContact.givenName &&
            this.primaryContact.surname) {
            return `PM: ${this.primaryContact.givenName} ${this.primaryContact.surname}`;
        }
        else if (this.primaryContact &&
            !(this.primaryContact.givenName && this.primaryContact.surname)) {
            return `PM: ${this.primaryContact.displayName}`;
        }
        else {
            return "Primary Contact Not Found";
        }
    }
    groupEstimatesByAssetLocation(estimates) {
        const groupedObject = estimates.reduce((groups, estimate) => {
            const assetLocation = estimate.assetLocation;
            const majorLocation = estimate.majorLocation;
            const groupKey = `${assetLocation}-${majorLocation}`;
            if (!groups[groupKey]) {
                groups[groupKey] = {
                    majorLocation,
                    assetLocation,
                    locationCost: 0,
                    values: [],
                };
            }
            // Add the estimate to the group
            groups[groupKey].values.push(estimate);
            // Increment the locationCost by the dollarAmount of the current estimate
            groups[groupKey].locationCost += estimate.dollarAmount || 0;
            return groups;
        }, {});
        return Object.values(groupedObject);
    }
    calculateTotalProjectCost(itProjects) {
        if (!itProjects || !itProjects.itProjectEstimates) {
            return 0; // Return 0 if the project or estimates are undefined
        }
        return itProjects.itProjectEstimates.reduce((total, estimate) => {
            return total + (estimate.dollarAmount || 0); // Add dollarAmount, default to 0 if undefined
        }, 0);
    }
    getGrandTotalCost() {
        if (!this.itProjects || this.itProjects.length === 0) {
            return 0; // Return 0 if there are no projects
        }
        return this.itProjects.reduce((total, project) => {
            return total + (project.totalProjectCost || 0); // Add totalProjectCost, default to 0 if undefined
        }, 0);
    }
    createProjectSubmissionBody(itProject, index) {
        let doc = document.implementation.createDocument("", "", null);
        const pi = doc.createProcessingInstruction("xml", 'version="1.0" encoding="UTF-8"');
        doc.insertBefore(pi, doc.firstChild);
        let elem1 = doc.createElement("soapenv:Envelope");
        elem1.setAttribute("xmlns:soapenv", "http://schemas.xmlsoap.org/soap/envelope/");
        let elem2 = doc.createElement("soapenv:Header");
        let elem3 = doc.createElement("wsse:Security");
        elem3.setAttribute("soapenv:mustUnderstand", "111");
        elem3.setAttribute("xmlns:wsse", "http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd");
        elem3.setAttribute("xmlns:wsu", "http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd");
        let elem4 = doc.createElement("wsse:UsernameToken");
        elem4.setAttribute("wsu:Id", "UsernameToken-459");
        let elem5 = doc.createElement("wsse:Username");
        // this needs to be parameterized.
        elem5.innerHTML = this.encodeToXML(this.webMethodUserName);
        let elem6 = doc.createElement("wsse:Password");
        elem6.setAttribute("Type", "http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-username-token-profile-1.0#PasswordText");
        // this needs to be parameterized.
        elem6.innerHTML = this.encodeToXML(this.webMethodPass);
        elem4.appendChild(elem5);
        elem4.appendChild(elem6);
        elem3.appendChild(elem4);
        elem2.appendChild(elem3);
        let elem7 = doc.createElement("soapenv:Body");
        let elem8 = doc.createElement("ns4:createAndChange_Project");
        elem8.setAttribute("xmlns:ns2", "urn:duk:objects:xmlschema:FIN:Project:version1.0.02Out");
        elem8.setAttribute("xmlns:ns3", "urn:duk:objects:xmlschema:FIN:Project:version1.0.02");
        elem8.setAttribute("xmlns:ns4", "urn:duk:objects:xmlschema:FIN:Project:version1.0.02In");
        elem8.setAttribute("xmlns:ns5", "urn:duk:objects:xmlschema:INF:FaultReturn:version1.02");
        let elem9 = doc.createElement("MessageHeader");
        let elem10 = doc.createElement("identifier");
        elem10.innerHTML = this.encodeToXML("MMAPS_PPFC6EC80FCD9FCA1D.0");
        let elem11 = doc.createElement("referenceID");
        elem11.innerHTML = this.encodeToXML("PLUSDESTVERSION_PLUSDESTVERSION :  Estimate Request=5581201 Estimate Version=4 Organization=DUKE");
        let elem12 = doc.createElement("source");
        elem12.innerHTML = "MMAPS";
        let elem13 = doc.createElement("target");
        elem13.innerHTML = "POWERPLAN";
        elem9.appendChild(elem10);
        elem9.appendChild(elem11);
        elem9.appendChild(elem12);
        elem9.appendChild(elem13);
        let elem14 = doc.createElement("Project");
        let elem15 = doc.createElement("description");
        // Project Name
        if (this.displayRevisionNumber > 0 && !this.projectNameChanged()) {
            elem15.innerHTML = this.encodeToXML(this.currentProjectData[index][0].project_name);
        }
        else {
            elem15.innerHTML = this.encodeToXML(this.projectName);
        }
        let elem16 = doc.createElement("type");
        // Project Type
        if (this.displayRevisionNumber > 0 && !this.projectTypeChanged()) {
            elem16.innerHTML = this.encodeToXML(this.currentProjectData[index][0].work_order_type);
        }
        else {
            elem16.innerHTML = this.encodeToXML(itProject.projectType);
        }
        let elem17 = doc.createElement("localID");
        // Project ID
        elem17.innerHTML = this.encodeToXML(itProject.projectID);
        let elem18 = doc.createElement("costEstimate");
        let elem19 = doc.createElement("currencyUnit");
        elem19.innerHTML = "USD";
        let elem20 = doc.createElement("decimalValue");
        // Cost Estimate
        elem20.innerHTML = "0";
        elem18.appendChild(elem19);
        elem18.appendChild(elem20);
        let elem21 = doc.createElement("extendedDescription");
        // Overview and Scope
        if (this.displayRevisionNumber > 0 &&
            !this.projectScopeDescriptionChanged()) {
            elem21.innerHTML = this.encodeToXML(this.currentProjectData[index][0].project_scope);
        }
        else {
            elem21.innerHTML = this.encodeToXML(this.projectScopeDescription);
        }
        let elem22 = doc.createElement("fundingProject");
        // Funding Project ID
        if (this.displayRevisionNumber > 0) {
            elem22.innerHTML = this.encodeToXML(this.currentProjectData[index][0].funding_project);
        }
        else {
            elem22.innerHTML = this.encodeToXML(itProject.fundingProjectID);
        }
        let elem23 = doc.createElement("Dates");
        let elem24 = doc.createElement("date");
        let correctedDate = new Date();
        let dateOffset = 24 * 60 * 60 * 1000;
        // Estimated Start Date
        correctedDate.setTime(this.estimatedStartDate.getTime() - dateOffset);
        if (this.displayRevisionNumber > 0 && !this.estimatedStartDateChanged()) {
            elem24.innerHTML = this.encodeToXML(this.currentProjectData[index][0].est_start_date);
        }
        else {
            elem24.innerHTML = this.encodeToXML(correctedDate.toISOString().slice(0, 10));
        }
        let elem25 = doc.createElement("category");
        elem25.innerHTML = "EstimatedStartDate";
        elem23.appendChild(elem24);
        elem23.appendChild(elem25);
        let elem26 = doc.createElement("Dates");
        let elem27 = doc.createElement("date");
        // Estimated Completion Date calculation
        let dateCopy = new Date(this.estimatedInServiceDate.getTime());
        let originalDate = dateCopy.getDate();
        let completeDate;
        if (itProject.lateWaitPeriod == 0 || !itProject.lateWaitPeriod) {
            completeDate = new Date(dateCopy.setMonth(dateCopy.getMonth() + 3));
        }
        else {
            completeDate = new Date(dateCopy.setMonth(dateCopy.getMonth() + itProject.lateWaitPeriod));
        }
        if ((originalDate === 31 || originalDate === 30) &&
            completeDate.getDate() === 1) {
            while (completeDate.getDate() < 28) {
                completeDate.setTime(completeDate.getTime() - dateOffset);
            }
        }
        // Estimated Completion Date
        correctedDate.setTime(completeDate.getTime() - dateOffset);
        if (this.displayRevisionNumber > 0 &&
            !this.estimatedStartDateChanged() &&
            !this.estimatedInServiceDateChanged()) {
            elem27.innerHTML = this.encodeToXML(this.currentProjectData[index][0].est_complete_date);
        }
        else {
            elem27.innerHTML = this.encodeToXML(correctedDate.toISOString().slice(0, 10));
        }
        let elem28 = doc.createElement("category");
        elem28.innerHTML = "EstimatedCompletionDate";
        elem26.appendChild(elem27);
        elem26.appendChild(elem28);
        let elem29 = doc.createElement("Dates");
        let elem30 = doc.createElement("date");
        // Estimated In Service Date
        correctedDate.setTime(this.estimatedInServiceDate.getTime() - dateOffset);
        if (this.displayRevisionNumber > 0 &&
            !this.estimatedInServiceDateChanged()) {
            elem30.innerHTML = this.encodeToXML(this.currentProjectData[index][0].est_in_service_date);
        }
        else {
            elem30.innerHTML = this.encodeToXML(correctedDate.toISOString().slice(0, 10));
        }
        let elem31 = doc.createElement("category");
        elem31.innerHTML = "EstimatedInServiceDate";
        elem29.appendChild(elem30);
        elem29.appendChild(elem31);
        let elem32 = doc.createElement("Location");
        let elem33 = doc.createElement("localID");
        // Major Location (using description for now)
        if (this.displayRevisionNumber > 0 &&
            !this.assetAndMajorLocationChanged()) {
            elem33.innerHTML = this.encodeToXML(this.currentProjectData[index][0].major_location);
        }
        else {
            elem33.innerHTML = this.encodeToXML(itProject.majorLocationId);
        }
        elem32.appendChild(elem33);
        let activityElems = [];
        // Activities
        if (this.displayRevisionNumber > 0 && !this.activitiesChanged()) {
            for (let i = 0; i < this.currentActivityData[index].length; i++) {
                let actElem1 = doc.createElement("WorkTasks");
                let actElem2 = doc.createElement("localID");
                // Activity ID
                actElem2.innerHTML = this.encodeToXML(this.currentActivityData[index][i].activity_id);
                let actElem3 = doc.createElement("description");
                // Activity Description
                actElem3.innerHTML = this.encodeToXML(this.currentActivityData[index][i].description);
                let actElem4 = doc.createElement("extendedDescription");
                // Activity Process (slot 1 of 2)
                actElem4.innerHTML = this.encodeToXML(this.currentActivityData[index][i].description);
                let actElem5 = doc.createElement("ErpProjectAccounting");
                let actElem6 = doc.createElement("CodeBlock");
                let actElem7 = doc.createElement("businessUnit");
                let actElem8 = doc.createElement("process");
                // Accounting Model
                let actElem6a = doc.createElement("accountingModel");
                actElem6a.innerHTML = this.encodeToXML(this.currentActivityData[index][i].accounting_model);
                // Activity Process (slot 2 of 2)
                actElem8.innerHTML = " ";
                actElem6.appendChild(actElem7);
                actElem6.appendChild(actElem8);
                actElem6.appendChild(actElem6a);
                actElem5.appendChild(actElem6);
                actElem1.appendChild(actElem2);
                actElem1.appendChild(actElem3);
                actElem1.appendChild(actElem4);
                actElem1.appendChild(actElem5);
                activityElems.push(actElem1);
            }
        }
        else {
            for (let i = 0; i < itProject.activities.length; i++) {
                if (itProject.activities[i].accountingModel) {
                    let actElem1 = doc.createElement("WorkTasks");
                    let actElem2 = doc.createElement("localID");
                    // Activity ID
                    actElem2.innerHTML = this.encodeToXML(itProject.activities[i].activity);
                    let actElem3 = doc.createElement("description");
                    // Activity Description
                    actElem3.innerHTML = this.encodeToXML(itProject.activities[i].activityDescription);
                    let actElem4 = doc.createElement("extendedDescription");
                    // Activity Process (slot 1 of 2)
                    actElem4.innerHTML = this.encodeToXML(itProject.activities[i].activityDescription);
                    let actElem5 = doc.createElement("ErpProjectAccounting");
                    let actElem6 = doc.createElement("CodeBlock");
                    let actElem7 = doc.createElement("businessUnit");
                    let actElem8 = doc.createElement("process");
                    // Accounting Model
                    let actElem6a = doc.createElement("accountingModel");
                    actElem6a.innerHTML = this.encodeToXML(itProject.activities[i].accountingModel);
                    // Activity Process (slot 2 of 2)
                    actElem8.innerHTML = " ";
                    actElem6.appendChild(actElem7);
                    actElem6.appendChild(actElem8);
                    actElem6.appendChild(actElem6a);
                    actElem5.appendChild(actElem6);
                    actElem1.appendChild(actElem2);
                    actElem1.appendChild(actElem3);
                    actElem1.appendChild(actElem4);
                    actElem1.appendChild(actElem5);
                    activityElems.push(actElem1);
                }
            }
        }
        // Project Manager (PAC approver)
        let elem34 = doc.createElement("Persons");
        let elem35 = doc.createElement("Credentials");
        let elem36 = doc.createElement("userID");
        //FLDT-1384 Replace PacAssignment with Project Manager from Derivation and Allocations
        //elem36.innerHTML = this.encodeToXML(this.etsPacAssignmentLan.toLowerCase());
        elem36.innerHTML = this.encodeToXML(this.projectManagerLanId.toLowerCase());
        //End FLDT-1384 Changes
        elem35.appendChild(elem36);
        let elem37 = doc.createElement("PersonRole");
        let elem38 = doc.createElement("name");
        elem38.innerHTML = "ProjectManager";
        // Contract Admin (2nd after PAC approver in PAC group)
        elem37.appendChild(elem38);
        elem34.appendChild(elem35);
        elem34.appendChild(elem37);
        let elem39 = doc.createElement("Persons");
        let elem40 = doc.createElement("Credentials");
        let elem41 = doc.createElement("userID");
        //FLDT-1384 Replace secondPacUserLan with Contract Admin from Derivation and Allocations
        //elem41.innerHTML = this.encodeToXML(this.secondPacUserLan.toLowerCase());
        elem41.innerHTML = this.encodeToXML(this.contractAdminLanId.toLowerCase());
        //End FLDT-1384 Changes
        elem40.appendChild(elem41);
        let elem42 = doc.createElement("PersonRole");
        let elem43 = doc.createElement("name");
        elem43.innerHTML = "ContractAdministrator";
        // Project Initiator (PAC approver)
        elem42.appendChild(elem43);
        elem39.appendChild(elem40);
        elem39.appendChild(elem42);
        let elem44 = doc.createElement("Persons");
        let elem45 = doc.createElement("Credentials");
        let elem45a = doc.createElement("userID");
        elem45a.innerHTML = this.encodeToXML(this.etsPacAssignmentLan.toLowerCase());
        elem45.appendChild(elem45a);
        let elem45b = doc.createElement("PersonRole");
        let elem45c = doc.createElement("name");
        elem45c.innerHTML = "ProjectInitiator";
        elem45b.appendChild(elem45c);
        elem44.appendChild(elem45);
        elem44.appendChild(elem45b);
        // Project Engineer (1st after PAC approver)
        let elem46a = doc.createElement("Persons");
        let elem46b = doc.createElement("Credentials");
        let elem46c = doc.createElement("userID");
        //FLDT-1384 Replace firstPacUserLan with Engineer from Derivation and Allocations
        //elem46c.innerHTML = this.encodeToXML(this.firstPacUserLan.toLowerCase());
        elem46c.innerHTML = this.encodeToXML(this.engineerLanId.toLowerCase());
        elem46b.appendChild(elem46c);
        let elem46d = doc.createElement("PersonRole");
        let elem46e = doc.createElement("name");
        elem46e.innerHTML = "ProjectEngineer";
        let elem46 = doc.createElement("remarks");
        elem46d.appendChild(elem46e);
        elem46a.appendChild(elem46b);
        elem46a.appendChild(elem46d);
        // Problem Statement (leave blank)
        elem46.innerHTML = "";
        let elem47 = doc.createElement("comment");
        // Notes (PM: Project Manager) using Primary Contact entered on form
        /*elem47.innerHTML = this.encodeToXML(
          "PM: " +
            this.etsPacAssignment.givenName +
            " " +
            this.etsPacAssignment.surname
        );*/
        //FLDT-1384 Replace Project Manager Name with Primary Contact Name
        elem47.innerHTML = this.encodeToXML("PM: " +
            (this.primaryContact && this.primaryContact.givenName ? this.primaryContact.givenName : "") +
            " " +
            (this.primaryContact && this.primaryContact.surname ? this.primaryContact.surname : ""));
        let elem48 = doc.createElement("reason");
        // Proposed Objective (leave blank)
        elem48.innerHTML = "";
        let elem49 = doc.createElement("Codes");
        let elem50 = doc.createElement("code");
        // Project Charge Indicator
        if (this.displayRevisionNumber > 0 &&
            !this.projectChargeIndicatorChanged()) {
            elem50.innerHTML = this.encodeToXML(this.currentProjectData[index][0].project_chg_indicator);
        }
        else {
            elem50.innerHTML = this.encodeToXML(itProject.projectChargeIndicator);
        }
        let elem51 = doc.createElement("category");
        elem51.innerHTML = "ProjectChargeCode";
        elem49.appendChild(elem50);
        elem49.appendChild(elem51);
        let elem52 = doc.createElement("Assets");
        let elem53 = doc.createElement("isReplacement");
        elem53.innerHTML = "false";
        let elem54 = doc.createElement("Location");
        let elem55 = doc.createElement("localID");
        // Asset Location (using description for now)
        if (this.displayRevisionNumber > 0 &&
            !this.assetAndMajorLocationChanged()) {
            elem33.innerHTML = this.encodeToXML(this.currentProjectData[index][0].asset_location);
        }
        else {
            elem55.innerHTML = this.encodeToXML(itProject.assetLocationId.toString());
        }
        elem54.appendChild(elem55);
        elem52.appendChild(elem53);
        elem52.appendChild(elem54);
        let elem56 = doc.createElement("ErpProjectAccounting");
        let elem57 = doc.createElement("CodeBlock");
        let elem58 = doc.createElement("businessUnit");
        // Business Unit
        elem58.innerHTML = this.encodeToXML(itProject.businessUnit);
        let elem59 = doc.createElement("responsibilityCenter");
        // Resp Center (hardcoded to 7800)
        elem59.innerHTML = "7800";
        let elem60 = doc.createElement("operatingUnit");
        // Operating Unit
        elem60.innerHTML = this.encodeToXML(itProject.operatingUnit);
        let elem61 = doc.createElement("process");
        elem61.innerHTML = " ";
        elem57.appendChild(elem58);
        elem57.appendChild(elem59);
        elem57.appendChild(elem60);
        elem57.appendChild(elem61);
        elem56.appendChild(elem57);
        let elem62 = doc.createElement("Transaction");
        let elem63 = doc.createElement("type");
        // using LOAD_ALL since we are loading both project and estimates.
        elem63.innerHTML = "LOAD_ALL";
        elem62.appendChild(elem63);
        let estimateEntries = [];
        if (this.displayRevisionNumber > 0 && !this.estimatesChanged()) {
            for (let i = 0; i < this.currentWorkOrderData[index].length; i++) {
                let estimateElem1 = doc.createElement("Estimates");
                // may need to split by project -- for now sending the same value over and over.
                let estimateElem2 = doc.createElement("quantity");
                estimateElem2.innerHTML = this.encodeToXML(this.currentWorkOrderData[index][i].quantity);
                let estimateElem3 = doc.createElement("category");
                estimateElem3.innerHTML = "DESIGN";
                let estimateElem4;
                estimateElem4 = doc.createElement("MeasurementType");
                let estimateElem5 = doc.createElement("name");
                estimateElem5.innerHTML = "EA";
                estimateElem4.appendChild(estimateElem5);
                let estimateElem6 = doc.createElement("Work");
                let estimateElem6a = doc.createElement("localID");
                // Project ID
                estimateElem6a.innerHTML = this.encodeToXML(itProject.projectID);
                let estimateElem7 = doc.createElement("WorkCostDetail");
                let estimateElem8 = doc.createElement("amount");
                let estimateElem9 = doc.createElement("currencyUnit");
                estimateElem9.innerHTML = "USD";
                let estimateElem10 = doc.createElement("multiplier");
                estimateElem10.innerHTML = "none";
                let estimateElem11 = doc.createElement("decimalValue");
                // Materials Amount
                if (this.currentWorkOrderData[index][i].chg_type === "Material") {
                    estimateElem11.innerHTML = this.encodeToXML(this.currentWorkOrderData[index][i].amount);
                }
                else {
                    estimateElem11.innerHTML = "0.00";
                }
                estimateElem8.appendChild(estimateElem9);
                estimateElem8.appendChild(estimateElem10);
                estimateElem8.appendChild(estimateElem11);
                let estimateElem12 = doc.createElement("typeWorkCost");
                estimateElem12.innerHTML = "InternalMaterialsAmount";
                estimateElem7.appendChild(estimateElem8);
                estimateElem7.appendChild(estimateElem12);
                let estimateElem13 = doc.createElement("WorkCostDetail");
                let estimateElem14 = doc.createElement("amount");
                let estimateElem15 = doc.createElement("currencyUnit");
                estimateElem15.innerHTML = "USD";
                let estimateElem16 = doc.createElement("multiplier");
                estimateElem16.innerHTML = "none";
                let estimateElem17 = doc.createElement("decimalValue");
                // Internal Labor
                if (this.currentWorkOrderData[index][i].chg_type === "Labor") {
                    estimateElem17.innerHTML = this.encodeToXML(this.currentWorkOrderData[index][i].amount);
                }
                else {
                    estimateElem17.innerHTML = "0.00";
                }
                estimateElem14.appendChild(estimateElem15);
                estimateElem14.appendChild(estimateElem16);
                estimateElem14.appendChild(estimateElem17);
                let estimateElem18 = doc.createElement("typeWorkCost");
                estimateElem18.innerHTML = "InternalLaborAmount";
                estimateElem13.appendChild(estimateElem14);
                estimateElem13.appendChild(estimateElem18);
                let estimateElem19 = doc.createElement("WorkCostDetail");
                let estimateElem20 = doc.createElement("amount");
                let estimateElem21 = doc.createElement("currencyUnit");
                estimateElem21.innerHTML = "USD";
                let estimateElem22 = doc.createElement("multiplier");
                estimateElem22.innerHTML = "none";
                let estimateElem23 = doc.createElement("decimalValue");
                estimateElem23.innerHTML = "0.00";
                estimateElem20.appendChild(estimateElem21);
                estimateElem20.appendChild(estimateElem22);
                estimateElem20.appendChild(estimateElem23);
                let estimateElem24 = doc.createElement("typeWorkCost");
                estimateElem24.innerHTML = "InternalToolsAmount";
                estimateElem19.appendChild(estimateElem20);
                estimateElem19.appendChild(estimateElem24);
                let estimateElem25 = doc.createElement("WorkCostDetail");
                let estimateElem26 = doc.createElement("amount");
                let estimateElem27 = doc.createElement("currencyUnit");
                estimateElem27.innerHTML = "USD";
                let estimateElem28 = doc.createElement("multiplier");
                estimateElem28.innerHTML = "none";
                let estimateElem29 = doc.createElement("decimalValue");
                estimateElem29.innerHTML = "0.00";
                estimateElem26.appendChild(estimateElem27);
                estimateElem26.appendChild(estimateElem28);
                estimateElem26.appendChild(estimateElem29);
                let estimateElem30 = doc.createElement("typeWorkCost");
                estimateElem30.innerHTML = "ExternalToolsAmount";
                estimateElem25.appendChild(estimateElem26);
                estimateElem25.appendChild(estimateElem30);
                let estimateElem31 = doc.createElement("WorkCostDetail");
                let estimateElem32 = doc.createElement("amount");
                let estimateElem33 = doc.createElement("currencyUnit");
                estimateElem33.innerHTML = "USD";
                let estimateElem34 = doc.createElement("multiplier");
                estimateElem34.innerHTML = "none";
                let estimateElem35 = doc.createElement("decimalValue");
                estimateElem35.innerHTML = "0.00";
                estimateElem32.appendChild(estimateElem33);
                estimateElem32.appendChild(estimateElem34);
                estimateElem32.appendChild(estimateElem35);
                let estimateElem36 = doc.createElement("typeWorkCost");
                estimateElem36.innerHTML = "ServiceAmount";
                estimateElem31.appendChild(estimateElem32);
                estimateElem31.appendChild(estimateElem36);
                let estimateElem37 = doc.createElement("WorkCostDetail");
                let estimateElem38 = doc.createElement("amount");
                let estimateElem39 = doc.createElement("currencyUnit");
                estimateElem39.innerHTML = "USD";
                let estimateElem40 = doc.createElement("multiplier");
                estimateElem40.innerHTML = "none";
                let estimateElem41 = doc.createElement("decimalValue");
                estimateElem41.innerHTML = "0.00";
                estimateElem38.appendChild(estimateElem39);
                estimateElem38.appendChild(estimateElem40);
                estimateElem38.appendChild(estimateElem41);
                let estimateElem42 = doc.createElement("typeWorkCost");
                estimateElem42.innerHTML = "SalvageAmount";
                estimateElem37.appendChild(estimateElem38);
                estimateElem37.appendChild(estimateElem42);
                let estimateElem43 = doc.createElement("WorkCostDetail");
                let estimateElem44 = doc.createElement("amount");
                let estimateElem45 = doc.createElement("currencyUnit");
                estimateElem45.innerHTML = "USD";
                let estimateElem46 = doc.createElement("multiplier");
                estimateElem46.innerHTML = "none";
                let estimateElem47 = doc.createElement("decimalValue");
                estimateElem47.innerHTML = "0.00";
                estimateElem44.appendChild(estimateElem45);
                estimateElem44.appendChild(estimateElem46);
                estimateElem44.appendChild(estimateElem47);
                let estimateElem48 = doc.createElement("typeWorkCost");
                estimateElem48.innerHTML = "LoadingAmount";
                estimateElem43.appendChild(estimateElem44);
                estimateElem43.appendChild(estimateElem48);
                let estimateElem49 = doc.createElement("WorkCostDetail");
                let estimateElem50 = doc.createElement("amount");
                let estimateElem51 = doc.createElement("currencyUnit");
                estimateElem51.innerHTML = "USD";
                let estimateElem52 = doc.createElement("multiplier");
                estimateElem52.innerHTML = "none";
                let estimateElem53 = doc.createElement("decimalValue");
                if (this.currentWorkOrderData[index][i].chg_type === "Other") {
                    estimateElem53.innerHTML = this.encodeToXML(this.currentWorkOrderData[index][i].amount);
                }
                else {
                    estimateElem53.innerHTML = "0.00";
                }
                estimateElem50.appendChild(estimateElem51);
                estimateElem50.appendChild(estimateElem52);
                estimateElem50.appendChild(estimateElem53);
                let estimateElem54 = doc.createElement("typeWorkCost");
                estimateElem54.innerHTML = "AppliedContributionAmount";
                estimateElem49.appendChild(estimateElem50);
                estimateElem49.appendChild(estimateElem54);
                let estimateElem55 = doc.createElement("WorkCostDetail");
                let estimateElem56 = doc.createElement("amount");
                let estimateElem57 = doc.createElement("currencyUnit");
                estimateElem57.innerHTML = "USD";
                let estimateElem58 = doc.createElement("multiplier");
                estimateElem58.innerHTML = "none";
                let estimateElem59 = doc.createElement("decimalValue");
                if (this.currentWorkOrderData[index][i].chg_type === "Contractor") {
                    estimateElem59.innerHTML = this.encodeToXML(this.currentWorkOrderData[index][i].amount);
                }
                else {
                    estimateElem59.innerHTML = "0.00";
                }
                estimateElem56.appendChild(estimateElem57);
                estimateElem56.appendChild(estimateElem58);
                estimateElem56.appendChild(estimateElem59);
                let estimateElem60 = doc.createElement("typeWorkCost");
                estimateElem60.innerHTML = "ExternalLaborAmount";
                estimateElem55.appendChild(estimateElem56);
                estimateElem55.appendChild(estimateElem60);
                let estimateElem61 = doc.createElement("WorkCostDetail");
                let estimateElem62 = doc.createElement("amount");
                let estimateElem63 = doc.createElement("currencyUnit");
                estimateElem63.innerHTML = "USD";
                let estimateElem64 = doc.createElement("multiplier");
                estimateElem64.innerHTML = "none";
                let estimateElem65 = doc.createElement("decimalValue");
                estimateElem65.innerHTML = "0.00";
                estimateElem62.appendChild(estimateElem63);
                estimateElem62.appendChild(estimateElem64);
                estimateElem62.appendChild(estimateElem65);
                let estimateElem66 = doc.createElement("typeWorkCost");
                estimateElem66.innerHTML = "ExternalMaterialsAmount";
                estimateElem61.appendChild(estimateElem62);
                estimateElem61.appendChild(estimateElem66);
                estimateElem6.appendChild(estimateElem6a);
                estimateElem6.appendChild(estimateElem7);
                estimateElem6.appendChild(estimateElem13);
                estimateElem6.appendChild(estimateElem19);
                estimateElem6.appendChild(estimateElem25);
                estimateElem6.appendChild(estimateElem31);
                estimateElem6.appendChild(estimateElem37);
                estimateElem6.appendChild(estimateElem43);
                estimateElem6.appendChild(estimateElem49);
                estimateElem6.appendChild(estimateElem55);
                estimateElem6.appendChild(estimateElem61);
                let estimateElem67 = doc.createElement("Asset");
                let estimateElem68 = doc.createElement("Location");
                let estimateElem69 = doc.createElement("localID");
                // Asset Location (Estimate level, using description for now)
                estimateElem69.innerHTML = this.encodeToXML(this.currentWorkOrderData[index][i].asset_location);
                estimateElem69.innerHTML = "";
                estimateElem68.appendChild(estimateElem69);
                estimateElem67.appendChild(estimateElem68);
                let estimateElem70 = doc.createElement("Transaction");
                let estimateElem71 = doc.createElement("type");
                estimateElem71.innerHTML = "UOP";
                let estimateElem72 = doc.createElement("sourceSystem");
                estimateElem72.innerHTML = "MMAPS";
                let estimateElem73 = doc.createElement("ErpProjectAccounting");
                let estimateElem74 = doc.createElement("retirementUnit");
                // Retirement Unit/Utility Account (potentially blank for O&M/Removal, but getting info on split for Retirement Unit/Utility Account)
                estimateElem74.innerHTML = this.encodeToXML(this.currentWorkOrderData[index][i].retirement_unit_id);
                let estimateElem75 = doc.createElement("utilityAccount");
                estimateElem75.innerHTML = this.encodeToXML(this.currentWorkOrderData[index][i].utility_account_id);
                estimateElem73.appendChild(estimateElem74);
                estimateElem73.appendChild(estimateElem75);
                let estimateElem76 = doc.createElement("PropertyUnit");
                let estimateElem77 = doc.createElement("workActionKind");
                if (this.currentWorkOrderData[index][i].expenditure_type === "Additions") {
                    estimateElem77.innerHTML = "Addition";
                }
                else if (this.currentWorkOrderData[index][i].expenditure_type === "Retirements") {
                    estimateElem77.innerHTML = "Retirement";
                }
                else if (this.currentWorkOrderData[index][i].expenditure_type ===
                    "Expense/Revenue") {
                    estimateElem77.innerHTML = "Expense";
                }
                estimateElem76.appendChild(estimateElem77);
                let estimateElem78 = doc.createElement("Person");
                let estimateElem79 = doc.createElement("localID");
                // Estimate sender
                estimateElem79.innerHTML = this.encodeToXML(this.etsPacAssignmentLan.toLowerCase());
                let estimateElem80 = doc.createElement("PersonRole");
                let estimateElem81 = doc.createElement("name");
                estimateElem81.innerHTML = "Sender";
                estimateElem80.appendChild(estimateElem81);
                estimateElem78.appendChild(estimateElem79);
                estimateElem78.appendChild(estimateElem80);
                estimateElem70.appendChild(estimateElem71);
                estimateElem70.appendChild(estimateElem72);
                estimateElem70.appendChild(estimateElem73);
                estimateElem70.appendChild(estimateElem76);
                estimateElem70.appendChild(estimateElem78);
                estimateElem1.appendChild(estimateElem2);
                estimateElem1.appendChild(estimateElem3);
                estimateElem1.appendChild(estimateElem4);
                estimateElem1.appendChild(estimateElem6);
                estimateElem1.appendChild(estimateElem67);
                estimateElem1.appendChild(estimateElem70);
                estimateEntries.push(estimateElem1);
            }
        }
        else {
            for (let i = 0; i < itProject.itProjectEstimates.length; i++) {
                let estimateElem1 = doc.createElement("Estimates");
                // may need to split by project -- for now sending the same value over and over.
                let estimateElem2 = doc.createElement("quantity");
                if (itProject.itProjectEstimates[i].quantity) {
                    estimateElem2.innerHTML = this.encodeToXML(itProject.itProjectEstimates[i].quantity.toString());
                }
                else {
                    estimateElem2.innerHTML = "0";
                }
                let estimateElem3 = doc.createElement("category");
                estimateElem3.innerHTML = "DESIGN";
                let estimateElem4;
                estimateElem4 = doc.createElement("MeasurementType");
                let estimateElem5 = doc.createElement("name");
                estimateElem5.innerHTML = "EA";
                estimateElem4.appendChild(estimateElem5);
                let estimateElem6 = doc.createElement("Work");
                let estimateElem6a = doc.createElement("localID");
                // Project ID
                estimateElem6a.innerHTML = this.encodeToXML(itProject.projectID);
                let estimateElem7 = doc.createElement("WorkCostDetail");
                let estimateElem8 = doc.createElement("amount");
                let estimateElem9 = doc.createElement("currencyUnit");
                estimateElem9.innerHTML = "USD";
                let estimateElem10 = doc.createElement("multiplier");
                estimateElem10.innerHTML = "none";
                let estimateElem11 = doc.createElement("decimalValue");
                // Materials Amount
                if (itProject.itProjectEstimates[i].estimateType.includes("Materials")) {
                    estimateElem11.innerHTML = this.encodeToXML(itProject.itProjectEstimates[i].dollarAmount.toString());
                }
                else {
                    estimateElem11.innerHTML = "0.00";
                }
                estimateElem8.appendChild(estimateElem9);
                estimateElem8.appendChild(estimateElem10);
                estimateElem8.appendChild(estimateElem11);
                let estimateElem12 = doc.createElement("typeWorkCost");
                estimateElem12.innerHTML = "InternalMaterialsAmount";
                estimateElem7.appendChild(estimateElem8);
                estimateElem7.appendChild(estimateElem12);
                let estimateElem13 = doc.createElement("WorkCostDetail");
                let estimateElem14 = doc.createElement("amount");
                let estimateElem15 = doc.createElement("currencyUnit");
                estimateElem15.innerHTML = "USD";
                let estimateElem16 = doc.createElement("multiplier");
                estimateElem16.innerHTML = "none";
                let estimateElem17 = doc.createElement("decimalValue");
                // Internal Labor
                if ((itProject.itProjectEstimates[i].estimateType.includes("Hardware") ||
                    itProject.itProjectEstimates[i].estimateType.includes("Software") ||
                    itProject.itProjectEstimates[i].estimateType.includes("Labor")) &&
                    itProject.itProjectEstimates[i].chargeType === "Internal") {
                    estimateElem17.innerHTML = this.encodeToXML(itProject.itProjectEstimates[i].dollarAmount.toString());
                }
                else {
                    estimateElem17.innerHTML = "0.00";
                }
                estimateElem14.appendChild(estimateElem15);
                estimateElem14.appendChild(estimateElem16);
                estimateElem14.appendChild(estimateElem17);
                let estimateElem18 = doc.createElement("typeWorkCost");
                estimateElem18.innerHTML = "InternalLaborAmount";
                estimateElem13.appendChild(estimateElem14);
                estimateElem13.appendChild(estimateElem18);
                let estimateElem19 = doc.createElement("WorkCostDetail");
                let estimateElem20 = doc.createElement("amount");
                let estimateElem21 = doc.createElement("currencyUnit");
                estimateElem21.innerHTML = "USD";
                let estimateElem22 = doc.createElement("multiplier");
                estimateElem22.innerHTML = "none";
                let estimateElem23 = doc.createElement("decimalValue");
                estimateElem23.innerHTML = "0.00";
                estimateElem20.appendChild(estimateElem21);
                estimateElem20.appendChild(estimateElem22);
                estimateElem20.appendChild(estimateElem23);
                let estimateElem24 = doc.createElement("typeWorkCost");
                estimateElem24.innerHTML = "InternalToolsAmount";
                estimateElem19.appendChild(estimateElem20);
                estimateElem19.appendChild(estimateElem24);
                let estimateElem25 = doc.createElement("WorkCostDetail");
                let estimateElem26 = doc.createElement("amount");
                let estimateElem27 = doc.createElement("currencyUnit");
                estimateElem27.innerHTML = "USD";
                let estimateElem28 = doc.createElement("multiplier");
                estimateElem28.innerHTML = "none";
                let estimateElem29 = doc.createElement("decimalValue");
                estimateElem29.innerHTML = "0.00";
                estimateElem26.appendChild(estimateElem27);
                estimateElem26.appendChild(estimateElem28);
                estimateElem26.appendChild(estimateElem29);
                let estimateElem30 = doc.createElement("typeWorkCost");
                estimateElem30.innerHTML = "ExternalToolsAmount";
                estimateElem25.appendChild(estimateElem26);
                estimateElem25.appendChild(estimateElem30);
                let estimateElem31 = doc.createElement("WorkCostDetail");
                let estimateElem32 = doc.createElement("amount");
                let estimateElem33 = doc.createElement("currencyUnit");
                estimateElem33.innerHTML = "USD";
                let estimateElem34 = doc.createElement("multiplier");
                estimateElem34.innerHTML = "none";
                let estimateElem35 = doc.createElement("decimalValue");
                estimateElem35.innerHTML = "0.00";
                estimateElem32.appendChild(estimateElem33);
                estimateElem32.appendChild(estimateElem34);
                estimateElem32.appendChild(estimateElem35);
                let estimateElem36 = doc.createElement("typeWorkCost");
                estimateElem36.innerHTML = "ServiceAmount";
                estimateElem31.appendChild(estimateElem32);
                estimateElem31.appendChild(estimateElem36);
                let estimateElem37 = doc.createElement("WorkCostDetail");
                let estimateElem38 = doc.createElement("amount");
                let estimateElem39 = doc.createElement("currencyUnit");
                estimateElem39.innerHTML = "USD";
                let estimateElem40 = doc.createElement("multiplier");
                estimateElem40.innerHTML = "none";
                let estimateElem41 = doc.createElement("decimalValue");
                estimateElem41.innerHTML = "0.00";
                estimateElem38.appendChild(estimateElem39);
                estimateElem38.appendChild(estimateElem40);
                estimateElem38.appendChild(estimateElem41);
                let estimateElem42 = doc.createElement("typeWorkCost");
                estimateElem42.innerHTML = "SalvageAmount";
                estimateElem37.appendChild(estimateElem38);
                estimateElem37.appendChild(estimateElem42);
                let estimateElem43 = doc.createElement("WorkCostDetail");
                let estimateElem44 = doc.createElement("amount");
                let estimateElem45 = doc.createElement("currencyUnit");
                estimateElem45.innerHTML = "USD";
                let estimateElem46 = doc.createElement("multiplier");
                estimateElem46.innerHTML = "none";
                let estimateElem47 = doc.createElement("decimalValue");
                estimateElem47.innerHTML = "0.00";
                estimateElem44.appendChild(estimateElem45);
                estimateElem44.appendChild(estimateElem46);
                estimateElem44.appendChild(estimateElem47);
                let estimateElem48 = doc.createElement("typeWorkCost");
                estimateElem48.innerHTML = "LoadingAmount";
                estimateElem43.appendChild(estimateElem44);
                estimateElem43.appendChild(estimateElem48);
                let estimateElem49 = doc.createElement("WorkCostDetail");
                let estimateElem50 = doc.createElement("amount");
                let estimateElem51 = doc.createElement("currencyUnit");
                estimateElem51.innerHTML = "USD";
                let estimateElem52 = doc.createElement("multiplier");
                estimateElem52.innerHTML = "none";
                let estimateElem53 = doc.createElement("decimalValue");
                if (itProject.itProjectEstimates[i].estimateType.includes("Contingency") ||
                    itProject.itProjectEstimates[i].estimateType.includes("Other") ||
                    itProject.itProjectEstimates[i].estimateType.includes("AFUDC")) {
                    estimateElem53.innerHTML = this.encodeToXML(itProject.itProjectEstimates[i].dollarAmount.toString());
                }
                else {
                    estimateElem53.innerHTML = "0.00";
                }
                estimateElem50.appendChild(estimateElem51);
                estimateElem50.appendChild(estimateElem52);
                estimateElem50.appendChild(estimateElem53);
                let estimateElem54 = doc.createElement("typeWorkCost");
                estimateElem54.innerHTML = "AppliedContributionAmount";
                estimateElem49.appendChild(estimateElem50);
                estimateElem49.appendChild(estimateElem54);
                let estimateElem55 = doc.createElement("WorkCostDetail");
                let estimateElem56 = doc.createElement("amount");
                let estimateElem57 = doc.createElement("currencyUnit");
                estimateElem57.innerHTML = "USD";
                let estimateElem58 = doc.createElement("multiplier");
                estimateElem58.innerHTML = "none";
                let estimateElem59 = doc.createElement("decimalValue");
                if ((itProject.itProjectEstimates[i].estimateType.includes("Hardware") ||
                    itProject.itProjectEstimates[i].estimateType.includes("Software") ||
                    itProject.itProjectEstimates[i].estimateType.includes("Labor")) &&
                    itProject.itProjectEstimates[i].chargeType === "External") {
                    estimateElem59.innerHTML = this.encodeToXML(itProject.itProjectEstimates[i].dollarAmount.toString());
                }
                else {
                    estimateElem59.innerHTML = "0.00";
                }
                estimateElem56.appendChild(estimateElem57);
                estimateElem56.appendChild(estimateElem58);
                estimateElem56.appendChild(estimateElem59);
                let estimateElem60 = doc.createElement("typeWorkCost");
                estimateElem60.innerHTML = "ExternalLaborAmount";
                estimateElem55.appendChild(estimateElem56);
                estimateElem55.appendChild(estimateElem60);
                let estimateElem61 = doc.createElement("WorkCostDetail");
                let estimateElem62 = doc.createElement("amount");
                let estimateElem63 = doc.createElement("currencyUnit");
                estimateElem63.innerHTML = "USD";
                let estimateElem64 = doc.createElement("multiplier");
                estimateElem64.innerHTML = "none";
                let estimateElem65 = doc.createElement("decimalValue");
                estimateElem65.innerHTML = "0.00";
                estimateElem62.appendChild(estimateElem63);
                estimateElem62.appendChild(estimateElem64);
                estimateElem62.appendChild(estimateElem65);
                let estimateElem66 = doc.createElement("typeWorkCost");
                estimateElem66.innerHTML = "ExternalMaterialsAmount";
                estimateElem61.appendChild(estimateElem62);
                estimateElem61.appendChild(estimateElem66);
                estimateElem6.appendChild(estimateElem6a);
                estimateElem6.appendChild(estimateElem7);
                estimateElem6.appendChild(estimateElem13);
                estimateElem6.appendChild(estimateElem19);
                estimateElem6.appendChild(estimateElem25);
                estimateElem6.appendChild(estimateElem31);
                estimateElem6.appendChild(estimateElem37);
                estimateElem6.appendChild(estimateElem43);
                estimateElem6.appendChild(estimateElem49);
                estimateElem6.appendChild(estimateElem55);
                estimateElem6.appendChild(estimateElem61);
                let estimateElem67 = doc.createElement("Asset");
                let estimateElem68 = doc.createElement("Location");
                let estimateElem69 = doc.createElement("localID");
                // Asset Location (Estimate level, using description for now)
                if (itProject.itProjectEstimates[i].assetLocationId) {
                    estimateElem69.innerHTML = this.encodeToXML(itProject.itProjectEstimates[i].assetLocationId.toString());
                }
                else {
                    estimateElem69.innerHTML = "";
                }
                estimateElem68.appendChild(estimateElem69);
                estimateElem67.appendChild(estimateElem68);
                let estimateElem70 = doc.createElement("Transaction");
                let estimateElem71 = doc.createElement("type");
                estimateElem71.innerHTML = "UOP";
                let estimateElem72 = doc.createElement("sourceSystem");
                estimateElem72.innerHTML = "MMAPS";
                let estimateElem73 = doc.createElement("ErpProjectAccounting");
                let estimateElem74 = doc.createElement("retirementUnit");
                // Retirement Unit/Utility Account (potentially blank for O&M/Removal, but getting info on split for Retirement Unit/Utility Account)
                if (itProject.itProjectEstimates[i].retirementUnitId &&
                    itProject.itProjectEstimates[i].retirementUnitId !== undefined) {
                    estimateElem74.innerHTML = this.encodeToXML(itProject.itProjectEstimates[i].retirementUnitId);
                }
                else {
                    estimateElem74.innerHTML = "";
                }
                let estimateElem75 = doc.createElement("utilityAccount");
                if (itProject.itProjectEstimates[i].utilityAccountId &&
                    itProject.itProjectEstimates[i].utilityAccountId !== undefined) {
                    estimateElem75.innerHTML = this.encodeToXML(itProject.itProjectEstimates[i].utilityAccountId);
                }
                else {
                    estimateElem75.innerHTML = "";
                }
                estimateElem73.appendChild(estimateElem74);
                estimateElem73.appendChild(estimateElem75);
                let estimateElem76 = doc.createElement("PropertyUnit");
                let estimateElem77 = doc.createElement("workActionKind");
                if (itProject.itProjectEstimates[i].estimateType.includes("CAP") ||
                    itProject.itProjectEstimates[i].estimateType.includes("AFUDC")) {
                    estimateElem77.innerHTML = "Addition";
                }
                else if (itProject.itProjectEstimates[i].estimateType.includes("Removal")) {
                    estimateElem77.innerHTML = "Retirement";
                }
                else if (itProject.itProjectEstimates[i].estimateType.includes("O&M")) {
                    estimateElem77.innerHTML = "Expense";
                }
                estimateElem76.appendChild(estimateElem77);
                let estimateElem78 = doc.createElement("Person");
                let estimateElem79 = doc.createElement("localID");
                // Estimate sender
                estimateElem79.innerHTML = this.encodeToXML(this.etsPacAssignmentLan.toLowerCase());
                let estimateElem80 = doc.createElement("PersonRole");
                let estimateElem81 = doc.createElement("name");
                estimateElem81.innerHTML = "Sender";
                estimateElem80.appendChild(estimateElem81);
                estimateElem78.appendChild(estimateElem79);
                estimateElem78.appendChild(estimateElem80);
                estimateElem70.appendChild(estimateElem71);
                estimateElem70.appendChild(estimateElem72);
                estimateElem70.appendChild(estimateElem73);
                estimateElem70.appendChild(estimateElem76);
                estimateElem70.appendChild(estimateElem78);
                estimateElem1.appendChild(estimateElem2);
                estimateElem1.appendChild(estimateElem3);
                estimateElem1.appendChild(estimateElem4);
                estimateElem1.appendChild(estimateElem6);
                estimateElem1.appendChild(estimateElem67);
                estimateElem1.appendChild(estimateElem70);
                estimateEntries.push(estimateElem1);
            }
        }
        elem14.appendChild(elem15);
        elem14.appendChild(elem16);
        elem14.appendChild(elem17);
        elem14.appendChild(elem18);
        elem14.appendChild(elem21);
        elem14.appendChild(elem22);
        elem14.appendChild(elem23);
        elem14.appendChild(elem26);
        elem14.appendChild(elem29);
        elem14.appendChild(elem32);
        for (let i = 0; i < activityElems.length; i++) {
            elem14.appendChild(activityElems[i]);
        }
        elem14.appendChild(elem34);
        elem14.appendChild(elem39);
        elem14.appendChild(elem44);
        elem14.appendChild(elem46a);
        elem14.appendChild(elem46);
        elem14.appendChild(elem47);
        elem14.appendChild(elem48);
        elem14.appendChild(elem49);
        elem14.appendChild(elem52);
        elem14.appendChild(elem56);
        elem14.appendChild(elem62);
        for (let i = 0; i < estimateEntries.length; i++) {
            elem14.appendChild(estimateEntries[i]);
        }
        elem8.appendChild(elem9);
        elem8.appendChild(elem14);
        elem7.appendChild(elem8);
        elem1.appendChild(elem2);
        elem1.appendChild(elem7);
        doc.appendChild(elem1);
        let finalString = '<?xml version="1.0" encoding="UTF-8"?>'.concat(doc.documentElement.outerHTML);
        return finalString;
    }
    submitProjects(projectSubmissions, dataStructure2, jointOwnerRejection, projectNumbers, businessUnits, projectFailures) {
        this.dataService.submitProjectTEST(projectSubmissions[0]).subscribe((result) => {
            this.xmlDoc = this.parser.parseFromString(result, "text/xml");
            if (this.xmlDoc.getElementsByTagName("Transaction")[0].childNodes[1]
                .innerHTML === "ERROR") {
                let dataStructure;
                let errors = this.xmlDoc.getElementsByTagName("errorMessage");
                let errorTexts = [];
                for (let i = 0; i < errors.length; i++) {
                    errorTexts.push(errors[i].innerHTML);
                }
                dataStructure = {
                    error: true,
                    data: errorTexts,
                    isEstimate: true,
                    projectNumber: projectNumbers[0],
                    businessUnit: businessUnits[0],
                    projectSubmissionError: true
                };
                this.sendFailureEmail(dataStructure);
                projectFailures.push({
                    projectNumber: projectNumbers[0],
                    businessUnit: businessUnits[0]
                });
            }
            projectSubmissions.shift();
            projectNumbers.shift();
            businessUnits.shift();
            if (projectSubmissions.length > 0) {
                this.submitProjects(projectSubmissions, dataStructure2, jointOwnerRejection, projectNumbers, businessUnits, projectFailures);
            }
            else {
                let itProjectCopy = JSON.parse(JSON.stringify(this.itProjects));
                let nonCatawbaProjects = [];
                if (jointOwnerRejection) {
                    for (let i = 0; i < itProjectCopy.length; i++) {
                        if (!this.catawbaOperatingUnits.includes(itProjectCopy[i].operatingUnit)) {
                            let matchFound = false;
                            for (let j = 0; j < projectFailures.length && !matchFound; j++) {
                                if (itProjectCopy[i].businessUnit === projectFailures[j].businessUnit &&
                                    itProjectCopy[i].projectID === projectFailures[j].projectNumber) {
                                    matchFound = true;
                                }
                            }
                            if (!matchFound) {
                                nonCatawbaProjects.push(itProjectCopy[i]);
                            }
                        }
                    }
                    this.submitClassCodes(nonCatawbaProjects, null, dataStructure2);
                }
                else {
                    let projectsForSetup = [];
                    for (let i = 0; i < itProjectCopy.length; i++) {
                        let matchFound = false;
                        for (let j = 0; j < projectFailures.length && !matchFound; j++) {
                            if (itProjectCopy[i].businessUnit === projectFailures[j].businessUnit &&
                                itProjectCopy[i].projectID === projectFailures[j].projectNumber) {
                                matchFound = true;
                            }
                        }
                        if (!matchFound) {
                            projectsForSetup.push(itProjectCopy[i]);
                        }
                    }
                    this.submitClassCodes(projectsForSetup, null, dataStructure2);
                }
            }
        }, (error) => {
            console.log("error", error);
            //Rewrite error log to avoid error.error.message if it doesnt exist 1-27-26
            let errorType = "";
            let errorDescription = "";
            if (error.error && error.error.message) {
                errorDescription = errorDescription.concat("Submit Project Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Submit Project Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            //Adding specific error handling for 500 timeout 1-23-26
            errorType = `${error.status} ${error.statusText}`;
            errorDescription = "Submit Project Error";
            if (error.message) {
                errorDescription += ` - ${error.message}`;
            }
            if (error.status === 500 ||
                error.status === 0 ||
                error.name === "TimeoutError" ||
                /timeout/i.test(error.message || '')) {
                errorDescription += " (Timed out waiting for a response from PowerPlan)";
            }
            //Error Handling logic that was already there
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
                isEstimate: true,
                projectNumber: projectNumbers[0],
                businessUnit: businessUnits[0],
                projectSubmissionError: true
            };
            this.sendFailureEmail(dataStructure, true);
            projectSubmissions.shift();
            projectNumbers.shift();
            businessUnits.shift();
            projectFailures.push({
                projectNumber: projectNumbers[0],
                businessUnit: businessUnits[0]
            });
            if (projectSubmissions.length > 0) {
                this.submitProjects(projectSubmissions, dataStructure2, jointOwnerRejection, projectNumbers, businessUnits, projectFailures);
            }
            else {
                let itProjectCopy = JSON.parse(JSON.stringify(this.itProjects));
                let nonCatawbaProjects = [];
                if (jointOwnerRejection) {
                    for (let i = 0; i < itProjectCopy.length; i++) {
                        if (!this.catawbaOperatingUnits.includes(itProjectCopy[i].operatingUnit)) {
                            let matchFound = false;
                            for (let j = 0; j < projectFailures.length && !matchFound; j++) {
                                if (itProjectCopy[i].businessUnit === projectFailures[j].businessUnit &&
                                    itProjectCopy[i].projectID === projectFailures[j].projectNumber) {
                                    matchFound = true;
                                }
                            }
                            if (!matchFound) {
                                nonCatawbaProjects.push(itProjectCopy[i]);
                            }
                        }
                    }
                    this.submitClassCodes(nonCatawbaProjects, null, dataStructure2);
                }
                else {
                    let projectsForSetup = [];
                    for (let i = 0; i < itProjectCopy.length; i++) {
                        let matchFound = false;
                        for (let j = 0; j < projectFailures.length && !matchFound; j++) {
                            if (itProjectCopy[i].businessUnit === projectFailures[j].businessUnit &&
                                itProjectCopy[i].projectID === projectFailures[j].projectNumber) {
                                matchFound = true;
                            }
                        }
                        if (!matchFound) {
                            projectsForSetup.push(itProjectCopy[i]);
                        }
                    }
                    this.submitClassCodes(projectsForSetup, null, dataStructure2);
                }
            }
        });
    }
    submitClassCodes(itProjects, token, dataStructure, index) {
        /*Output parameters passed to sumbitClassCodes
        console.log(
          `submitClassCodes called with:
          itProjects: ${JSON.stringify(itProjects, null, 2)}
          token: ${token}
          dataStructure: ${JSON.stringify(dataStructure, null, 2)}
          index: ${index}`
        );
        */
        if (itProjects.length > 0) {
            //FLDT-1385 Check if Index is defined
            if (index === undefined) {
                index = 0;
            }
            let callBody1;
            if (this.displayRevisionNumber > 0 &&
                !this.projectClassificationChanged()) {
                //FLDT-1385 Mapping Spend Governance to SG-Run for PPL Class Code submission
                //console.log('ClasscodeValue at Start of If: ', this.currentProjectData[index][0].it_proj_classification);
                let classCodeValue = this.currentProjectData[index][0].it_proj_classification;
                if (classCodeValue === "Spend Governance") {
                    classCodeValue = "SG - Run";
                }
                callBody1 = {
                    company_id: itProjects[0].businessUnit,
                    work_order_number: itProjects[0].projectID,
                    class_code_id: "16066",
                    class_code_value1: classCodeValue,
                };
                //console.log('ClasscodeValue at End of If: ', classCodeValue);
            }
            else {
                //FLDT-1385 Mapping Spend Governance to SG-Run for PPL Class Code submission
                //console.log('ClasscodeValue at Start of Else: ', this.itProjectClassification.ets_proj_classification);
                let classCodeValue = this.itProjectClassification.ets_proj_classification;
                if (classCodeValue === "Spend Governance") {
                    classCodeValue = "SG - Run";
                }
                callBody1 = {
                    company_id: itProjects[0].businessUnit,
                    work_order_number: itProjects[0].projectID,
                    class_code_id: "16066",
                    class_code_value1: classCodeValue,
                };
                //console.log('ClasscodeValue at End of Else: ', classCodeValue);
            }
            let callBody2 = {
                company_id: itProjects[0].businessUnit,
                work_order_number: itProjects[0].projectID,
                class_code_id: "7895",
                class_code_value1: "Paula Barr",
            };
            if (!token) {
                this.dataService.getPPLClassCodeAccessToken().subscribe((result) => {
                    token = result.token;
                    this.dataService
                        .getPPLClassCode(token, callBody1)
                        .subscribe((result) => {
                        this.dataService
                            .getPPLClassCode(token, callBody2)
                            .subscribe((result) => {
                            itProjects.shift();
                            if (itProjects.length > 0) {
                                this.submitClassCodes(itProjects, token, dataStructure, index + 1);
                            }
                            else {
                                this.dataService
                                    .saveItSparData(dataStructure.callBody)
                                    .subscribe((result) => {
                                    if (result.statusCode !== 200) {
                                        console.log("error", result);
                                        let errorType = "";
                                        let errorDescription = result;
                                        let dataStructure = {
                                            errorType: errorType,
                                            errorDescription: errorDescription,
                                        };
                                        this.dialog.open(ErrorDialogComponent, {
                                            data: dataStructure,
                                            disableClose: true,
                                        });
                                    }
                                    this.getItSparData(this.itSparGuid, this.displayRevisionNumber);
                                    this.sendEmailNotifications(dataStructure);
                                }, (error) => {
                                    console.log("error", error);
                                    let errorType = "";
                                    let errorDescription = "";
                                    if (error.error.message) {
                                        errorDescription = errorDescription.concat("Save IT SPAR Data Error - ", error.error.message);
                                    }
                                    else {
                                        errorDescription = errorDescription.concat("Save IT SPAR Data Error");
                                    }
                                    errorType = errorType.concat(error.status, " ", error.statusText);
                                    let dataStructure = {
                                        errorType: errorType,
                                        errorDescription: errorDescription,
                                    };
                                    this.dialog.open(ErrorDialogComponent, {
                                        data: dataStructure,
                                        disableClose: true,
                                    });
                                });
                            }
                        }, (error) => {
                            console.log("error", error);
                            let errorType = "";
                            let errorDescription = "";
                            if (error.error.message) {
                                errorDescription = errorDescription.concat("Submit Class Code Error - ", error.error.message);
                            }
                            else {
                                errorDescription = errorDescription.concat("Submit Class Code Error");
                            }
                            errorType = errorType.concat(error.status, " ", error.statusText);
                            let dataStructure2 = {
                                errorType: errorType,
                                errorDescription: errorDescription,
                                projectNumber: itProjects[0].projectID,
                                businessUnit: itProjects[0].businessUnit,
                                projectSubmissionError: false
                            };
                            this.sendFailureEmail(dataStructure2, true);
                            itProjects.shift();
                            if (itProjects.length > 0) {
                                this.submitClassCodes(itProjects, token, dataStructure);
                            }
                            else {
                                this.dataService
                                    .saveItSparData(dataStructure.callBody)
                                    .subscribe((result) => {
                                    if (result.statusCode !== 200) {
                                        console.log("error", result);
                                        let errorType = "";
                                        let errorDescription = result;
                                        let dataStructure = {
                                            errorType: errorType,
                                            errorDescription: errorDescription,
                                        };
                                        this.dialog.open(ErrorDialogComponent, {
                                            data: dataStructure,
                                            disableClose: true,
                                        });
                                    }
                                    this.getItSparData(this.itSparGuid, this.displayRevisionNumber);
                                    this.sendEmailNotifications(dataStructure);
                                }, (error) => {
                                    console.log("error", error);
                                    let errorType = "";
                                    let errorDescription = "";
                                    if (error.error.message) {
                                        errorDescription = errorDescription.concat("Save IT SPAR Data Error - ", error.error.message);
                                    }
                                    else {
                                        errorDescription = errorDescription.concat("Save IT SPAR Data Error");
                                    }
                                    errorType = errorType.concat(error.status, " ", error.statusText);
                                    let dataStructure = {
                                        errorType: errorType,
                                        errorDescription: errorDescription,
                                    };
                                    this.dialog.open(ErrorDialogComponent, {
                                        data: dataStructure,
                                        disableClose: true,
                                    });
                                });
                            }
                        });
                    }, (error) => {
                        console.log("error", error);
                        let errorType = "";
                        let errorDescription = "";
                        if (error.error && error.error.message) {
                            errorDescription = errorDescription.concat("Submit Class Code Error - ", error.error.message);
                        }
                        else {
                            errorDescription = errorDescription.concat("Submit Class Code Error");
                        }
                        errorType = errorType.concat(error.status, " ", error.statusText);
                        let dataStructure2 = {
                            errorType: errorType,
                            errorDescription: errorDescription,
                            projectNumber: itProjects[0].projectID,
                            businessUnit: itProjects[0].businessUnit,
                            projectSubmissionError: false
                        };
                        this.sendFailureEmail(dataStructure2, true);
                        itProjects.shift();
                        if (itProjects.length > 0) {
                            this.submitClassCodes(itProjects, token, dataStructure);
                        }
                        else {
                            this.dataService
                                .saveItSparData(dataStructure.callBody)
                                .subscribe((result) => {
                                if (result.statusCode !== 200) {
                                    console.log("error", result);
                                    let errorType = "";
                                    let errorDescription = result;
                                    let dataStructure = {
                                        errorType: errorType,
                                        errorDescription: errorDescription,
                                    };
                                    this.dialog.open(ErrorDialogComponent, {
                                        data: dataStructure,
                                        disableClose: true,
                                    });
                                }
                                this.getItSparData(this.itSparGuid, this.displayRevisionNumber);
                                this.sendEmailNotifications(dataStructure);
                            }, (error) => {
                                console.log("error", error);
                                let errorType = "";
                                let errorDescription = "";
                                if (error.error.message) {
                                    errorDescription = errorDescription.concat("Save IT SPAR Data Error - ", error.error.message);
                                }
                                else {
                                    errorDescription = errorDescription.concat("Save IT SPAR Data Error");
                                }
                                errorType = errorType.concat(error.status, " ", error.statusText);
                                let dataStructure = {
                                    errorType: errorType,
                                    errorDescription: errorDescription,
                                };
                                this.dialog.open(ErrorDialogComponent, {
                                    data: dataStructure,
                                    disableClose: true,
                                });
                            });
                        }
                    });
                }, (error) => {
                    console.log("error", error);
                    let errorType = "";
                    let errorDescription = "";
                    if (error.error.message) {
                        errorDescription = errorDescription.concat("Get Class Code Access Token Error - ", error.error.message);
                    }
                    else {
                        errorDescription = errorDescription.concat("Get Class Code Access Token Error");
                    }
                    errorType = errorType.concat(error.status, " ", error.statusText);
                    let dataStructure2 = {
                        errorType: errorType,
                        errorDescription: errorDescription,
                        projectNumber: itProjects[0].projectID,
                        businessUnit: itProjects[0].businessUnit,
                        projectSubmissionError: false
                    };
                    this.sendFailureEmail(dataStructure2, true);
                    itProjects.shift();
                    if (itProjects.length > 0) {
                        this.submitClassCodes(itProjects, token, dataStructure);
                    }
                    else {
                        this.dataService
                            .saveItSparData(dataStructure.callBody)
                            .subscribe((result) => {
                            if (result.statusCode !== 200) {
                                console.log("error", result);
                                let errorType = "";
                                let errorDescription = result;
                                let dataStructure = {
                                    errorType: errorType,
                                    errorDescription: errorDescription,
                                };
                                this.dialog.open(ErrorDialogComponent, {
                                    data: dataStructure,
                                    disableClose: true,
                                });
                            }
                            this.getItSparData(this.itSparGuid, this.displayRevisionNumber);
                            this.sendEmailNotifications(dataStructure);
                        }, (error) => {
                            console.log("error", error);
                            let errorType = "";
                            let errorDescription = "";
                            if (error.error.message) {
                                errorDescription = errorDescription.concat("Save IT SPAR Data Error - ", error.error.message);
                            }
                            else {
                                errorDescription = errorDescription.concat("Save IT SPAR Data Error");
                            }
                            errorType = errorType.concat(error.status, " ", error.statusText);
                            let dataStructure = {
                                errorType: errorType,
                                errorDescription: errorDescription,
                            };
                            this.dialog.open(ErrorDialogComponent, {
                                data: dataStructure,
                                disableClose: true,
                            });
                        });
                    }
                });
            }
            else {
                this.dataService.getPPLClassCode(token, callBody1).subscribe((result) => {
                    // TODO: handling class code call 1 result
                    console.log(result);
                    this.dataService.getPPLClassCode(token, callBody2).subscribe((result) => {
                        // TODO: handling class code call 2 result
                        console.log(result);
                        itProjects.shift();
                        if (itProjects.length > 0) {
                            this.submitClassCodes(itProjects, token, dataStructure);
                        }
                        else {
                            this.dataService
                                .saveItSparData(dataStructure.callBody)
                                .subscribe((result) => {
                                if (result.statusCode !== 200) {
                                    console.log("error", result);
                                    let errorType = "";
                                    let errorDescription = result;
                                    let dataStructure = {
                                        errorType: errorType,
                                        errorDescription: errorDescription,
                                    };
                                    this.dialog.open(ErrorDialogComponent, {
                                        data: dataStructure,
                                        disableClose: true,
                                    });
                                }
                                this.getItSparData(this.itSparGuid, this.displayRevisionNumber);
                                this.sendEmailNotifications(dataStructure);
                            }, (error) => {
                                console.log("error", error);
                                let errorType = "";
                                let errorDescription = "";
                                if (error.error.message) {
                                    errorDescription = errorDescription.concat("Save IT SPAR Data Error - ", error.error.message);
                                }
                                else {
                                    errorDescription = errorDescription.concat("Save IT SPAR Data Error");
                                }
                                errorType = errorType.concat(error.status, " ", error.statusText);
                                let dataStructure = {
                                    errorType: errorType,
                                    errorDescription: errorDescription,
                                };
                                this.dialog.open(ErrorDialogComponent, {
                                    data: dataStructure,
                                    disableClose: true,
                                });
                            });
                        }
                    }, (error) => {
                        console.log("error", error);
                        let errorType = "";
                        let errorDescription = "";
                        if (error.error.message) {
                            errorDescription = errorDescription.concat("Submit Class Code Error - ", error.error.message);
                        }
                        else {
                            errorDescription = errorDescription.concat("Submit Class Code Error");
                        }
                        errorType = errorType.concat(error.status, " ", error.statusText);
                        let dataStructure2 = {
                            errorType: errorType,
                            errorDescription: errorDescription,
                            projectNumber: itProjects[0].projectID,
                            businessUnit: itProjects[0].businessUnit,
                            projectSubmissionError: false
                        };
                        this.sendFailureEmail(dataStructure2, true);
                        itProjects.shift();
                        if (itProjects.length > 0) {
                            this.submitClassCodes(itProjects, token, dataStructure);
                        }
                        else {
                            this.dataService
                                .saveItSparData(dataStructure.callBody)
                                .subscribe((result) => {
                                if (result.statusCode !== 200) {
                                    console.log("error", result);
                                    let errorType = "";
                                    let errorDescription = result;
                                    let dataStructure = {
                                        errorType: errorType,
                                        errorDescription: errorDescription,
                                    };
                                    this.dialog.open(ErrorDialogComponent, {
                                        data: dataStructure,
                                        disableClose: true,
                                    });
                                }
                                this.getItSparData(this.itSparGuid, this.displayRevisionNumber);
                                this.sendEmailNotifications(dataStructure);
                            }, (error) => {
                                console.log("error", error);
                                let errorType = "";
                                let errorDescription = "";
                                if (error.error.message) {
                                    errorDescription = errorDescription.concat("Save IT SPAR Data Error - ", error.error.message);
                                }
                                else {
                                    errorDescription = errorDescription.concat("Save IT SPAR Data Error");
                                }
                                errorType = errorType.concat(error.status, " ", error.statusText);
                                let dataStructure = {
                                    errorType: errorType,
                                    errorDescription: errorDescription,
                                };
                                this.dialog.open(ErrorDialogComponent, {
                                    data: dataStructure,
                                    disableClose: true,
                                });
                            });
                        }
                    });
                }, (error) => {
                    console.log("error", error);
                    let errorType = "";
                    let errorDescription = "";
                    if (error.error.message) {
                        errorDescription = errorDescription.concat("Submit Class Code Error - ", error.error.message);
                    }
                    else {
                        errorDescription = errorDescription.concat("Submit Class Code Error");
                    }
                    errorType = errorType.concat(error.status, " ", error.statusText);
                    let dataStructure2 = {
                        errorType: errorType,
                        errorDescription: errorDescription,
                        projectNumber: itProjects[0].projectID,
                        businessUnit: itProjects[0].businessUnit,
                        projectSubmissionError: false
                    };
                    this.sendFailureEmail(dataStructure2, true);
                    itProjects.shift();
                    if (itProjects.length > 0) {
                        this.submitClassCodes(itProjects, token, dataStructure);
                    }
                    else {
                        this.dataService
                            .saveItSparData(dataStructure.callBody)
                            .subscribe((result) => {
                            if (result.statusCode !== 200) {
                                console.log("error", result);
                                let errorType = "";
                                let errorDescription = result;
                                let dataStructure = {
                                    errorType: errorType,
                                    errorDescription: errorDescription,
                                };
                                this.dialog.open(ErrorDialogComponent, {
                                    data: dataStructure,
                                    disableClose: true,
                                });
                            }
                            this.getItSparData(this.itSparGuid, this.displayRevisionNumber);
                            this.sendEmailNotifications(dataStructure);
                        }, (error) => {
                            console.log("error", error);
                            let errorType = "";
                            let errorDescription = "";
                            if (error.error.message) {
                                errorDescription = errorDescription.concat("Save IT SPAR Data Error - ", error.error.message);
                            }
                            else {
                                errorDescription = errorDescription.concat("Save IT SPAR Data Error");
                            }
                            errorType = errorType.concat(error.status, " ", error.statusText);
                            let dataStructure = {
                                errorType: errorType,
                                errorDescription: errorDescription,
                            };
                            this.dialog.open(ErrorDialogComponent, {
                                data: dataStructure,
                                disableClose: true,
                            });
                        });
                    }
                });
            }
        }
        else {
            this.dataService
                .saveItSparData(dataStructure.callBody)
                .subscribe((result) => {
                if (result.statusCode !== 200) {
                    console.log("error", result);
                    let errorType = "";
                    let errorDescription = result;
                    let dataStructure = {
                        errorType: errorType,
                        errorDescription: errorDescription,
                    };
                    this.dialog.open(ErrorDialogComponent, {
                        data: dataStructure,
                        disableClose: true,
                    });
                }
                this.getItSparData(this.itSparGuid, this.displayRevisionNumber);
                this.sendEmailNotifications(dataStructure);
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Save IT SPAR Data Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Save IT SPAR Data Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            });
        }
    }
    encodeToXML(encodeString) {
        if (encodeString) {
            return encodeString
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&apos;");
        }
        else {
            return "";
        }
    }
    //FLDT-1384 Creating new getUserLanID Function that takes in name from json
    getLanIdFromName(name, callback) {
        this.dataService.searchUsers(name).subscribe((result) => {
            if (result.value && result.value.length > 0) {
                const email = result.value[0].mail;
                this.dataService.getUserLanId(email).subscribe((lanResult) => {
                    if (lanResult.value && lanResult.value.length > 0) {
                        callback(lanResult.value[0].mailNickname);
                    }
                    else {
                        callback("");
                    }
                }, () => callback(""));
            }
            else {
                callback("");
            }
        }, () => callback(""));
    }
    //End FLDT-1384
    getUserLanIds() {
        this.dataService.getUserLanId(this.etsPacAssignment.mail).subscribe((result) => {
            this.etsPacAssignmentLan = result.value[0].mailNickname;
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Get ETS PAC Lan ID Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Get ETS PAC Lan ID Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    getPACUsers() {
        let pacGroup = this.config.getConfig("ItPacGroup");
        this.dataService.getGroupId(pacGroup).subscribe((result) => {
            this.dataService.getPACUserList(result.value[0].id).subscribe((result) => {
                this.pacUsers = result.value;
                if (this.etsPacAssignment.mail) {
                    this.getPACUserNotAssigned();
                }
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Get PAC User List Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Get PAC User List Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            });
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Get PAC Group ID Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Get PAC Group ID Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    getPACUserNotAssigned() {
        let firstFound = false;
        let secondFound = false;
        for (let i = 0; i < this.pacUsers.length && !secondFound; i++) {
            if (this.pacUsers[i].mail &&
                this.etsPacAssignment.mail &&
                this.pacUsers[i].mail.toLowerCase() !==
                    this.etsPacAssignment.mail.toLowerCase()) {
                if (!firstFound) {
                    firstFound = true;
                    this.firstPacUser = this.pacUsers[i];
                }
                else {
                    secondFound = true;
                    this.secondPacUser = this.pacUsers[i];
                }
            }
        }
        this.getPACLanIds();
    }
    getPACLanIds() {
        this.dataService.getUserLanId(this.firstPacUser.mail).subscribe((result) => {
            this.firstPacUserLan = result.value[0].mailNickname;
            this.dataService.getUserLanId(this.secondPacUser.mail).subscribe((result) => {
                this.secondPacUserLan = result.value[0].mailNickname;
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Get Second PAC Lan ID Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Get Second PAC Lan ID Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            });
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Get First PAC Lan ID Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Get First PAC Lan ID Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    compareItProjectClassification(o1, o2) {
        if (!o1 || !o2) {
            return false;
        }
        return o1.it_proj_classification === o2.it_proj_classification;
    }
    getRevisionWorkOrderData(index) {
        let callBody = {
            businessUnit: this.itProjects[index].businessUnit,
            fundProjId: this.itProjects[index].projectID,
        };
        this.dataService
            .getAthenaData("it_spar_wo_data_for_revision", callBody)
            .subscribe((result) => {
            this.currentWorkOrderData[index] = JSON.parse(result);
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Get Revision Work Order Data Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Get Revision Work Order Data Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    getRevisionActivityData(index) {
        let callBody = {
            businessUnit: this.itProjects[index].businessUnit,
            fundProjId: this.itProjects[index].projectID,
        };
        this.dataService
            .getAthenaData("it_spar_activity_data_for_revision", callBody)
            .subscribe((result) => {
            this.currentActivityData[index] = JSON.parse(result);
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Get Revision Activity Data Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Get Revision Activity Data Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    getRevisionProjectData(index) {
        let callBody = {
            businessUnit: this.itProjects[index].businessUnit,
            fundProjId: this.itProjects[index].projectID,
        };
        this.dataService
            .getAthenaData("it_spar_prj_data_for_revision", callBody)
            .subscribe((result) => {
            this.currentProjectData[index] = JSON.parse(result);
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Get Revision Project Data Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Get Revision Project Data Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    getPreviousItSparData(guid, revisionNumber) {
        let callBody;
        if (revisionNumber !== undefined) {
            callBody = {
                itSparGuid: guid,
                displayRevisionNumber: revisionNumber - 1,
            };
        }
        else {
            callBody = {
                itSparGuid: guid,
            };
        }
        this.dataService.getItSparData(callBody, "ui").subscribe((result) => {
            this.previousRevisionData = result;
        });
    }
    projectNameChanged() {
        if (this.projectName !== this.previousRevisionData.body.shortDescription) {
            return true;
        }
        else {
            return false;
        }
    }
    projectTypeChanged() {
        if (!_.isEqual(this.previousRevisionData.body.buildings, this.currentRevisionData.body.buildings) ||
            this.agileEffort !== this.previousRevisionData.agileEffort) {
            return true;
        }
        else {
            return false;
        }
    }
    projectScopeDescriptionChanged() {
        if (this.projectScopeDescription !==
            this.previousRevisionData.body.overviewAndScope) {
            return true;
        }
        else {
            return false;
        }
    }
    estimatedStartDateChanged() {
        if (this.previousRevisionData.body.estimatedStartDate !==
            this.currentRevisionData.body.estimatedStartDate) {
            return true;
        }
        else {
            return false;
        }
    }
    estimatedInServiceDateChanged() {
        if (this.previousRevisionData.body.estimatedInServiceDate !==
            this.currentRevisionData.body.estimatedInServiceDate) {
            return true;
        }
        else {
            return false;
        }
    }
    assetAndMajorLocationChanged() {
        if (!_.isEqual(this.previousRevisionData.body.buildings, this.currentRevisionData.body.buildings) ||
            !_.isEqual(this.previousRevisionData.body.allocations, this.currentRevisionData.body.allocations)) {
            return true;
        }
        else {
            return false;
        }
    }
    activitiesChanged() {
        if (!_.isEqual(this.previousRevisionData.body.buildings, this.currentRevisionData.body.buildings) ||
            this.agileEffort !== this.previousRevisionData.body.agileEffort ||
            this.previousRevisionData.body.etsProjectClassification !==
                this.currentRevisionData.body.etsProjectClassification) {
            return true;
        }
        else {
            return false;
        }
    }
    projectChargeIndicatorChanged() {
        if (this.projectClassificationChanged() ||
            !_.isEqual(this.previousRevisionData.body.buildings, this.currentRevisionData.body.buildings) ||
            !_.isEqual(this.previousRevisionData.body.contingencyDetails, this.currentRevisionData.body.contingencyDetails) ||
            !_.isEqual(this.previousRevisionData.body.laborDetails, this.currentRevisionData.body.laborDetails)) {
            return true;
        }
        else {
            return false;
        }
    }
    estimatesChanged() {
        if (this.projectClassificationChanged() ||
            !_.isEqual(this.previousRevisionData.body.buildings, this.currentRevisionData.body.buildings) ||
            !_.isEqual(this.previousRevisionData.body.contingencyDetails, this.currentRevisionData.body.contingencyDetails) ||
            !_.isEqual(this.previousRevisionData.body.laborDetails, this.currentRevisionData.body.laborDetails ||
                !_.isEqual(this.previousRevisionData.body.allocations, this.currentRevisionData.body.allocations))) {
            return true;
        }
        else {
            return false;
        }
    }
    projectClassificationChanged() {
        if (this.previousRevisionData.body.etsProjectClassification !==
            this.currentRevisionData.body.etsProjectClassification) {
            return true;
        }
        else {
            return false;
        }
    }
    getNuclearCode(allocation) {
        for (let i = 0; i < this.nuclearAbbreviations.length; i++) {
            if (allocation.operatingUnit.OPERATING_UNIT ===
                this.nuclearAbbreviations[i].operatingUnit) {
                return this.nuclearAbbreviations[i].stationCode;
            }
        }
        return "";
    }
    isSameNuclearAbbreviation(allocation1, allocation2) {
        let firstAllocationStationCode;
        let secondAllocationStationCode;
        let firstMatchFound = false;
        let secondMatchFound = false;
        for (let i = 0; i < this.nuclearAbbreviations.length &&
            (!firstMatchFound || !secondMatchFound); i++) {
            if (allocation1.operatingUnit.OPERATING_UNIT ===
                this.nuclearAbbreviations[i].operatingUnit) {
                firstAllocationStationCode = this.nuclearAbbreviations[i].stationCode;
                firstMatchFound = true;
            }
            if (allocation2.operatingUnit.OPERATING_UNIT ===
                this.nuclearAbbreviations[i].operatingUnit) {
                secondAllocationStationCode = this.nuclearAbbreviations[i].stationCode;
                secondMatchFound = true;
            }
        }
        return (firstMatchFound &&
            secondMatchFound &&
            firstAllocationStationCode === secondAllocationStationCode);
    }
    getAssetUsers() {
        let assetGroup = this.config.getConfig("AssetAccountingGroup");
        this.dataService.getGroupIdExact(assetGroup).subscribe((result) => {
            const assetGroups = result && Array.isArray(result.value)
                ? result.value
                : [];
            if (!assetGroups.length) {
                let dataStructure = {
                    errorType: "",
                    errorDescription: "Get Asset Group ID Error - Exact Asset group match not found for ".concat(assetGroup),
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
                return;
            }
            this.dataService.getPACUserList(assetGroups[0].id).subscribe((result) => {
                this.assetUsers = result.value;
            }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Get Asset User List Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Get Asset User List Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            });
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Get Asset Group ID Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Get Asset Group ID Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    getAssetOrder() {
        let data = {
            fileName: "asset-order.json",
            contentType: "application/json",
            method: "get_object",
        };
        this.dataService.getPresignedURL(data).subscribe((result) => {
            let presignedUrl = JSON.parse(result).presigned_url;
            this.http
                .get(presignedUrl, {
                responseType: "blob",
            })
                .subscribe((result) => {
                result.text().then((text) => {
                    this.assetOrder = JSON.parse(text);
                });
            }, (error) => {
                if (error.status === 404) {
                    this.assetOrder = [];
                    this.saveAssetOrder("[]");
                }
                else {
                    console.log("error", error);
                    let errorType = "";
                    let errorDescription = "";
                    if (error.error.message) {
                        errorDescription = errorDescription.concat("Get Asset Order File Error - ", error.error.message);
                    }
                    else {
                        errorDescription = errorDescription.concat("Get Asset Order File Error");
                    }
                    errorType = errorType.concat(error.status, " ", error.statusText);
                    let dataStructure = {
                        errorType: errorType,
                        errorDescription: errorDescription,
                    };
                    this.dialog.open(ErrorDialogComponent, {
                        data: dataStructure,
                        disableClose: true,
                    });
                }
            });
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Get Presigned URL Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Get Presigned URL Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    saveAssetOrder(fileBody) {
        let data = {
            fileName: "asset-order.json",
            contentType: "application/json",
            method: "put_object",
        };
        this.dataService.getPresignedURL(data).subscribe((result) => {
            let presignedURL = JSON.parse(result).presigned_url;
            const blob = new Blob([fileBody], { type: "application/json" });
            const file = new File([blob], "asset-order.json", {
                type: "application/json",
            });
            this.httpNoInterceptors.put(presignedURL, file, { headers: { 'Content-Type': file.type } }).subscribe((result) => { }, (error) => {
                console.log("error", error);
                let errorType = "";
                let errorDescription = "";
                if (error.error.message) {
                    errorDescription = errorDescription.concat("Upload Asset Order to Presigned URL Error - ", error.error.message);
                }
                else {
                    errorDescription = errorDescription.concat("Upload Asset Order to Presigned URL Error");
                }
                errorType = errorType.concat(error.status, " ", error.statusText);
                let dataStructure = {
                    errorType: errorType,
                    errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                    data: dataStructure,
                    disableClose: true,
                });
            });
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Get Presigned URL Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Get Presigned URL Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    selectAssetReviewer() {
        if (!Array.isArray(this.assetUsers) || this.assetUsers.length === 0) {
            return;
        }
        if (!Array.isArray(this.assetOrder)) {
            this.assetOrder = [];
        }
        let foundMatches = [];
        for (let i = 0; i < this.assetUsers.length; i++) {
            let matchFound = false;
            for (let j = 0; j < this.assetOrder.length && !matchFound; j++) {
                if (this.assetUsers[i].mail &&
                    this.assetOrder[j].mail &&
                    this.assetUsers[i].mail.toLowerCase() ===
                        this.assetOrder[j].mail.toLowerCase()) {
                    matchFound = true;
                    foundMatches.push({ userIndex: i, orderIndex: j });
                }
            }
            if (!matchFound) {
                this.assetOrder.unshift({
                    displayName: this.assetUsers[i].displayName,
                    givenName: this.assetUsers[i].givenName,
                    surname: this.assetUsers[i].surname,
                    mail: this.assetUsers[i].mail,
                    mailNickname: this.assetUsers[i].mailNickname,
                    jobTitle: this.assetUsers[i].jobTitle,
                });
                this.saveAssetOrder(JSON.stringify(this.assetOrder));
                this.assetReviewer = {
                    displayName: this.assetUsers[i].displayName,
                    givenName: this.assetUsers[i].givenName,
                    surname: this.assetUsers[i].surname,
                    mail: this.assetUsers[i].mail,
                    mailNickname: this.assetUsers[i].mailNickname,
                    jobTitle: this.assetUsers[i].jobTitle,
                };
            }
        }
        let selectedMatch = null;
        for (let i = 0; i < foundMatches.length; i++) {
            if (!selectedMatch || foundMatches[i].orderIndex > selectedMatch.orderIndex) {
                selectedMatch = foundMatches[i];
            }
        }
        if (!selectedMatch) {
            return;
        }
        this.assetOrder.splice(selectedMatch.orderIndex, 1);
        this.assetOrder.unshift({
            displayName: this.assetUsers[selectedMatch.userIndex].displayName,
            givenName: this.assetUsers[selectedMatch.userIndex].givenName,
            surname: this.assetUsers[selectedMatch.userIndex].surname,
            mail: this.assetUsers[selectedMatch.userIndex].mail,
            mailNickname: this.assetUsers[selectedMatch.userIndex].mailNickname,
            jobTitle: this.assetUsers[selectedMatch.userIndex].jobTitle,
        });
        this.saveAssetOrder(JSON.stringify(this.assetOrder));
        this.assetReviewer = {
            displayName: this.assetUsers[selectedMatch.userIndex].displayName,
            givenName: this.assetUsers[selectedMatch.userIndex].givenName,
            surname: this.assetUsers[selectedMatch.userIndex].surname,
            mail: this.assetUsers[selectedMatch.userIndex].mail,
            mailNickname: this.assetUsers[selectedMatch.userIndex].mailNickname,
            jobTitle: this.assetUsers[selectedMatch.userIndex].jobTitle,
        };
    }
    updateHardwareOrSoftwareOptions() {
        if (this.omOnlyCopy && this.omOnlyCopy.toUpperCase() === "YES") {
            this.hardwareOrSoftwareOptions = this.workOptions["O&M"];
        }
        else {
            this.hardwareOrSoftwareOptions = this.workOptions["Not O&M"];
        }
    }
    omOnlyChanged() {
        this.updateHardwareOrSoftwareOptions();
        this.relatedWorkCopy = "";
        this.relatedWorkChanged();
    }
    relatedWorkChanged() {
        if (!this.relatedWorkCopy) {
            this.hardwareOrSoftwareCopy = "";
            this.hardwareSoftwareChanged();
            return;
        }
        if (this.omOnlyCopy.toUpperCase() === "YES") {
            this.hardwareOrSoftwareCopy = "O&M Only";
        }
        else {
            if (this.relatedWorkCopy === "Hardware and Software Both") {
                this.hardwareOrSoftwareCopy = "Hardware and Software";
            }
            if (this.relatedWorkCopy === "Hardware") {
                this.hardwareOrSoftwareCopy = "Hardware Only";
            }
            if (this.relatedWorkCopy === "Software") {
                this.hardwareOrSoftwareCopy = "Software Only";
            }
        }
        this.hardwareSoftwareChanged();
    }
    hardwareSoftwareChanged() {
        if (!((this.hardwareOrSoftwarePrevious === "Hardware Only" &&
            this.hardwareOrSoftwareCopy === "Hardware and Software") ||
            (this.hardwareOrSoftwarePrevious === "Hardware and Software" &&
                this.hardwareOrSoftwareCopy === "Hardware Only"))) {
            this.purchasingWarrantiesCopy = "";
        }
        if (!((this.hardwareOrSoftwarePrevious === "Software Only" &&
            this.hardwareOrSoftwareCopy === "Hardware and Software") ||
            (this.hardwareOrSoftwarePrevious === "Hardware and Software" &&
                this.hardwareOrSoftwareCopy === "Software Only"))) {
            for (let i = 0; i < this.projectConsistsOfCheckboxesCopy.length; i++) {
                this.projectConsistsOfCheckboxesCopy[i] = false;
            }
            for (let i = 0; i < this.buildingsCopy.length; i++) {
                for (let j = 0; j < this.buildingsCopy[i].materialEstimates.length; j++) {
                    this.buildingsCopy[i].materialEstimates[j].cost = null;
                    this.buildingsCopy[i].materialEstimates[j].unitOfPropertyDescription =
                        null;
                }
            }
            this.expectedLifeCopy = null;
            this.agileEffortCopy = "";
            this.softwareBeingUsedCopy = "";
            this.vendorNameCopy = "";
            this.softwareNameCopy = "";
            this.inServiceYearCopy = "";
            this.softwareProjectOverviewCopy = "";
            this.dataConversionActivitiesCopy = "";
            this.trainingCostsCopy = "";
            this.associatedRetirementCopy = "";
            this.softwareToBeRetiredCopy = "";
            this.retiredInServiceDateCopy = "";
            this.maintenanceContractsCopy = "";
            this.replacingInterfacesCopy = "";
            this.howSoftwareReleasedCopy = "";
            this.perpetualLicensesCopy = "";
            this.contractualRightCopy = "";
            this.significantPenaltyCopy = "";
            this.isFeasibleCopy = "";
            this.serviceFeesCopy = "";
            this.useWithoutPayingCopy = "";
            this.releaseDetailsCopy = [new ReleaseDetail()];
            for (let i = 0; i < this.laborDetailsCopy.length; i++) {
                const detail = new LaborDetail();
                detail.workTask = null;
                detail.workDescription = null;
                detail.chargeType = this.laborDetailsCopy[i].chargeType;
                detail.totalCosts = this.laborDetailsCopy[i].totalCosts;
                this.laborDetailsCopy[i] = detail;
            }
            for (let i = 0; i < this.contingencyDetailsCopy.length; i++) {
                const detail = new ContingencyDetail();
                detail.cost = null;
                detail.description = null;
                detail.totalCosts = this.contingencyDetailsCopy[i].totalCosts;
                this.contingencyDetailsCopy[i] = detail;
            }
        }
        this.hardwareOrSoftwarePrevious = this.hardwareOrSoftwareCopy;
        this.loadHardOrSoftwareRelatedData();
    }
    distributeCostChange(value) {
        if (value !== "Default") {
            this.defaultOptionCopy = null;
            this.allocationsCopy = [new Allocation()];
            this.allocationsTouched = false;
            if (this.buildingInfoCopy && this.buildingInfoCopy.OMOperatingUnits) {
                let matchFound = false;
                for (let i = 0; i < this.operatingUnitOptions.length && !matchFound; i++) {
                    if (this.hardwareOrSoftwareCopy === "O&M Only") {
                        if (this.buildingInfoCopy.NewOMOUs ===
                            this.operatingUnitOptions[i].OPERATING_UNIT) {
                            this.allocationsCopy[0].operatingUnit =
                                this.operatingUnitOptions[i];
                            matchFound = true;
                        }
                    }
                    else {
                        if (this.buildingInfoCopy.NewCapOUs ===
                            this.operatingUnitOptions[i].OPERATING_UNIT) {
                            this.allocationsCopy[0].operatingUnit =
                                this.operatingUnitOptions[i];
                            matchFound = true;
                        }
                    }
                    if (matchFound) {
                        this.setBusinessUnit(this.allocationsCopy[0], this.allocationsCopy[0].operatingUnit, 0);
                        this.getFundingProjectIDChoices(this.allocationsCopy[0], this.allocationsCopy[0].operatingUnit, 0);
                        this.getUOPDescriptionChoices();
                    }
                }
            }
        }
    }
    assignAllocationDefaults(value) {
        this.allocationDefaultsCopy = value.defaults;
    }
    deleteDefaultOption() {
        this.defaultOptionCopy = "";
    }
    setDefaultAllocation(value) {
        let allocationSet = null;
        for (let i = 0; i < this.allocationDefaultList.length; i++) {
            if (value === this.allocationDefaultList[i].default) {
                allocationSet = this.allocationDefaultList[i];
            }
        }
        this.allocationsCopy = [];
        this.operatingUnitControl = [];
        this.fundingProjectControl = [];
        this.stateControl = [];
        this.filteredOperatingUnitOptions = [];
        this.filteredFundingProjectOptions = [];
        this.filteredStateOptions = [];
        for (let i = 0; i < allocationSet.allocations.length; i++) {
            this.allocationsCopy.push(new Allocation());
            this.operatingUnitControl.push(new FormControl());
            this.fundingProjectControl.push(new FormControl());
            this.stateControl.push(new FormControl());
            this.filteredOperatingUnitOptions.push(new Observable());
            this.filteredOperatingUnitOptions[this.filteredOperatingUnitOptions.length - 1] = this.operatingUnitControl[this.operatingUnitControl.length - 1].valueChanges.pipe(startWith(""), map((value) => (typeof value === "string" ? value : this.lastFilter)), map((filter) => this.operatingUnitFilter(filter)));
            this.filteredFundingProjectOptions.push(new Observable());
            this.filteredFundingProjectOptions[this.filteredFundingProjectOptions.length - 1] = this.fundingProjectControl[this.fundingProjectControl.length - 1].valueChanges.pipe(startWith(""), map((value) => (typeof value === "string" ? value : this.lastFilter)), map((filter) => this.fundingProjectFilter(filter, this.allocationsCopy[this.allocationsCopy.length - 1])));
            this.filteredStateOptions.push(new Observable());
            this.filteredStateOptions[this.filteredStateOptions.length - 1] =
                this.stateControl[this.stateControl.length - 1].valueChanges.pipe(startWith(""), map((value) => (typeof value === "string" ? value : this.lastFilter)), map((filter) => this.stateFilter(filter, this.allocationsCopy[this.allocationsCopy.length - 1])));
            let matchFound = false;
            for (let j = 0; j < this.operatingUnitOptions.length && !matchFound; j++) {
                if (this.operatingUnitOptions[j].OPERATING_UNIT.startsWith(allocationSet.allocations[i].operatingUnit)) {
                    matchFound = true;
                    this.allocationsCopy[i].operatingUnit = this.operatingUnitOptions[j];
                    this.allocationsCopy[i].businessUnitValue =
                        this.operatingUnitOptions[j].BUSINESS_UNIT;
                    this.allocationsCopy[i].businessUnit = this.operatingUnitOptions[j].BUSINESS_UNIT.concat(" - ").concat(this.operatingUnitOptions[j].BU_DESCR);
                    this.setAllocationSetId(this.allocationsCopy[i], this.operatingUnitOptions[j].BUSINESS_UNIT);
                    let matchFoundState = false;
                    for (let k = 0; k < this.buForStateOptions.length && !matchFoundState; k++) {
                        if (this.allocationsCopy[i].businessUnitValue ===
                            this.buForStateOptions[k]) {
                            matchFoundState = true;
                            this.allocationsCopy[i].stateOptions = ["NC", "SC", "NC & SC"];
                        }
                    }
                    if (!matchFound) {
                        this.allocationsCopy[i].stateOptions = [];
                    }
                    this.filteredStateOptions[i] = this.stateControl[i].valueChanges.pipe(startWith(""), map((value) => typeof value === "string" ? value : this.lastFilter), map((filter) => this.stateFilter(filter, this.allocationsCopy[i])));
                }
            }
            this.allocationsCopy[i].percentage = Number(allocationSet.allocations[i].percentage);
            this.getFundingProjectIDChoices(this.allocationsCopy[i], this.allocationsCopy[i].businessUnitValue, i, true);
            this.getUOPDescriptionChoices();
        }
        this.allocationTotal();
    }
    setAllocationSetId(allocation, businessUnit) {
        let callBody = {
            businessUnit: [businessUnit],
        };
        this.dataService.getFireHubData("fihub_get_acct_model", callBody).subscribe((result) => {
            if (result.length > 0) {
                allocation.setId = result[0].ACCT_MODEL_SETID;
            }
            else {
                allocation.setId = "";
            }
        }, (error) => {
            console.log("error", error);
            let errorType = "";
            let errorDescription = "";
            if (error.error.message) {
                errorDescription = errorDescription.concat("Get FiHub SetID Error - ", error.error.message);
            }
            else {
                errorDescription = errorDescription.concat("Get FiHub SetID Error");
            }
            errorType = errorType.concat(error.status, " ", error.statusText);
            let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
            });
        });
    }
    getAllocationFunctions(allocation) {
        const val = this.allocationFunctions.find((a) => a.setId === allocation.setId);
        return val ? val.functions : [];
    }
    showFunctionField(allocation) {
        return ["PWGCT", "EDIST"].includes(allocation.setId);
    }
    isAllocationFunctionVisible(allocations) {
        return allocations.some((a) => this.showFunctionField(a));
    }
    allocationsHasFunction(allocations) {
        return allocations.some((a) => a.function);
    }
    assetAndMajorLocationFullyLoaded() {
        for (let i = 0; i < this.itProjects.length; i++) {
            for (let j = 0; j < this.itProjects[i].itProjectEstimates.length; j++) {
                if (!this.itProjects[i].itProjectEstimates[j].assetAndMajorLoaded) {
                    return false;
                }
            }
        }
        return true;
    }
    approvedAfterJointOwner() {
        if (this.formActivity && this.formActivity.length > 0) {
            return this.formStatus === 'Approved' && this.formActivity[0].status === 'Joint Owner Review';
        }
        else {
            return false;
        }
    }
}
